/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(7);
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(13);
	
	__webpack_require__(17);
	
	__webpack_require__(18);

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _elements = __webpack_require__(4);
	
	var _inViewport = __webpack_require__(5);
	
	var _inViewport2 = _interopRequireDefault(_inViewport);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debouncedCancelMoveNav = (0, _lodash.debounce)(cancelMoveNav, 500);
	
	var lastScrollTop = 0;
	var scrolling = void 0;
	
	startAnimation();
	_windowDimensions2.default.onResize(moveNav);
	_windowDimensions2.default.onResize(setFixedInnerHeight);
	
	function onScroll() {
	    debouncedCancelMoveNav();
	
	    if (scrolling) {
	        return;
	    }
	
	    scrolling = true;
	    startAnimation();
	}
	
	function startAnimation() {
	    window.requestAnimationFrame(onTick);
	}
	
	function onTick() {
	    var scrollTop = window.pageYOffset;
	    scrollTop = scrollTop < 0 ? 0 : scrollTop;
	
	    if (scrollTop !== lastScrollTop) {
	        lastScrollTop = scrollTop;
	        moveNav();
	    }
	
	    if (!scrolling) {
	        return;
	    }
	
	    window.requestAnimationFrame(onTick);
	}
	
	function moveNav() {
	    var visible = (0, _inViewport2.default)(_elements.articles, lastScrollTop, _windowDimensions2.default.height);
	
	    (0, _lodash.forEach)(_elements.articles, function (article) {
	        var isVisible = visible.indexOf(article) !== -1,
	            offset = article.offset - lastScrollTop,
	            height = _windowDimensions2.default.height - offset,
	            clipped = offset > 0;
	
	        var css = {
	            visibility: isVisible ? 'visible' : 'hidden',
	            height: clipped ? height + 'px' : '',
	            top: clipped ? 'auto' : ''
	        };
	
	        applyCss(article, css);
	    });
	}
	
	function cancelMoveNav() {
	    scrolling = false;
	}
	
	function applyCss(article, css) {
	    if ((0, _lodash.isEqual)(article.css, css)) {
	        return;
	    }
	
	    article.css = css;
	
	    (0, _lodash.forEach)(css, function (value, property) {
	        article.fixed.style[property] = value;
	    });
	}
	
	function setFixedInnerHeight() {
	    (0, _lodash.forEach)(_elements.articles, function (article) {
	        article.fixed.children[0].style.height = _windowDimensions2.default.height + 'px';
	    });
	}
	
	window.addEventListener('scroll', onScroll);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)(module), (function() { return this; }())))

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reCalc = exports.backgrounds = exports.images = exports.articles = undefined;
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var articles = _lodash2.default.map(document.getElementsByTagName('article'), buildArticlesObject);
	var images = _lodash2.default.map(document.getElementsByClassName('image'), buildImageObject);
	var backgrounds = _lodash2.default.compact(_lodash2.default.map(articles, buildBackgroundObject));
	
	window.addEventListener('load', updateOffsets);
	window.addEventListener('resize', _lodash2.default.debounce(updateOffsets, 20));
	document.addEventListener('typekitLoaded', updateOffsets);
	
	exports.articles = articles;
	exports.images = images;
	exports.backgrounds = backgrounds;
	exports.reCalc = updateOffsets;
	
	
	function buildArticlesObject($article) {
	    return {
	        el: $article,
	        fixed: $article.getElementsByClassName('fixed')[0]
	    };
	}
	
	function buildImageObject($image) {
	    return {
	        el: $image,
	        path: $image.getAttribute('data-src')
	    };
	}
	
	function buildBackgroundObject(article) {
	    var $el = article.el.getElementsByClassName('fixed-inner')[0];
	    var imageObject = _lodash2.default.assign({
	        article: article,
	        background: true
	    }, buildImageObject($el));
	    return imageObject.path && imageObject;
	}
	
	function updateOffsets() {
	    updateArticlesOffsets();
	    updateImagesOffsets();
	    updateBackgroundOffsets();
	}
	
	function updateArticlesOffsets() {
	    _lodash2.default.forEach(articles, function (article) {
	        article.offset = article.el.offsetTop;
	    });
	}
	
	function updateImagesOffsets() {
	    _lodash2.default.forEach(images, function (image) {
	        image.hidden = !image.el.offsetParent;
	        image.offset = image.el.offsetParent && image.el.offsetParent.offsetTop + image.el.offsetTop;
	    });
	}
	
	function updateBackgroundOffsets() {
	    _lodash2.default.forEach(backgrounds, function (background) {
	        background.offset = background.article.offset;
	    });
	}

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (elements, scrollPos, offset) {
	    var inViewport = [];
	
	    for (var i = elements.length - 1; i >= 0; i--) {
	        if (!elements[i].hidden) {
	            if (elements[i].offset < scrollPos) {
	                inViewport.push(elements[i]);
	                break;
	            }
	
	            if (elements[i].offset < scrollPos + offset) {
	                inViewport.push(elements[i]);
	            }
	        }
	    }
	
	    return inViewport;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(2);
	
	var _elements = __webpack_require__(4);
	
	var callbacks = [];
	
	var win = {
	    width: window.innerWidth,
	    height: window.innerHeight,
	    onResize: function onResize(callback) {
	        callbacks.push(callback);
	    },
	    reflow: resizeHandler
	};
	
	exports.default = win;
	
	
	window.addEventListener('resize', resizeHandler);
	
	function resizeHandler(event) {
	    win.width = window.innerWidth;
	    win.height = window.innerHeight;
	    (0, _elements.reCalc)();
	    (0, _lodash.forEach)(callbacks, function (callback) {
	        callback(event);
	    });
	}

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// init
	
	setLanguage(window.localStorage.getItem('language') || (window.navigator.language.indexOf('de') !== -1 ? 'de' : 'en'));
	
	(0, _lodash.forEach)(document.getElementsByClassName('language-switch'), addListeners);
	
	function setLanguage(language) {
	    document.documentElement.setAttribute('lang', language);
	    window.localStorage.setItem('language', language);
	    _windowDimensions2.default.reflow();
	}
	
	function addListeners(element) {
	    element.addEventListener('click', function (event) {
	        setLanguage(event.target.getAttribute('data-lang'));
	    });
	}

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _elements = __webpack_require__(4);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	var _inViewport = __webpack_require__(5);
	
	var _inViewport2 = _interopRequireDefault(_inViewport);
	
	var _loadImage = __webpack_require__(9);
	
	var _loadImage2 = _interopRequireDefault(_loadImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_windowDimensions2.default.onResize(setPicSrc);
	window.addEventListener('scroll', setPicSrc);
	setPicSrc();
	
	function setPicSrc() {
	    _lodash2.default.forEach((0, _inViewport2.default)(_elements.backgrounds, window.pageYOffset, _windowDimensions2.default.height * 4), _loadImage2.default);
	    _lodash2.default.forEach((0, _inViewport2.default)(_elements.images, window.pageYOffset, _windowDimensions2.default.height * 2), _loadImage2.default);
	}

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (image) {
	    var url = (0, _getImageUrl2.default)(image);
	
	    if (url === image.url) {
	        return;
	    }
	
	    image.url = url;
	
	    var loadIndicator = document.createElement('img');
	    loadIndicator.addEventListener('load', setSrc);
	    loadIndicator.src = url;
	    image.el.classList.add('is-loading');
	
	    function setSrc() {
	        image.el.style.backgroundImage = 'url(' + url + ')';
	        image.el.classList.remove('is-loading');
	        loadIndicator.removeEventListener('load', setSrc);
	    }
	};
	
	var _getImageUrl = __webpack_require__(10);
	
	var _getImageUrl2 = _interopRequireDefault(_getImageUrl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(2);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sizes = [400, 800, 1200, 1600, 2000];
	var breakPoints = [{
	    size: 600,
	    ratio: 1
	}, {
	    size: 900,
	    ratio: 0.75
	}, {
	    ratio: 0.375
	}];
	
	exports.default = getUrl;
	
	
	function getCurrentSize(full) {
	    var width = full ? _windowDimensions2.default.width : getContentWidth() - 40;
	    return (0, _lodash.find)(sizes, function (size) {
	        return width * window.devicePixelRatio < size;
	    }) || (0, _lodash.last)(sizes);
	}
	
	function getUrl(image) {
	    var parts = image.path.split('.');
	    var name = parts[0];
	    var size = image.background ? '' : '-' + getCurrentSize(image.full);
	    var suffix = parts[1] || 'jpg';
	    return name + size + '.' + suffix;
	}
	
	function getContentWidth() {
	    var breakPoint = (0, _lodash.find)(breakPoints, function (point) {
	        return !point.size || point.size > _windowDimensions2.default.width;
	    });
	
	    return _windowDimensions2.default.width * breakPoint.ratio;
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _elements = __webpack_require__(4);
	
	var _loadImage = __webpack_require__(9);
	
	var _loadImage2 = _interopRequireDefault(_loadImage);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	var _touch = __webpack_require__(12);
	
	var _touch2 = _interopRequireDefault(_touch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = _lodash2.default.isUndefined(document.body.style.transform) ? 'webkitTransform' : 'transform';
	
	var $viewer = document.createElement('div');
	var touch = (0, _touch2.default)($viewer);
	
	var current = void 0;
	var gallery = void 0;
	
	$viewer.classList.add('image-view');
	$viewer.addEventListener('click', hideImageViewer);
	document.body.appendChild($viewer);
	
	_windowDimensions2.default.onResize(initImageViewer);
	initImageViewer();
	
	touch.on('move', touchMoveHandler);
	touch.on('end', touchEndHandler);
	
	document.addEventListener('keydown', function (event) {
	    switch (event.keyCode) {
	        case 27:
	            hideImageViewer();
	            break;
	        case 37:
	            goToImage(-1);
	            break;
	        case 39:
	            goToImage(1);
	            break;
	    }
	});
	
	_lodash2.default.forEach(_elements.images, addListener);
	
	function addListener(image) {
	    image.el.addEventListener('click', function () {
	        showImage(_lodash2.default.find(gallery, 'trigger', image.el), image.url);
	        showImageViewer();
	    });
	}
	
	function touchMoveHandler(distance) {
	    $viewer.classList.remove('is-animating');
	
	    setViewerCss(convertToVw(distance));
	}
	
	function touchEndHandler(distance) {
	    $viewer.classList.add('is-animating');
	
	    var vw = convertToVw(distance);
	
	    if (vw > 20) {
	        goToImage(1);
	    } else if (vw < -20) {
	        goToImage(-1);
	    } else {
	        goToImage(0);
	    }
	}
	
	function convertToVw(distance) {
	    return distance / _windowDimensions2.default.width * 100;
	}
	
	function setViewerCss(offset) {
	    var vw = _lodash2.default.findIndex(gallery, current) * -100 - (offset ? offset : 0);
	
	    if (vw > 0 || vw < (gallery.length - 1) * -100) {
	        return;
	    }
	
	    $viewer.style[transform] = 'translateX(' + vw + 'vw)';
	}
	
	function goToImage(offset) {
	    if (!current) {
	        return;
	    }
	
	    var image = gallery[gallery.indexOf(current) + offset];
	
	    if (!image) {
	        return;
	    }
	
	    showImage(image);
	}
	
	function showImage(image, oldUrl) {
	    if (oldUrl) {
	        image.url = oldUrl;
	        image.el.style.backgroundImage = 'url(' + oldUrl + ')';
	    }
	
	    current = image;
	    (0, _loadImage2.default)(image);
	    loadAround(image);
	
	    setViewerCss();
	}
	
	function initImageViewer(event) {
	    if (event) {
	        return;
	    }
	
	    while ($viewer.firstChild) {
	        $viewer.removeChild($viewer.firstChild);
	    }
	
	    gallery = visibleImages().map(function (image) {
	        var newImage = _lodash2.default.clone(image);
	        newImage.trigger = image.el;
	        newImage.el = document.createElement('div');
	        newImage.el.classList.add('image');
	        newImage.full = true;
	        delete newImage.url;
	
	        $viewer.appendChild(newImage.el);
	
	        return newImage;
	    });
	}
	
	function showImageViewer() {
	    $viewer.classList.add('is-active');
	    document.body.classList.add('no-scroll');
	}
	
	function hideImageViewer() {
	    current = null;
	    $viewer.classList.remove('is-active', 'is-animating');
	    document.body.classList.remove('no-scroll');
	}
	
	function visibleImages() {
	    return _elements.images.filter(function (image) {
	        return !image.hidden;
	    });
	}
	
	function loadAround(image) {
	    var index = gallery.indexOf(image);
	
	    if (index === -1) {
	        return;
	    }
	
	    [index - 1, index + 1].forEach(function (i) {
	        if (!gallery[i]) {
	            return;
	        }
	
	        (0, _loadImage2.default)(gallery[i]);
	    });
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(2);
	
	exports.default = touchHandler;
	
	
	function touchHandler(el) {
	    var callbacks = {};
	
	    var currentTouch = void 0;
	    var currentX = void 0;
	
	    el.addEventListener('touchstart', startHandler);
	    el.addEventListener('touchmove', moveHandler);
	    el.addEventListener('touchleave', endHandler);
	    el.addEventListener('touchend', endHandler);
	    el.addEventListener('touchcancel', endHandler);
	
	    function startHandler(event) {
	        if (currentTouch) {
	            return;
	        }
	
	        currentTouch = event.changedTouches[0];
	        currentX = currentTouch.clientX;
	    }
	
	    function moveHandler(event) {
	        event.preventDefault();
	
	        var touch = findTouch(event.touches, currentTouch);
	
	        if (!touch) {
	            return;
	        }
	
	        callback('move', currentX - touch.clientX);
	    }
	
	    function endHandler(event) {
	        var touch = findTouch(event.changedTouches, currentTouch);
	
	        if (!touch) {
	            return;
	        }
	
	        callback('end', currentX - touch.clientX);
	        currentTouch = null;
	    }
	
	    function registerHandler(type, fn) {
	        callbacks[type] = fn;
	    }
	
	    function callback(type, value) {
	        if (callbacks[type]) {
	            callbacks[type](value);
	        }
	    }
	
	    return {
	        on: registerHandler
	    };
	}
	
	function findTouch(touches, touch) {
	    return (0, _lodash.findWhere)(touches, { identifier: touch.identifier });
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _d = __webpack_require__(14);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _topojsonClient = __webpack_require__(15);
	
	var topojson = _interopRequireWildcard(_topojsonClient);
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _elements = __webpack_require__(4);
	
	var _mapProvider = __webpack_require__(16);
	
	var _mapProvider2 = _interopRequireDefault(_mapProvider);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapData = JSON.parse(_mapProvider2.default);
	var subMap = _elements.articles[0].fixed.getElementsByTagName('svg')[1];
	
	var map = {
	    world: mapData.map,
	    svg: _d2.default.select('#map'),
	    $stops: document.getElementsByClassName('stop'),
	    stops: {}
	};
	
	_lodash2.default.assign(map, getSize());
	
	map.projection = _d2.default.geo.mercator().translate([0, 0]).scale(1);
	
	map.path = _d2.default.geo.path().projection(map.projection);
	
	map.svg.append('path').datum(topojson.feature(map.world, map.world.objects.countries)).attr('d', map.path).attr('class', 'country');
	
	map.svg.append('path').datum(topojson.mesh(map.world, map.world.objects.countries, function (a, b) {
	    return a !== b;
	})).attr('d', map.path).attr('class', 'border');
	
	setRoute(mapData.route);
	
	function setRoute(path) {
	    var feature = topojson.feature(path, path.objects.route);
	
	    map.bounds = map.path.bounds(feature);
	
	    map.svg.append('path').datum(feature).attr('d', map.path).attr('class', 'route');
	
	    refreshMap();
	}
	
	window.addEventListener('resize', _lodash2.default.debounce(resize, 500));
	
	function setStop(el) {
	    var id = el.getAttribute('data-for');
	    if (map.stops[id]) {
	        var pos = map.projection(map.stops[id]);
	        el.style.top = pos[1] + 'px';
	        el.style.left = pos[0] + 'px';
	    }
	}
	
	function resize() {
	    _lodash2.default.assign(map, getSize());
	
	    refreshMap();
	}
	
	function getSize() {
	    var rect = subMap.getBoundingClientRect();
	
	    return {
	        width: rect.width,
	        height: rect.height
	    };
	}
	
	function refreshMap() {
	    if (!map.bounds) {
	        return;
	    }
	
	    var b = map.bounds,
	        s = 0.9 / Math.max((b[1][0] - b[0][0]) / map.width, (b[1][1] - b[0][1]) / map.height),
	        t = [(map.width - s * (b[1][0] + b[0][0])) / 2, (map.height - s * (b[1][1] + b[0][1])) / 2];
	
	    map.projection.scale(s).translate(t);
	
	    map.svg.select('.country').attr('d', map.path);
	    map.svg.select('.border').attr('d', map.path);
	    map.svg.select('.route').attr('d', map.path);
	
	    _lodash2.default.forEach(map.$stops, setStop);
	}
	
	_lodash2.default.forEach(_elements.articles, function (article) {
	    var location = article.el.dataset.location.split(',').map(parseFloat);
	    var id = article.el.id;
	    map.stops[id] = location;
	    _lodash2.default.forEach(document.querySelectorAll('[data-for="' + id + '"]'), setStop);
	});

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/topojson/topojson-client v3.1.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.topojson = global.topojson || {}));
	}(this, function (exports) { 'use strict';
	
	function identity(x) {
	  return x;
	}
	
	function transform(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2, n = input.length, output = new Array(n);
	    output[0] = (x0 += input[0]) * kx + dx;
	    output[1] = (y0 += input[1]) * ky + dy;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	}
	
	function bbox(topology) {
	  var t = transform(topology.transform), key,
	      x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
	
	  function bboxPoint(p) {
	    p = t(p);
	    if (p[0] < x0) x0 = p[0];
	    if (p[0] > x1) x1 = p[0];
	    if (p[1] < y0) y0 = p[1];
	    if (p[1] > y1) y1 = p[1];
	  }
	
	  function bboxGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
	      case "Point": bboxPoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
	    }
	  }
	
	  topology.arcs.forEach(function(arc) {
	    var i = -1, n = arc.length, p;
	    while (++i < n) {
	      p = t(arc[i], i);
	      if (p[0] < x0) x0 = p[0];
	      if (p[0] > x1) x1 = p[0];
	      if (p[1] < y0) y0 = p[1];
	      if (p[1] > y1) y1 = p[1];
	    }
	  });
	
	  for (key in topology.objects) {
	    bboxGeometry(topology.objects[key]);
	  }
	
	  return [x0, y0, x1, y1];
	}
	
	function reverse(array, n) {
	  var t, j = array.length, i = j - n;
	  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
	}
	
	function feature(topology, o) {
	  if (typeof o === "string") o = topology.objects[o];
	  return o.type === "GeometryCollection"
	      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature$1(topology, o); })}
	      : feature$1(topology, o);
	}
	
	function feature$1(topology, o) {
	  var id = o.id,
	      bbox = o.bbox,
	      properties = o.properties == null ? {} : o.properties,
	      geometry = object(topology, o);
	  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
	      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
	      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
	}
	
	function object(topology, o) {
	  var transformPoint = transform(topology.transform),
	      arcs = topology.arcs;
	
	  function arc(i, points) {
	    if (points.length) points.pop();
	    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
	      points.push(transformPoint(a[k], k));
	    }
	    if (i < 0) reverse(points, n);
	  }
	
	  function point(p) {
	    return transformPoint(p);
	  }
	
	  function line(arcs) {
	    var points = [];
	    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
	    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
	    return points;
	  }
	
	  function ring(arcs) {
	    var points = line(arcs);
	    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
	    return points;
	  }
	
	  function polygon(arcs) {
	    return arcs.map(ring);
	  }
	
	  function geometry(o) {
	    var type = o.type, coordinates;
	    switch (type) {
	      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
	      case "Point": coordinates = point(o.coordinates); break;
	      case "MultiPoint": coordinates = o.coordinates.map(point); break;
	      case "LineString": coordinates = line(o.arcs); break;
	      case "MultiLineString": coordinates = o.arcs.map(line); break;
	      case "Polygon": coordinates = polygon(o.arcs); break;
	      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
	      default: return null;
	    }
	    return {type: type, coordinates: coordinates};
	  }
	
	  return geometry(o);
	}
	
	function stitch(topology, arcs) {
	  var stitchedArcs = {},
	      fragmentByStart = {},
	      fragmentByEnd = {},
	      fragments = [],
	      emptyIndex = -1;
	
	  // Stitch empty arcs first, since they may be subsumed by other arcs.
	  arcs.forEach(function(i, j) {
	    var arc = topology.arcs[i < 0 ? ~i : i], t;
	    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
	      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
	    }
	  });
	
	  arcs.forEach(function(i) {
	    var e = ends(i),
	        start = e[0],
	        end = e[1],
	        f, g;
	
	    if (f = fragmentByEnd[start]) {
	      delete fragmentByEnd[f.end];
	      f.push(i);
	      f.end = end;
	      if (g = fragmentByStart[end]) {
	        delete fragmentByStart[g.start];
	        var fg = g === f ? f : f.concat(g);
	        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else if (f = fragmentByStart[end]) {
	      delete fragmentByStart[f.start];
	      f.unshift(i);
	      f.start = start;
	      if (g = fragmentByEnd[start]) {
	        delete fragmentByEnd[g.end];
	        var gf = g === f ? f : g.concat(f);
	        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else {
	      f = [i];
	      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
	    }
	  });
	
	  function ends(i) {
	    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
	    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
	    else p1 = arc[arc.length - 1];
	    return i < 0 ? [p1, p0] : [p0, p1];
	  }
	
	  function flush(fragmentByEnd, fragmentByStart) {
	    for (var k in fragmentByEnd) {
	      var f = fragmentByEnd[k];
	      delete fragmentByStart[f.start];
	      delete f.start;
	      delete f.end;
	      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
	      fragments.push(f);
	    }
	  }
	
	  flush(fragmentByEnd, fragmentByStart);
	  flush(fragmentByStart, fragmentByEnd);
	  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });
	
	  return fragments;
	}
	
	function mesh(topology) {
	  return object(topology, meshArcs.apply(this, arguments));
	}
	
	function meshArcs(topology, object, filter) {
	  var arcs, i, n;
	  if (arguments.length > 1) arcs = extractArcs(topology, object, filter);
	  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
	  return {type: "MultiLineString", arcs: stitch(topology, arcs)};
	}
	
	function extractArcs(topology, object, filter) {
	  var arcs = [],
	      geomsByArc = [],
	      geom;
	
	  function extract0(i) {
	    var j = i < 0 ? ~i : i;
	    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
	  }
	
	  function extract1(arcs) {
	    arcs.forEach(extract0);
	  }
	
	  function extract2(arcs) {
	    arcs.forEach(extract1);
	  }
	
	  function extract3(arcs) {
	    arcs.forEach(extract2);
	  }
	
	  function geometry(o) {
	    switch (geom = o, o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "LineString": extract1(o.arcs); break;
	      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
	      case "MultiPolygon": extract3(o.arcs); break;
	    }
	  }
	
	  geometry(object);
	
	  geomsByArc.forEach(filter == null
	      ? function(geoms) { arcs.push(geoms[0].i); }
	      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });
	
	  return arcs;
	}
	
	function planarRingArea(ring) {
	  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
	  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
	  return Math.abs(area); // Note: doubled area!
	}
	
	function merge(topology) {
	  return object(topology, mergeArcs.apply(this, arguments));
	}
	
	function mergeArcs(topology, objects) {
	  var polygonsByArc = {},
	      polygons = [],
	      groups = [];
	
	  objects.forEach(geometry);
	
	  function geometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "Polygon": extract(o.arcs); break;
	      case "MultiPolygon": o.arcs.forEach(extract); break;
	    }
	  }
	
	  function extract(polygon) {
	    polygon.forEach(function(ring) {
	      ring.forEach(function(arc) {
	        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
	      });
	    });
	    polygons.push(polygon);
	  }
	
	  function area(ring) {
	    return planarRingArea(object(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
	  }
	
	  polygons.forEach(function(polygon) {
	    if (!polygon._) {
	      var group = [],
	          neighbors = [polygon];
	      polygon._ = 1;
	      groups.push(group);
	      while (polygon = neighbors.pop()) {
	        group.push(polygon);
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
	              if (!polygon._) {
	                polygon._ = 1;
	                neighbors.push(polygon);
	              }
	            });
	          });
	        });
	      }
	    }
	  });
	
	  polygons.forEach(function(polygon) {
	    delete polygon._;
	  });
	
	  return {
	    type: "MultiPolygon",
	    arcs: groups.map(function(polygons) {
	      var arcs = [], n;
	
	      // Extract the exterior (unique) arcs.
	      polygons.forEach(function(polygon) {
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
	              arcs.push(arc);
	            }
	          });
	        });
	      });
	
	      // Stitch the arcs into one or more rings.
	      arcs = stitch(topology, arcs);
	
	      // If more than one ring is returned,
	      // at most one of these rings can be the exterior;
	      // choose the one with the greatest absolute area.
	      if ((n = arcs.length) > 1) {
	        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
	          if ((ki = area(arcs[i])) > k) {
	            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
	          }
	        }
	      }
	
	      return arcs;
	    }).filter(function(arcs) {
	      return arcs.length > 0;
	    })
	  };
	}
	
	function bisect(a, x) {
	  var lo = 0, hi = a.length;
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	    if (a[mid] < x) lo = mid + 1;
	    else hi = mid;
	  }
	  return lo;
	}
	
	function neighbors(objects) {
	  var indexesByArc = {}, // arc index -> array of object indexes
	      neighbors = objects.map(function() { return []; });
	
	  function line(arcs, i) {
	    arcs.forEach(function(a) {
	      if (a < 0) a = ~a;
	      var o = indexesByArc[a];
	      if (o) o.push(i);
	      else indexesByArc[a] = [i];
	    });
	  }
	
	  function polygon(arcs, i) {
	    arcs.forEach(function(arc) { line(arc, i); });
	  }
	
	  function geometry(o, i) {
	    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
	    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
	  }
	
	  var geometryType = {
	    LineString: line,
	    MultiLineString: polygon,
	    Polygon: polygon,
	    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
	  };
	
	  objects.forEach(geometry);
	
	  for (var i in indexesByArc) {
	    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
	      for (var k = j + 1; k < m; ++k) {
	        var ij = indexes[j], ik = indexes[k], n;
	        if ((n = neighbors[ij])[i = bisect(n, ik)] !== ik) n.splice(i, 0, ik);
	        if ((n = neighbors[ik])[i = bisect(n, ij)] !== ij) n.splice(i, 0, ij);
	      }
	    }
	  }
	
	  return neighbors;
	}
	
	function untransform(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2,
	        n = input.length,
	        output = new Array(n),
	        x1 = Math.round((input[0] - dx) / kx),
	        y1 = Math.round((input[1] - dy) / ky);
	    output[0] = x1 - x0, x0 = x1;
	    output[1] = y1 - y0, y0 = y1;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	}
	
	function quantize(topology, transform) {
	  if (topology.transform) throw new Error("already quantized");
	
	  if (!transform || !transform.scale) {
	    if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be ≥2");
	    box = topology.bbox || bbox(topology);
	    var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
	    transform = {scale: [x1 - x0 ? (x1 - x0) / (n - 1) : 1, y1 - y0 ? (y1 - y0) / (n - 1) : 1], translate: [x0, y0]};
	  } else {
	    box = topology.bbox;
	  }
	
	  var t = untransform(transform), box, key, inputs = topology.objects, outputs = {};
	
	  function quantizePoint(point) {
	    return t(point);
	  }
	
	  function quantizeGeometry(input) {
	    var output;
	    switch (input.type) {
	      case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(quantizeGeometry)}; break;
	      case "Point": output = {type: "Point", coordinates: quantizePoint(input.coordinates)}; break;
	      case "MultiPoint": output = {type: "MultiPoint", coordinates: input.coordinates.map(quantizePoint)}; break;
	      default: return input;
	    }
	    if (input.id != null) output.id = input.id;
	    if (input.bbox != null) output.bbox = input.bbox;
	    if (input.properties != null) output.properties = input.properties;
	    return output;
	  }
	
	  function quantizeArc(input) {
	    var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
	    output[0] = t(input[0], 0);
	    while (++i < n) if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
	    if (j === 1) output[j++] = [0, 0]; // an arc must have at least two points
	    output.length = j;
	    return output;
	  }
	
	  for (key in inputs) outputs[key] = quantizeGeometry(inputs[key]);
	
	  return {
	    type: "Topology",
	    bbox: box,
	    transform: transform,
	    objects: outputs,
	    arcs: topology.arcs.map(quantizeArc)
	  };
	}
	
	exports.bbox = bbox;
	exports.feature = feature;
	exports.merge = merge;
	exports.mergeArcs = mergeArcs;
	exports.mesh = mesh;
	exports.meshArcs = meshArcs;
	exports.neighbors = neighbors;
	exports.quantize = quantize;
	exports.transform = transform;
	exports.untransform = untransform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = "{\"map\":{\"type\":\"Topology\",\"objects\":{\"countries\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"MultiPolygon\",\"arcs\":[[[0,1]],[[2,3]],[[4,5,6,7,8,9,10,11,12,13,14,15,16,17]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[18]],[[19]]]},{\"type\":\"Polygon\",\"arcs\":[[20,21]]},{\"type\":\"Polygon\",\"arcs\":[[22,23,24,25,26,27,28,29,30,31]]},{\"type\":\"Polygon\",\"arcs\":[[32,33,34,35,36,37,38]]},{\"type\":\"Polygon\",\"arcs\":[[39,40,41,42,43,44]]},{\"type\":\"Polygon\",\"arcs\":[[45,46,47,48,49]]},{\"type\":\"Polygon\",\"arcs\":[[50,51,52,53,54]]},{\"type\":\"Polygon\",\"arcs\":[[55,56,57,-29,58,-27,59,60,61,62,63]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[64,65,66,67]],[[-69,-70,-71,-72]],[[72,73,74,75]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[76,-71]],[[-68,77,-76,78]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[79,80]],[[81]],[[82,83,-66]],[[84,85,86,87,-69,88,-74]]]},{\"type\":\"Polygon\",\"arcs\":[[89,90,-32,91]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-57,92]],[[93,94]],[[95]],[[96]],[[97,98,-92,-31,99,-64,100,101,-33,102,103,104]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[105]],[[106]],[[107]],[[108]],[[109]],[[110]],[[111]],[[112]],[[113]],[[114]],[[-105,115]]]},{\"type\":\"Polygon\",\"arcs\":[[116,117,118,119,120]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[121,122,123,124,125]]]},{\"type\":\"Polygon\",\"arcs\":[[-67,-84,126,-81,127,-85,-73,-78],[-82]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[128]],[[129]],[[130]],[[131]],[[132,-21,133,134]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[135]],[[136]],[[137]],[[138]],[[139,140,141,142,143,144,145,146,147]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[148]],[[149]],[[150]],[[151,152]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[153]],[[154,-101,-63,155,-61,156,157,158,159,-134,-22,-133,160,-35],[-132]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[161]],[[162]],[[163]],[[164]]]},{\"type\":\"Polygon\",\"arcs\":[[165,166]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[167]],[[168]],[[169]],[[170]],[[171]],[[172]],[[173]],[[174]],[[175]],[[176]],[[177]],[[178]],[[179]],[[180]],[[181]],[[182]],[[183]],[[184]],[[185]],[[186]],[[187]],[[188]],[[189]],[[190]],[[191]],[[192]],[[193]],[[194]],[[195]],[[196]],[[197]],[[198]],[[199]],[[200]],[[201]],[[202,-42,203,204,-14,205,-12,206]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[207]],[[-48,208,209]],[[210]],[[211]],[[212]],[[213]],[[214]],[[215]],[[216]],[[217,218,-50,219,220]]]},{\"type\":\"Polygon\",\"arcs\":[[221,222,223,-218,224,-24,225]]},{\"type\":\"Polygon\",\"arcs\":[[226,227,228,229]]},{\"type\":\"Polygon\",\"arcs\":[[230,231,232,233,234,235,236,-123,237,238,239,240]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[241]],[[242]],[[243]],[[244]],[[245,246,-157,-60,-26],[247],[248]]]},{\"type\":\"Polygon\",\"arcs\":[[249,250,-236,251,-234,252,253,-231,254,-228]]},{\"type\":\"Polygon\",\"arcs\":[[255,-5,256,257]]},{\"type\":\"Polygon\",\"arcs\":[[-240,258,259]]},{\"type\":\"Polygon\",\"arcs\":[[-125,260,-118,261,262]]},{\"type\":\"Polygon\",\"arcs\":[[-59,-28]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[263,264]],[[-54,265,266,267,268]]]},{\"type\":\"Polygon\",\"arcs\":[[-102,-155,-34]]},{\"type\":\"Polygon\",\"arcs\":[[269,-55,-269,270,-147]]},{\"type\":\"Polygon\",\"arcs\":[[-120,271]]},{\"type\":\"Polygon\",\"arcs\":[[272,-159]]},{\"type\":\"Polygon\",\"arcs\":[[273,274]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-10,275]],[[-43,-203,276,-2,277,-8,278,-6,-256,279]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[280]]]},{\"type\":\"Polygon\",\"arcs\":[[281,-257,-18,282,-3,283,-16,284,-209,-47]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-37,285]],[[286]],[[287]],[[288]],[[-103,-39,289],[290]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[291]],[[292]],[[293]],[[294]],[[295]],[[296]],[[297]],[[298]],[[299]],[[300]],[[301]],[[302]],[[303]],[[304]],[[305]],[[306]],[[307]],[[308,309]]]},{\"type\":\"Polygon\",\"arcs\":[[310,311,312,-266,-53,313,314,-90,-99,315,-94,316]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-122,317,-238]],[[-254,318,-232]]]},{\"type\":\"Polygon\",\"arcs\":[[319,320,-45,321,-223,322,-274]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-313,323,-311,324,-264,325,-267]],[[326,-142]],[[-166,327,328,-51,-270,-146,329,-144,330,-140,331,-152,332]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[333,-250,-227]]]},{\"type\":\"Polygon\",\"arcs\":[[-248]]},{\"type\":\"Polygon\",\"arcs\":[[-322,-44,-280,-258,-282,-46,-219,-224]]},{\"type\":\"Polygon\",\"arcs\":[[334,-226,-23,-91,-315]]},{\"type\":\"Polygon\",\"arcs\":[[-221,335,-246,-25,-225]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[336]],[[337]],[[338]],[[339]],[[340]],[[-309,341]]]},{\"type\":\"Polygon\",\"arcs\":[[-229,-255,-241,-260,342,343,344]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[345]],[[346]],[[-262,-117,347]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[348]],[[349]],[[350,-204,-41]],[[-344,351]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[352]],[[353,-320,-275,-323,-222,-335,-314,-52,-329],[354],[355]]]},{\"type\":\"Polygon\",\"arcs\":[[-249]]},{\"type\":\"Polygon\",\"arcs\":[[356,-87]]}]}},\"arcs\":[[[5343,4235],[-4,5]],[[5339,4240],[4,-5]],[[4956,4576],[2,4]],[[4958,4580],[-2,-4]],[[5127,4643],[17,-9],[24,-47],[53,-17],[23,-31],[12,-44],[-8,-18]],[[5248,4477],[-16,-34],[5,-41],[-19,-4],[24,-37],[-16,-20],[24,-55],[14,-3]],[[5264,4283],[4,-41],[18,-2]],[[5286,4240],[53,0]],[[5339,4240],[5,-12]],[[5344,4228],[0,-1]],[[5344,4227],[0,-14]],[[5344,4213],[12,-25]],[[5356,4188],[2,-2]],[[5358,4186],[-2,-35],[-42,-18],[-34,-47],[-12,-47],[-52,-6],[-33,-19],[24,-41],[-30,-7],[6,-18],[-28,-20],[-44,14]],[[5111,3942],[4,37],[-27,17],[-12,33],[-92,41],[-45,52],[30,-23],[16,30],[-43,49],[18,39],[36,32],[-19,15],[-1,34],[18,28],[-24,15],[24,48],[-18,18],[30,0],[4,56],[-53,9]],[[4957,4472],[2,58]],[[4959,4530],[26,13],[-28,22],[9,24]],[[4966,4589],[66,78],[19,-37],[18,-8],[58,21]],[[5135,8952],[30,-20],[-48,7],[18,13]],[[5091,9019],[87,-22],[-28,-28],[-33,27],[5,-46],[-69,-3],[-28,47],[37,8],[6,-25],[23,42]],[[684,4631],[-48,-18],[-24,15],[5,27]],[[617,4655],[9,11],[62,-8],[-4,-27]],[[4372,6130],[-25,-58],[27,-23],[6,-28],[41,-39]],[[4421,5982],[-35,-34],[12,-39],[-62,-8],[-65,18],[-29,-20],[48,-8],[20,-23],[-12,-22],[-48,-9],[6,-36],[-14,-15],[19,-50],[-48,2],[-47,-36]],[[4166,5702],[-30,-10],[4,-31],[-85,5],[-42,-24],[-97,8],[-51,-12],[-71,-54],[-39,14],[-63,0],[-17,11],[-88,9]],[[3587,5618],[-53,11],[-61,-4],[-40,12],[-130,15],[-62,31],[-5,23],[-34,27],[22,23],[-63,-10],[-47,-17],[-69,9],[-70,-11],[-43,-48],[-68,7],[-16,16],[-47,0]],[[2801,5702],[-21,33],[-57,-38],[-56,18],[-10,25],[-67,10]],[[2590,5750],[8,11],[-23,40]],[[2575,5801],[31,45],[-23,16]],[[2583,5862],[40,7]],[[2623,5869],[52,-2],[33,-23],[3,-20],[31,4],[-13,-25],[36,7],[35,34],[-9,33],[47,-4],[59,-16],[31,-25],[56,1],[82,29],[17,19],[132,2],[3,26],[87,-18],[54,9],[4,-28],[37,-21],[26,6],[9,38],[-44,19],[24,30],[-61,59],[67,42],[62,12],[32,17],[28,51],[47,-16],[22,26],[2,35]],[[3614,6170],[41,-16],[14,-25],[66,-11],[35,22],[57,-14],[29,46],[30,-3],[6,51],[41,6],[77,-13],[56,-20],[33,3],[65,-33],[66,-3],[18,16],[106,-18],[18,-28]],[[1722,6657],[45,-33],[4,-32],[33,-1],[10,-41],[-53,-22],[-10,-26]],[[1751,6502],[-28,13],[-31,-18],[-38,-54],[3,-19],[38,-40],[-23,-25]],[[1672,6359],[-81,-9],[-17,28],[-23,2],[-77,43],[-30,-1],[-14,44],[18,27],[-18,17],[-32,-40],[-47,-14],[-78,10],[17,22],[-21,16],[19,28],[-44,24],[-87,-5],[-4,31],[-35,17],[-52,0],[-15,47],[-29,18],[-53,-20],[-72,36],[5,29],[-21,31]],[[881,6740],[146,59],[55,12]],[[1082,6811],[12,-34],[50,13],[77,-22],[59,23],[13,18]],[[1293,6809],[9,0]],[[1302,6809],[32,-5],[-4,23],[33,9],[34,-13],[19,15],[43,-24],[25,21],[49,-53],[67,7],[13,-17],[69,-15],[-27,-61],[-23,-14],[16,-22],[74,-3]],[[7187,4936],[6,-46],[-35,-43],[-22,10],[-61,-7],[-41,-55],[-15,-33],[2,-79],[-39,1],[-68,-62],[58,-9],[20,-47],[45,-35],[14,-29]],[[7051,4502],[-51,5],[-62,-17],[-59,37],[-69,0],[-20,-20],[-96,-18],[-4,-24],[-36,-2],[-11,-25]],[[6643,4438],[-24,7],[-45,-13],[29,-42],[-12,-40],[-57,-13],[-83,3],[-67,-19],[-35,20],[-59,21],[-24,-14],[-43,20],[-21,32],[-54,-10],[-58,1],[1,-14],[-36,0],[-78,-23],[-71,7],[-23,-18],[-66,2]],[[5817,4345],[5,73],[17,21],[-32,40],[-8,33],[-76,28],[-45,45]],[[5678,4585],[19,3],[28,38],[-26,23],[13,40],[-14,18],[33,18],[40,0],[12,23],[38,27],[11,27],[-20,5],[-40,40],[-52,23],[-12,43],[-29,38],[12,46],[47,18],[3,27],[21,13]],[[5762,5055],[82,-33],[-38,-30],[-2,-28],[65,-3],[85,9],[161,-32],[85,12],[61,-15],[51,3],[106,-24],[92,19],[89,70],[112,16],[100,23],[55,-12],[32,-27],[66,2],[15,-18],[46,10],[17,-34],[58,-22],[87,-5]],[[4873,5212],[38,15],[48,-11],[-13,-41],[-46,-48],[2,-53],[41,-7],[14,-21],[60,-42],[-15,-9],[-78,-7],[57,-47],[4,-49],[-28,10],[-41,-18]],[[4916,4884],[-69,-5],[39,-50],[-19,-9],[-23,19],[-53,-24],[-10,-56],[-37,-2],[-10,-48],[26,-44],[-27,-19]],[[4733,4646],[-44,12],[-96,51],[-12,23],[-38,-6]],[[4543,4726],[-18,13]],[[4525,4739],[20,7],[-18,28],[-63,44],[-21,52],[-38,9],[-63,49],[-78,69],[-37,18],[-32,36],[-2,34],[-22,43],[-55,49],[-22,-5],[-20,24],[16,90],[55,13],[49,-46],[31,-6],[14,28],[32,24],[62,-10],[36,24],[61,-32],[20,10],[71,-17],[30,11],[31,-23],[49,19],[23,-11],[30,14],[59,-23],[48,6],[23,-36],[28,-20],[31,1]],[[7083,7980],[39,-23],[75,10],[21,-32],[78,17],[84,-17],[-8,-41],[28,-25],[99,36],[84,5],[61,-16],[66,-47],[41,-7],[2,-39],[-30,-30],[40,-31],[11,-34],[-46,-23],[-13,-31],[98,-44],[-25,-32],[35,-12],[28,-54],[103,-34],[24,-23],[-26,-48],[82,3],[88,-23],[-3,-38],[70,-30],[-1,-25],[-34,-4],[-41,-32],[-70,-27],[-79,8],[-13,19],[-78,3],[-41,-46],[62,-42],[16,-29],[-21,-10],[29,-84],[40,-59]],[[7958,6989],[-93,4],[-37,-21],[-23,11],[-52,-5],[-43,-39],[-55,-72],[30,-67],[-24,-24],[-52,23],[1,15],[-43,22],[-100,-10],[-13,13],[-52,-26],[-41,-4],[-36,61],[-21,2],[-64,-23],[-17,-32],[-28,33],[-37,9],[-27,-12],[-39,30],[-28,-23],[-47,14],[-20,-23],[-32,-6],[7,24],[-52,9],[-54,-7],[-18,37],[-78,0],[-109,25],[-154,18],[-101,0],[-41,7],[-112,-17],[-80,-1],[-35,-39],[-64,-33],[-61,15],[-27,-5],[-3,-27]],[[5983,6845],[-16,22],[5,37],[28,58],[-9,23],[-45,25],[-58,11],[-11,14],[55,54],[115,39],[13,18],[-7,101],[-27,28],[-46,85],[-26,80]],[[5954,7440],[38,-10],[128,15],[50,-18],[72,27],[32,-5],[11,42],[42,-5],[48,33],[60,9],[17,-39],[48,2],[12,22],[-26,22],[-37,5],[28,42],[23,13],[-4,52],[35,39],[57,4],[50,46],[65,-6],[54,37],[-86,16],[36,57],[0,24]],[[6707,7864],[60,12],[33,27],[68,-9],[21,11],[59,-9],[13,30],[64,45],[58,9]],[[2493,5901],[1,-1]],[[2494,5900],[3,-4]],[[2497,5896],[72,-41],[14,7]],[[2575,5801],[-11,-50],[26,-1]],[[2801,5702],[-21,-46],[22,-13],[-8,-21],[-82,16],[-11,-41],[22,-5],[6,-37],[-28,-11],[-19,34],[-59,-1],[-39,-15],[-28,21],[-1,28],[-47,-7],[8,-33],[-13,-24],[-37,-27],[-22,-38],[20,-16],[-39,-18],[-10,32],[-22,5],[16,22],[-56,14],[-43,31],[4,45],[-89,-45],[9,-31],[-30,-32],[-39,-19],[-69,17],[-43,-20],[-66,-6],[-18,10]],[[1969,5471],[-39,50],[-20,3],[13,33],[-10,35]],[[1913,5592],[36,3],[-81,24],[-64,-15],[-27,-42]],[[1777,5562],[8,-18],[-28,-18],[-44,-3],[0,20],[32,8],[11,28],[-19,14],[18,44],[72,40],[3,45],[54,19],[8,15],[62,40],[22,23],[-43,4],[25,32],[51,0],[15,-16],[33,3],[50,38]],[[2107,5880],[18,-11],[38,13],[65,-8],[40,15],[25,-11],[40,11],[-31,19],[40,24],[84,-36],[67,5]],[[8502,2805],[2,-2]],[[8504,2803],[-30,2]],[[8474,2805],[2,0]],[[8476,2805],[26,0]],[[8173,2835],[-17,-3]],[[8169,2835],[4,0]],[[8160,2832],[9,3]],[[8156,2832],[4,0]],[[8421,2798],[6,-11]],[[8427,2787],[-62,0],[-6,40],[-29,-10],[-31,11],[-58,-21],[-54,14],[-6,14]],[[8181,2835],[6,-1]],[[8187,2834],[35,-25],[81,27],[51,1],[24,-32],[43,-7]],[[8160,2832],[9,3]],[[8476,2805],[-55,-7]],[[8187,2834],[28,-8],[25,20],[-3,40],[16,-6],[107,-10],[56,7],[91,27],[36,21],[96,34],[-1,-10],[-106,-58],[-23,-25],[-29,-9],[-6,-27],[28,-25]],[[8446,2784],[0,0]],[[8446,2784],[0,0]],[[8437,2790],[0,0]],[[8504,2803],[19,-22],[-51,-3]],[[8472,2778],[-22,21],[24,6]],[[8427,2787],[-1,-5]],[[8426,2782],[-16,-29],[-94,-39],[-42,-1],[-14,-14]],[[8260,2699],[-44,16],[-17,-11]],[[8199,2704],[-23,0],[-61,24],[-19,31],[-16,53],[35,-12],[41,32]],[[8173,2835],[8,0]],[[3855,6683],[42,0],[5,40],[60,-13],[23,-46],[23,5],[125,-27],[16,-20],[67,11],[22,-32],[-47,-20],[35,-17],[58,-60],[29,-8],[66,33],[-27,48],[78,-12],[36,-27],[97,4],[-4,-22],[-33,-11],[62,-43],[47,8],[63,-24],[61,1],[22,-53],[38,-9],[9,-36]],[[4828,6353],[-72,-7],[-36,-35],[-47,-17],[-21,-45],[-46,-19],[-13,-22],[-79,-27],[-89,12],[-34,-28],[-19,-35]],[[3614,6170],[-50,43],[-30,-1],[-48,40],[-26,4],[-71,55],[-26,-2],[-35,26],[-33,57],[-27,18],[34,38],[-14,18],[-53,18],[-41,48],[22,15],[25,-32],[49,49],[83,18],[24,-10],[22,22],[37,1],[17,20],[52,4],[38,29],[51,2],[17,13],[112,26],[-26,25],[54,9],[40,-24],[-4,-19],[48,3]],[[2494,5900],[3,-4]],[[3710,7440],[-3,-16]],[[3707,7424],[-63,-7],[-8,37],[35,-13],[-20,30],[-47,-11],[10,38],[96,-58]],[[2995,7573],[14,-16],[-75,13],[28,16],[33,-13]],[[3511,7614],[19,-18],[42,3],[-8,-42],[38,-17],[-64,0],[-34,-17],[-59,14],[33,13],[-19,14],[47,35],[15,-23],[18,15],[-28,23]],[[2555,7654],[34,14],[59,-27],[22,8],[29,-29],[-3,-31],[-33,-21],[58,9],[4,-31],[43,18],[111,-32],[38,16],[49,2],[-11,-45],[-82,-39],[40,-21],[62,14],[17,-17],[52,-10],[8,23],[40,35],[107,8],[59,32],[44,43],[41,-11],[-62,-12],[-17,-29],[75,29],[45,-7],[35,20],[28,-40],[40,-10],[39,-31],[60,10],[14,-29],[36,-22],[-21,-22],[108,-38]],[[3723,7381],[9,-48],[24,-55],[-14,-58],[-48,-20],[-5,-27],[126,-67],[-25,-39],[10,-32],[28,-9],[-3,-32],[18,-11],[-42,-67],[32,-32],[3,-39],[52,-16],[18,-44],[-16,-51],[-35,-51]],[[2623,5869],[-51,25],[-45,10],[-35,19],[1,-22]],[[2107,5880],[-18,30],[26,65],[-2,51],[34,40],[14,67],[71,50],[23,34],[-65,18],[-69,0],[-45,31],[-47,-13],[-104,26],[-26,-14],[-52,67],[-40,7]],[[1807,6339],[2,30],[33,29],[3,25],[-68,22],[-31,39],[5,18]],[[1722,6657],[16,39],[-34,30],[55,29],[-23,9],[34,39],[0,40],[-23,34],[-39,23],[-2,18],[48,21],[62,-17],[87,18],[16,18],[-33,14],[84,49],[7,32],[-19,22],[-56,0],[-16,22],[15,23],[67,-2],[16,56],[28,35],[0,61]],[[2012,7270],[26,21],[-64,4],[12,59],[34,19],[175,14],[53,-42],[-27,-12],[36,-23],[28,25],[-16,23],[75,-14],[-20,33],[35,51],[67,-14],[89,8],[71,-66],[-41,58],[-43,14],[-51,0],[-42,36],[39,-2],[-10,30],[-23,-6],[-5,32],[30,14],[-69,-11],[-19,16],[100,42],[-78,57],[-7,39]],[[2367,7675],[39,2],[149,-23]],[[2995,7689],[82,-35],[32,16],[31,-32],[-22,-24],[-76,-5],[-102,32],[-3,36],[58,12]],[[3305,7700],[-75,-26],[-24,15],[50,19],[49,-8]],[[2641,7720],[56,-30],[10,-19],[-61,5],[-5,44]],[[2894,7685],[-26,-49],[-22,26],[52,49],[-4,-26]],[[3873,7758],[64,-25],[-19,-34],[-94,26],[19,51],[30,-18]],[[2773,7849],[36,-14],[-4,-27],[32,13],[1,30],[33,-31],[-21,-8],[34,-23],[4,-31],[-23,-42],[-44,-8],[-114,14],[22,13],[-60,22],[-37,77],[44,-6],[97,21]],[[3315,7837],[7,36],[16,-24],[-23,-12]],[[3254,7977],[71,-20],[-26,-31],[22,-52],[-34,-25],[-52,-14],[-6,-28],[51,-17],[7,-18],[-68,-16],[-8,-57],[-46,-11],[51,-27],[-51,-36],[-60,63],[42,7],[-60,50],[-95,8],[-33,28],[26,18],[-31,32],[0,32],[-51,20],[91,-3],[54,27],[0,25],[40,0],[41,-65],[35,43],[23,-19],[-34,-28],[37,-3],[8,20],[-17,52],[-39,7],[73,32],[39,6]],[[2427,8181],[-7,-37],[-56,-31],[-25,27],[26,26],[62,15]],[[2979,8272],[-39,-31],[-38,13],[77,18]],[[2367,7675],[5,58],[-48,-16],[1,32],[49,-14],[-24,76],[-85,27],[18,-22],[-53,23],[24,61],[47,19],[-26,45],[-43,6],[7,21],[-2,91],[40,10],[67,-4],[43,-20],[-10,24],[61,51],[37,0],[17,-23],[-29,-18],[65,9],[-40,55],[31,24],[44,8],[33,-14],[45,34],[-133,-26],[-31,14],[-106,-27],[-47,-41],[30,-38],[-17,-8],[-73,44],[8,17],[77,65],[48,-1],[47,14],[105,1],[39,19],[95,86],[56,2],[89,37],[-33,-44],[28,-33],[-2,-49],[-31,-23],[-35,-58],[18,-47],[-47,2],[-48,-16],[94,10],[-1,-25],[34,-19],[77,3],[42,-21],[-12,-28],[-40,-30],[-29,6],[-27,-33],[-3,43],[-32,-1],[-37,-31],[14,-31],[-23,-46],[-16,12],[-54,-11],[40,-21],[-64,-19],[15,-13],[-36,-20],[-26,-43],[21,-41],[-48,-10],[20,-26],[41,-18],[1,-36],[-38,24],[-36,-29]],[[2353,3266],[9,-27],[-48,-9],[-8,-37],[-58,-29],[46,-23],[-10,-70],[-19,-78],[20,-44],[3,-36],[-11,-25],[7,-27],[27,-13],[-28,-34],[-16,-50],[-3,-61],[-34,-29],[-64,-29],[-14,-37],[-34,-16],[-28,-25],[-9,-49],[18,-58],[34,-50],[14,-62],[81,-27],[51,-72],[5,-59],[40,-31],[130,-80],[6,-9],[32,-129],[83,-323]],[[2575,1618],[-57,-28],[64,-77],[29,-48],[38,-117],[6,-85],[-18,-127],[38,-99],[-27,-89],[-25,-52],[28,-96],[18,-13],[-3,-48],[-15,-36],[-85,-37],[-26,-46],[6,-13],[138,-176],[12,-31],[3,-102],[39,-26],[16,-43],[32,-23],[79,18],[181,-56],[24,-14],[81,-154]],[[3151,0],[-3151,0],[0,2156]],[[0,2156],[21,18],[-21,16]],[[0,2190],[0,750],[18,16],[59,23],[38,-13],[41,35],[31,10],[21,-21],[36,-7],[35,18],[23,46],[125,68],[53,13],[44,27],[78,14],[26,-4],[142,10],[60,14],[70,-9],[47,25],[34,29],[50,-18],[21,18],[56,-9],[46,12],[23,17],[41,5],[46,-7],[38,7],[59,-7],[64,3],[81,-28],[4,-20],[45,-14],[38,5],[27,23],[45,18],[26,-2],[80,20],[18,30],[46,17],[50,-34],[37,-1],[21,-15],[60,6],[22,15],[-16,23],[49,2],[49,-22],[42,-6],[3,-18],[33,-11],[78,27],[64,-13],[26,9]],[[8547,1884],[12,-25]],[[8559,1859],[56,-137],[11,-60],[18,-17],[33,-82],[36,-127]],[[8713,1436],[-36,-44],[-28,-114],[1,-27],[-53,-105],[12,-32],[-7,-49],[-53,-49],[-37,9],[-16,18],[-55,34],[-48,67],[-31,16],[-50,49],[-8,27],[-4,78],[-71,61],[-17,43],[-18,9],[-15,35],[2,34],[-20,23],[-11,35],[-40,-58],[-14,-34],[62,-61],[15,-63],[-8,-29],[48,-56],[12,-41],[32,-21],[30,-51],[52,-48],[42,-31],[19,-43],[-27,15],[19,-42],[-13,-3],[32,-43],[11,-33],[38,-27],[-1,-31],[41,-66],[-14,-5],[-2,-44],[16,-7],[81,-152],[50,-68],[33,-73],[74,-128],[60,-125],[32,-22],[30,-50],[34,-26],[20,-1],[-8,-20],[-41,16],[-9,-45],[7,-38],[-2547,0]],[[6316,0],[0,1361],[-26,70],[-1,41],[-15,30],[1,33],[-30,62],[18,42],[31,37],[26,79],[-28,62],[-5,84],[40,28],[30,38]],[[6357,1967],[10,-29],[48,-7],[116,29],[24,-2],[95,-23],[146,-18],[37,-14],[49,-2],[31,-39],[52,-10],[49,13],[8,-30],[102,-13],[21,6],[100,-33],[51,-30],[39,1],[76,31],[81,47],[56,44],[36,-27],[28,40],[6,30],[42,-10],[80,20],[-74,-30],[41,-8],[11,11],[49,0],[33,26],[-33,10],[58,-1],[92,-34],[66,24],[12,-4],[-37,-58],[35,-19],[31,3],[-6,-21],[22,-21],[40,17],[15,38],[49,-46],[57,-10],[52,16],[28,19],[11,-30],[58,12],[5,9],[58,-8],[50,11],[84,37]],[[8472,2778],[-26,6]],[[8446,2784],[-20,-2]],[[653,3797],[11,-18],[-53,-48],[-47,17],[35,42],[54,7]],[[1040,4010],[-20,-22],[24,-31],[68,-1],[-8,-26],[-54,-70],[-38,-22],[-25,23],[-48,9],[-1,24],[-30,14],[-34,-21],[-32,34],[55,27],[55,37],[88,25]],[[1267,4032],[34,-16],[11,-42],[-13,-3],[-65,31],[-36,0],[-2,26],[71,4]],[[752,4617],[0,0]],[[0,4756],[34,-13],[53,-2],[43,-38],[63,12],[39,-12],[20,-24],[60,8],[29,-14],[91,6],[-2,35],[100,-16],[16,-14],[50,-2],[21,-27]],[[684,4631],[53,-15],[17,-22],[68,19],[58,-25],[46,22],[55,14],[60,-11]],[[1041,4613],[5,-21],[28,-4],[-13,-21],[-27,4],[-7,-28],[22,-18],[4,-30],[-20,-25],[-52,-32],[-154,-61],[-57,-47],[-126,-21],[-87,-31],[-31,0],[-43,-27],[-44,-41],[43,-14],[-6,-13],[-65,-18],[-55,-78],[-69,-62],[-63,-78],[-33,-57],[7,-39],[21,-35],[1,-26],[25,-34],[63,-26],[20,-18],[-71,-50],[-66,-21],[-43,-32],[1,-33],[-33,-17],[-3,-36],[-16,-11],[-33,-54],[36,-25],[-53,-16],[-47,1],[0,1338]],[[5750,8582],[63,8],[86,-30],[-41,-26],[-101,-42],[-33,8],[-63,-19],[-20,-48],[-35,-17],[-12,17],[50,41],[-81,28],[35,22],[-44,39],[46,-3],[19,-18],[21,29],[99,21],[11,-10]],[[5921,8591],[13,-17],[-43,-5],[-40,16],[28,20],[42,-14]],[[5887,8694],[43,-16],[-57,-2],[14,18]],[[5769,8686],[52,-7],[26,-35],[-74,-9],[-13,-20],[-44,-7],[-17,39],[-91,24],[99,5],[32,29],[30,-19]],[[7051,8801],[39,-31]],[[7090,8770],[-43,-5]],[[7047,8765],[23,-4]],[[7070,8761],[-52,-10],[-9,-28]],[[7009,8723],[-31,-41]],[[6978,8682],[-104,1],[-67,-19],[-15,-25],[52,-39],[24,-62],[36,-8],[0,-21],[56,-71]],[[6960,8438],[35,-38],[-63,-10],[-29,-29],[-13,-40]],[[6890,8321],[-65,6],[-56,18],[-9,-11],[-76,-16],[-58,26],[-57,38],[-3,17],[-105,18],[-76,39],[-232,-51]],[[6153,8405],[38,50],[16,68],[-41,12],[-60,-39],[-32,19],[-54,6],[-19,45],[-39,7],[-6,30],[22,15],[54,-1],[2,17],[-93,-9],[23,14],[-25,21],[49,16],[-40,5],[3,54],[69,17],[81,8],[-18,13],[70,13],[7,12],[106,-5],[7,30],[26,-15],[48,5],[72,-10],[31,10],[-12,34],[33,-22],[89,14],[23,-12],[150,-11],[57,-23],[114,1],[112,-11],[35,18]],[[5796,8976],[-23,-46],[-64,-2],[-5,47],[92,1]],[[5583,9027],[-38,-7],[9,24],[29,-17]],[[5372,9736],[28,-16],[55,6],[-43,-24],[-40,34]],[[7554,9998],[112,-33],[-12,-57],[-75,-48],[-53,-13],[116,-66],[87,-24],[98,-44],[5,-20],[78,-51],[-31,-29],[-47,-70],[-82,-52],[-66,-26],[-159,-112],[-106,-60],[-81,-59],[-98,-36],[-240,-134]],[[7000,9064],[-21,-16],[-51,7],[-13,-13],[-67,26],[-44,-20],[-75,-17],[-51,17],[-13,-22],[-122,-9],[-38,-30],[-22,31],[-41,-29],[-73,0],[-5,-16],[-133,-11],[-51,-36],[-12,21],[-145,-26],[-77,-3],[-48,-29],[-84,-7],[83,27],[-36,5],[25,27],[-41,-2],[-40,35],[34,22],[-32,6],[-78,-23],[-25,10],[43,32],[-82,1],[-82,34],[-40,-10],[13,37],[-68,-34],[-50,49],[21,-3],[-29,46],[26,9],[-31,39],[38,-2],[25,37],[8,69],[-32,19],[62,-9],[-43,31],[-40,71],[-33,11],[37,55],[-12,36],[-50,12],[-6,89],[86,45],[10,65],[94,11],[75,-5],[41,20],[-44,34],[57,7],[24,42],[36,11],[20,-20],[57,47],[102,27],[-4,32],[41,10],[102,64],[1478,0]],[[2558,4676],[19,-29],[6,-111],[-37,-39],[0,-61],[-33,-43],[-8,-38],[-95,38],[-15,15],[35,24],[-65,15],[32,18],[-2,26],[-39,-7],[-7,16],[38,18],[-38,22],[-10,26],[35,10],[-32,17],[25,20],[12,38],[74,16],[22,20],[57,5],[-9,22],[10,41],[28,-3],[5,-47],[-8,-29]],[[1672,6359],[41,-24],[43,13],[51,-9]],[[1777,5562],[17,20],[50,9],[69,1]],[[1969,5471],[-49,-22],[0,-33],[38,-17],[3,-28],[43,-26],[-13,-37],[-64,-31],[-26,7],[-32,-14],[29,-22],[1,-21],[67,-27],[12,-32],[-23,-1],[-30,-36],[20,-24],[-12,-18],[43,-30],[69,-29],[79,12],[8,-27],[-51,-50],[6,-18]],[[2087,4947],[-16,-11]],[[2071,4936],[-18,-5]],[[2053,4931],[-52,-16],[-3,-25],[-42,-3],[-10,-23],[-46,-10],[-33,-30],[20,-22],[-178,-31],[-80,22],[-21,13],[-43,1],[-2,29],[-66,-2],[-15,13],[41,12],[-35,32],[8,-26],[-32,-4],[-27,-23],[-61,7],[-13,21],[-74,0],[-18,20],[-43,1],[-107,-64],[-31,1],[-65,-44],[-19,-41],[4,-95],[31,-31]],[[0,4756],[0,618],[49,-18],[37,-31],[12,-48],[19,-14],[-28,86],[-22,22],[-67,39],[0,902],[11,13],[61,-9],[73,-1],[73,-19],[68,18],[24,15],[61,9],[-75,10],[16,49],[103,41],[140,25],[53,28],[31,35],[37,-6],[-32,21],[10,73],[0,72],[82,32],[145,22]],[[498,6809],[-35,0],[-10,18],[45,-18]],[[0,7609],[79,-16],[56,-21],[40,-51],[78,-39],[-35,-22],[16,-30],[69,-63],[-50,-4],[-36,23],[-104,-3],[30,-7],[54,9],[127,-72],[30,-48],[-2,-33],[-79,-48],[58,-25],[32,-2],[34,41],[40,8],[142,-14],[90,-39],[25,-37],[6,-33],[-34,-53],[-12,-46],[-27,-6],[-66,-44],[19,-8],[-58,-17],[-15,17],[-31,-27],[23,0],[-4,-36],[-26,-13],[-88,-7],[58,-7],[-26,-22],[94,-10],[109,10],[-17,-64],[-79,-22],[-13,-30],[-42,5],[-43,-20],[-63,-10],[-22,-18],[-108,21],[-96,-7],[-59,-16],[-12,16],[-62,12],[0,928]],[[10,9109],[20,-1],[-9,-57],[-21,-1],[10,59]],[[83,9123],[-42,-27],[3,29],[39,-2]],[[9947,4848],[18,36],[34,11]],[[9999,4895],[0,-61],[-52,14]],[[6055,2918],[30,-2],[22,20],[21,-14],[-32,-10],[44,-5],[3,-27],[18,-5],[92,19],[81,-5],[5,-16],[73,0],[25,-10],[69,9],[-13,-38],[26,-16],[19,17],[41,11],[21,-9],[20,18],[15,-20],[-14,-36],[-26,-10],[-34,10],[-45,-8],[-50,2],[-72,-8],[-47,-12],[-90,0],[-4,39],[-38,4],[-39,16],[-139,20],[-58,-4],[-17,14],[25,56],[38,13],[30,-13]],[[6860,2988],[-17,-48],[19,-29],[-35,-11],[16,86],[17,2]],[[5850,3085],[-32,-5],[-5,37],[13,12],[36,-37],[-12,-7]],[[7105,3141],[-1,-15],[-42,-63],[6,-14],[-34,-5],[-40,-36],[-17,14],[12,27],[-19,25],[22,9],[30,36],[53,20],[30,2]],[[6674,3182],[-38,-22],[-10,18],[48,4]],[[6188,3219],[23,-16],[-53,-9],[7,25],[23,0]],[[6417,3214],[-6,-18],[-29,18],[13,16],[22,-16]],[[6851,3234],[-52,-18],[45,38],[47,-8],[-40,-12]],[[6581,3255],[-53,-12],[36,23],[17,-11]],[[6238,3293],[26,-23],[-13,-13],[-13,36]],[[6798,3291],[15,-22],[-27,-1],[12,23]],[[6388,3311],[-18,-33],[-24,6],[11,23],[31,4]],[[6465,3305],[-11,-32],[-24,-12],[-19,41],[39,27],[15,-24]],[[6196,3331],[12,-18],[-28,1],[16,17]],[[6405,3404],[28,-9],[-38,-13],[10,22]],[[6312,3379],[-20,-9],[3,36],[17,-27]],[[6341,3440],[39,-7],[-7,-23],[-53,27],[21,3]],[[6169,3449],[6,-16],[-30,-23],[1,23],[23,16]],[[6640,3436],[-63,-28],[-21,3],[21,24],[63,1]],[[5956,3447],[-16,22],[33,0],[-17,-22]],[[6794,3465],[20,-9],[-58,-18],[-53,25],[47,18],[44,-16]],[[5293,3490],[24,-4],[32,-30],[-22,4],[-19,-20],[-47,43],[16,25],[16,-18]],[[6284,3505],[26,-2],[9,-34],[-10,-18],[-62,57],[15,16],[22,-19]],[[5966,3521],[-4,-20],[-28,4],[32,16]],[[5249,3643],[14,-32],[43,-56],[-21,-13],[-51,11],[-15,41],[-5,-25],[-20,2],[20,43],[25,-5],[10,34]],[[6579,3668],[23,-9],[0,-59],[-34,-36],[-35,30],[28,17],[-35,57],[53,0]],[[5280,3694],[5,-12],[-41,-16],[20,61],[21,0],[-5,-33]],[[6218,3743],[26,-19],[-36,-2],[-18,41],[28,-20]],[[5944,3747],[36,-31],[44,-16],[88,-11],[23,-35],[-11,-31],[14,-38],[24,-21],[59,0],[-5,-41],[-33,8],[-18,-10],[-35,29],[-22,52],[-20,21],[-97,4],[0,28],[-45,36],[-74,43],[-70,-3],[68,43],[39,7],[35,-34]],[[5983,3822],[46,-21],[-31,-6],[-15,27]],[[6662,3851],[41,-61],[-8,-22],[-34,-5],[-61,14],[-13,16],[47,22],[-29,5],[-22,-25],[-60,21],[5,18],[77,19],[-3,12],[44,0],[16,-14]],[[5094,3966],[-22,-22],[21,-20],[1,-35],[37,-8],[5,-20],[-58,26],[-9,25],[-49,43],[55,19],[19,-8]],[[6426,4023],[-21,-30],[0,-28],[-69,14],[-7,37],[52,2],[9,-12],[36,17]],[[6483,4137],[-20,-22],[-33,17],[23,12],[30,-7]],[[6268,4170],[-34,-14],[-30,18],[30,41],[34,-15],[0,-30]],[[5381,4227],[70,13],[43,-10],[44,14],[35,43],[66,14],[58,-10],[71,8],[16,46],[33,0]],[[6643,4438],[35,-9],[24,-21],[14,-42],[-73,-41],[7,-71],[-24,-12],[-43,-45],[-10,2]],[[6573,4199],[-22,25],[-93,6],[-128,34],[-57,-37],[-42,1],[-27,25],[-50,-20],[7,-12],[-56,-25],[-64,14],[-36,-16],[33,-38],[11,-39],[43,-3],[43,-19],[37,-34],[-21,-13],[-31,36],[-60,24],[-46,-3],[-9,-17],[20,-22],[52,-20],[0,-40],[-49,24],[-28,40],[-57,16],[-25,-18],[40,-40],[41,-14],[8,-18],[-78,22],[-18,25],[-2,32],[-65,22],[-50,44],[39,11],[-18,24],[-80,-44],[20,-24],[-27,-51],[12,-37],[61,-54],[21,-52],[38,-18],[42,-45],[18,-32],[-34,-22],[-8,41],[-57,22],[-22,-17],[14,-27],[41,-35],[-22,-22],[-60,-19],[-27,10],[-23,-14],[43,-2],[11,-12],[71,-13],[12,-23],[23,9],[35,-15],[-1,-30],[66,-7],[27,-34],[58,-11],[31,-31],[-22,-12],[6,-56],[18,-27],[-13,-32],[-32,32],[-33,15],[-21,26],[-38,24],[-71,-18],[-52,-30],[41,-11],[-3,-47],[86,-43],[-64,-9],[-22,-25],[-24,14],[15,23],[-68,15],[-18,21],[-13,-16],[8,-34],[48,-66],[14,-45],[24,-39],[-21,-16],[13,-35],[28,-35],[-24,3],[-67,54],[-13,35],[-35,-1],[-33,-48],[7,-38],[-38,16],[1,45],[-34,48],[-20,5],[4,26],[-48,-4],[0,-50],[-18,-20],[-14,22],[-33,9],[4,27],[-30,28],[3,36],[22,16],[-2,27],[-25,38],[-41,27],[-25,4],[-3,26],[-40,14],[11,22],[39,23],[11,49],[56,-18],[39,37],[46,10],[64,-38],[27,-2],[84,-27],[46,-32],[18,36],[38,-5],[27,25],[-77,19],[-49,20],[-11,16],[-24,-21],[-35,37],[-3,-25],[-58,4],[-39,11],[-38,-4],[-17,-16],[-39,5],[-27,-10],[-29,24],[-47,-26],[-22,11],[1,46],[-39,34],[-10,27],[-38,4],[6,30],[41,9],[39,-23],[19,32],[-19,16],[-19,-11],[-44,24],[-28,-15],[-55,42],[1,14],[-39,6],[-24,33],[10,18],[-28,6],[8,21],[-44,18]],[[5358,4186],[-2,2]],[[5344,4213],[37,14]],[[4329,4747],[64,3],[40,-16],[-84,-4],[-52,8],[32,9]],[[4733,4646],[14,-35]],[[4747,4611],[-169,96],[-12,-4],[-75,20],[-54,27],[-48,7],[54,3],[54,-26],[46,-8]],[[4279,4810],[40,-17],[113,-9],[-127,0],[-72,18],[46,8]],[[4338,4838],[10,-18],[-69,0],[-34,12],[1,19],[92,-13]],[[3897,5022],[56,-44],[-23,0],[-33,44]],[[3863,5146],[49,-39],[50,-25],[-31,-6],[-68,70]],[[3841,5207],[23,-35],[-39,36],[16,-1]],[[3773,5234],[-5,-39],[20,-40],[-34,18],[-24,57],[23,-7],[-25,47],[45,-36]],[[3795,5306],[23,-34],[38,-32],[-26,-8],[-20,22],[-48,13],[25,10],[8,29]],[[4268,5614],[81,-32],[9,-20],[51,-41],[24,-1],[35,-40],[51,-2],[27,-26],[158,-23],[51,10],[35,30],[55,5]],[[4845,5474],[-14,-30],[29,-37],[-15,-22],[26,-18],[-8,-25],[36,-24],[58,-12],[7,-20],[-84,-9],[9,-36],[-16,-29]],[[4525,4739],[-64,45],[-49,22],[-56,48],[-62,10],[-37,22],[-121,-9],[-5,37],[-117,65],[-79,69],[0,21],[37,-9],[-8,21],[58,-18],[-48,24],[-73,54],[-24,27],[4,67],[-18,36],[-73,44],[-51,16],[-45,-73],[5,-14],[-45,-24],[-8,-21],[-34,24],[-50,56],[1,36],[-25,52],[22,-2]],[[3560,5365],[72,-16],[23,13],[94,0],[46,46],[57,-50],[29,14],[54,-21],[45,5],[-14,37],[25,9],[-30,18],[46,24],[54,5],[9,51],[-26,18],[11,24],[27,0],[74,27],[1,14],[53,-1],[-11,25],[27,18],[42,-11]],[[5627,6081],[34,0],[20,-40],[30,0],[29,-34],[56,-7],[11,-32]],[[5807,5968],[-58,-42],[-44,4],[-60,-29],[-14,-23],[-39,-21],[3,-24],[-34,-24],[-23,-48],[-32,-19],[4,-20],[-32,-30],[-8,-33],[-41,-17],[-41,-82],[-27,-13],[-47,10],[-56,-36],[-34,12],[-54,-17]],[[5170,5516],[-76,14],[-34,-9],[-58,9],[-69,-45],[-48,9],[-40,-20]],[[4268,5614],[-36,34],[-23,54],[-43,0]],[[4421,5982],[46,-1],[32,-27],[86,-35],[99,2],[77,10],[34,-4],[29,14],[-17,34],[23,16],[95,5],[60,13],[8,23],[32,4],[63,-24],[52,28],[49,10],[38,61],[77,11],[75,-20],[77,18],[73,-55],[98,16]],[[9999,2044],[-255,38]],[[9744,2082],[35,31],[-13,26],[-49,-9],[-13,40],[18,5],[-68,214]],[[9654,2389],[214,108],[131,68]],[[9999,2565],[0,-521]],[[8924,2235],[-48,-25],[0,-63]],[[8876,2147],[-37,7],[-3,20],[-44,12],[-36,-19],[-28,-69],[7,-59],[17,-25],[33,-9],[-51,-43],[-25,-57],[14,-13],[58,4],[56,30]],[[8837,1926],[6,-39]],[[8843,1887],[-5,-24]],[[8838,1863],[7,-34]],[[8845,1829],[-11,-31],[-44,-85],[-15,-46],[1,-75],[-14,-23],[-9,-46],[-23,-70]],[[8730,1453],[-17,-17]],[[8559,1859],[25,19],[4,26],[39,31],[-12,14]],[[8615,1949],[56,92],[30,81],[29,136],[26,5],[10,57]],[[8766,2320],[45,3],[10,-11],[36,8],[11,37],[56,23],[15,18]],[[8939,2398],[-13,-18],[16,-36],[14,-59],[-32,-50]],[[4055,3591],[-103,-123],[-11,-48],[-18,-23],[5,-38],[34,-16],[-17,-11],[36,-50],[-38,-16],[-19,-36],[9,-27],[-69,9],[-16,-5],[-71,23],[-23,36],[-45,34],[-29,9],[-47,-4],[-107,49],[-67,46],[-36,1],[-12,17],[-77,1],[-41,28],[-6,36],[7,48],[65,40],[34,-38],[31,8],[20,32],[51,7],[17,-29],[96,-32],[56,18],[21,-6],[86,4],[41,11],[24,18],[52,7],[34,-13],[102,41],[31,-8]],[[2294,3801],[25,-15],[-13,-25],[-12,40]],[[2507,4323],[49,-28],[28,-1],[-11,-27],[13,-27],[35,-16],[-13,-10],[41,-69],[-19,-35],[-30,-28],[26,-45],[-11,-30],[-10,-117],[-19,-82],[-30,-6],[-55,26],[-48,-20],[7,-24],[-49,-43],[-25,13],[-34,-7],[-10,39],[-45,40],[15,20],[-15,19],[22,47],[-5,45],[18,-13],[9,40],[-38,9],[2,35],[21,15],[-7,52],[-19,9],[-18,55],[-36,-3],[9,31],[-16,9],[19,34],[75,-11],[77,34],[40,39],[37,12],[20,19]],[[2795,4709],[-10,-13],[-58,-7],[-4,18],[72,2]],[[3587,5618],[-6,-16],[-59,-24],[-3,-31],[52,-13],[-42,-42],[39,-10],[-14,-33],[51,-21],[27,-31],[-43,-7]],[[3589,5390],[23,6],[-62,44],[-31,-18],[-48,13],[-39,-34],[-158,-49],[31,24],[-64,-18],[-14,-41],[22,-15],[5,-32],[49,-30],[-21,-40],[-36,7],[-10,-23],[8,-65],[25,-65],[78,-59],[57,-21],[74,-47],[88,-43],[53,-100],[26,-81],[32,-48],[117,-92],[37,-12],[4,-18],[100,-43],[74,-4],[140,9],[37,-14],[4,-24],[-65,-37],[8,-44],[154,-62],[112,-31],[35,-15],[66,-47],[129,-44],[7,-23],[64,-39],[33,-32],[19,-40],[-20,-20],[-12,-52],[-11,-4],[-65,29],[-18,22],[0,28],[-36,42],[-81,4],[-73,25],[27,23],[-66,5],[-33,-18],[-44,-61],[-31,-29],[7,-28],[-34,-39],[6,-29],[26,-17],[42,-4],[12,-14],[75,-35],[-9,-17],[0,-53],[14,-26],[-18,-28],[-41,10],[-78,-30],[-18,-23],[6,-77],[-54,-27],[-41,-40],[-22,-50],[-78,-2],[-27,15],[0,62],[33,9],[33,67],[-18,27],[38,16],[29,-1],[23,22],[0,27],[-32,38],[-21,89],[-29,27],[-17,36],[-6,42],[-41,50],[-44,-18],[-39,8],[-35,35],[-52,18],[21,38],[-39,58],[-20,10],[-44,-14],[-59,-4],[36,23],[-48,36],[-44,-2],[-59,77],[-31,26],[-36,-11],[-61,21],[-67,-16],[-37,42],[-62,12],[-46,45],[-48,25],[-24,42],[-56,33],[-22,-1],[-41,59],[-71,32],[-67,5],[25,13],[-8,21],[-64,49],[-39,10],[11,22],[-35,16],[-28,-9],[4,75],[-23,38],[-27,22],[-15,82],[-38,52],[-64,22],[-6,-11],[-142,71],[-98,19],[-25,-1],[-62,-31],[-18,-29],[-30,-11],[-30,-45],[-45,-25],[-64,-16],[-46,0]],[[3272,4976],[0,0]],[[3284,4485],[0,0]],[[9744,2082],[-36,-27],[-145,-38],[-348,-89],[126,-119],[121,-125],[-84,-45],[-40,-79],[-172,-31],[-13,-9],[-55,-83],[-99,-72],[-12,-2],[-259,39]],[[8728,1402],[12,45],[-10,6]],[[8845,1829],[23,24],[-30,10]],[[8843,1887],[22,-6],[14,41],[4,70],[-7,2]],[[8876,1994],[-9,72],[12,45],[-3,36]],[[8924,2235],[33,-7],[42,-49],[29,2],[45,-33],[108,-17],[39,23],[434,235]],[[5489,4569],[-35,-2],[-31,-37],[-46,27],[-76,-28],[-20,-58],[-33,6]],[[5127,4643],[9,26],[-19,22],[38,0],[39,21]],[[5194,4712],[32,5],[0,29],[34,13],[13,21],[-18,18],[48,21],[11,-23],[61,-21],[41,-50],[36,-9],[-8,-25],[40,-4],[56,-20],[-63,-82],[12,-16]],[[8766,2320],[17,19],[23,72],[19,14],[31,71],[2,27],[23,0],[16,53],[2,37],[37,43],[43,20],[-4,28]],[[8975,2704],[56,-8],[30,14],[28,-12],[-26,-33],[47,-18],[19,-55],[-31,-36],[-21,-1],[-30,-33],[25,-13],[-77,-11],[-31,-43],[28,-13],[-53,-44]],[[6316,0],[-3165,0]],[[2575,1618],[54,25],[31,5],[77,92],[19,46],[-6,40],[-33,82],[2,21],[48,54],[41,4],[48,55],[30,19],[16,25],[138,57],[29,34],[-27,31],[1,66],[12,68]],[[3055,2342],[32,-18],[51,-5],[67,-40],[54,-23],[115,-7],[88,29],[40,-4],[53,-25],[52,0],[94,-20],[71,-50],[63,-16],[113,-14],[43,-58],[-3,-47],[36,-82],[60,-59],[70,-29],[76,-12],[89,0],[105,-26],[49,-8],[25,-13],[75,-24],[36,-19],[60,-17],[36,-32],[80,-59],[66,-30],[32,-7],[68,8],[67,29],[32,23],[70,76],[28,65],[-2,33],[-30,44],[-16,40],[-9,60],[5,37],[26,47],[68,63],[57,38],[129,54],[46,-2],[41,10],[37,29],[55,-7],[64,6],[68,-13],[23,-16],[156,-44],[-10,-73],[77,-34],[66,-2],[79,-23],[23,-21],[110,-3],[45,10],[60,-17],[41,-77]],[[5350,7767],[-15,3]],[[5335,7770],[38,52],[6,-19],[-29,-36]],[[5954,7440],[-5,47],[-36,26],[-116,41],[-17,-11]],[[5780,7543],[-21,23],[11,66],[26,13],[-5,30],[-46,18],[-10,22],[-79,2],[-49,-9],[-163,64],[-26,-10]],[[5418,7762],[-11,66],[-35,54],[-6,82]],[[5366,7964],[131,58],[121,26],[101,-5],[41,-11],[66,13],[38,-22],[43,15],[46,-11],[57,5],[95,-22],[43,9],[39,-9],[46,24],[66,16],[48,-59],[134,-11],[11,-14],[114,-57],[24,-26],[77,-19]],[[6890,8321],[43,0],[-5,-24],[77,-30],[2,-31],[-33,-15],[12,-19],[-29,-49],[49,5],[8,-29],[35,-39],[28,-9],[22,-67],[-16,-34]],[[5366,7964],[-20,39],[9,90],[14,61],[71,34],[13,70],[69,70],[73,11],[147,38],[12,-41],[114,-53],[29,-63],[22,-14],[86,-22],[41,4],[84,34],[41,26],[6,28],[-24,129]],[[0,2156],[0,34]],[[2071,4936],[-18,-5]],[[7095,5358],[-33,32],[25,9],[-20,95],[40,111],[0,34],[-31,56],[-9,34],[-58,35],[-29,42],[-21,4],[-51,68],[-30,22],[-32,75],[-42,48],[-46,22],[-46,0]],[[6712,6045],[41,29],[58,5],[44,-9],[72,28],[60,-5],[42,-28],[31,-4],[6,-20],[70,-3],[29,-40],[21,22],[56,-13],[26,-37],[51,6],[27,-26],[0,-27],[-29,-56],[79,-62],[31,7],[-6,-43],[14,-22],[-9,-27],[88,-32],[-4,-70],[40,-35],[-56,-9],[-32,32],[-32,-26],[-36,27],[-31,0],[-26,-29],[-4,45],[-57,-21],[-4,-45],[19,-16],[-19,-52],[-49,-13],[2,-25],[-64,-44],[16,-20],[-14,-20],[-51,5],[-17,-14]],[[5344,4228],[0,-1]],[[5381,4227],[-18,37],[-33,-13],[13,-16]],[[5339,4240],[0,0]],[[5286,4240],[14,5],[9,45],[-40,15],[-5,-22]],[[5489,4569],[28,-3],[61,24],[40,-7],[40,16],[20,-14]],[[3796,2997],[-9,-11],[-45,20],[-5,22],[45,-11],[14,-20]],[[4916,4884],[6,-23],[37,-14],[50,-47],[33,-5],[22,-20],[30,7],[45,-34],[53,-18],[2,-18]],[[4966,4589],[-8,-9]],[[4956,4576],[-52,-1],[19,-28],[36,-17]],[[4957,4472],[-47,21],[-7,25],[-65,62],[-23,-5],[-23,46],[-45,-10]],[[1082,6811],[46,10],[77,-18],[41,15],[47,-9]],[[1243,6890],[-9,-19],[-70,24],[66,4],[13,-9]],[[1684,7103],[-14,-36],[-57,-15],[-30,-22],[-65,18],[-5,10],[126,56],[45,-11]],[[1455,7237],[-23,-27],[-20,13],[34,33],[9,-19]],[[1302,6809],[-77,20],[-28,-15],[-70,17],[-21,17],[27,15],[65,5],[66,-41],[44,0],[-11,18],[-61,18],[49,7],[-50,47],[23,9],[-17,32],[32,7],[89,82],[21,41],[36,114],[41,-16],[113,47],[16,31],[35,20],[94,25],[89,2],[93,12],[40,-27],[72,-26]],[[1497,7191],[14,-38],[39,-5],[-14,-24],[-47,-8],[14,-45],[-30,-16],[95,-25],[42,0],[60,34],[23,28],[-12,22],[-40,0],[-12,39],[27,17],[-76,4],[-9,54],[-74,-37]],[[1548,8755],[5,-31],[-32,7],[10,54],[17,-30]],[[1533,8887],[25,-19],[-59,3],[34,16]],[[1601,8880],[-45,-2],[-14,28],[33,12],[26,-38]],[[1641,8945],[-32,-41],[-37,25],[69,16]],[[1504,9007],[-7,-32],[-32,24],[4,37],[35,-29]],[[1487,9057],[44,-18],[-20,-12],[-24,30]],[[1645,9045],[-46,-8],[-40,26],[88,32],[-2,-50]],[[1470,9394],[65,-12],[-51,-13],[-51,12],[37,13]],[[1652,9493],[22,-17],[-63,-9],[6,24],[35,2]],[[1739,9505],[-47,-23],[-14,32],[31,11],[30,-20]],[[1941,9599],[-53,-18],[5,19],[48,-1]],[[2130,9670],[-38,-18],[-36,15],[74,3]],[[2253,9704],[-63,5],[44,15],[19,-20]],[[2324,9726],[20,-17],[-54,-1],[-16,25],[50,-7]],[[2231,9749],[-71,7],[1,13],[70,10],[0,-30]],[[2441,9826],[34,-30],[-169,-25],[-32,9],[65,33],[102,13]],[[2400,9863],[7,-21],[-85,-14],[-49,5],[127,30]],[[3691,9998],[4,-46],[-51,-39],[-170,20],[-61,-8],[-73,-25],[-94,-74],[-30,-14],[8,-35],[-51,-41],[56,-71],[-29,-19],[13,-46],[-16,-37],[55,-86],[-38,-125],[62,-35],[40,-5],[74,-49],[-50,-79],[-97,-6],[23,-64],[53,-59],[0,-30],[-26,-24],[6,-44],[-89,-54],[-71,-6],[10,-41],[-52,-36],[32,-76],[-35,-81],[-52,-6],[-3,24]],[[3039,8681],[-16,27],[-133,15],[-55,64],[15,42],[-24,32],[32,46],[-52,-15],[10,-40],[24,-20],[-18,-18],[-74,6],[59,-36],[-2,-40],[-27,5],[-32,-59],[-65,-18],[-79,43],[23,-28],[-49,-29],[-55,-4],[37,-12],[-61,-40],[-60,-22],[-5,-17],[-104,-63],[-24,3],[-67,-41],[-23,30],[-27,-35],[-82,-15],[-140,3],[-111,19],[38,28],[-72,12],[-97,29],[-11,22],[-61,10],[-54,58],[23,34],[-6,35],[66,-18],[65,-29],[-53,59],[92,47],[-34,-1],[-8,32],[-37,-12],[-26,45],[-13,-26],[23,-20],[-57,-14],[-61,3],[-45,52],[73,54],[7,-49],[11,34],[39,-3],[44,25],[-57,22],[104,58],[10,30],[51,38],[70,12],[8,20],[-98,-27],[-35,-35],[-26,6],[-63,-69],[-12,46],[-37,-7],[19,54],[-54,-58],[-45,19],[-11,44],[29,2],[2,32],[65,-28],[32,14],[10,61],[-108,-39],[-77,54],[78,-17],[31,-20],[-34,47],[-60,6],[-7,49],[29,8],[72,-13],[41,16],[120,8],[40,-16],[68,11],[13,18],[86,-21],[95,13],[3,12],[-103,-19],[-11,12],[-94,24],[-16,-36],[-119,14],[-98,-10],[-39,-12],[-57,35],[-45,7],[28,40],[53,16],[-35,28],[-43,10],[5,27],[85,24],[14,17],[133,-18],[-53,14],[57,5],[-108,5],[-87,-10],[55,34],[-67,18],[18,26],[65,-37],[-5,30],[103,5],[65,-30],[-48,35],[25,20],[160,35],[-107,4],[69,17],[-65,-2],[13,20],[148,11],[105,-15],[39,20],[133,26],[-167,-23],[-17,14],[-83,-4],[10,28],[-33,17],[95,26],[56,-26],[115,16],[43,-39],[100,-33],[-93,41],[-8,25],[-45,19],[13,18],[50,-17],[3,29],[75,-4],[16,17],[-33,22],[55,8],[-15,16],[58,2],[33,17],[17,-36],[84,14],[-65,22],[49,23],[80,20],[63,-53],[-30,-24],[64,-1],[-1,28],[50,7],[123,-12],[-34,32],[88,42],[99,16],[-7,16],[-73,0],[27,23],[66,19],[-57,2],[-94,-33],[44,-8],[-35,-32],[-58,-11],[-61,-27],[-106,-21],[-44,49],[56,22],[-117,-29],[0,27],[148,47],[-53,-1],[57,58],[77,24],[-10,14],[891,1]],[[5016,7567],[3,-1]],[[5019,7566],[-43,-20],[-52,-9],[38,-14],[81,27],[9,12]],[[5052,7562],[370,-12],[342,-11],[16,4]],[[5983,6845],[23,-27],[-16,-16],[56,-47],[11,-36],[53,-41],[-41,-7],[29,-23],[7,-43],[-31,-33],[-65,-5],[-148,-106],[-111,-104],[18,-34],[-2,-54],[35,-21],[1,-22],[-77,18]],[[5725,6244],[-36,5],[-91,30],[-5,17],[-42,24],[-53,12],[-42,-4],[-40,10],[-87,-40],[-51,27],[-36,-7],[-54,5],[-46,-21],[-14,-31],[-32,12],[-37,-10],[-6,52],[-32,0],[-47,48],[-49,-21],[-14,-27],[-53,0],[1,23],[-31,5]],[[3723,7381],[6,11],[54,-19],[26,42],[-102,9]],[[3710,7440],[38,-5],[100,29],[328,62],[48,17],[40,43],[106,18],[97,35],[132,18],[105,4],[61,-71],[4,-28],[100,-22],[91,8],[56,19]],[[8547,1884],[68,65]],[[8876,1994],[-20,-7],[-17,-30],[-2,-31]],[[7095,5358],[32,-34],[59,-18],[49,-4],[9,23],[38,0],[87,29],[77,-24],[2,-32]],[[7448,5298],[4,-17],[-15,-73],[-111,-17],[-37,-23],[24,72],[-31,8],[-25,-17],[16,-45],[-31,-9],[-6,-18],[33,8],[-45,-28],[3,-20],[40,24],[-63,-61],[-5,-45],[10,-37],[-22,-64]],[[5762,5055],[-52,62],[22,19],[48,7],[-82,37],[-26,-12],[-32,-42],[-15,-3],[-29,36],[-36,12],[-37,-5],[-26,21],[-61,17],[43,12],[-41,27],[34,38],[-124,46],[-53,39],[4,65],[-16,-6],[-37,41],[-50,19],[-26,31]],[[5807,5968],[35,9],[23,27],[59,-24],[102,-2],[109,-23],[75,13],[86,-58],[54,15],[34,32],[209,19],[32,23],[11,35],[76,11]],[[5052,7562],[157,61],[-55,3],[-52,-12],[-83,-48]],[[5016,7567],[68,50],[18,28],[-6,40],[103,1],[65,27],[71,57]],[[5350,7767],[-111,-75],[133,-16],[37,10],[-12,63],[21,13]],[[7047,8765],[23,-4]],[[9947,4848],[-28,27],[-37,18],[-94,81],[-51,31],[-34,31],[-92,45],[-101,18],[-30,38],[-17,0],[-50,41],[5,-23],[-78,11],[-26,16],[-15,41],[-28,20],[-85,29],[-34,-1],[-27,24],[88,18],[-39,4],[10,37],[74,-27],[-12,-24],[104,31],[53,-14],[-11,65],[-25,-34],[3,53],[55,26],[27,66],[24,9],[10,-32],[21,47],[25,4],[43,-26],[26,21],[-62,25],[-56,45],[-23,-10],[-35,28],[-22,49],[59,-14],[70,28],[11,-14],[63,-5],[-42,41],[97,18],[66,34],[45,-6],[15,22],[-14,40],[-43,6],[-36,-23],[-102,-18],[-73,-4]],[[9519,5761],[20,43],[-26,10],[39,71],[92,16],[15,36],[20,11],[52,-8],[161,1],[1,43],[56,65],[-43,8],[26,17],[-28,51],[-43,1],[18,39],[60,25],[-41,9],[-25,32],[58,8],[8,19],[44,27],[6,20],[-28,34],[21,31],[-27,7],[-52,-17],[-44,18],[-15,27],[-56,1],[-35,32],[-60,-13],[-62,27],[-78,16],[-14,20],[-30,0],[-2,-31],[-40,-10],[-21,27],[-45,18],[-34,34],[3,18],[-40,33],[-58,-16],[-84,-10],[-51,-27],[-55,23],[-34,-5],[-40,34],[-69,0],[-35,-20],[-55,34],[-17,36],[22,11],[-46,80],[-26,11],[-19,39],[-35,4],[-48,-12],[-31,14],[-105,7],[23,11],[-16,18],[2,36],[-23,41],[60,6],[2,26],[-70,34],[-6,49],[-65,50],[-66,-16],[-12,17],[-69,3],[-69,-33],[-93,20],[-42,1],[-18,-54],[-89,-18],[-35,18]],[[6960,8438],[57,-10],[15,-25],[45,0],[8,35],[-51,42],[-82,-10],[-18,44],[61,39],[4,86],[-21,43]],[[7009,8723],[25,28],[67,6],[-11,13]],[[7051,8801],[13,24],[-16,44],[20,10],[70,-33],[34,49],[48,-19],[71,17],[27,34],[35,1],[224,-29],[5,30],[-64,7],[-24,33],[-36,9],[-68,-8],[-98,7],[-48,40],[-50,7],[-41,42],[59,-26],[-7,56],[-61,-4],[-14,-18],[-75,-17],[-55,7]],[[7554,9998],[1264,0],[7,-15],[112,12],[40,-36],[63,-18],[13,-28],[100,-21],[119,-8],[23,-18],[77,-1],[12,21],[79,11],[25,21],[-45,52],[10,28],[546,0],[0,-5103]],[[9999,2044],[0,-2044],[-412,0],[-11,34],[-21,23],[-44,24],[-25,24],[-52,19],[-46,35],[-37,-5],[-22,25],[6,18],[-74,99],[26,6],[0,64],[-37,46],[-7,28],[-34,53],[-29,27],[-22,-1],[-15,24],[8,41],[-38,16],[-86,147],[-21,18],[-16,36],[-29,24],[-27,36],[-4,21],[-63,70],[-7,28],[-41,60],[-39,32],[12,13],[-39,14],[-30,-10],[-53,16],[-18,-26],[-15,18],[21,16],[35,87],[-6,34],[16,52],[2,41],[23,75]],[[5725,6244],[-43,-55],[-19,-45],[-35,-22],[-1,-41]],[[3560,5365],[29,25]],[[4403,8276],[-2,-29],[-47,-63],[-57,-100],[-35,-79],[-20,0],[-3,75],[54,80],[23,5],[87,111]],[[4817,8398],[12,18],[39,0],[-13,-45],[-30,2],[-14,-30],[7,-41],[29,-2],[-137,-88],[-11,-35],[-39,-5],[15,36],[-21,109],[85,72],[68,28],[10,-19]],[[3112,8452],[-35,-31],[-22,28],[57,3]],[[3124,8498],[4,-30],[-73,-10],[-18,19],[58,30],[29,-9]],[[4792,8814],[-31,-27],[-11,14],[42,13]],[[3691,9998],[1739,0],[-90,-55],[-41,-64],[-95,-48],[-88,-7],[-65,-30],[-16,-23],[-26,22],[-22,-26],[-50,11],[-3,-29],[-33,-8],[-24,-31],[-31,21],[-36,-6],[-78,-56],[10,-34],[-46,0],[-22,-25],[-65,11],[28,-48],[-36,-24],[-80,-21],[-30,23],[-24,-9],[5,-35],[36,-34],[-14,-54],[-26,-18],[13,-50],[-83,-34],[30,-24],[-18,-21],[24,-15],[-9,-85],[35,-61],[-29,-10],[113,-23],[-5,-23],[68,21],[12,-22],[51,-28],[65,-14],[28,-28],[-35,-8],[97,-19],[20,-42],[21,-6],[-48,-35],[61,2],[-69,-23],[-28,-27],[-55,-23],[-90,-23],[106,-12],[-13,22],[51,-30],[-87,0],[35,-42],[-99,-24],[-27,-32],[-31,11],[-4,41],[-35,-8],[4,-43],[-66,-41],[-54,-4],[-50,-27],[-168,11],[124,-18],[47,-26],[-68,-19],[34,-22],[-5,-48],[-39,18],[33,-44],[-23,-8],[24,-28],[-82,4],[66,-41],[-41,-34],[41,-28],[-35,-22],[-20,-51],[29,-32],[-55,-71],[6,-21],[-33,-7],[-50,-95],[-45,-42],[-6,18],[-62,11],[-50,-16],[-99,9],[-61,-3],[16,-33],[-66,2],[-70,-54],[-3,-22],[41,-50],[-44,-32],[-61,10],[-68,-4],[-89,-18],[-73,14],[-15,36],[35,31],[-34,19],[-76,90],[-25,39],[46,-13],[34,10],[-52,37],[73,17],[-9,37],[-37,2],[-32,43],[-62,30],[-30,37],[-40,91],[-29,-25],[-4,64],[-51,25],[23,13],[-35,16],[35,45],[10,42],[-28,33],[-54,-12],[40,35],[-28,3],[-14,-30],[-19,29],[-48,-21],[18,31],[-28,65],[5,46],[-22,7],[21,32],[31,4],[28,-26]],[[8975,2704],[-25,67],[7,47],[17,19],[-11,54],[-44,36],[25,45],[-10,25],[27,18]],[[8961,3015],[60,-25],[9,32],[39,12],[4,56],[70,0],[-32,63],[18,65],[13,19],[65,-14],[21,-30],[55,3],[50,-5],[35,19],[55,11],[98,36],[74,-18],[47,-34],[74,2],[51,-11],[127,20],[105,38]],[[9999,3254],[0,-689]],[[2916,2518],[32,-23],[-41,-35],[-39,18],[1,38],[47,2]],[[3001,2731],[-36,-25],[29,40],[7,-15]],[[2353,3266],[73,20],[32,32],[42,20],[32,0],[97,27],[28,-4],[-21,-29],[26,-16],[0,29],[43,1],[52,-22],[-22,-37],[40,-36],[-18,-17],[40,-20],[31,32],[40,9],[73,47],[25,-54],[-28,-20],[-53,-82],[-61,-18],[-17,-40],[9,-59],[25,-34],[54,-18],[-1,-16],[52,-21],[-3,-68],[29,-24],[-59,-70],[0,-20],[-81,-84],[-37,-9],[-73,-41],[-27,-59],[13,-34],[63,-61],[38,-13],[55,15],[0,-56],[47,14],[17,25],[32,-25],[-5,-20],[19,-30],[2,-30],[79,-8]],[[6554,4055],[-53,-14],[-20,6],[23,21],[38,9],[12,-22]],[[6958,4179],[23,-5],[-30,-15],[-19,15],[26,5]],[[7051,4502],[-11,-37],[27,-44],[36,-31],[37,-17],[127,-45],[48,-7],[-30,-58],[-39,-10],[-48,2],[-94,28],[-61,-14],[-6,-12],[-44,8],[-61,-5],[-24,-39],[-60,-48],[-32,-5],[-88,-39],[-16,-23],[-66,-40],[8,-11],[-53,-25],[28,43],[-15,23],[93,46],[56,23],[-9,14],[-69,-15],[-104,4],[-8,31]],[[8961,3015],[16,25],[-45,74],[31,30],[65,39],[3,45],[-34,33],[-18,-1],[-43,-35],[-30,-2],[-25,-20],[11,-20],[-29,4],[-39,-20],[-147,70],[-46,-14],[-58,-39],[-56,-47],[1,-22],[-28,-26],[-26,21],[-37,-30],[-37,-15],[-101,2],[-11,-13],[-36,6],[-33,-18],[-71,18],[-35,19],[-82,90],[-51,11],[-115,54],[-158,20],[-21,-13],[-11,-49],[4,-27],[-23,-32],[11,-14],[-29,-23],[-36,14],[-35,-16],[-46,-5],[-60,-24],[-17,20],[-46,16],[-15,-9],[-49,29],[-7,50],[-23,9],[20,16],[-40,23],[-23,-30],[-55,18],[-10,29],[-46,10],[3,-18],[-39,6],[13,-18],[-49,-23],[-11,19],[20,18],[-50,-14],[-48,5],[-12,-25],[-64,2],[-12,12],[128,24],[34,-7],[0,34],[39,5],[31,27],[-82,-5],[-100,-15],[-30,14],[-43,-15],[-8,24],[38,22],[22,-16],[32,27],[2,18],[-38,-1],[-31,21],[-34,1],[5,56],[-48,20],[52,14],[11,50],[-79,34],[-18,-7],[-27,43],[-30,-2],[-7,-23],[-56,31],[-34,9],[19,16],[39,7],[-21,21],[-8,52],[32,0],[36,-39],[-12,-11],[21,-37],[0,23],[29,-11],[87,25],[-53,-7],[-44,45],[-4,29],[47,6],[-8,15],[40,16],[-5,14],[-45,-7],[-12,29],[18,9],[-66,50],[78,52],[-9,25],[-106,-16],[-23,-9],[-69,-2],[18,36],[0,77],[12,18],[37,10],[13,35],[23,6],[52,43],[67,0],[25,15],[50,1],[8,-21],[28,-12],[82,0],[-26,45],[12,6],[73,-14],[-32,-18],[139,0],[39,-9],[37,9],[63,-9],[24,18],[-20,12],[-36,-3],[-35,13],[51,30],[72,5],[55,15],[12,-9],[88,5],[-62,18],[-75,-6],[-22,27],[-57,27],[-5,11],[29,45],[25,8],[158,-23],[61,-1],[32,16],[136,-32],[81,3],[54,24],[3,32],[62,20],[121,52],[25,27],[33,5],[58,25],[70,9],[96,34],[244,-18],[27,7],[61,-7],[47,14],[14,24],[41,-24],[-6,-19],[50,-52],[67,-21],[97,24],[35,-24],[3,-41],[29,-28],[48,-26],[41,33],[52,-6],[36,-14],[13,-28],[54,-8],[59,-26],[25,1],[20,22],[27,-23],[128,-31],[91,9],[53,22],[55,9],[33,-6],[31,14],[42,-21],[69,-18],[29,7],[49,-10],[0,-994]],[[8169,5505],[83,-2],[14,-9],[-97,11]],[[9519,5761],[-18,-16],[-17,15],[-87,-6],[-32,4],[-59,-52],[-18,14],[-78,-23],[-27,-27],[-47,12],[-64,-17],[-25,-22],[-19,12],[-69,-4],[-135,-72],[-43,32],[8,-27],[-30,-27],[-41,-4],[-23,-19],[15,-63],[41,-61],[70,-74],[36,-18],[52,8],[29,32],[50,-23],[28,23],[35,4],[61,-17],[-24,-33],[5,-44],[-56,-21],[-43,10],[-48,-14],[-52,29],[-55,-13],[-9,-28],[-23,5],[-47,-42],[-18,11],[-60,-5],[-70,-22],[-33,-46],[-95,-40],[-53,6],[-34,24],[-48,15],[41,13],[-1,55],[18,22],[-14,41],[-40,23],[-33,-8],[-88,48],[-94,-2],[4,29],[99,50],[80,22],[52,25],[51,1],[12,22],[-29,1],[7,33],[-13,17],[-42,-26],[-31,21],[-66,8],[-1,-11],[-61,3],[-63,-15],[-59,12],[2,20],[-37,2],[-77,32],[64,12],[-13,14],[-104,23],[124,-8],[65,-11],[17,19],[-44,15],[-26,-11],[-29,17],[-21,42],[-17,-5],[11,-30],[-80,-10],[-22,12],[-37,-16],[-43,7],[-86,-17],[-2,-28],[-73,-90],[-86,-64],[-41,5],[-9,-29],[-48,-26],[-20,41],[-11,-75],[37,-13],[-7,-46],[-17,-5]],[[7562,5582],[-4,-13],[46,-23],[29,-34],[19,13],[-21,28],[-50,35],[-19,-6]],[[8536,5557],[-4,-36],[-40,21],[-74,4],[53,-39],[13,8],[95,-18],[41,-36],[30,17],[-19,-38],[49,27],[-25,-29],[17,-16],[63,-14],[27,-51],[-19,-6],[27,-24],[72,-20],[-81,82],[-57,80],[-13,29],[-32,14],[26,13],[-29,10],[-23,-50],[-35,7],[27,29],[-49,22],[-7,-13],[-33,27]],[[8260,2699],[-18,-16],[-6,22],[-37,-1]]],\"transform\":{\"scale\":[0.004132413241324132,0.004072407240724072],\"translate\":[-1.12,23.64]}},\"route\":{\"type\":\"Topology\",\"bbox\":[10.7799,37.908965,28.647618333,52.50215],\"objects\":{\"route\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"LineString\",\"arcs\":[0]}]}},\"arcs\":[[[13.430658333,52.478893333],[13.43059,52.478403333],[13.426451667,52.476983333],[13.42838,52.472818333],[13.432026667,52.466558333],[13.433493333,52.4665],[13.440293333,52.467473333],[13.441761667,52.467403333],[13.442495,52.46547],[13.444983333,52.462715],[13.449616667,52.463403333],[13.452478333,52.463553333],[13.45447,52.463111667],[13.455871667,52.461011667],[13.460123333,52.456006667],[13.462111667,52.452788333],[13.4653,52.449803333],[13.472421667,52.446095],[13.489973333,52.437818333],[13.499236667,52.433375],[13.505445,52.429953333],[13.50858,52.428776667],[13.516243333,52.427866667],[13.520096667,52.426603333],[13.521606667,52.424935],[13.521905,52.420485],[13.52354,52.411535],[13.522971667,52.409486667],[13.521453333,52.406348333],[13.520635,52.402116667],[13.518745,52.398761667],[13.519465,52.396113333],[13.526091667,52.389815],[13.531068333,52.38629],[13.533926667,52.384788333],[13.539798333,52.38099],[13.544301667,52.37659],[13.546976667,52.372806667],[13.54824,52.369605],[13.54852,52.366803333],[13.547985,52.362746667],[13.548628333,52.35871],[13.553186667,52.350833333],[13.554891667,52.346843333],[13.555126667,52.342306667],[13.553795,52.33454],[13.55367,52.329926667],[13.55477,52.314725],[13.555775,52.30631],[13.55635,52.299363333],[13.557113333,52.296225],[13.558135,52.29407],[13.567103333,52.280328333],[13.589033333,52.246225],[13.59091,52.242281667],[13.595578333,52.22419],[13.597005,52.220878333],[13.599996667,52.217276667],[13.606371667,52.210543333],[13.607671667,52.20899],[13.613123333,52.201293333],[13.614291667,52.199155],[13.615195,52.196475],[13.615795,52.1908],[13.616305,52.188423333],[13.617606667,52.185756667],[13.62378,52.177341667],[13.626348333,52.17483],[13.629036667,52.172956667],[13.63665,52.168653333],[13.63992,52.16656],[13.641891667,52.164875],[13.645815,52.160486667],[13.647623333,52.157673333],[13.648733333,52.153878333],[13.6491,52.148846667],[13.64887,52.14511],[13.646498333,52.125361667],[13.646345,52.111015],[13.648328333,52.090838333],[13.649788333,52.077851667],[13.6516,52.068543333],[13.652181667,52.066325],[13.653823333,52.057388333],[13.655248333,52.054013333],[13.656716667,52.05194],[13.667493333,52.040695],[13.685893333,52.021875],[13.688303333,52.019803333],[13.692501667,52.017203333],[13.714046667,52.007025],[13.716768333,52.005396667],[13.719768333,52.002976667],[13.722303333,51.999993333],[13.726771667,51.991846667],[13.728105,51.98975],[13.730276667,51.987503333],[13.745461667,51.97507],[13.751261667,51.971748333],[13.755801667,51.969685],[13.75938,51.967603333],[13.761571667,51.965908333],[13.764346667,51.962838333],[13.765995,51.959941667],[13.766853333,51.956091667],[13.766511667,51.952671667],[13.763561667,51.943303333],[13.762958333,51.939615],[13.763261667,51.936796667],[13.764405,51.93398],[13.765703333,51.931973333],[13.76837,51.929235],[13.772043333,51.926506667],[13.783393333,51.918686667],[13.792011667,51.912965],[13.802986667,51.906338333],[13.807881667,51.903253333],[13.81632,51.897278333],[13.820423333,51.894911667],[13.823315,51.893738333],[13.8331,51.890453333],[13.836895,51.889363333],[13.851156667,51.88615],[13.863073333,51.88359],[13.869281667,51.882075],[13.878738333,51.88004],[13.883595,51.878496667],[13.88708,51.87705],[13.891983333,51.874235],[13.895563333,51.871411667],[13.897791667,51.86902],[13.899368333,51.866678333],[13.906321667,51.854675],[13.90872,51.852306667],[13.914596667,51.84808],[13.916838333,51.847045],[13.932985,51.841233333],[13.9386,51.840108333],[13.953416667,51.839573333],[13.95633,51.839363333],[13.96012,51.838155],[13.96481,51.836261667],[13.97449,51.83364],[13.980546667,51.832228333],[13.990741667,51.829643333],[14.002515,51.826363333],[14.006001667,51.82474],[14.019045,51.816646667],[14.044373333,51.800626667],[14.057545,51.791961667],[14.060058333,51.789865],[14.067215,51.782863333],[14.06892,51.78146],[14.073096667,51.779148333],[14.098883333,51.769633333],[14.105076667,51.766803333],[14.108941667,51.764583333],[14.115098333,51.760531667],[14.1196,51.757826667],[14.124323333,51.755726667],[14.141708333,51.748775],[14.162341667,51.73896],[14.171686667,51.734885],[14.177433333,51.732121667],[14.181751667,51.730446667],[14.186221667,51.729181667],[14.18969,51.72867],[14.21015,51.727183333],[14.212851667,51.726843333],[14.228645,51.725421667],[14.229255,51.725466667],[14.246908333,51.724003333],[14.264266667,51.722758333],[14.270531667,51.722603333],[14.280165,51.723635],[14.286295,51.724473333],[14.29131,51.724888333],[14.294181667,51.724875],[14.298971667,51.724453333],[14.303741667,51.723571667],[14.317848333,51.719905],[14.32186,51.719003333],[14.332916667,51.71769],[14.342495,51.716888333],[14.35665,51.717063333],[14.367918333,51.717031667],[14.379353333,51.716831667],[14.38619,51.716066667],[14.39133,51.714571667],[14.394853333,51.713185],[14.403405,51.70946],[14.406495,51.708316667],[14.411075,51.707143333],[14.414506667,51.706623333],[14.42007,51.706338333],[14.42493,51.706556667],[14.440921667,51.708496667],[14.448286667,51.70963],[14.469996667,51.71326],[14.472843333,51.71362],[14.478518333,51.71367],[14.49227,51.712338333],[14.496503333,51.711781667],[14.499263333,51.711751667],[14.514976667,51.710158333],[14.5198,51.70958],[14.524838333,51.709335],[14.534618333,51.709086667],[14.54444,51.708621667],[14.548173333,51.708793333],[14.558688333,51.709675],[14.576501667,51.710923333],[14.584276667,51.71168],[14.591051667,51.712561667],[14.597416667,51.713161667],[14.601046667,51.71331],[14.60455,51.713015],[14.623921667,51.708678333],[14.633431667,51.706728333],[14.638753333,51.705326667],[14.649341667,51.70196],[14.657525,51.698986667],[14.662703333,51.696338333],[14.676663333,51.688208333],[14.692866667,51.67869],[14.699316667,51.675045],[14.703655,51.67311],[14.711678333,51.670568333],[14.720796667,51.668523333],[14.728088333,51.667193333],[14.739936667,51.666123333],[14.744981667,51.666253333],[14.767623333,51.667803333],[14.782761667,51.668713333],[14.788103333,51.668626667],[14.792761667,51.66804],[14.79891,51.666435],[14.803761667,51.664341667],[14.825941667,51.649426667],[14.831716667,51.646956667],[14.838456667,51.645366667],[14.855881667,51.64299],[14.862066667,51.641466667],[14.865981667,51.639883333],[14.871248333,51.636586667],[14.880156667,51.628955],[14.88327,51.626815],[14.88804,51.624565],[14.891591667,51.623416667],[14.90716,51.619341667],[14.925043333,51.614785],[14.92953,51.614016667],[14.936263333,51.61356],[14.947053333,51.612648333],[14.959465,51.61171],[14.97693,51.608316667],[14.981636667,51.606841667],[14.985328333,51.605151667],[14.987626667,51.603771667],[14.99812,51.596056667],[15.001251667,51.59413],[15.013671667,51.589156667],[15.01775,51.587013333],[15.020435,51.585053333],[15.037945,51.569421667],[15.040425,51.567635],[15.044008333,51.565975],[15.047558333,51.56487],[15.066031667,51.561],[15.073458333,51.558728333],[15.0801,51.556886667],[15.085936667,51.554658333],[15.092328333,51.551606667],[15.095941667,51.550138333],[15.107113333,51.546803333],[15.13807,51.537796667],[15.151991667,51.533603333],[15.15917,51.53192],[15.176771667,51.528593333],[15.181146667,51.528131667],[15.186605,51.528103333],[15.1981,51.52851],[15.203073333,51.528973333],[15.206975,51.528353333],[15.21211,51.526871667],[15.215613333,51.525118333],[15.216291667,51.523805],[15.217138333,51.524516667],[15.222956667,51.522168333],[15.22874,51.5193],[15.232023333,51.517151667],[15.236535,51.512931667],[15.239458333,51.509271667],[15.253351667,51.490621667],[15.25539,51.488318333],[15.263116667,51.481628333],[15.26852,51.477951667],[15.27255,51.47576],[15.280455,51.472463333],[15.300713333,51.464716667],[15.313605,51.45999],[15.316983333,51.45865],[15.323735,51.456325],[15.325868333,51.455393333],[15.333681667,51.451188333],[15.348356667,51.444313333],[15.367658333,51.434766667],[15.371886667,51.433261667],[15.374931667,51.432548333],[15.381871667,51.431848333],[15.385313333,51.431756667],[15.38556,51.432151667],[15.391433333,51.431661667],[15.399391667,51.431873333],[15.407131667,51.431405],[15.420311667,51.429005],[15.424656667,51.42807],[15.434038333,51.426526667],[15.44624,51.424245],[15.454298333,51.422905],[15.460968333,51.421631667],[15.4723,51.419663333],[15.481003333,51.417675],[15.49113,51.414195],[15.502188333,51.409005],[15.516893333,51.401536667],[15.52285,51.398625],[15.526816667,51.39627],[15.539825,51.387618333],[15.55081,51.380126667],[15.560866667,51.373465],[15.566931667,51.369643333],[15.572896667,51.36664],[15.587675,51.359941667],[15.607131667,51.351315],[15.61344,51.348001667],[15.635155,51.334086667],[15.641221667,51.330055],[15.644688333,51.327356667],[15.64684,51.326336667],[15.65355,51.324591667],[15.658105,51.321601667],[15.679995,51.310958333],[15.685631667,51.308871667],[15.689036667,51.308318333],[15.698673333,51.306415],[15.716438333,51.303181667],[15.742738333,51.298145],[15.748135,51.29695],[15.753751667,51.295381667],[15.759675,51.293393333],[15.765186667,51.290988333],[15.7711,51.287778333],[15.788953333,51.276863333],[15.796046667,51.27315],[15.810576667,51.267155],[15.835206667,51.257151667],[15.838321667,51.25612],[15.848615,51.253465],[15.850163333,51.252943333],[15.860403333,51.2503],[15.865976667,51.24874],[15.873128333,51.247253333],[15.891961667,51.240805],[15.905183333,51.236368333],[15.920718333,51.231015],[15.926885,51.229993333],[15.937543333,51.229015],[15.954808333,51.22703],[15.965458333,51.22529],[15.9709,51.223376667],[15.979741667,51.21928],[15.984351667,51.216713333],[15.986955,51.214666667],[15.994576667,51.207015],[15.99778,51.204548333],[16.001585,51.202463333],[16.00571,51.200626667],[16.01392,51.197926667],[16.019021667,51.195526667],[16.026888333,51.190766667],[16.041961667,51.181855],[16.048436667,51.178265],[16.052603333,51.176536667],[16.055825,51.175735],[16.07094,51.172993333],[16.078426667,51.17151],[16.087335,51.169978333],[16.105635,51.166526667],[16.128043333,51.16253],[16.134766667,51.16177],[16.16011,51.161325],[16.176478333,51.160701667],[16.181221667,51.160611667],[16.188746667,51.1602],[16.204361667,51.157606667],[16.21087,51.156368333],[16.223451667,51.154365],[16.231418333,51.1532],[16.235481667,51.15232],[16.244711667,51.151053333],[16.248806667,51.150178333],[16.256991667,51.149015],[16.261391667,51.148143333],[16.267971667,51.145986667],[16.277106667,51.142431667],[16.284181667,51.13934],[16.292011667,51.136333333],[16.303385,51.131768333],[16.307885,51.130336667],[16.31721,51.129211667],[16.329943333,51.128778333],[16.33489,51.128916667],[16.336376667,51.128575],[16.342035,51.128348333],[16.349556667,51.127675],[16.355106667,51.126915],[16.365491667,51.12431],[16.371226667,51.12199],[16.382443333,51.116155],[16.391628333,51.111713333],[16.396423333,51.109],[16.399036667,51.106855],[16.401908333,51.103998333],[16.404488333,51.100973333],[16.40774,51.095338333],[16.41079,51.091803333],[16.41729,51.08695],[16.419748333,51.085391667],[16.426145,51.082783333],[16.434796667,51.080493333],[16.436193333,51.079796667],[16.452618333,51.075298333],[16.455113333,51.074091667],[16.45909,51.072683333],[16.462455,51.071908333],[16.470765,51.06881],[16.474295,51.067745],[16.48068,51.066401667],[16.495465,51.064543333],[16.502206667,51.063816667],[16.510271667,51.062736667],[16.533711667,51.056931667],[16.553613333,51.051878333],[16.559656667,51.050496667],[16.563103333,51.049938333],[16.578768333,51.047025],[16.584731667,51.045695],[16.595313333,51.042763333],[16.602391667,51.040951667],[16.611718333,51.038051667],[16.620475,51.035661667],[16.625083333,51.034545],[16.647476667,51.030526667],[16.660578333,51.02807],[16.664428333,51.027203333],[16.675843333,51.023683333],[16.686623333,51.020645],[16.690563333,51.019775],[16.697046667,51.019016667],[16.700581667,51.01889],[16.71526,51.019616667],[16.722158333,51.019443333],[16.729716667,51.01951],[16.735075,51.019796667],[16.736948333,51.019465],[16.739966667,51.019971667],[16.744801667,51.020023333],[16.75133,51.020478333],[16.755838333,51.021048333],[16.764566667,51.02184],[16.775963333,51.022413333],[16.783043333,51.024516667],[16.786433333,51.026023333],[16.793846667,51.030506667],[16.797973333,51.0325],[16.804205,51.034286667],[16.811478333,51.03516],[16.823146667,51.035031667],[16.83134,51.034813333],[16.834541667,51.03504],[16.842183333,51.035053333],[16.852111667,51.034701667],[16.857806667,51.03473],[16.861161667,51.035211667],[16.863526667,51.034971667],[16.873933333,51.035878333],[16.885066667,51.037083333],[16.891573333,51.038191667],[16.90227,51.038821667],[16.90403,51.039278333],[16.90836,51.039345],[16.914165,51.040081667],[16.916545,51.0408],[16.924296667,51.042286667],[16.93593,51.045006667],[16.940233333,51.046135],[16.954323333,51.049446667],[16.960166667,51.050365],[16.96508,51.050495],[16.967953333,51.050293333],[16.972841667,51.049475],[16.976575,51.048323333],[16.976806667,51.047308333],[16.975495,51.04724],[16.972405,51.04825],[16.972106667,51.048803333],[16.975405,51.051746667],[16.987861667,51.058896667],[16.992168333,51.060358333],[16.996243333,51.061283333],[17.00128,51.063411667],[17.004031667,51.067285],[17.005681667,51.070965],[17.007476667,51.074046667],[17.007648333,51.078106667],[17.008691667,51.080911667],[17.011921667,51.08601],[17.013523333,51.087646667],[17.017926667,51.0902],[17.018031667,51.091541667],[17.028723333,51.100431667],[17.029716667,51.10283],[17.031451667,51.104543333],[17.03332,51.105226667],[17.034011667,51.106933333],[17.03759,51.107431667],[17.039185,51.109088333],[17.040688333,51.10955],[17.04115,51.110881667],[17.044051667,51.110503333],[17.049301667,51.11468],[17.045276667,51.110828333],[17.043946667,51.11188],[17.044708333,51.110055],[17.042003333,51.11172],[17.044251667,51.111363333],[17.044296667,51.110495],[17.039123333,51.11691],[17.036486667,51.118571667],[17.035823333,51.119495],[17.017843333,51.141346667],[17.02322,51.134488333],[17.035961667,51.119395],[17.059381667,51.0943],[17.037406667,51.118116667],[17.042775,51.111876667],[17.043968333,51.110763333],[17.039011667,51.110565],[17.038405,51.106916667],[17.037265,51.1041],[17.034995,51.10382],[17.031251667,51.10419],[17.030613333,51.103866667],[17.029355,51.101366667],[17.026931667,51.099488333],[17.023556667,51.096318333],[17.019928333,51.093401667],[17.018503333,51.092653333],[17.017195,51.09111],[17.015045,51.090605],[17.014926667,51.088936667],[17.012,51.086341667],[17.011543333,51.085081667],[17.008093333,51.08001],[17.00692,51.073823333],[17.00493,51.06935],[17.00394,51.068145],[17.001385,51.063856667],[17.000143333,51.062906667],[16.995011667,51.060908333],[16.993841667,51.06106],[16.9596,51.015221667],[16.959413333,51.015023333],[17.058636667,50.98413],[17.062905,50.973626667],[17.065165,50.96771],[17.067558333,50.964208333],[17.070008333,50.96188],[17.078978333,50.955065],[17.08843,50.947723333],[17.094768333,50.943875],[17.10801,50.937283333],[17.11087,50.935686667],[17.131558333,50.922651667],[17.143035,50.915551667],[17.150486667,50.911493333],[17.15563,50.908971667],[17.158645,50.907043333],[17.169001667,50.901446667],[17.171851667,50.900173333],[17.179091667,50.8963],[17.18328,50.893558333],[17.187193333,50.89039],[17.204223333,50.877443333],[17.206173333,50.875748333],[17.212613333,50.870818333],[17.219188333,50.864738333],[17.22458,50.859225],[17.229898333,50.854233333],[17.235013333,50.851083333],[17.238886667,50.849445],[17.2455,50.84733],[17.251923333,50.845785],[17.258323333,50.843255],[17.262466667,50.841363333],[17.26638,50.839903333],[17.27786,50.836806667],[17.278993333,50.836108333],[17.284071667,50.834396667],[17.288755,50.831345],[17.296753333,50.825265],[17.298795,50.823358333],[17.30575,50.818058333],[17.308646667,50.815555],[17.313715,50.810361667],[17.321651667,50.80165],[17.329671667,50.79317],[17.331803333,50.791346667],[17.35186,50.780193333],[17.357983333,50.777221667],[17.363146667,50.77526],[17.373155,50.772296667],[17.3765,50.771493333],[17.384146667,50.770141667],[17.391265,50.769425],[17.398276667,50.769191667],[17.402763333,50.76864],[17.409,50.766888333],[17.413001667,50.765153333],[17.416633333,50.76317],[17.429925,50.756768333],[17.435858333,50.753761667],[17.448465,50.746933333],[17.455863333,50.743213333],[17.46215,50.740846667],[17.463876667,50.74052],[17.472191667,50.738206667],[17.475933333,50.737496667],[17.488581667,50.735946667],[17.492273333,50.735251667],[17.498115,50.7338],[17.501806667,50.732576667],[17.506141667,50.730826667],[17.508978333,50.729363333],[17.517538333,50.725476667],[17.521723333,50.724273333],[17.5296,50.722456667],[17.53456,50.721573333],[17.55647,50.717086667],[17.563311667,50.715993333],[17.569083333,50.714818333],[17.57367,50.714221667],[17.584818333,50.712125],[17.598206667,50.70996],[17.605186667,50.708593333],[17.611366667,50.706358333],[17.614585,50.704488333],[17.621345,50.698766667],[17.623805,50.696263333],[17.63128,50.690475],[17.640766667,50.684223333],[17.64493,50.681688333],[17.654665,50.676616667],[17.661371667,50.673601667],[17.661938333,50.673635],[17.67453,50.668341667],[17.685095,50.66513],[17.695245,50.661761667],[17.702616667,50.659613333],[17.708706667,50.657585],[17.714575,50.655073333],[17.723186667,50.65062],[17.729226667,50.645291667],[17.737278333,50.637193333],[17.744906667,50.631593333],[17.747683333,50.629355],[17.76845,50.616433333],[17.773646667,50.612991667],[17.777791667,50.610605],[17.785996667,50.605083333],[17.792596667,50.601063333],[17.797301667,50.597573333],[17.801046667,50.595316667],[17.803653333,50.59411],[17.80753,50.591768333],[17.812921667,50.589096667],[17.821133333,50.58551],[17.82843,50.582558333],[17.838075,50.579181667],[17.840788333,50.578035],[17.850121667,50.574533333],[17.854676667,50.572395],[17.858911667,50.570146667],[17.859396667,50.569001667],[17.862093333,50.568188333],[17.870645,50.56335],[17.882271667,50.556571667],[17.887663333,50.553005],[17.893988333,50.547551667],[17.89832,50.542825],[17.900883333,50.53976],[17.904093333,50.536446667],[17.905893333,50.534993333],[17.911113333,50.531651667],[17.915895,50.529323333],[17.922863333,50.527088333],[17.925556667,50.526495],[17.935765,50.52342],[17.936995,50.522815],[17.943206667,50.520813333],[17.946793333,50.519301667],[17.960705,50.512891667],[17.964563333,50.51014],[17.966471667,50.508101667],[17.970758333,50.501353333],[17.975285,50.49489],[17.976511667,50.493576667],[17.979165,50.491785],[17.983811667,50.489688333],[17.997306667,50.48639],[18.00335,50.484788333],[18.01164,50.482831667],[18.0171,50.482048333],[18.020308333,50.481915],[18.025235,50.482211667],[18.032621667,50.48329],[18.040638333,50.483478333],[18.046655,50.482978333],[18.054241667,50.481703333],[18.066248333,50.478521667],[18.071995,50.477561667],[18.076455,50.477245],[18.082261667,50.477278333],[18.08678,50.477638333],[18.10314,50.480055],[18.104358333,50.480025],[18.113503333,50.481325],[18.11716,50.48125],[18.122998333,50.480148333],[18.12681,50.479935],[18.131508333,50.479211667],[18.134645,50.477815],[18.13678,50.476108333],[18.13973,50.472583333],[18.143368333,50.470248333],[18.14862,50.46807],[18.151715,50.466126667],[18.154906667,50.46363],[18.156993333,50.46273],[18.161111667,50.46187],[18.166325,50.462641667],[18.1682,50.46332],[18.173091667,50.466065],[18.177555,50.467318333],[18.182031667,50.467508333],[18.202898333,50.466741667],[18.210148333,50.466395],[18.217981667,50.46522],[18.221665,50.463908333],[18.233988333,50.460251667],[18.235953333,50.459818333],[18.243175,50.45887],[18.250541667,50.458511667],[18.260951667,50.458878333],[18.271821667,50.45913],[18.278068333,50.459021667],[18.284435,50.458085],[18.291371667,50.455515],[18.301051667,50.453161667],[18.30818,50.451838333],[18.321773333,50.449761667],[18.32613,50.449265],[18.33722,50.447633333],[18.339521667,50.447155],[18.346565,50.446188333],[18.351125,50.445116667],[18.356065,50.443098333],[18.361488333,50.439358333],[18.367691667,50.43398],[18.371321667,50.431921667],[18.376588333,50.429766667],[18.388433333,50.42565],[18.393538333,50.423696667],[18.398706667,50.420128333],[18.406173333,50.414091667],[18.411495,50.410268333],[18.42264,50.40258],[18.434083333,50.39814],[18.447988333,50.392325],[18.454545,50.388985],[18.463125,50.38217],[18.46523,50.38095],[18.47518,50.376908333],[18.489368333,50.371623333],[18.504013333,50.366386667],[18.507576667,50.365198333],[18.513446667,50.362453333],[18.516765,50.360025],[18.521431667,50.355755],[18.524623333,50.353201667],[18.529133333,50.350593333],[18.533001667,50.349006667],[18.536436667,50.34805],[18.540798333,50.345645],[18.542673333,50.343295],[18.543948333,50.33934],[18.545166667,50.333481667],[18.547146667,50.326371667],[18.548318333,50.320868333],[18.550556667,50.31243],[18.552818333,50.304923333],[18.554588333,50.301411667],[18.558378333,50.295816667],[18.562883333,50.290483333],[18.566886667,50.285331667],[18.57344,50.277551667],[18.574293333,50.276093333],[18.577116667,50.272871667],[18.57953,50.27104],[18.585118333,50.268153333],[18.591165,50.266383333],[18.601895,50.264895],[18.608658333,50.264385],[18.621091667,50.262966667],[18.624965,50.262266667],[18.627803333,50.262621667],[18.63459,50.262021667],[18.63575,50.261486667],[18.65178,50.260298333],[18.658593333,50.259428333],[18.668558333,50.258545],[18.673258333,50.258928333],[18.673918333,50.259575],[18.675683333,50.259528333],[18.679058333,50.258611667],[18.6831,50.258835],[18.688215,50.259533333],[18.68987,50.259038333],[18.696256667,50.259506667],[18.707408333,50.259328333],[18.71139,50.259616667],[18.723398333,50.261425],[18.72441,50.262046667],[18.730846667,50.263333333],[18.7374,50.263886667],[18.742468333,50.265435],[18.742811667,50.265903333],[18.749908333,50.267881667],[18.752318333,50.269116667],[18.761415,50.269841667],[18.769551667,50.269403333],[18.77096,50.268545],[18.774998333,50.267346667],[18.785181667,50.263106667],[18.793126667,50.260765],[18.794221667,50.260963333],[18.799346667,50.26051],[18.800828333,50.260821667],[18.80384,50.260578333],[18.80458,50.260116667],[18.81519,50.259481667],[18.820606667,50.25954],[18.822486667,50.259896667],[18.824345,50.259593333],[18.833668333,50.259261667],[18.836141667,50.258516667],[18.841531667,50.25755],[18.848923333,50.257],[18.863286667,50.25481],[18.870073333,50.253583333],[18.873608333,50.25324],[18.882356667,50.251876667],[18.884716667,50.250978333],[18.888356667,50.249081667],[18.891193333,50.247961667],[18.896301667,50.24695],[18.904341667,50.247626667],[18.907471667,50.248275],[18.911965,50.249613333],[18.918098333,50.250793333],[18.919405,50.250733333],[18.926583333,50.251786667],[18.932026667,50.252816667],[18.935116667,50.253116667],[18.940306667,50.253198333],[18.94422,50.253716667],[18.944908333,50.254266667],[18.950493333,50.254931667],[18.951423333,50.255435],[18.96267,50.257251667],[18.964396667,50.256351667],[18.971801667,50.255923333],[18.9763,50.25543],[18.978098333,50.254238333],[18.985651667,50.252568333],[18.989045,50.252176667],[18.997415,50.250671667],[19.001016667,50.2495],[19.005276667,50.247621667],[19.008415,50.246993333],[19.02379,50.246228333],[19.033488333,50.245276667],[19.040998333,50.24393],[19.051415,50.241758333],[19.053211667,50.241691667],[19.057041667,50.2398],[19.058923333,50.238456667],[19.062861667,50.233358333],[19.064993333,50.231815],[19.06855,50.230096667],[19.069576667,50.230031667],[19.076506667,50.228083333],[19.08194,50.226086667],[19.095651667,50.221725],[19.102451667,50.219868333],[19.10549,50.219331667],[19.11259,50.218695],[19.123635,50.217318333],[19.131348333,50.215895],[19.141318333,50.213315],[19.146465,50.212296667],[19.163148333,50.2085],[19.165896667,50.205825],[19.166313333,50.204308333],[19.168153333,50.2006],[19.168555,50.19768],[19.166615,50.190758333],[19.166478333,50.186358333],[19.167338333,50.182381667],[19.168408333,50.178848333],[19.169186667,50.175105],[19.168305,50.172306667],[19.170433333,50.168516667],[19.171325,50.167508333],[19.176036667,50.159945],[19.18369,50.148275],[19.185538333,50.147093333],[19.186096667,50.145426667],[19.190928333,50.143311667],[19.193151667,50.141885],[19.194286667,50.139226667],[19.199131667,50.13064],[19.200086667,50.125283333],[19.200193333,50.121873333],[19.20087,50.115986667],[19.200711667,50.113998333],[19.202425,50.106668333],[19.202793333,50.104338333],[19.201765,50.098198333],[19.200938333,50.095245],[19.201861667,50.088245],[19.196691667,50.082231667],[19.191766667,50.077365],[19.187113333,50.07609],[19.18431,50.076176667],[19.179151667,50.07551],[19.178575,50.075203333],[19.182543333,50.072365],[19.191821667,50.064891667],[19.194215,50.06171],[19.198493333,50.056548333],[19.200241667,50.054805],[19.205256667,50.049121667],[19.208865,50.04723],[19.209336667,50.04659],[19.207658333,50.04526],[19.205275,50.044268333],[19.200771667,50.041576667],[19.20018,50.040856667],[19.194758333,50.036978333],[19.196805,50.033886667],[19.200236667,50.028133333],[19.19918,50.028076667],[19.200963333,50.033148333],[19.20074,50.034115],[19.198943333,50.027966667],[19.199763333,50.028458333],[19.198778333,50.030168333],[19.198056667,50.03259],[19.19697,50.033118333],[19.195256667,50.037085],[19.201856667,50.042285],[19.206106667,50.045081667],[19.207906667,50.045656667],[19.211538333,50.044328333],[19.21455,50.042293333],[19.214966667,50.040573333],[19.211485,50.03744],[19.21015,50.034886667],[19.212603333,50.033178333],[19.21922,50.031091667],[19.220343333,50.031001667],[19.225408333,50.028631667],[19.231563333,50.024271667],[19.233921667,50.022961667],[19.237483333,50.02206],[19.240053333,50.02196],[19.240295,50.022441667],[19.243253333,50.021313333],[19.24504,50.02112],[19.247973333,50.021653333],[19.251978333,50.02352],[19.252808333,50.024303333],[19.253316667,50.030745],[19.254436667,50.030996667],[19.270546667,50.030575],[19.285503333,50.030363333],[19.30054,50.03],[19.302863333,50.029796667],[19.304143333,50.02903],[19.307768333,50.02777],[19.314778333,50.023801667],[19.31838,50.022351667],[19.32101,50.020918333],[19.32428,50.019895],[19.325645,50.019908333],[19.332741667,50.018531667],[19.334445,50.018641667],[19.347158333,50.016118333],[19.347456667,50.016518333],[19.353353333,50.01579],[19.361006667,50.013793333],[19.36439,50.012701667],[19.373965,50.009021667],[19.37668,50.006266667],[19.381055,50.005016667],[19.385243333,50.004588333],[19.393076667,50.00437],[19.395551667,50.005078333],[19.39749,50.005158333],[19.400565,50.004255],[19.401598333,50.003466667],[19.40546,50.002221667],[19.408093333,50.001885],[19.415648333,49.999546667],[19.419823333,49.998596667],[19.423598333,49.998163333],[19.429423333,49.9981],[19.431686667,49.997785],[19.435355,49.997873333],[19.440966667,49.998758333],[19.449321667,49.999408333],[19.452146667,49.998913333],[19.458323333,49.994395],[19.459961667,49.994126667],[19.46584,49.994821667],[19.468925,49.994426667],[19.477215,49.994113333],[19.482071667,49.994286667],[19.488805,49.994258333],[19.493498333,49.993888333],[19.498683333,49.993788333],[19.502098333,49.99346],[19.506301667,49.993425],[19.509245,49.994833333],[19.511258333,49.996671667],[19.513141667,49.997023333],[19.513775,49.995831667],[19.519733333,49.991371667],[19.524728333,49.988115],[19.530086667,49.985691667],[19.532806667,49.984956667],[19.535246667,49.985825],[19.5382,49.987935],[19.540563333,49.98837],[19.543373333,49.987468333],[19.544366667,49.986556667],[19.544858333,49.983636667],[19.5457,49.982476667],[19.547878333,49.98151],[19.550018333,49.98159],[19.551725,49.980936667],[19.551276667,49.979693333],[19.559055,49.97625],[19.561436667,49.973116667],[19.56388,49.972436667],[19.56555,49.971385],[19.566748333,49.969618333],[19.570508333,49.966473333],[19.573066667,49.965731667],[19.579233333,49.966016667],[19.583073333,49.965858333],[19.585945,49.966906667],[19.588268333,49.966371667],[19.5906,49.967825],[19.593526667,49.96797],[19.606176667,49.963885],[19.61043,49.964093333],[19.612785,49.963936667],[19.617726667,49.964795],[19.627385,49.965293333],[19.632858333,49.966191667],[19.638705,49.964886667],[19.643535,49.96429],[19.649416667,49.963188333],[19.653251667,49.961903333],[19.663625,49.959596667],[19.667191667,49.959828333],[19.673421667,49.960625],[19.677536667,49.960393333],[19.681361667,49.961175],[19.685836667,49.96092],[19.689003333,49.961183333],[19.694768333,49.961213333],[19.698988333,49.960158333],[19.703893333,49.959266667],[19.708013333,49.959018333],[19.712848333,49.957726667],[19.716408333,49.958068333],[19.720173333,49.958943333],[19.723608333,49.959178333],[19.72939,49.958928333],[19.734021667,49.95837],[19.740575,49.95821],[19.746315,49.959158333],[19.748396667,49.960513333],[19.751131667,49.961048333],[19.754415,49.961015],[19.7572,49.962243333],[19.762456667,49.963451667],[19.765233333,49.964351667],[19.773048333,49.965213333],[19.775101667,49.965198333],[19.779351667,49.96629],[19.784708333,49.968461667],[19.792021667,49.970975],[19.797018333,49.972155],[19.80792,49.973558333],[19.812235,49.973635],[19.81516,49.974173333],[19.815688333,49.975555],[19.8195,49.976088333],[19.823016667,49.975885],[19.824401667,49.9754],[19.826431667,49.975688333],[19.827793333,49.975098333],[19.829301667,49.976221667],[19.830976667,49.976238333],[19.832755,49.977045],[19.835098333,49.97957],[19.838115,49.983958333],[19.838945,49.984778333],[19.844828333,49.988691667],[19.84887,49.991828333],[19.851146667,49.994703333],[19.85432,49.996825],[19.856998333,49.997941667],[19.85621,49.998846667],[19.853688333,49.999173333],[19.85219,50.001381667],[19.850455,50.008118333],[19.848393333,50.011988333],[19.845738333,50.014333333],[19.842635,50.016045],[19.833458333,50.018628333],[19.829971667,50.020233333],[19.829461667,50.022731667],[19.83377,50.024681667],[19.843451667,50.026523333],[19.847046667,50.027445],[19.850258333,50.02861],[19.854451667,50.029236667],[19.858525,50.029306667],[19.861298333,50.030513333],[19.867956667,50.032671667],[19.879393333,50.034541667],[19.881406667,50.034518333],[19.88548,50.035083333],[19.888758333,50.036403333],[19.893408333,50.036558333],[19.896931667,50.037188333],[19.899395,50.03828],[19.900381667,50.039775],[19.90255,50.041625],[19.903318333,50.043235],[19.905805,50.045071667],[19.911491667,50.046668333],[19.913491667,50.045296667],[19.916095,50.044515],[19.922943333,50.045791667],[19.928893333,50.047938333],[19.932278333,50.048636667],[19.936178333,50.050073333],[19.938555,50.050291667],[19.94191,50.051235],[19.94336,50.048306667],[19.946798333,50.04862],[19.946308333,50.047255],[19.948348333,50.046296667],[19.944623333,50.049376667],[19.945843333,50.045236667],[19.94796,50.04606],[19.946678333,50.046661667],[19.945893333,50.04872],[19.948256667,50.04725],[19.947778333,50.046765],[19.93395,50.065793333],[19.947466667,50.047861667],[19.945916667,50.048751667],[19.948113333,50.044836667],[19.946746667,50.048311667],[19.972531667,50.092796667],[19.946561667,50.047676667],[19.948031667,50.054605],[20.001895,50.065356667],[19.997676667,50.064883333],[19.99644,50.065625],[19.98577,50.063748333],[19.983955,50.06316],[19.977908333,50.06026],[19.974411667,50.059726667],[19.970485,50.060646667],[19.968366667,50.060543333],[19.96334,50.059281667],[19.960075,50.058],[19.956915,50.057651667],[19.953373333,50.058658333],[19.948636667,50.058808333],[19.94646,50.058138333],[19.941581667,50.051991667],[19.940221667,50.051015],[19.937751667,50.050678333],[19.930735,50.048628333],[19.921248333,50.045553333],[19.91651,50.04452],[19.913611667,50.045206667],[19.911565,50.046756667],[19.907533333,50.045183333],[19.905591667,50.044958333],[19.903215,50.043135],[19.901978333,50.04105],[19.899265,50.038268333],[19.896195,50.037051667],[19.89307,50.036558333],[19.888691667,50.036556667],[19.88765,50.035838333],[19.884458333,50.034798333],[19.876715,50.034138333],[19.877066667,50.035228333],[19.878535,50.036163333],[19.87813,50.037395],[19.879571667,50.035941667],[19.877908333,50.03603],[19.876643333,50.034295],[19.942646667,50.035445],[19.875126667,50.034506667],[19.880203333,50.034156667],[19.879293333,50.023055],[19.875896667,50.0346],[19.876418333,50.03408],[19.868021667,50.03266],[19.860663333,50.030073333],[19.858903333,50.029283333],[19.856808333,50.029313333],[19.850275,50.028641667],[19.843753333,50.026641667],[19.841363333,50.026343333],[19.834643333,50.024848333],[19.825898333,50.021175],[19.82728,50.020303333],[19.829936667,50.019978333],[19.83485,50.017981667],[19.84152,50.016141667],[19.845246667,50.014363333],[19.84741,50.012698333],[19.849108333,50.010833333],[19.850498333,50.007938333],[19.852371667,50.000968333],[19.853998333,49.998501667],[19.8572,49.996381667],[19.861266667,49.995131667],[19.876398333,49.992201667],[19.881641667,49.99138],[19.887048333,49.990803333],[19.895113333,49.990418333],[19.900025,49.990518333],[19.905743333,49.990948333],[19.913363333,49.991821667],[19.915138333,49.991655],[19.91563,49.989405],[19.912738333,49.98436],[19.911435,49.981628333],[19.905068333,49.9695],[19.902821667,49.96754],[19.898988333,49.966275],[19.896208333,49.96394],[19.889743333,49.960471667],[19.88839,49.958176667],[19.889951667,49.954208333],[19.889845,49.951553333],[19.891688333,49.943488333],[19.894963333,49.938581667],[19.895053333,49.93699],[19.894263333,49.935846667],[19.89022,49.93371],[19.884513333,49.928866667],[19.882593333,49.924515],[19.882096667,49.92154],[19.879181667,49.9183],[19.875466667,49.916103333],[19.870438333,49.910938333],[19.869473333,49.909401667],[19.869506667,49.906783333],[19.870723333,49.903786667],[19.87393,49.893813333],[19.874785,49.89251],[19.877788333,49.890098333],[19.879213333,49.887953333],[19.87916,49.886318333],[19.877456667,49.884671667],[19.877655,49.880161667],[19.879891667,49.878666667],[19.889713333,49.880435],[19.891756667,49.880335],[19.898561667,49.878196667],[19.902656667,49.877328333],[19.904411667,49.876351667],[19.908275,49.870971667],[19.908906667,49.86727],[19.910803333,49.86492],[19.911263333,49.863251667],[19.908711667,49.859966667],[19.908871667,49.858328333],[19.910055,49.8572],[19.916723333,49.85275],[19.924341667,49.848961667],[19.925345,49.848253333],[19.926748333,49.844873333],[19.927958333,49.84362],[19.930378333,49.84269],[19.936556667,49.842303333],[19.943678333,49.841326667],[19.945493333,49.84053],[19.948916667,49.83698],[19.951638333,49.830598333],[19.951458333,49.829001667],[19.950483333,49.82813],[19.946388333,49.826425],[19.942376667,49.825078333],[19.939446667,49.82189],[19.935245,49.819425],[19.927318333,49.816468333],[19.923015,49.813723333],[19.921868333,49.811096667],[19.922203333,49.809871667],[19.924508333,49.806933333],[19.925208333,49.805373333],[19.925383333,49.803333333],[19.924535,49.798811667],[19.923255,49.795273333],[19.925246667,49.792143333],[19.928438333,49.79014],[19.93079,49.789161667],[19.936321667,49.788436667],[19.939248333,49.787625],[19.944546667,49.785303333],[19.947698333,49.784873333],[19.95012,49.78366],[19.95631,49.777443333],[19.957783333,49.775483333],[19.960818333,49.768846667],[19.96581,49.76278],[19.967451667,49.757596667],[19.968405,49.755975],[19.97024,49.754121667],[19.97168,49.750325],[19.975475,49.745216667],[19.977375,49.741963333],[19.977436667,49.739818333],[19.975231667,49.73713],[19.97461,49.73549],[19.974896667,49.734186667],[19.978901667,49.72664],[19.979333333,49.722238333],[19.981268333,49.71853],[19.981656667,49.716918333],[19.98032,49.714625],[19.977213333,49.712886667],[19.975401667,49.711356667],[19.972553333,49.707586667],[19.966965,49.703535],[19.962373333,49.701001667],[19.959801667,49.698431667],[19.959165,49.696116667],[19.957063333,49.693285],[19.957711667,49.690838333],[19.95562,49.6888],[19.951843333,49.688261667],[19.950033333,49.687635],[19.948185,49.686225],[19.94692,49.685945],[19.943198333,49.686471667],[19.940798333,49.68599],[19.938525,49.684758333],[19.935695,49.684191667],[19.932583333,49.683988333],[19.928303333,49.684076667],[19.91507,49.681401667],[19.911955,49.679491667],[19.908698333,49.679261667],[19.905865,49.678385],[19.901565,49.675645],[19.901238333,49.673746667],[19.899608333,49.671791667],[19.89563,49.669373333],[19.892638333,49.668031667],[19.889423333,49.665058333],[19.889151667,49.663948333],[19.893053333,49.660176667],[19.897633333,49.659188333],[19.898693333,49.657143333],[19.901546667,49.657055],[19.901863333,49.65432],[19.905953333,49.653313333],[19.911243333,49.649115],[19.914566667,49.643276667],[19.914858333,49.64128],[19.920851667,49.630996667],[19.921118333,49.629836667],[19.919153333,49.62741],[19.91659,49.626085],[19.916015,49.625298333],[19.917296667,49.623371667],[19.920185,49.621986667],[19.921308333,49.620598333],[19.925423333,49.617536667],[19.925683333,49.616786667],[19.924716667,49.614133333],[19.927136667,49.611253333],[19.929855,49.600546667],[19.930768333,49.594495],[19.93328,49.59302],[19.93366,49.592148333],[19.93213,49.586743333],[19.933478333,49.58546],[19.937006667,49.586426667],[19.938275,49.585571667],[19.93587,49.58364],[19.935701667,49.582698333],[19.938105,49.577401667],[19.938791667,49.576726667],[19.942698333,49.575635],[19.946946667,49.573801667],[19.94752,49.573145],[19.947233333,49.570863333],[19.945763333,49.568625],[19.939481667,49.557215],[19.93853,49.554496667],[19.939898333,49.553255],[19.945218333,49.551533333],[19.951705,49.549163333],[19.955958333,49.549356667],[19.957803333,49.549115],[19.960208333,49.547848333],[19.966003333,49.546098333],[19.973675,49.542615],[19.974376667,49.541366667],[19.973255,49.538841667],[19.97394,49.537076667],[19.97262,49.534306667],[19.972595,49.533296667],[19.978238333,49.52849],[19.979438333,49.524776667],[19.985158333,49.519086667],[19.98762,49.517186667],[19.987956667,49.516353333],[19.987958333,49.51248],[19.988626667,49.511156667],[19.991821667,49.50704],[19.998571667,49.501861667],[20.00479,49.496071667],[20.01496,49.490953333],[20.017555,49.489258333],[20.01944,49.485291667],[20.021796667,49.478973333],[20.022448333,49.47578],[20.022266667,49.473835],[20.020523333,49.468818333],[20.02031,49.458165],[20.020276667,49.445853333],[20.020661667,49.440978333],[20.022235,49.436153333],[20.021793333,49.43362],[20.019565,49.425443333],[20.017101667,49.404798333],[20.016643333,49.393211667],[20.015853333,49.391015],[20.014155,49.388143333],[20.01369,49.385855],[20.012813333,49.385416667],[20.010405,49.378865],[20.009211667,49.377548333],[20.002686667,49.368201667],[20.001788333,49.365193333],[20.002023333,49.363213333],[20.00457,49.361606667],[20.006746667,49.359613333],[20.007028333,49.357838333],[20.006291667,49.35319],[20.004056667,49.35069],[20.00322,49.344608333],[20.003333333,49.339473333],[20.002146667,49.334613333],[20.000241667,49.331816667],[19.995416667,49.32933],[19.985315,49.320376667],[19.984851667,49.319628333],[19.976275,49.312733333],[19.96997,49.309858333],[19.96618,49.309273333],[19.96193,49.308225],[19.958991667,49.306203333],[19.95881,49.305068333],[19.960626667,49.302356667],[19.96128,49.300643333],[19.96094,49.299583333],[19.958221667,49.298498333],[19.95636,49.296958333],[19.954323333,49.29591],[19.953221667,49.29657],[19.95196,49.298646667],[19.952365,49.299726667],[19.95453,49.300366667],[19.957756667,49.302553333],[19.958636667,49.305893333],[19.962165,49.308471667],[19.966198333,49.30959],[19.96796,49.30976],[19.972638333,49.311045],[19.975825,49.312388333],[19.9788,49.314595],[19.984498333,49.319461667],[19.985528333,49.320561667],[19.996356667,49.329916667],[19.998808333,49.330975],[20.000421667,49.332215],[20.001773333,49.334045],[20.00309,49.337786667],[20.005531667,49.337448333],[20.00706,49.33507],[20.014061667,49.331665],[20.020558333,49.33136],[20.024378333,49.33153],[20.03159,49.33107],[20.034918333,49.332128333],[20.037176667,49.331596667],[20.038953333,49.33216],[20.044915,49.332476667],[20.0476,49.333545],[20.060078333,49.337301667],[20.061475,49.337205],[20.072541667,49.333388333],[20.077736667,49.334173333],[20.079461667,49.333816667],[20.082651667,49.332253333],[20.086716667,49.331163333],[20.091845,49.331125],[20.094228333,49.32974],[20.097861667,49.329883333],[20.09875,49.328561667],[20.09881,49.326955],[20.099798333,49.326326667],[20.104836667,49.324528333],[20.106206667,49.323213333],[20.105808333,49.321668333],[20.106581667,49.320146667],[20.10522,49.318028333],[20.106646667,49.315568333],[20.108948333,49.313838333],[20.109211667,49.31134],[20.1111,49.308858333],[20.112616667,49.305355],[20.114361667,49.30523],[20.115605,49.30418],[20.114458333,49.302311667],[20.11572,49.301511667],[20.11821,49.301136667],[20.118376667,49.30026],[20.11538,49.296796667],[20.114431667,49.295083333],[20.114406667,49.292611667],[20.112485,49.286285],[20.114471667,49.280866667],[20.115056667,49.277788333],[20.117106667,49.276583333],[20.116831667,49.274796667],[20.117488333,49.272976667],[20.119496667,49.272308333],[20.119523333,49.273513333],[20.117681667,49.273966667],[20.119981667,49.274431667],[20.120288333,49.273896667],[20.118658333,49.272858333],[20.115846667,49.270045],[20.116755,49.267756667],[20.1168,49.265193333],[20.11535,49.263395],[20.11683,49.26329],[20.117568333,49.264336667],[20.121315,49.266051667],[20.123116667,49.266476667],[20.125616667,49.267946667],[20.131185,49.270183333],[20.13313,49.270271667],[20.136371667,49.26964],[20.139351667,49.270046667],[20.140491667,49.266125],[20.141686667,49.265393333],[20.142305,49.266886667],[20.144205,49.268461667],[20.147033333,49.26982],[20.14971,49.271636667],[20.152531667,49.272805],[20.156563333,49.27357],[20.161748333,49.275248333],[20.168926667,49.278453333],[20.174121667,49.280578333],[20.176793333,49.28017],[20.178505,49.27921],[20.184715,49.277276667],[20.188875,49.274473333],[20.189156667,49.275245],[20.186843333,49.276946667],[20.188133333,49.277923333],[20.190493333,49.278305],[20.194913333,49.277303333],[20.200385,49.275398333],[20.201568333,49.275586667],[20.205843333,49.277265],[20.207188333,49.278261667],[20.207758333,49.280065],[20.209003333,49.281036667],[20.218741667,49.278171667],[20.22305,49.27627],[20.228563333,49.274306667],[20.233845,49.272921667],[20.235628333,49.272766667],[20.24552,49.273595],[20.24924,49.27375],[20.25187,49.273275],[20.254028333,49.27232],[20.260661667,49.270355],[20.2671,49.269576667],[20.268976667,49.269746667],[20.272831667,49.2712],[20.279891667,49.27079],[20.282578333,49.268746667],[20.285845,49.266841667],[20.290886667,49.266481667],[20.293693333,49.265863333],[20.300098333,49.263135],[20.30233,49.261455],[20.303131667,49.258071667],[20.301685,49.25704],[20.30287,49.253663333],[20.305718333,49.252463333],[20.311298333,49.24865],[20.309161667,49.244271667],[20.309156667,49.242486667],[20.31125,49.23768],[20.31282,49.23602],[20.313591667,49.234303333],[20.313396667,49.23257],[20.315838333,49.231128333],[20.319018333,49.227995],[20.321698333,49.226526667],[20.32497,49.224175],[20.326746667,49.223411667],[20.332795,49.21997],[20.329356667,49.215771667],[20.32353,49.213286667],[20.318095,49.210691667],[20.311876667,49.20816],[20.309675,49.206831667],[20.308138333,49.204625],[20.306631667,49.201533333],[20.302913333,49.197073333],[20.301535,49.194818333],[20.297583333,49.191405],[20.29442,49.189245],[20.292236667,49.186775],[20.290451667,49.183566667],[20.290226667,49.181721667],[20.29388,49.178066667],[20.294056667,49.172685],[20.29314,49.171003333],[20.289908333,49.170815],[20.286286667,49.169648333],[20.285475,49.168076667],[20.282791667,49.166756667],[20.288,49.165108333],[20.298075,49.16163],[20.30547,49.160473333],[20.30864,49.160296667],[20.310966667,49.157518333],[20.31628,49.152843333],[20.323013333,49.146536667],[20.323846667,49.144621667],[20.325136667,49.143743333],[20.332141667,49.14067],[20.334805,49.139016667],[20.337763333,49.135456667],[20.34552,49.125475],[20.350456667,49.12137],[20.353601667,49.117985],[20.354508333,49.114955],[20.355461667,49.1139],[20.357271667,49.113555],[20.35921,49.110941667],[20.353548333,49.108118333],[20.345565,49.10442],[20.344618333,49.103755],[20.341341667,49.098583333],[20.336838333,49.08999],[20.332698333,49.083763333],[20.332021667,49.08028],[20.32852,49.073571667],[20.321105,49.065723333],[20.318386667,49.06372],[20.311676667,49.060016667],[20.304875,49.05686],[20.300506667,49.056345],[20.2936,49.054253333],[20.293026667,49.04953],[20.292116667,49.047101667],[20.290611667,49.045146667],[20.289943333,49.043383333],[20.289151667,49.037228333],[20.285256667,49.032823333],[20.283853333,49.027716667],[20.27984,49.025906667],[20.278343333,49.024356667],[20.282365,49.022183333],[20.283723333,49.020611667],[20.283781667,49.016628333],[20.282841667,49.016068333],[20.280945,49.013108333],[20.283241667,49.010913333],[20.285348333,49.007236667],[20.287411667,49.006318333],[20.290416667,49.00586],[20.290388333,49.004628333],[20.292798333,49.004216667],[20.29899,49.003696667],[20.300728333,49.003943333],[20.306093333,49.002615],[20.30803,49.000975],[20.309213333,48.998258333],[20.308558333,48.993311667],[20.308721667,48.991215],[20.309715,48.990173333],[20.30951,48.988935],[20.308338333,48.987465],[20.305391667,48.982561667],[20.304391667,48.979691667],[20.301465,48.977776667],[20.296291667,48.972563333],[20.294213333,48.968706667],[20.294581667,48.966943333],[20.292701667,48.96473],[20.292295,48.962878333],[20.292571667,48.958713333],[20.294618333,48.955615],[20.295928333,48.952666667],[20.290818333,48.945861667],[20.288896667,48.944825],[20.287935,48.942011667],[20.287938333,48.940775],[20.285936667,48.938181667],[20.285195,48.93562],[20.286398333,48.93588],[20.286196667,48.931646667],[20.28214,48.92866],[20.274115,48.923635],[20.27281,48.921703333],[20.272265,48.919233333],[20.27073,48.917805],[20.265036667,48.917008333],[20.263683333,48.915665],[20.260625,48.914408333],[20.260305,48.911848333],[20.258646667,48.91131],[20.256095,48.909488333],[20.257321667,48.907933333],[20.256866667,48.904731667],[20.253013333,48.902896667],[20.251388333,48.90545],[20.249866667,48.905125],[20.25047,48.904373333],[20.250478333,48.902143333],[20.25196,48.900248333],[20.249661667,48.899828333],[20.247355,48.897175],[20.245141667,48.898613333],[20.245378333,48.896631667],[20.247961667,48.89565],[20.246876667,48.892013333],[20.241348333,48.890468333],[20.239316667,48.888118333],[20.239045,48.88697],[20.240408333,48.886141667],[20.242225,48.886008333],[20.240408333,48.885418333],[20.246116667,48.885008333],[20.24913,48.883923333],[20.250861667,48.88285],[20.25332,48.880643333],[20.255855,48.880583333],[20.257743333,48.880048333],[20.259451667,48.8783],[20.264993333,48.874803333],[20.271126667,48.873091667],[20.277391667,48.872738333],[20.27905,48.871858333],[20.284526667,48.870856667],[20.286718333,48.871243333],[20.290743333,48.873606667],[20.291398333,48.874346667],[20.294581667,48.873743333],[20.30221,48.873958333],[20.305125,48.874723333],[20.30716,48.875975],[20.311425,48.877785],[20.312275,48.879495],[20.310721667,48.883245],[20.313158333,48.88544],[20.31427,48.88563],[20.318241667,48.884228333],[20.318488333,48.880518333],[20.321123333,48.875193333],[20.323496667,48.873245],[20.332605,48.872561667],[20.335271667,48.870538333],[20.340043333,48.86929],[20.342603333,48.870258333],[20.344875,48.868236667],[20.347585,48.867663333],[20.347848333,48.866811667],[20.350305,48.863596667],[20.348956667,48.858101667],[20.351566667,48.855788333],[20.355576667,48.854835],[20.362705,48.85417],[20.365468333,48.852563333],[20.369785,48.850711667],[20.374155,48.850406667],[20.377488333,48.846888333],[20.381471667,48.845266667],[20.37747,48.845976667],[20.3753,48.846851667],[20.373118333,48.846695],[20.377045,48.844605],[20.378141667,48.842053333],[20.383238333,48.841706667],[20.384823333,48.840928333],[20.384655,48.838278333],[20.385813333,48.837955],[20.389451667,48.834716667],[20.388755,48.833746667],[20.384231667,48.832275],[20.38343,48.831446667],[20.3833,48.829505],[20.383635,48.823606667],[20.384071667,48.82045],[20.382608333,48.819233333],[20.381436667,48.819158333],[20.378476667,48.821468333],[20.376178333,48.823753333],[20.375096667,48.82573],[20.374388333,48.825131667],[20.374043333,48.820381667],[20.375091667,48.81931],[20.379336667,48.818596667],[20.381943333,48.8175],[20.383458333,48.815591667],[20.387241667,48.812303333],[20.387296667,48.809806667],[20.388448333,48.80636],[20.387748333,48.803978333],[20.386346667,48.801656667],[20.387383333,48.798768333],[20.388993333,48.797686667],[20.39171,48.796966667],[20.398175,48.794246667],[20.398218333,48.793028333],[20.401391667,48.788891667],[20.402868333,48.787476667],[20.404646667,48.784266667],[20.406625,48.782248333],[20.408445,48.778656667],[20.40876,48.776723333],[20.41013,48.774213333],[20.411773333,48.773446667],[20.413913333,48.76985],[20.416251667,48.765368333],[20.417141667,48.763076667],[20.417323333,48.760733333],[20.416391667,48.75287],[20.415513333,48.749698333],[20.41527,48.74622],[20.416411667,48.742035],[20.416308333,48.740771667],[20.414986667,48.737573333],[20.415528333,48.73535],[20.414566667,48.727505],[20.416063333,48.72449],[20.419523333,48.720853333],[20.424305,48.716428333],[20.431523333,48.713526667],[20.433251667,48.71328],[20.43635,48.713925],[20.439888333,48.714091667],[20.442871667,48.71462],[20.448126667,48.71424],[20.452546667,48.71284],[20.460013333,48.713815],[20.46247,48.713806667],[20.464735,48.713218333],[20.469795,48.7133],[20.471105,48.713008333],[20.473623333,48.711573333],[20.476053333,48.710886667],[20.481676667,48.710813333],[20.485561667,48.708915],[20.490578333,48.707196667],[20.494206667,48.705458333],[20.49742,48.704435],[20.502813333,48.702035],[20.506115,48.700858333],[20.513258333,48.694936667],[20.515841667,48.692288333],[20.518711667,48.687895],[20.520896667,48.684001667],[20.522481667,48.677438333],[20.522251667,48.675266667],[20.519625,48.666446667],[20.519961667,48.664561667],[20.521263333,48.661936667],[20.520618333,48.65996],[20.520645,48.65827],[20.521451667,48.65461],[20.522775,48.650138333],[20.522881667,48.64779],[20.525261667,48.644295],[20.524823333,48.64126],[20.525721667,48.640255],[20.528268333,48.640125],[20.528943333,48.641813333],[20.533226667,48.642758333],[20.53729,48.64595],[20.53873,48.648001667],[20.545913333,48.650688333],[20.549718333,48.651431667],[20.554123333,48.651456667],[20.556035,48.651143333],[20.560153333,48.65109],[20.570186667,48.65154],[20.573328333,48.651968333],[20.575786667,48.651926667],[20.580435,48.65121],[20.58608,48.651598333],[20.590946667,48.650923333],[20.595565,48.649875],[20.60039,48.647643333],[20.60264,48.646003333],[20.606468333,48.642636667],[20.613635,48.636915],[20.618976667,48.63131],[20.621276667,48.630285],[20.623513333,48.630506667],[20.626648333,48.629268333],[20.629183333,48.628746667],[20.63701,48.626141667],[20.636545,48.625396667],[20.632483333,48.624611667],[20.631358333,48.623635],[20.631613333,48.621921667],[20.6333,48.619633333],[20.632623333,48.618953333],[20.62892,48.61918],[20.629678333,48.618033333],[20.634886667,48.612778333],[20.637953333,48.60763],[20.637741667,48.605205],[20.639311667,48.60225],[20.641555,48.600833333],[20.646248333,48.601681667],[20.648115,48.601058333],[20.652453333,48.600781667],[20.655361667,48.601028333],[20.65961,48.59984],[20.666396667,48.59877],[20.668095,48.597888333],[20.67085,48.597255],[20.675091667,48.597398333],[20.680273333,48.596908333],[20.6822,48.59617],[20.686973333,48.595393333],[20.697693333,48.595073333],[20.701981667,48.595386667],[20.705693333,48.596126667],[20.713198333,48.597061667],[20.72604,48.598991667],[20.731831667,48.599721667],[20.738626667,48.601045],[20.742333333,48.601413333],[20.751005,48.600935],[20.759676667,48.600668333],[20.765921667,48.60067],[20.78473,48.60038],[20.794376667,48.600076667],[20.809748333,48.5998],[20.811733333,48.599856667],[20.83051,48.601751667],[20.834943333,48.603296667],[20.837935,48.60563],[20.842225,48.606838333],[20.847441667,48.609295],[20.850421667,48.609763333],[20.858688333,48.610233333],[20.8626,48.610018333],[20.867096667,48.608278333],[20.87082,48.60614],[20.87564,48.604801667],[20.879441667,48.604833333],[20.884886667,48.603546667],[20.890193333,48.603043333],[20.898483333,48.604908333],[20.911936667,48.606605],[20.916853333,48.607431667],[20.919525,48.607451667],[20.921671667,48.60841],[20.908185,48.606251667],[20.899796667,48.605055],[20.892895,48.603898333],[20.889468333,48.603066667],[20.880825,48.604311667],[20.879128333,48.601633333],[20.874986667,48.59822],[20.87203,48.597473333],[20.868415,48.597118333],[20.8684,48.595823333],[20.866298333,48.594188333],[20.853966667,48.587705],[20.853388333,48.587053333],[20.850896667,48.582228333],[20.84278,48.576385],[20.827135,48.569531667],[20.805075,48.56496],[20.802961667,48.564008333],[20.782238333,48.556111667],[20.7687,48.550775],[20.761945,48.548233333],[20.738751667,48.539013333],[20.734105,48.537286667],[20.731895,48.535868333],[20.732145,48.533861667],[20.731783333,48.532185],[20.72942,48.528105],[20.728555,48.52729],[20.713796667,48.519756667],[20.707603333,48.515375],[20.70644,48.51384],[20.702396667,48.507498333],[20.699011667,48.501661667],[20.697778333,48.500608333],[20.695721667,48.500198333],[20.692736667,48.500336667],[20.689871667,48.499525],[20.689408333,48.498735],[20.690411667,48.496825],[20.690686667,48.49479],[20.691915,48.49272],[20.692916667,48.489575],[20.694426667,48.486153333],[20.693425,48.482348333],[20.69072,48.476268333],[20.6908,48.473436667],[20.690043333,48.471333333],[20.689148333,48.465345],[20.689721667,48.462613333],[20.6906,48.462101667],[20.695051667,48.460921667],[20.697378333,48.459678333],[20.703416667,48.458458333],[20.715498333,48.454146667],[20.719448333,48.451281667],[20.721636667,48.450328333],[20.722745,48.450625],[20.726196667,48.4505],[20.731188333,48.449811667],[20.736928333,48.449345],[20.73973,48.4469],[20.741225,48.44604],[20.741093333,48.438085],[20.742336667,48.43487],[20.742215,48.431178333],[20.740016667,48.428436667],[20.738113333,48.426861667],[20.736243333,48.421533333],[20.73458,48.42027],[20.728506667,48.416751667],[20.727745,48.414786667],[20.728435,48.412368333],[20.729973333,48.409635],[20.730055,48.408725],[20.728558333,48.406895],[20.728256667,48.404218333],[20.728766667,48.402481667],[20.730641667,48.400711667],[20.73187,48.398891667],[20.736626667,48.398293333],[20.738855,48.397661667],[20.74073,48.396356667],[20.741473333,48.392973333],[20.741406667,48.390041667],[20.740868333,48.386731667],[20.738633333,48.383795],[20.738116667,48.382318333],[20.736318333,48.380888333],[20.732523333,48.379573333],[20.729451667,48.377308333],[20.728545,48.36908],[20.730386667,48.366796667],[20.730411667,48.363883333],[20.731268333,48.36081],[20.730695,48.359565],[20.732648333,48.358763333],[20.736663333,48.355555],[20.73755,48.353813333],[20.737228333,48.349541667],[20.73966,48.347203333],[20.740498333,48.345191667],[20.742553333,48.342581667],[20.745715,48.340761667],[20.745986667,48.339696667],[20.739608333,48.337781667],[20.735136667,48.336045],[20.731228333,48.333271667],[20.731158333,48.332046667],[20.737476667,48.32345],[20.738401667,48.318686667],[20.7393,48.317425],[20.747953333,48.312783333],[20.746585,48.306798333],[20.747048333,48.303756667],[20.743535,48.296491667],[20.736113333,48.294535],[20.733445,48.294411667],[20.728456667,48.29311],[20.72311,48.29195],[20.722096667,48.291411667],[20.718236667,48.286945],[20.717933333,48.285545],[20.720015,48.272485],[20.719843333,48.268625],[20.720183333,48.266865],[20.721563333,48.2638],[20.722558333,48.259401667],[20.723411667,48.256981667],[20.725066667,48.254118333],[20.72558,48.251106667],[20.725575,48.248638333],[20.728048333,48.244278333],[20.727408333,48.241305],[20.730841667,48.233736667],[20.728993333,48.22735],[20.728033333,48.225518333],[20.725686667,48.223913333],[20.720756667,48.221918333],[20.719973333,48.22124],[20.720071667,48.218445],[20.725245,48.216335],[20.732213333,48.209721667],[20.733436667,48.207958333],[20.736985,48.204825],[20.738691667,48.202311667],[20.746335,48.19617],[20.752583333,48.18938],[20.756281667,48.184295],[20.758573333,48.181678333],[20.764086667,48.169786667],[20.763843333,48.16903],[20.769275,48.158661667],[20.771341667,48.153251667],[20.773215,48.149171667],[20.774151667,48.145775],[20.77459,48.146008333],[20.776353333,48.141896667],[20.778368333,48.138186667],[20.781393333,48.134656667],[20.782753333,48.129956667],[20.782256667,48.127723333],[20.783426667,48.126546667],[20.78233,48.121271667],[20.782875,48.121181667],[20.78405,48.128073333],[20.783878333,48.125613333],[20.784816667,48.124706667],[20.788061667,48.119296667],[20.783761667,48.12564],[20.785516667,48.126305],[20.785186667,48.127305],[20.786173333,48.128408333],[20.791501667,48.12961],[20.798713333,48.13011],[20.799221667,48.129738333],[20.803366667,48.117931667],[20.808215,48.118556667],[20.811188333,48.118203333],[20.813516667,48.116728333],[20.81477,48.114691667],[20.815455,48.11087],[20.814936667,48.108223333],[20.817175,48.106938333],[20.82031,48.107031667],[20.825853333,48.106661667],[20.835501667,48.10558],[20.838766667,48.1059],[20.841698333,48.10674],[20.844186667,48.106163333],[20.845308333,48.105386667],[20.846513333,48.098833333],[20.848441667,48.094236667],[20.85109,48.089451667],[20.851491667,48.086856667],[20.850401667,48.082246667],[20.849728333,48.078251667],[20.849055,48.071543333],[20.84785,48.068258333],[20.844883333,48.063415],[20.844165,48.060501667],[20.84325,48.059678333],[20.839131667,48.05786],[20.825883333,48.05502],[20.816631667,48.054803333],[20.806745,48.055218333],[20.799523333,48.05523],[20.799731667,48.053073333],[20.798473333,48.052548333],[20.804436667,48.040986667],[20.806613333,48.037401667],[20.811496667,48.03087],[20.8125,48.028681667],[20.816256667,48.024811667],[20.818993333,48.021511667],[20.821633333,48.01786],[20.830056667,48.003653333],[20.831386667,48.000873333],[20.831463333,47.99868],[20.830106667,47.992891667],[20.830983333,47.987606667],[20.83323,47.98706],[20.83735,47.987586667],[20.84125,47.987408333],[20.844925,47.986858333],[20.854141667,47.984703333],[20.858955,47.984038333],[20.892066667,47.980693333],[20.897935,47.979508333],[20.905161667,47.979],[20.91065,47.977881667],[20.918626667,47.975191667],[20.928838333,47.970693333],[20.933251667,47.96849],[20.942645,47.96085],[20.944046667,47.960148333],[20.95159,47.958978333],[20.954461667,47.958208333],[20.961243333,47.954811667],[20.965028333,47.95349],[20.971165,47.952455],[20.974375,47.951655],[20.984988333,47.94804],[20.991175,47.947246667],[20.994855,47.946036667],[20.998975,47.941905],[21.007256667,47.93747],[21.019625,47.932126667],[21.022596667,47.930983333],[21.037568333,47.926785],[21.064666667,47.919566667],[21.069498333,47.917175],[21.072395,47.914788333],[21.07967,47.907538333],[21.083418333,47.904125],[21.092195,47.895741667],[21.094888333,47.893858333],[21.098606667,47.891685],[21.10286,47.889961667],[21.107248333,47.88731],[21.109778333,47.88647],[21.118326667,47.885953333],[21.121041667,47.885586667],[21.12454,47.883776667],[21.125896667,47.881568333],[21.127605,47.876971667],[21.128311667,47.875828333],[21.131405,47.87366],[21.13653,47.871981667],[21.139278333,47.870801667],[21.148963333,47.867505],[21.151611667,47.865886667],[21.15266,47.864281667],[21.152383333,47.861388333],[21.151016667,47.859235],[21.150288333,47.85682],[21.151138333,47.851501667],[21.150686667,47.845258333],[21.151035,47.843685],[21.153218333,47.840451667],[21.154346667,47.83962],[21.165608333,47.836978333],[21.169323333,47.835993333],[21.179518333,47.833648333],[21.191443333,47.831091667],[21.19642,47.830445],[21.213641667,47.828596667],[21.22238,47.82758],[21.225511667,47.827056667],[21.236998333,47.820133333],[21.239288333,47.817863333],[21.241676667,47.811436667],[21.243581667,47.809785],[21.25058,47.806791667],[21.252003333,47.805621667],[21.255506667,47.801021667],[21.256218333,47.797908333],[21.25718,47.79628],[21.260318333,47.794245],[21.262965,47.791886667],[21.313895,47.76392],[21.326676667,47.756863333],[21.327828333,47.756065],[21.330196667,47.752578333],[21.332423333,47.751056667],[21.335328333,47.7503],[21.337615,47.750165],[21.34047,47.749325],[21.368636667,47.733885],[21.389043333,47.72284],[21.397515,47.717223333],[21.402373333,47.714338333],[21.408575,47.711043333],[21.420413333,47.704231667],[21.42905,47.699611667],[21.44191,47.692178333],[21.443195,47.691163333],[21.444918333,47.687323333],[21.446148333,47.686286667],[21.449616667,47.685261667],[21.453653333,47.6849],[21.45549,47.684341667],[21.459378333,47.682285],[21.48248,47.676148333],[21.485218333,47.674703333],[21.490505,47.670376667],[21.494513333,47.666643333],[21.498601667,47.664083333],[21.501415,47.663041667],[21.504596667,47.662746667],[21.512571667,47.66271],[21.516238333,47.66168],[21.517975,47.660543333],[21.525953333,47.652048333],[21.53224,47.646176667],[21.54162,47.637611667],[21.544473333,47.634046667],[21.547281667,47.627525],[21.55126,47.618945],[21.553786667,47.616148333],[21.565886667,47.606946667],[21.574073333,47.601206667],[21.575095,47.600266667],[21.581345,47.592565],[21.588968333,47.582441667],[21.589636667,47.58126],[21.591693333,47.575411667],[21.593365,47.572405],[21.59811,47.567701667],[21.601736667,47.56188],[21.609011667,47.55285],[21.609691667,47.55141],[21.609428333,47.547105],[21.609613333,47.542646667],[21.612676667,47.534171667],[21.61418,47.53394],[21.618,47.53448],[21.625831667,47.534728333],[21.628896667,47.534085],[21.630776667,47.531775],[21.631751667,47.528183333],[21.630095,47.531046667],[21.633193333,47.526943333],[21.630875,47.529501667],[21.63206,47.530641667],[21.632788333,47.524325],[21.632388333,47.52041],[21.631721667,47.518816667],[21.629586667,47.516411667],[21.629231667,47.514943333],[21.630003333,47.50912],[21.630305,47.505301667],[21.632098333,47.494166667],[21.63485,47.473846667],[21.634936667,47.472235],[21.636076667,47.464365],[21.636646667,47.458583333],[21.633281667,47.451195],[21.631755,47.443043333],[21.63208,47.442048333],[21.631383333,47.439991667],[21.631463333,47.438381667],[21.62884,47.436598333],[21.62695,47.431665],[21.62447,47.422523333],[21.624793333,47.417571667],[21.62432,47.412475],[21.621253333,47.406613333],[21.618718333,47.402748333],[21.61688,47.398571667],[21.613503333,47.395271667],[21.60849,47.389986667],[21.604286667,47.385141667],[21.602128333,47.382306667],[21.593621667,47.374191667],[21.58053,47.362121667],[21.575123333,47.35685],[21.573983333,47.35528],[21.569031667,47.351936667],[21.56432,47.345776667],[21.562716667,47.342238333],[21.562795,47.340756667],[21.560935,47.325345],[21.559971667,47.319161667],[21.55982,47.316738333],[21.558583333,47.307525],[21.556876667,47.303636667],[21.554118333,47.29551],[21.551238333,47.280995],[21.547583333,47.270056667],[21.547023333,47.26805],[21.541586667,47.25418],[21.540916667,47.253171667],[21.537675,47.250646667],[21.537053333,47.249551667],[21.535443333,47.240566667],[21.533793333,47.233865],[21.539903333,47.232378333],[21.551238333,47.228933333],[21.553248333,47.227991667],[21.55719,47.223018333],[21.56563,47.207318333],[21.567283333,47.203261667],[21.573045,47.18598],[21.575306667,47.1831],[21.577916667,47.18185],[21.587341667,47.178783333],[21.615158333,47.169513333],[21.617893333,47.16854],[21.624005,47.167296667],[21.639485,47.16046],[21.64446,47.15794],[21.657003333,47.152428333],[21.679943333,47.14224],[21.694108333,47.13584],[21.696421667,47.135163333],[21.70044,47.13531],[21.70944,47.140301667],[21.713305,47.141998333],[21.715138333,47.142285],[21.71978,47.142098333],[21.729726667,47.139788333],[21.736978333,47.138336667],[21.73965,47.136643333],[21.742351667,47.132688333],[21.744135,47.131283333],[21.748243333,47.130053333],[21.754701667,47.12944],[21.763188333,47.127781667],[21.773005,47.124313333],[21.786331667,47.120348333],[21.795138333,47.117228333],[21.799921667,47.11676],[21.803101667,47.116076667],[21.808565,47.114086667],[21.815498333,47.110906667],[21.828596667,47.105595],[21.841988333,47.101373333],[21.844171667,47.10086],[21.856031667,47.099231667],[21.861186667,47.097588333],[21.86705,47.094326667],[21.878351667,47.087715],[21.882983333,47.085141667],[21.88779,47.082863333],[21.902273333,47.07633],[21.90652,47.074673333],[21.906941667,47.07314],[21.906103333,47.07225],[21.902918333,47.07023],[21.901601667,47.068883333],[21.902158333,47.068486667],[21.911175,47.064333333],[21.912435,47.063165],[21.90931,47.057633333],[21.906401667,47.051955],[21.905241667,47.050488333],[21.903356667,47.045905],[21.907363333,47.04559],[21.909735,47.044993333],[21.911448333,47.043095],[21.912673333,47.038511667],[21.914918333,47.03695],[21.925171667,47.034678333],[21.939231667,47.029966667],[21.945585,47.025205],[21.948038333,47.024293333],[21.951131667,47.024563333],[21.96908,47.028226667],[21.973068333,47.028885],[21.980405,47.030588333],[21.984968333,47.030213333],[21.986846667,47.03038],[21.991955,47.031623333],[21.99144,47.033125],[21.989286667,47.03595],[21.989703333,47.036363333],[22.010056667,47.03714],[22.013236667,47.03745],[22.027286667,47.040941667],[22.028888333,47.041011667],[22.031676667,47.04198],[22.035716667,47.045008333],[22.042025,47.048001667],[22.045555,47.04904],[22.051905,47.050053333],[22.063011667,47.052056667],[22.067471667,47.052241667],[22.0743,47.053991667],[22.079745,47.054465],[22.08764,47.054121667],[22.09515,47.053953333],[22.099293333,47.054895],[22.108035,47.0561],[22.139155,47.060223333],[22.149288333,47.06165],[22.151538333,47.061848333],[22.171121667,47.062423333],[22.171873333,47.062763333],[22.180996667,47.069646667],[22.185315,47.071756667],[22.19503,47.073308333],[22.201733333,47.07741],[22.20245,47.078315],[22.202556667,47.08046],[22.203515,47.08127],[22.205718333,47.081816667],[22.210265,47.081748333],[22.21888,47.080083333],[22.223218333,47.078621667],[22.233513333,47.0769],[22.268351667,47.070781667],[22.273335,47.069986667],[22.27989,47.06863],[22.281536667,47.067545],[22.283745,47.066835],[22.29171,47.066081667],[22.304503333,47.06604],[22.312293333,47.065185],[22.316383333,47.064948333],[22.325971667,47.064768333],[22.33082,47.06434],[22.338605,47.064403333],[22.340801667,47.064655],[22.342953333,47.064278333],[22.346215,47.062838333],[22.348358333,47.060636667],[22.349671667,47.060121667],[22.358588333,47.058246667],[22.367506667,47.058771667],[22.382235,47.059183333],[22.392505,47.059753333],[22.396621667,47.059598333],[22.399391667,47.058605],[22.401205,47.057455],[22.408368333,47.054928333],[22.423881667,47.052896667],[22.42926,47.053043333],[22.4377,47.051995],[22.442471667,47.052221667],[22.447853333,47.051553333],[22.458138333,47.049551667],[22.470946667,47.047641667],[22.475053333,47.046233333],[22.483958333,47.042475],[22.490726667,47.039895],[22.491806667,47.039208333],[22.496801667,47.03316],[22.499468333,47.030533333],[22.500366667,47.029026667],[22.512451667,47.02248],[22.514928333,47.020548333],[22.51586,47.017525],[22.5168,47.015995],[22.516595,47.013335],[22.518411667,47.008441667],[22.519805,47.006535],[22.522663333,47.00386],[22.524745,47.002778333],[22.52913,47.001963333],[22.544181667,47.001613333],[22.560405,47.001021667],[22.563025,47.000643333],[22.573891667,46.998586667],[22.587721667,46.99609],[22.600643333,46.993458333],[22.607253333,46.992271667],[22.611826667,46.99193],[22.617106667,46.991128333],[22.623938333,46.991013333],[22.629306667,46.99011],[22.633735,46.988495],[22.638415,46.986481667],[22.641583333,46.98429],[22.64402,46.98297],[22.648553333,46.977938333],[22.65211,46.976643333],[22.654616667,46.975333333],[22.654826667,46.973755],[22.65651,46.971913333],[22.659263333,46.970878333],[22.660063333,46.972268333],[22.661255,46.972418333],[22.66174,46.971416667],[22.66508,46.969211667],[22.666541667,46.969676667],[22.66767,46.97111],[22.669868333,46.97139],[22.673321667,46.970128333],[22.673886667,46.969181667],[22.673483333,46.96641],[22.67381,46.9631],[22.67501,46.963121667],[22.675181667,46.965393333],[22.676516667,46.964643333],[22.677708333,46.965255],[22.679941667,46.9636],[22.68005,46.962423333],[22.678708333,46.960443333],[22.678203333,46.958758333],[22.680153333,46.95544],[22.68207,46.954545],[22.683403333,46.951681667],[22.684916667,46.95073],[22.683333333,46.950516667],[22.687421667,46.948801667],[22.694833333,46.9489],[22.701096667,46.94755],[22.709383333,46.946116667],[22.711898333,46.946095],[22.716035,46.946658333],[22.72009,46.946558333],[22.720988333,46.947445],[22.721458333,46.95128],[22.7215,46.955423333],[22.722315,46.958028333],[22.722431667,46.960185],[22.725308333,46.962056667],[22.729498333,46.961535],[22.73285,46.961538333],[22.742091667,46.959043333],[22.746908333,46.957331667],[22.749816667,46.956036667],[22.754701667,46.955746667],[22.757263333,46.954435],[22.762565,46.953243333],[22.76689,46.951505],[22.770096667,46.950668333],[22.77716,46.950958333],[22.780518333,46.951611667],[22.783801667,46.953331667],[22.786058333,46.955093333],[22.78971,46.95699],[22.791235,46.957441667],[22.799061667,46.957303333],[22.802801667,46.958295],[22.8086,46.95818],[22.810788333,46.956243333],[22.812445,46.952461667],[22.813508333,46.948998333],[22.81428,46.947875],[22.819473333,46.945038333],[22.819811667,46.93887],[22.82016,46.937161667],[22.82143,46.935486667],[22.823583333,46.93461],[22.826913333,46.934638333],[22.832461667,46.935411667],[22.837718333,46.936496667],[22.839991667,46.936391667],[22.842928333,46.935385],[22.847008333,46.933511667],[22.850023333,46.933141667],[22.851881667,46.932198333],[22.853033333,46.930705],[22.855071667,46.924863333],[22.856658333,46.922258333],[22.857471667,46.91996],[22.858535,46.918423333],[22.864076667,46.91196],[22.865741667,46.910225],[22.867031667,46.90497],[22.869293333,46.901373333],[22.870485,46.898711667],[22.872793333,46.895085],[22.87816,46.893711667],[22.881315,46.893738333],[22.883931667,46.892356667],[22.886696667,46.891793333],[22.895135,46.887786667],[22.89563,46.8873],[22.895671667,46.884518333],[22.897411667,46.883801667],[22.900316667,46.884888333],[22.903381667,46.885491667],[22.906156667,46.884243333],[22.90828,46.882553333],[22.909973333,46.882165],[22.923788333,46.88099],[22.929701667,46.880873333],[22.933828333,46.880508333],[22.938435,46.879266667],[22.947876667,46.877038333],[22.953328333,46.875616667],[22.96506,46.873905],[22.968718333,46.873715],[22.973865,46.872145],[22.999301667,46.868548333],[23.003353333,46.867728333],[23.017751667,46.864431667],[23.021185,46.86475],[23.02532,46.86458],[23.030735,46.863388333],[23.031355,46.861271667],[23.03377,46.859145],[23.03567,46.858268333],[23.04765,46.85455],[23.051323333,46.85297],[23.06333,46.850555],[23.06686,46.85081],[23.069208333,46.851598333],[23.078041667,46.851823333],[23.079438333,46.851161667],[23.085915,46.844523333],[23.087151667,46.843786667],[23.09168,46.842361667],[23.094896667,46.84191],[23.097768333,46.840963333],[23.104195,46.83999],[23.10773,46.839916667],[23.10996,46.840226667],[23.112988333,46.839483333],[23.118583333,46.837091667],[23.125478333,46.832573333],[23.134481667,46.828963333],[23.14454,46.826506667],[23.14789,46.82683],[23.15081,46.829426667],[23.152155,46.829083333],[23.15438,46.82625],[23.158716667,46.823675],[23.165213333,46.822155],[23.169063333,46.82052],[23.181988333,46.813881667],[23.18341,46.813573333],[23.185771667,46.815205],[23.188246667,46.819921667],[23.19024,46.82084],[23.194543333,46.820758333],[23.19985,46.822105],[23.202398333,46.821918333],[23.206023333,46.819846667],[23.210016667,46.819183333],[23.211865,46.81795],[23.214965,46.817411667],[23.217608333,46.817645],[23.221423333,46.816895],[23.22366,46.81609],[23.225908333,46.81393],[23.229246667,46.812823333],[23.231,46.8115],[23.233106667,46.808921667],[23.23502,46.80795],[23.239328333,46.80725],[23.240328333,46.80749],[23.243743333,46.809571667],[23.250865,46.809473333],[23.254201667,46.80873],[23.25634,46.807906667],[23.26189,46.803306667],[23.264471667,46.801688333],[23.272848333,46.798368333],[23.280333333,46.796255],[23.282573333,46.79581],[23.2849,46.794371667],[23.289018333,46.78846],[23.290203333,46.78765],[23.307325,46.780118333],[23.32208,46.774971667],[23.330318333,46.771976667],[23.346323333,46.767906667],[23.349385,46.767596667],[23.355053333,46.766416667],[23.358896667,46.765015],[23.368946667,46.762285],[23.37188,46.761658333],[23.378133333,46.759915],[23.38432,46.758571667],[23.38868,46.753695],[23.394031667,46.751735],[23.397845,46.75107],[23.4088,46.750476667],[23.413685,46.750806667],[23.423703333,46.750488333],[23.433961667,46.750498333],[23.438735,46.750338333],[23.44314,46.74956],[23.451701667,46.745373333],[23.455411667,46.744325],[23.472246667,46.743795],[23.474946667,46.743465],[23.478843333,46.743641667],[23.483458333,46.744345],[23.484988333,46.744108333],[23.490263333,46.745038333],[23.4947,46.745266667],[23.496883333,46.74566],[23.50819,46.748436667],[23.520433333,46.75129],[23.531648333,46.753756667],[23.534413333,46.755115],[23.549431667,46.758636667],[23.551663333,46.758945],[23.557253333,46.76031],[23.564183333,46.760721667],[23.570971667,46.762431667],[23.57306,46.763273333],[23.57457,46.764433333],[23.578366667,46.764701667],[23.584825,46.766443333],[23.586641667,46.76726],[23.587501667,46.76637],[23.590261667,46.766688333],[23.589588333,46.768593333],[23.59073,46.769196667],[23.589338333,46.772096667],[23.588173333,46.773505],[23.584898333,46.772001667],[23.584975,46.771116667],[23.586433333,46.77191],[23.579601667,46.770835],[23.582383333,46.770901667],[23.586393333,46.772],[23.585783333,46.771523333],[23.587015,46.769538333],[23.586483333,46.772186667],[23.58579,46.772026667],[23.587543333,46.768165],[23.586135,46.768445],[23.586413333,46.770793333],[23.585706667,46.771238333],[23.589996667,46.774698333],[23.585961667,46.771818333],[23.586486667,46.769743333],[23.587005,46.770111667],[23.585973333,46.771771667],[23.585698333,46.773958333],[23.584381667,46.773546667],[23.58551,46.771661667],[23.613845,46.794775],[23.619301667,46.798933333],[23.66866,46.837916667],[23.667878333,46.837531667],[23.586555,46.771843333],[23.586153333,46.772331667],[23.58504,46.769108333],[23.599616667,46.783055],[23.586046667,46.772023333],[23.58705,46.767545],[23.585591667,46.771845],[23.562088333,46.770971667],[23.55269,46.770711667],[23.54921,46.770836667],[23.553713333,46.771761667],[23.585938333,46.771536667],[23.584803333,46.771073333],[23.585221667,46.76919],[23.586876667,46.767476667],[23.591583333,46.769295],[23.597796667,46.770961667],[23.60475,46.772583333],[23.608578333,46.77409],[23.611925,46.776231667],[23.615018333,46.77689],[23.61532,46.778343333],[23.626303333,46.780548333],[23.63299,46.781225],[23.637835,46.781966667],[23.641951667,46.782861667],[23.645123333,46.784],[23.650741667,46.78424],[23.653765,46.784111667],[23.65916,46.784643333],[23.66594,46.780495],[23.667118333,46.780208333],[23.679096667,46.780866667],[23.688656667,46.781488333],[23.700701667,46.782046667],[23.704481667,46.781963333],[23.705373333,46.783488333],[23.70895,46.785328333],[23.712993333,46.786143333],[23.715855,46.787601667],[23.717623333,46.790305],[23.717996667,46.795338333],[23.717245,46.797466667],[23.721291667,46.799023333],[23.722961667,46.799983333],[23.727538333,46.803316667],[23.732593333,46.806103333],[23.734278333,46.807536667],[23.7353,46.809246667],[23.737676667,46.814761667],[23.742068333,46.819178333],[23.74355,46.821515],[23.74477,46.822413333],[23.744493333,46.82328],[23.745905,46.83219],[23.747138333,46.838088333],[23.755991667,46.851566667],[23.774598333,46.879678333],[23.775398333,46.881156667],[23.776478333,46.884775],[23.779026667,46.888731667],[23.779521667,46.890041667],[23.77859,46.893718333],[23.774198333,46.901611667],[23.773345,46.905365],[23.773456667,46.907055],[23.7752,46.90932],[23.776858333,46.913045],[23.780238333,46.916901667],[23.789571667,46.94014],[23.790205,46.941413333],[23.79561,46.94962],[23.79582,46.95041],[23.795555,46.957203333],[23.795775,46.958443333],[23.798736667,46.964493333],[23.805361667,46.978483333],[23.806346667,46.98088],[23.80846,46.982381667],[23.810005,46.984155],[23.811606667,46.987336667],[23.813101667,46.988665],[23.826955,46.995313333],[23.833706667,47.000878333],[23.838776667,47.004091667],[23.842476667,47.005603333],[23.861303333,47.010923333],[23.86308,47.011625],[23.867283333,47.014465],[23.875151667,47.02102],[23.88793,47.027285],[23.889355,47.028255],[23.8938,47.03312],[23.89813,47.036938333],[23.899756667,47.040575],[23.900615,47.043231667],[23.900981667,47.047283333],[23.90101,47.053755],[23.909245,47.063735],[23.91011,47.065468333],[23.909891667,47.067248333],[23.908058333,47.071553333],[23.907988333,47.072558333],[23.909805,47.079103333],[23.909336667,47.085161667],[23.905345,47.092666667],[23.902333333,47.09757],[23.892883333,47.12013],[23.893233333,47.121046667],[23.897651667,47.127591667],[23.899448333,47.136336667],[23.89772,47.139535],[23.893573333,47.141568333],[23.888443333,47.143141667],[23.885925,47.143248333],[23.883473333,47.143943333],[23.87787,47.146585],[23.879048333,47.14863],[23.878586667,47.149928333],[23.875293333,47.151835],[23.87487,47.153918333],[23.879413333,47.155586667],[23.882323333,47.156186667],[23.89268,47.161308333],[23.899506667,47.165093333],[23.901141667,47.16574],[23.908813333,47.167528333],[23.912468333,47.168828333],[23.916321667,47.169556667],[23.918768333,47.17032],[23.923618333,47.17091],[23.931866667,47.173163333],[23.95282,47.17931],[23.97244,47.185211667],[23.99387,47.188238333],[24.001385,47.189788333],[24.010758333,47.192135],[24.013498333,47.193065],[24.015245,47.19461],[24.019641667,47.196741667],[24.021286667,47.197211667],[24.025506667,47.197016667],[24.037575,47.199253333],[24.042956667,47.200121667],[24.059545,47.201256667],[24.06207,47.201873333],[24.070643333,47.200828333],[24.0727,47.200163333],[24.081138333,47.195893333],[24.087378333,47.193476667],[24.089985,47.193365],[24.092995,47.193678333],[24.095285,47.193038333],[24.098596667,47.191128333],[24.104556667,47.189283333],[24.113458333,47.188355],[24.116481667,47.187583333],[24.129861667,47.183605],[24.136343333,47.182196667],[24.138605,47.18147],[24.140813333,47.180118333],[24.147126667,47.178223333],[24.1508,47.178971667],[24.159813333,47.178486667],[24.162313333,47.179578333],[24.16687,47.182495],[24.168178333,47.185161667],[24.17001,47.18719],[24.17361,47.188298333],[24.177196667,47.18836],[24.179116667,47.187896667],[24.180976667,47.1882],[24.187058333,47.190571667],[24.189805,47.192886667],[24.190943333,47.193366667],[24.193395,47.193346667],[24.195788333,47.194015],[24.201466667,47.197266667],[24.202341667,47.199651667],[24.208425,47.203815],[24.213428333,47.207973333],[24.218158333,47.211325],[24.22016,47.211688333],[24.223351667,47.213505],[24.22689,47.217738333],[24.229188333,47.221145],[24.237348333,47.232505],[24.239225,47.234488333],[24.241111667,47.23504],[24.252116667,47.242118333],[24.25958,47.245903333],[24.262335,47.247078333],[24.265188333,47.249986667],[24.267743333,47.250603333],[24.270811667,47.250583333],[24.27394,47.252626667],[24.274943333,47.254666667],[24.279181667,47.256808333],[24.286106667,47.258266667],[24.288246667,47.259263333],[24.292505,47.259568333],[24.293335,47.26061],[24.29106,47.263943333],[24.292948333,47.2667],[24.296515,47.266025],[24.297315,47.266585],[24.300061667,47.27126],[24.30248,47.2739],[24.313746667,47.27681],[24.316316667,47.27861],[24.319228333,47.281498333],[24.32017,47.283538333],[24.322626667,47.286083333],[24.327505,47.289695],[24.32989,47.292831667],[24.333753333,47.29669],[24.335021667,47.298925],[24.338948333,47.301958333],[24.342946667,47.30432],[24.345306667,47.305406667],[24.348151667,47.307385],[24.35042,47.307926667],[24.352535,47.307345],[24.353405,47.308363333],[24.357473333,47.311298333],[24.357125,47.313126667],[24.358255,47.314681667],[24.361323333,47.316636667],[24.363301667,47.316841667],[24.36575,47.318881667],[24.368618333,47.320138333],[24.372016667,47.32411],[24.372443333,47.327481667],[24.374938333,47.330371667],[24.383095,47.334148333],[24.385355,47.336806667],[24.385711667,47.338006667],[24.384136667,47.339953333],[24.38397,47.344028333],[24.384728333,47.348411667],[24.385705,47.35005],[24.38764,47.350341667],[24.388875,47.351961667],[24.388288333,47.3546],[24.385535,47.35678],[24.385101667,47.358078333],[24.385563333,47.359506667],[24.38782,47.36134],[24.392748333,47.367105],[24.393751667,47.370626667],[24.392218333,47.373251667],[24.392076667,47.378165],[24.388658333,47.381186667],[24.386781667,47.38415],[24.38767,47.387785],[24.386981667,47.392168333],[24.385596667,47.396073333],[24.38398,47.396758333],[24.382713333,47.398298333],[24.382716667,47.401416667],[24.38538,47.404395],[24.388861667,47.406353333],[24.390568333,47.409098333],[24.390953333,47.411736667],[24.3908,47.414045],[24.392146667,47.416341667],[24.391275,47.418565],[24.39201,47.421048333],[24.392315,47.4243],[24.393515,47.427316667],[24.396405,47.430178333],[24.391523333,47.435061667],[24.389268333,47.438051667],[24.387211667,47.439161667],[24.38435,47.44176],[24.382496667,47.44391],[24.382291667,47.444766667],[24.383481667,47.446896667],[24.382483333,47.450058333],[24.382521667,47.451648333],[24.383355,47.453751667],[24.383458333,47.455381667],[24.385298333,47.456681667],[24.384886667,47.46234],[24.382851667,47.465496667],[24.382068333,47.469698333],[24.382478333,47.471878333],[24.386101667,47.476296667],[24.38717,47.478438333],[24.387971667,47.482451667],[24.385291667,47.484825],[24.385781667,47.486233333],[24.38548,47.488418333],[24.384531667,47.489105],[24.38495,47.491103333],[24.388026667,47.493401667],[24.388588333,47.496975],[24.390591667,47.498685],[24.391326667,47.500296667],[24.38976,47.502523333],[24.390603333,47.506883333],[24.393216667,47.508753333],[24.393701667,47.509941667],[24.392386667,47.512258333],[24.393971667,47.515031667],[24.39673,47.517166667],[24.39757,47.5183],[24.399066667,47.521713333],[24.400368333,47.523146667],[24.40047,47.524416667],[24.401946667,47.525378333],[24.40754,47.530186667],[24.41175,47.53177],[24.414688333,47.533323333],[24.418076667,47.533708333],[24.420011667,47.533518333],[24.422958333,47.534795],[24.424646667,47.535948333],[24.426401667,47.536401667],[24.43289,47.540541667],[24.43455,47.542758333],[24.434858333,47.544901667],[24.437328333,47.549278333],[24.436295,47.555525],[24.434763333,47.558103333],[24.431785,47.560436667],[24.429391667,47.563371667],[24.422886667,47.566681667],[24.419041667,47.570066667],[24.416841667,47.570965],[24.41558,47.572996667],[24.416776667,47.576431667],[24.418175,47.578048333],[24.42201,47.5791],[24.423978333,47.580496667],[24.422886667,47.582098333],[24.423901667,47.583811667],[24.422581667,47.585073333],[24.423761667,47.586511667],[24.42435,47.590025],[24.425765,47.590886667],[24.423648333,47.591186667],[24.421861667,47.590646667],[24.42067,47.591645],[24.42256,47.593495],[24.42201,47.594843333],[24.417203333,47.599085],[24.417448333,47.602811667],[24.415238333,47.603373333],[24.41539,47.604955],[24.419676667,47.605963333],[24.421628333,47.608228333],[24.42344,47.607626667],[24.42543,47.608648333],[24.425155,47.609446667],[24.428485,47.611425],[24.430088333,47.61286],[24.431968333,47.613266667],[24.435646667,47.615696667],[24.438685,47.618556667],[24.438855,47.619411667],[24.442205,47.623088333],[24.442915,47.62492],[24.443655,47.629245],[24.443216667,47.632478333],[24.456046667,47.6315],[24.472366667,47.62742],[24.477446667,47.62767],[24.480116667,47.628226667],[24.485398333,47.627686667],[24.489955,47.628451667],[24.491283333,47.628295],[24.496883333,47.629561667],[24.500105,47.629628333],[24.504086667,47.630596667],[24.5056,47.631416667],[24.505961667,47.632705],[24.509653333,47.63478],[24.512998333,47.635233333],[24.511335,47.636255],[24.511726667,47.63697],[24.52054,47.63946],[24.524246667,47.639115],[24.524006667,47.640605],[24.522221667,47.642345],[24.52344,47.642975],[24.521233333,47.644598333],[24.519856667,47.643713333],[24.521666667,47.646203333],[24.521701667,47.64706],[24.520245,47.648555],[24.51752,47.650543333],[24.515441667,47.65516],[24.516401667,47.655731667],[24.520035,47.65611],[24.522548333,47.656736667],[24.524473333,47.656248333],[24.526893333,47.654871667],[24.531035,47.655603333],[24.533051667,47.65662],[24.536253333,47.65622],[24.541763333,47.654753333],[24.550915,47.653328333],[24.557063333,47.65529],[24.560336667,47.655711667],[24.564251667,47.654771667],[24.571296667,47.654903333],[24.573723333,47.655138333],[24.585836667,47.655495],[24.595033333,47.654453333],[24.60095,47.653455],[24.602898333,47.653506667],[24.615843333,47.655645],[24.61981,47.656515],[24.622238333,47.656758333],[24.631006667,47.659995],[24.635923333,47.66082],[24.646246667,47.65851],[24.651358333,47.657023333],[24.657453333,47.65619],[24.662815,47.656751667],[24.668911667,47.65386],[24.67969,47.650738333],[24.692943333,47.64902],[24.696671667,47.64883],[24.699721667,47.649055],[24.706333333,47.647426667],[24.711661667,47.64649],[24.721866667,47.64199],[24.740238333,47.633741667],[24.742568333,47.632063333],[24.743506667,47.629168333],[24.746588333,47.627158333],[24.753761667,47.625681667],[24.760183333,47.624608333],[24.76344,47.624751667],[24.764433333,47.623193333],[24.76665,47.622173333],[24.767771667,47.620701667],[24.769618333,47.620766667],[24.772811667,47.618691667],[24.774888333,47.617736667],[24.77967,47.61799],[24.781496667,47.618831667],[24.78619,47.619286667],[24.790876667,47.619128333],[24.792016667,47.6184],[24.793771667,47.61843],[24.796023333,47.619695],[24.802575,47.619471667],[24.804221667,47.620011667],[24.808496667,47.620365],[24.809095,47.621788333],[24.810836667,47.622415],[24.81251,47.621445],[24.815425,47.621566667],[24.816833333,47.624616667],[24.820231667,47.625913333],[24.818491667,47.623793333],[24.818411667,47.621921667],[24.81993,47.621348333],[24.822851667,47.62174],[24.827455,47.621668333],[24.832816667,47.621025],[24.835406667,47.619906667],[24.839596667,47.619273333],[24.838998333,47.61867],[24.835623333,47.618111667],[24.834426667,47.617315],[24.828603333,47.616073333],[24.82571,47.615866667],[24.828775,47.615113333],[24.832675,47.614838333],[24.837813333,47.615265],[24.839461667,47.61599],[24.841171667,47.615801667],[24.844663333,47.617003333],[24.846163333,47.617085],[24.844405,47.615763333],[24.839558333,47.61426],[24.837095,47.611923333],[24.834318333,47.611533333],[24.838466667,47.611668333],[24.840086667,47.612601667],[24.844403333,47.612895],[24.846496667,47.611836667],[24.851381667,47.610968333],[24.854106667,47.611188333],[24.85623,47.611913333],[24.860786667,47.611845],[24.857701667,47.610706667],[24.855646667,47.60889],[24.848853333,47.607445],[24.848805,47.60707],[24.852451667,47.607161667],[24.855798333,47.607786667],[24.859625,47.607868333],[24.863615,47.606825],[24.862935,47.605721667],[24.861093333,47.604701667],[24.861466667,47.60097],[24.862023333,47.599675],[24.865101667,47.597228333],[24.871475,47.595996667],[24.873636667,47.596648333],[24.874165,47.597431667],[24.876525,47.598676667],[24.882668333,47.599683333],[24.88754,47.601405],[24.887345,47.602623333],[24.883586667,47.605923333],[24.885666667,47.605466667],[24.8901,47.601608333],[24.893918333,47.602838333],[24.899228333,47.603198333],[24.90578,47.602605],[24.909175,47.60182],[24.913535,47.599026667],[24.917005,47.59863],[24.919685,47.598913333],[24.925866667,47.597908333],[24.927085,47.598703333],[24.929196667,47.598373333],[24.932813333,47.59856],[24.939196667,47.597268333],[24.941281667,47.597618333],[24.945016667,47.597613333],[24.951961667,47.59673],[24.958703333,47.596575],[24.960971667,47.597628333],[24.968066667,47.595026667],[24.974168333,47.593143333],[24.97905,47.590631667],[24.979401667,47.58932],[24.985355,47.587086667],[24.992196667,47.586038333],[24.99038,47.58409],[24.991061667,47.581663333],[24.994188333,47.581113333],[24.99875,47.584183333],[25.000235,47.584135],[24.996951667,47.577138333],[24.998836667,47.576733333],[24.999511667,47.57586],[25.002368333,47.574496667],[25.003073333,47.573636667],[25.008945,47.56973],[25.012201667,47.569038333],[25.014905,47.569136667],[25.02566,47.5653],[25.033805,47.561255],[25.034608333,47.561073333],[25.038708333,47.56191],[25.04364,47.56087],[25.047718333,47.561696667],[25.051285,47.560453333],[25.053591667,47.562031667],[25.057326667,47.562288333],[25.061406667,47.561576667],[25.063771667,47.562451667],[25.065498333,47.56431],[25.069161667,47.565111667],[25.07286,47.567276667],[25.070418333,47.567851667],[25.0695,47.567013333],[25.068975,47.569485],[25.069123333,47.572491667],[25.071501667,47.574191667],[25.07422,47.575216667],[25.08129,47.575928333],[25.084063333,47.576515],[25.086175,47.575743333],[25.089223333,47.573651667],[25.09208,47.572633333],[25.094293333,47.573403333],[25.099421667,47.574518333],[25.101986667,47.574503333],[25.10408,47.573726667],[25.105343333,47.574263333],[25.105481667,47.573186667],[25.107163333,47.573346667],[25.108146667,47.57275],[25.111218333,47.57332],[25.114395,47.57326],[25.119266667,47.57373],[25.120945,47.57363],[25.12764,47.571106667],[25.130155,47.569496667],[25.13353,47.568443333],[25.14126,47.567025],[25.154298333,47.562741667],[25.15919,47.557195],[25.159378333,47.554306667],[25.161668333,47.552875],[25.166626667,47.551341667],[25.168163333,47.549176667],[25.169715,47.54822],[25.170695,47.54529],[25.171666667,47.54359],[25.174715,47.540901667],[25.17479,47.539368333],[25.175748333,47.538328333],[25.181481667,47.535881667],[25.18233,47.533816667],[25.183648333,47.53311],[25.188858333,47.533335],[25.190908333,47.532321667],[25.200321667,47.528876667],[25.201198333,47.5279],[25.20176,47.523231667],[25.202825,47.522825],[25.204726667,47.523395],[25.206693333,47.523291667],[25.211631667,47.521058333],[25.214456667,47.519465],[25.218506667,47.518141667],[25.222763333,47.517556667],[25.225551667,47.514508333],[25.22969,47.511413333],[25.233281667,47.509003333],[25.2359,47.506473333],[25.239566667,47.50437],[25.24454,47.502816667],[25.249403333,47.502268333],[25.254731667,47.5013],[25.257276667,47.499726667],[25.261031667,47.498446667],[25.261385,47.4977],[25.261001667,47.495018333],[25.259823333,47.492086667],[25.260135,47.490621667],[25.26266,47.487853333],[25.266106667,47.486263333],[25.273618333,47.483821667],[25.278018333,47.48034],[25.279523333,47.478665],[25.27886,47.476513333],[25.278783333,47.473766667],[25.279281667,47.47256],[25.278678333,47.47],[25.281078333,47.46671],[25.281906667,47.463496667],[25.28384,47.462236667],[25.28803,47.460833333],[25.292631667,47.460086667],[25.29516,47.458685],[25.295596667,47.45696],[25.293033333,47.451786667],[25.291001667,47.450465],[25.290445,47.448593333],[25.293928333,47.446776667],[25.295641667,47.44466],[25.29657,47.4443],[25.302446667,47.443518333],[25.304965,47.441911667],[25.306488333,47.442406667],[25.305078333,47.441088333],[25.305705,47.438656667],[25.3051,47.436756667],[25.305705,47.434535],[25.305638333,47.432258333],[25.308518333,47.428676667],[25.312501667,47.424835],[25.310475,47.419481667],[25.30926,47.417705],[25.309326667,47.415005],[25.308678333,47.412265],[25.306431667,47.408301667],[25.30533,47.407373333],[25.298115,47.40475],[25.299383333,47.402975],[25.303096667,47.401271667],[25.30717,47.401263333],[25.30868,47.400121667],[25.307251667,47.390663333],[25.307488333,47.389078333],[25.308493333,47.387965],[25.312296667,47.386085],[25.315066667,47.385525],[25.321958333,47.382661667],[25.323878333,47.380615],[25.32554,47.377295],[25.327196667,47.375213333],[25.330271667,47.372233333],[25.335983333,47.370038333],[25.340165,47.368985],[25.345036667,47.367206667],[25.350531667,47.362053333],[25.351591667,47.358896667],[25.356528333,47.353863333],[25.359328333,47.352018333],[25.362016667,47.3491],[25.36053,47.347678333],[25.357063333,47.347771667],[25.352441667,47.346861667],[25.347768333,47.347275],[25.345765,47.348048333],[25.349721667,47.348021667],[25.349801667,47.348981667],[25.352031667,47.346063333],[25.34992,47.348145],[25.350778333,47.348373333],[25.351371667,47.347128333],[25.361856667,47.338593333],[25.349456667,47.348921667],[25.348658333,47.3503],[25.349965,47.350471667],[25.349881667,47.348061667],[25.346441667,47.34779],[25.353688333,47.345773333],[25.355826667,47.345921667],[25.360368333,47.34753],[25.361825,47.349141667],[25.361008333,47.350485],[25.356225,47.35419],[25.351558333,47.35909],[25.350725,47.361915],[25.345831667,47.366716667],[25.344791667,47.367456667],[25.34055,47.369013333],[25.33679,47.369976667],[25.330191667,47.372443333],[25.32863,47.373771667],[25.32589,47.376898333],[25.324151667,47.380343333],[25.322153333,47.382556667],[25.314961667,47.385458333],[25.312895,47.385836667],[25.308988333,47.387643333],[25.307381667,47.389428333],[25.30739,47.391515],[25.308071667,47.393418333],[25.308061667,47.400165],[25.306231667,47.401688333],[25.3031,47.401378333],[25.298813333,47.403613333],[25.299176667,47.405251667],[25.303996667,47.406921667],[25.306223333,47.408215],[25.307675,47.410536667],[25.308653333,47.413081667],[25.309281667,47.418305],[25.312193333,47.42332],[25.311605,47.42609],[25.308398333,47.428748333],[25.305618333,47.432076667],[25.305781667,47.434121667],[25.305126667,47.43672],[25.305613333,47.438676667],[25.304998333,47.441161667],[25.306466667,47.442465],[25.309498333,47.444163333],[25.311225,47.445821667],[25.31421,47.447193333],[25.316236667,47.448621667],[25.324555,47.450525],[25.326758333,47.450226667],[25.330235,47.450703333],[25.332803333,47.452428333],[25.33488,47.45533],[25.334078333,47.455933333],[25.33077,47.454666667],[25.32885,47.453105],[25.328278333,47.453388333],[25.330216667,47.455681667],[25.332656667,47.459271667],[25.33267,47.460743333],[25.335221667,47.464248333],[25.337433333,47.464331667],[25.33898,47.46545],[25.34238,47.464653333],[25.343843333,47.464676667],[25.348123333,47.463938333],[25.35193,47.464168333],[25.353406667,47.463711667],[25.353328333,47.462056667],[25.353975,47.460546667],[25.355075,47.459925],[25.35935,47.460801667],[25.359123333,47.46127],[25.356235,47.461066667],[25.355535,47.462365],[25.357811667,47.465396667],[25.357295,47.462913333],[25.358396667,47.462528333],[25.362071667,47.464763333],[25.360031667,47.464383333],[25.361313333,47.46666],[25.363375,47.468298333],[25.365355,47.471098333],[25.366123333,47.475035],[25.366765,47.476708333],[25.368883333,47.479031667],[25.372553333,47.481376667],[25.373028333,47.482806667],[25.374963333,47.48492],[25.377563333,47.48569],[25.380968333,47.4876],[25.385555,47.491418333],[25.38913,47.492383333],[25.392511667,47.492731667],[25.396376667,47.493506667],[25.399835,47.495843333],[25.402095,47.499078333],[25.40226,47.501373333],[25.403783333,47.50262],[25.406231667,47.503313333],[25.40992,47.503481667],[25.413621667,47.505505],[25.41841,47.50751],[25.425303333,47.507775],[25.428976667,47.507466667],[25.431841667,47.509946667],[25.43449,47.51116],[25.440815,47.512066667],[25.445451667,47.514303333],[25.451315,47.51598],[25.453306667,47.516851667],[25.45685,47.520225],[25.459965,47.523955],[25.464426667,47.526256667],[25.466015,47.52644],[25.470315,47.525326667],[25.47401,47.525771667],[25.480655,47.527056667],[25.484876667,47.529578333],[25.496746667,47.53508],[25.501183333,47.53479],[25.503151667,47.535275],[25.506046667,47.534831667],[25.511451667,47.535196667],[25.514595,47.535763333],[25.530548333,47.536106667],[25.53812,47.536036667],[25.539545,47.535801667],[25.545668333,47.533791667],[25.549778333,47.532641667],[25.555956667,47.530216667],[25.564783333,47.527886667],[25.575326667,47.525775],[25.585283333,47.521295],[25.590053333,47.51896],[25.60006,47.516916667],[25.621648333,47.510096667],[25.623075,47.510176667],[25.626413333,47.512878333],[25.627826667,47.51526],[25.634215,47.51955],[25.64545,47.526836667],[25.648133333,47.52744],[25.64903,47.528831667],[25.648398333,47.529803333],[25.645903333,47.531126667],[25.644826667,47.532573333],[25.646255,47.535661667],[25.64751,47.536328333],[25.651625,47.536241667],[25.655033333,47.538461667],[25.656368333,47.542203333],[25.657203333,47.547193333],[25.659406667,47.54942],[25.679826667,47.557788333],[25.687091667,47.562621667],[25.688791667,47.564335],[25.691896667,47.569071667],[25.691103333,47.57204],[25.693853333,47.5744],[25.696095,47.574218333],[25.699693333,47.572565],[25.703251667,47.573616667],[25.708088333,47.573731667],[25.711028333,47.573165],[25.713418333,47.573248333],[25.717995,47.574116667],[25.719645,47.574075],[25.722803333,47.572648333],[25.727831667,47.570835],[25.728998333,47.570121667],[25.737105,47.561986667],[25.738595,47.561418333],[25.747128333,47.560173333],[25.749896667,47.558226667],[25.758266667,47.555313333],[25.761348333,47.55375],[25.762413333,47.55239],[25.764228333,47.548956667],[25.76653,47.547655],[25.77107,47.546753333],[25.775395,47.54558],[25.778661667,47.545326667],[25.799235,47.53853],[25.80005,47.538433333],[25.837118333,47.542203333],[25.84023,47.542136667],[25.843193333,47.543885],[25.848585,47.545163333],[25.853416667,47.544833333],[25.861568333,47.545085],[25.8657,47.545815],[25.86824,47.54702],[25.889523333,47.55457],[25.890871667,47.554525],[25.896171667,47.552741667],[25.901305,47.552951667],[25.904905,47.55283],[25.912725,47.552235],[25.914245,47.552326667],[25.919113333,47.553436667],[25.921025,47.55429],[25.922436667,47.554143333],[25.944946667,47.545228333],[25.946276667,47.544786667],[25.947528333,47.54536],[25.953978333,47.550923333],[25.955348333,47.556728333],[25.954236667,47.559213333],[25.95407,47.565333333],[25.959545,47.569595],[25.966956667,47.571316667],[25.971706667,47.571511667],[25.974603333,47.57211],[25.976126667,47.57348],[25.981086667,47.575486667],[25.9843,47.57629],[25.994813333,47.579358333],[25.997788333,47.579241667],[25.999798333,47.578713333],[26.001863333,47.578771667],[26.005323333,47.579598333],[26.006241667,47.580428333],[26.007316667,47.58302],[26.008511667,47.58378],[26.016505,47.587011667],[26.019736667,47.58984],[26.020213333,47.591876667],[26.021336667,47.59318],[26.019833333,47.595806667],[26.021163333,47.59766],[26.021108333,47.599231667],[26.019543333,47.602201667],[26.019791667,47.604988333],[26.021266667,47.606333333],[26.03444,47.609656667],[26.039706667,47.610168333],[26.041125,47.609783333],[26.054975,47.610103333],[26.05737,47.610383333],[26.074726667,47.616653333],[26.075891667,47.617253333],[26.084143333,47.622631667],[26.089301667,47.623513333],[26.093575,47.622645],[26.096368333,47.623375],[26.100773333,47.62303],[26.10298,47.623755],[26.109865,47.62422],[26.114503333,47.623828333],[26.117643333,47.62529],[26.119371667,47.626545],[26.127651667,47.629841667],[26.139038333,47.633513333],[26.16179,47.640551667],[26.16552,47.642208333],[26.167758333,47.642861667],[26.196793333,47.649613333],[26.210058333,47.652753333],[26.2114,47.652816667],[26.21911,47.650048333],[26.220598333,47.649866667],[26.22506,47.650141667],[26.22664,47.64906],[26.227528333,47.647126667],[26.22988,47.645696667],[26.232643333,47.642066667],[26.238311667,47.63734],[26.238981667,47.637408333],[26.24702,47.640211667],[26.248428333,47.64052],[26.25853,47.64084],[26.252863333,47.640906667],[26.247898333,47.640545],[26.242948333,47.639078333],[26.238955,47.63737],[26.234275,47.63572],[26.228311667,47.632766667],[26.231853333,47.628293333],[26.23484,47.626448333],[26.242076667,47.619326667],[26.243381667,47.617221667],[26.244958333,47.612321667],[26.246566667,47.609905],[26.250578333,47.605648333],[26.25169,47.603475],[26.256725,47.595586667],[26.266333333,47.584528333],[26.267421667,47.583028333],[26.272218333,47.573625],[26.274655,47.56967],[26.274748333,47.568421667],[26.270285,47.557938333],[26.270433333,47.556655],[26.269431667,47.551756667],[26.27086,47.549205],[26.270853333,47.546678333],[26.269481667,47.54419],[26.26925,47.542811667],[26.26994,47.539553333],[26.273331667,47.534208333],[26.279731667,47.526878333],[26.281443333,47.5256],[26.285173333,47.520121667],[26.286086667,47.516321667],[26.28676,47.515108333],[26.28643,47.513933333],[26.284991667,47.512705],[26.284383333,47.508328333],[26.285163333,47.50334],[26.282186667,47.498736667],[26.281551667,47.496296667],[26.282575,47.494326667],[26.285115,47.491308333],[26.287491667,47.489865],[26.291601667,47.488148333],[26.291923333,47.486071667],[26.291495,47.484445],[26.291935,47.482671667],[26.291321667,47.477781667],[26.291498333,47.476468333],[26.29526,47.470671667],[26.296931667,47.468803333],[26.299758333,47.464818333],[26.302166667,47.46241],[26.302561667,47.460485],[26.300901667,47.459123333],[26.298823333,47.456453333],[26.29632,47.453966667],[26.29601,47.4531],[26.296421667,47.450256667],[26.294993333,47.449466667],[26.293985,47.446386667],[26.294301667,47.444915],[26.294135,47.441353333],[26.297586667,47.437863333],[26.298351667,47.434298333],[26.29989,47.432186667],[26.298196667,47.4299],[26.29825,47.42918],[26.316596667,47.412363333],[26.323201667,47.40612],[26.324486667,47.402398333],[26.324476667,47.401133333],[26.323416667,47.398951667],[26.324083333,47.39753],[26.328636667,47.393886667],[26.334113333,47.38925],[26.3363,47.388348333],[26.357005,47.383058333],[26.363728333,47.381183333],[26.365233333,47.380465],[26.371393333,47.376388333],[26.38118,47.370346667],[26.384186667,47.368626667],[26.391765,47.362931667],[26.395773333,47.36153],[26.39979,47.361041667],[26.405115,47.355486667],[26.407413333,47.353913333],[26.429986667,47.340771667],[26.457231667,47.32482],[26.462766667,47.320353333],[26.47957,47.306418333],[26.484811667,47.30303],[26.48626,47.301378333],[26.490233333,47.294445],[26.496253333,47.289713333],[26.503141667,47.284088333],[26.508256667,47.279555],[26.513161667,47.275658333],[26.517598333,47.273331667],[26.527816667,47.268326667],[26.544653333,47.259468333],[26.549071667,47.256811667],[26.55425,47.254911667],[26.567583333,47.250345],[26.578971667,47.242396667],[26.590116667,47.234951667],[26.59815,47.227393333],[26.61017,47.209908333],[26.612451667,47.206803333],[26.617066667,47.199956667],[26.622003333,47.192333333],[26.632135,47.177275],[26.633368333,47.175271667],[26.634665,47.167996667],[26.634735,47.164406667],[26.635881667,47.15956],[26.636708333,47.157723333],[26.645208333,47.147358333],[26.647593333,47.145811667],[26.655243333,47.143076667],[26.656603333,47.142046667],[26.663548333,47.13325],[26.670191667,47.125273333],[26.672473333,47.123128333],[26.684303333,47.110813333],[26.695826667,47.100575],[26.714923333,47.086988333],[26.744326667,47.069613333],[26.769288333,47.060585],[26.782886667,47.055418333],[26.786141667,47.054066667],[26.805488333,47.047223333],[26.816908333,47.042911667],[26.82032,47.041776667],[26.834683333,47.03639],[26.840023333,47.034758333],[26.87617,47.029145],[26.88085,47.028363333],[26.883131667,47.026835],[26.904673333,46.987556667],[26.905431667,46.985781667],[26.91187,46.964478333],[26.920491667,46.935513333],[26.921785,46.93062],[26.927598333,46.930348333],[26.929605,46.924175],[26.929095,46.920885],[26.928521667,46.920358333],[26.92515,46.919348333],[26.918205,46.913446667],[26.907398333,46.893231667],[26.890478333,46.862185],[26.883373333,46.848885],[26.882888333,46.846981667],[26.88601,46.8156],[26.887231667,46.802543333],[26.887078333,46.799248333],[26.891035,46.783458333],[26.890911667,46.781968333],[26.888816667,46.775435],[26.887723333,46.773548333],[26.881888333,46.767036667],[26.88127,46.765085],[26.885201667,46.74215],[26.886481667,46.735435],[26.889213333,46.719131667],[26.894053333,46.691883333],[26.897286667,46.682846667],[26.901521667,46.67043],[26.910861667,46.643796667],[26.913971667,46.634756667],[26.917795,46.624081667],[26.923646667,46.613745],[26.930268333,46.602686667],[26.930678333,46.60182],[26.929943333,46.579615],[26.931208333,46.575416667],[26.930276667,46.574121667],[26.928538333,46.573516667],[26.915041667,46.570028333],[26.91683,46.566511667],[26.916446667,46.564273333],[26.913171667,46.560936667],[26.911596667,46.557863333],[26.911738333,46.555685],[26.920863333,46.528425],[26.923093333,46.519871667],[26.925675,46.507786667],[26.925618333,46.506171667],[26.921508333,46.487833333],[26.918023333,46.471763333],[26.913863333,46.453346667],[26.91373,46.450518333],[26.91595,46.446523333],[26.931615,46.421973333],[26.93603,46.414801667],[26.94445,46.401668333],[26.95455,46.386751667],[26.95625,46.38495],[26.963975,46.379373333],[26.967583333,46.376595],[26.977776667,46.369258333],[26.988993333,46.361378333],[26.99041,46.359306667],[26.99359,46.353268333],[26.998935,46.3426],[27.00294,46.334933333],[27.003623333,46.334073333],[27.009838333,46.328556667],[27.025031667,46.310873333],[27.03393,46.300738333],[27.04016,46.293861667],[27.054748333,46.278955],[27.064636667,46.269046667],[27.07758,46.255698333],[27.080883333,46.252138333],[27.082363333,46.249713333],[27.085096667,46.24262],[27.087633333,46.23897],[27.095345,46.227425],[27.101035,46.21921],[27.109383333,46.206415],[27.118256667,46.19198],[27.136118333,46.162513333],[27.140996667,46.154813333],[27.145775,46.146966667],[27.1509,46.13908],[27.155971667,46.130711667],[27.161846667,46.12165],[27.165245,46.117668333],[27.179616667,46.101236667],[27.182126667,46.098626667],[27.187155,46.095406667],[27.188788333,46.09223],[27.191376667,46.085836667],[27.195545,46.081438333],[27.196796667,46.080456667],[27.200316667,46.078965],[27.20179,46.07791],[27.202616667,46.075806667],[27.20214,46.074251667],[27.199486667,46.070066667],[27.196805,46.067451667],[27.192741667,46.062988333],[27.18751,46.05673],[27.187016667,46.05467],[27.18665,46.047761667],[27.18713,46.043325],[27.188201667,46.036521667],[27.19064,46.019775],[27.191538333,46.015865],[27.19239,46.008455],[27.192391667,46.003403333],[27.191945,46.000188333],[27.191728333,45.994543333],[27.191243333,45.989183333],[27.191511667,45.987496667],[27.193036667,45.983895],[27.200046667,45.96872],[27.204298333,45.958953333],[27.207061667,45.936223333],[27.209535,45.914536667],[27.209408333,45.908718333],[27.209755,45.906951667],[27.20997,45.887011667],[27.210326667,45.86054],[27.210015,45.85728],[27.207903333,45.854021667],[27.208188333,45.852176667],[27.209981667,45.85002],[27.210395,45.848276667],[27.21108,45.82028],[27.210296667,45.816815],[27.211716667,45.81157],[27.213423333,45.807183333],[27.214441667,45.801563333],[27.215813333,45.796556667],[27.215715,45.792248333],[27.214935,45.789193333],[27.205781667,45.773906667],[27.204366667,45.770328333],[27.200511667,45.73517],[27.199453333,45.725928333],[27.197795,45.710338333],[27.199033333,45.708661667],[27.202415,45.70588],[27.203026667,45.704768333],[27.203185,45.702605],[27.20294,45.698171667],[27.20289,45.692325],[27.20146,45.689856667],[27.197468333,45.686958333],[27.19341,45.683693333],[27.19165,45.681753333],[27.189736667,45.678776667],[27.187543333,45.676628333],[27.183533333,45.674748333],[27.170636667,45.671293333],[27.165895,45.670451667],[27.164508333,45.668591667],[27.165405,45.664623333],[27.165251667,45.663376667],[27.163348333,45.659928333],[27.161196667,45.657381667],[27.158575,45.655033333],[27.129155,45.632758333],[27.127976667,45.6315],[27.115738333,45.615643333],[27.110575,45.608655],[27.100408333,45.595145],[27.098443333,45.591605],[27.098481667,45.589456667],[27.099288333,45.579788333],[27.099875,45.577831667],[27.104296667,45.571003333],[27.105086667,45.569036667],[27.106911667,45.555841667],[27.1058,45.553166667],[27.105875,45.551936667],[27.107645,45.547871667],[27.107573333,45.546705],[27.105408333,45.544626667],[27.105148333,45.542908333],[27.107086667,45.539471667],[27.106395,45.538021667],[27.10396,45.535756667],[27.09953,45.533461667],[27.097783333,45.532233333],[27.085136667,45.518116667],[27.083958333,45.516465],[27.077188333,45.503556667],[27.075515,45.501268333],[27.07574,45.497148333],[27.074918333,45.494541667],[27.060803333,45.476233333],[27.057993333,45.47239],[27.057663333,45.47127],[27.056845,45.464853333],[27.056816667,45.46255],[27.057603333,45.45401],[27.057111667,45.448483333],[27.054056667,45.440708333],[27.053925,45.438138333],[27.054813333,45.435483333],[27.054805,45.433708333],[27.051368333,45.418461667],[27.049015,45.408401667],[27.047145,45.399768333],[27.045438333,45.393048333],[27.04254,45.389965],[27.04077,45.38299],[27.034491667,45.380923333],[27.03291,45.379765],[27.032301667,45.375171667],[27.03167,45.373448333],[27.029451667,45.37116],[27.026866667,45.3697],[27.006523333,45.356658333],[26.975038333,45.336571667],[26.957471667,45.325293333],[26.94676,45.318543333],[26.941223333,45.314898333],[26.924616667,45.30432],[26.923493333,45.303483333],[26.922261667,45.301321667],[26.921486667,45.29752],[26.919196667,45.295598333],[26.910443333,45.290191667],[26.908298333,45.288696667],[26.906628333,45.28678],[26.894765,45.26907],[26.885371667,45.255221667],[26.876603333,45.241995],[26.868768333,45.23069],[26.85895,45.216133333],[26.846366667,45.197233333],[26.844543333,45.194636667],[26.840888333,45.19064],[26.839156667,45.189465],[26.833528333,45.187398333],[26.829985,45.181856667],[26.824741667,45.17419],[26.819948333,45.169986667],[26.818073333,45.167446667],[26.817775,45.165931667],[26.815946667,45.16197],[26.81617,45.159498333],[26.817495,45.151666667],[26.815023333,45.148298333],[26.811923333,45.1452],[26.810621667,45.144423333],[26.807795,45.141578333],[26.805768333,45.140675],[26.796848333,45.13742],[26.793031667,45.137075],[26.789681667,45.136416667],[26.783766667,45.133845],[26.777393333,45.132206667],[26.762736667,45.126586667],[26.75834,45.125028333],[26.758455,45.123025],[26.770906667,45.106796667],[26.77393,45.10312],[26.77767,45.097918333],[26.778305,45.096408333],[26.778508333,45.093661667],[26.776586667,45.085638333],[26.776445,45.08096],[26.773956667,45.074938333],[26.772646667,45.07117],[26.767778333,45.058511667],[26.766525,45.055863333],[26.765155,45.054353333],[26.760946667,45.050726667],[26.738788333,45.018913333],[26.735391667,45.013883333],[26.727983333,45.003776667],[26.723246667,44.997116667],[26.719695,44.992471667],[26.717928333,44.989653333],[26.71675,44.986583333],[26.709616667,44.969678333],[26.705855,44.961193333],[26.70285,44.95392],[26.70078,44.9484],[26.695028333,44.933615],[26.687525,44.913745],[26.687381667,44.898128333],[26.687155,44.889888333],[26.687198333,44.881886667],[26.687076667,44.866698333],[26.686796667,44.85591],[26.686575,44.854751667],[26.682635,44.84377],[26.676396667,44.826861667],[26.671983333,44.814403333],[26.669773333,44.808513333],[26.664725,44.794246667],[26.661263333,44.785056667],[26.65483,44.766923333],[26.645738333,44.745573333],[26.645193333,44.744523333],[26.631915,44.733261667],[26.630671667,44.731718333],[26.624378333,44.711376667],[26.623698333,44.710528333],[26.619645,44.707328333],[26.616621667,44.70624],[26.600988333,44.705175],[26.599355,44.704798333],[26.5857,44.7001],[26.582096667,44.69898],[26.57668,44.69862],[26.57417,44.696986667],[26.571808333,44.691218333],[26.565488333,44.682148333],[26.564318333,44.681226667],[26.555291667,44.676625],[26.55333,44.674398333],[26.551801667,44.673301667],[26.531866667,44.664143333],[26.500533333,44.64981],[26.488473333,44.641738333],[26.482423333,44.637385],[26.470753333,44.629428333],[26.468958333,44.627648333],[26.466925,44.626508333],[26.441731667,44.616596667],[26.427378333,44.608348333],[26.413536667,44.600238333],[26.401075,44.590735],[26.399471667,44.589165],[26.39786,44.586723333],[26.392165,44.58153],[26.388911667,44.576348333],[26.385675,44.571743333],[26.383001667,44.568418333],[26.374848333,44.562178333],[26.37404,44.56046],[26.374593333,44.559146667],[26.376633333,44.556721667],[26.37726,44.55484],[26.37611,44.55194],[26.37708,44.549815],[26.377108333,44.548546667],[26.376036667,44.547181667],[26.368691667,44.543238333],[26.31918,44.516388333],[26.314293333,44.51303],[26.31281,44.512341667],[26.309828333,44.51246],[26.28932,44.518331667],[26.286823333,44.51866],[26.28247,44.518458333],[26.280378333,44.518701667],[26.261825,44.523126667],[26.257738333,44.523401667],[26.25585,44.523913333],[26.251915,44.525598333],[26.245176667,44.519871667],[26.216355,44.505158333],[26.202316667,44.497946667],[26.164205,44.478476667],[26.149976667,44.471148333],[26.143126667,44.468836667],[26.138691667,44.46639],[26.13521,44.464733333],[26.132966667,44.462196667],[26.131545,44.45911],[26.125333333,44.450386667],[26.124146667,44.449501667],[26.12272,44.446855],[26.12059,44.44491],[26.116736667,44.440431667],[26.113743333,44.437558333],[26.10843,44.436448333],[26.106548333,44.436281667],[26.098586667,44.434726667],[26.089965,44.434595],[26.086613333,44.440133333],[26.085685,44.441021667],[26.080041667,44.443463333],[26.076748333,44.445655],[26.075245,44.445778333],[26.075645,44.444695],[26.081055,44.44077],[26.08069,44.439693333],[26.07497,44.435985],[26.078665,44.434111667],[26.081666667,44.433586667],[26.090953333,44.43304],[26.093646667,44.432076667],[26.096606667,44.429463333],[26.101058333,44.429095],[26.101028333,44.426871667],[26.101968333,44.425998333],[26.103473333,44.425908333],[26.104568333,44.426665],[26.12307,44.425813333],[26.122993333,44.424683333],[26.124216667,44.423983333],[26.128643333,44.423081667],[26.133755,44.420573333],[26.139713333,44.419575],[26.145585,44.417803333],[26.15508,44.41412],[26.158066667,44.413418333],[26.164186667,44.412913333],[26.171438333,44.410986667],[26.191305,44.4079],[26.207948333,44.405243333],[26.212616667,44.40555],[26.215581667,44.406391667],[26.220176667,44.406935],[26.227963333,44.406598333],[26.231171667,44.406751667],[26.239168333,44.408223333],[26.24573,44.409048333],[26.251043333,44.409101667],[26.266018333,44.408406667],[26.273693333,44.408511667],[26.281371667,44.409731667],[26.296643333,44.412985],[26.304281667,44.414945],[26.376351667,44.436615],[26.379316667,44.43742],[26.383926667,44.438281667],[26.39173,44.43878],[26.402778333,44.438585],[26.410306667,44.439015],[26.416263333,44.440143333],[26.42176,44.441915],[26.42434,44.443023333],[26.442398333,44.451296667],[26.446355,44.452876667],[26.45208,44.454441667],[26.458026667,44.45532],[26.462565,44.455515],[26.476181667,44.455263333],[26.48068,44.455086667],[26.486688333,44.454456667],[26.495665,44.452718333],[26.503933333,44.450371667],[26.510676667,44.449133333],[26.521066667,44.448688333],[26.526316667,44.448353333],[26.529828333,44.447908333],[26.549743333,44.44484],[26.555721667,44.444435],[26.561728333,44.444728333],[26.57361,44.445878333],[26.581191667,44.446881667],[26.58728,44.447423333],[26.596278333,44.447885],[26.612758333,44.449301667],[26.617305,44.449341667],[26.624803333,44.448545],[26.627758333,44.44792],[26.634633333,44.445658333],[26.639611667,44.443283333],[26.643543333,44.441733333],[26.650605,44.439911667],[26.657285,44.439158333],[26.662321667,44.439161667],[26.668518333,44.439838333],[26.671926667,44.440543333],[26.68355,44.443618333],[26.689473333,44.444626667],[26.698568333,44.445521667],[26.712936667,44.446638333],[26.71948,44.446786667],[26.73081,44.446075],[26.737163333,44.445205],[26.746186667,44.442946667],[26.749353333,44.442426667],[26.754281667,44.44201],[26.761058333,44.442205],[26.766221667,44.442808333],[26.773165,44.443206667],[26.776658333,44.44311],[26.800936667,44.441551667],[26.81439,44.440526667],[26.820801667,44.439238333],[26.825386667,44.437713333],[26.830945,44.435026667],[26.837323333,44.431368333],[26.843736667,44.42849],[26.846506667,44.42761],[26.852381667,44.426323333],[26.855441667,44.425946667],[26.861758333,44.425691667],[26.869353333,44.426506667],[26.879691667,44.428893333],[26.884376667,44.429466667],[26.889125,44.429643333],[26.893943333,44.429355],[26.918165,44.427028333],[26.926356667,44.426298333],[26.938295,44.425035],[26.955166667,44.423401667],[26.967101667,44.422715],[26.975471667,44.422608333],[26.980503333,44.422701667],[26.990463333,44.423516667],[26.997003333,44.424263333],[27.014383333,44.42655],[27.020905,44.427178333],[27.034005,44.427898333],[27.04733,44.428088333],[27.07248,44.428115],[27.079131667,44.42823],[27.107953333,44.428513333],[27.114751667,44.428148333],[27.14389,44.424815],[27.15034,44.424411667],[27.156753333,44.424406667],[27.166216667,44.424705],[27.17579,44.424771667],[27.183895,44.425016667],[27.187096667,44.425258333],[27.194968333,44.425395],[27.202778333,44.425226667],[27.220575,44.42469],[27.228941667,44.42467],[27.245663333,44.424356667],[27.250858333,44.424113333],[27.266235,44.423746667],[27.272908333,44.423083333],[27.282676667,44.421493333],[27.312363333,44.416851667],[27.347121667,44.411335],[27.380496667,44.406123333],[27.385225,44.405473333],[27.401228333,44.40368],[27.442855,44.399278333],[27.452311667,44.39843],[27.461926667,44.397725],[27.471646667,44.397175],[27.481406667,44.396753333],[27.491105,44.396458333],[27.50082,44.396336667],[27.51499,44.396395],[27.526198333,44.396638333],[27.537581667,44.397061667],[27.616305,44.400661667],[27.622565,44.401081667],[27.630786667,44.402103333],[27.635971667,44.403],[27.64355,44.404548333],[27.683138333,44.412318333],[27.691986667,44.413941667],[27.701228333,44.415783333],[27.711025,44.417466667],[27.717645,44.417888333],[27.736533333,44.417433333],[27.762596667,44.416725],[27.76774,44.41622],[27.774271667,44.414795],[27.778876667,44.413171667],[27.792043333,44.407591667],[27.813793333,44.398483333],[27.818198333,44.396931667],[27.822811667,44.39582],[27.829346667,44.395003333],[27.838828333,44.394933333],[27.841545,44.39393],[27.84334,44.391971667],[27.844345,44.387615],[27.847063333,44.383433333],[27.848301667,44.382636667],[27.853068333,44.381483333],[27.862315,44.378621667],[27.867541667,44.377735],[27.883785,44.37345],[27.964233333,44.353695],[27.971271667,44.352138333],[27.976435,44.350726667],[27.996043333,44.345981667],[28.001121667,44.345386667],[28.003963333,44.344271667],[28.006221667,44.342376667],[28.007648333,44.341706667],[28.012406667,44.340808333],[28.019928333,44.338798333],[28.022896667,44.337678333],[28.024746667,44.335801667],[28.028753333,44.32818],[28.03425,44.31626],[28.037318333,44.310813333],[28.037846667,44.308315],[28.037421667,44.305691667],[28.036213333,44.302363333],[28.035878333,44.299926667],[28.036408333,44.29654],[28.038205,44.29319],[28.040076667,44.29115],[28.046778333,44.285571667],[28.0501,44.282608333],[28.052888333,44.279746667],[28.056308333,44.275578333],[28.065093333,44.262413333],[28.069656667,44.257095],[28.072646667,44.25436],[28.076055,44.251726667],[28.082461667,44.247826667],[28.087718333,44.245368333],[28.095526667,44.242625],[28.098858333,44.241823333],[28.104225,44.241383333],[28.107848333,44.241581667],[28.111385,44.242183333],[28.117575,44.243886667],[28.120801667,44.244566667],[28.125876667,44.244738333],[28.129156667,44.244301667],[28.132241667,44.243448333],[28.147665,44.23689],[28.151875,44.235418333],[28.156521667,44.23411],[28.165026667,44.23226],[28.171306667,44.230581667],[28.17538,44.22913],[28.180733333,44.226711667],[28.189401667,44.222066667],[28.19392,44.219958333],[28.200273333,44.21762],[28.205336667,44.216305],[28.21332,44.214973333],[28.2525,44.210653333],[28.260703333,44.209331667],[28.265576667,44.208148333],[28.27174,44.20616],[28.278496667,44.203281667],[28.28355,44.200625],[28.287218333,44.198316667],[28.314278333,44.180253333],[28.32643,44.172068333],[28.341353333,44.161656667],[28.351008333,44.154393333],[28.36305,44.145168333],[28.368603333,44.141508333],[28.374163333,44.138671667],[28.381311667,44.13598],[28.387476667,44.134353333],[28.392453333,44.133436667],[28.400365,44.132658333],[28.408735,44.132738333],[28.41393,44.133225],[28.41733,44.133766667],[28.431351667,44.136448333],[28.436051667,44.137193333],[28.442511667,44.137965],[28.450073333,44.139321667],[28.454918333,44.140016667],[28.459998333,44.140391667],[28.475716667,44.141025],[28.524436667,44.142851667],[28.532661667,44.143316667],[28.54378,44.144298333],[28.5454,44.1443],[28.549783333,44.142903333],[28.552441667,44.143793333],[28.557121667,44.150008333],[28.556883333,44.152175],[28.552891667,44.154178333],[28.551541667,44.156136667],[28.550115,44.160533333],[28.549765,44.16489],[28.549443333,44.173991667],[28.553085,44.206596667],[28.552938333,44.211646667],[28.551966667,44.218431667],[28.549021667,44.237361667],[28.547601667,44.24161],[28.545896667,44.24516],[28.544918333,44.249385],[28.544435,44.255355],[28.545536667,44.258645],[28.547523333,44.260521667],[28.55014,44.261788333],[28.553025,44.262458333],[28.554545,44.262288333],[28.554563333,44.264548333],[28.557691667,44.271125],[28.557655,44.275538333],[28.556913333,44.28331],[28.55739,44.284328333],[28.573158333,44.28559],[28.577916667,44.28514],[28.593785,44.28666],[28.603411667,44.28727],[28.606378333,44.288225],[28.609876667,44.290728333],[28.61173,44.292528333],[28.613265,44.29568],[28.615605,44.308023333],[28.617368333,44.318003333],[28.618,44.322441667],[28.619521667,44.322805],[28.622521667,44.322311667],[28.627198333,44.31945],[28.627685,44.318373333],[28.625515,44.311755],[28.624958333,44.310665],[28.621903333,44.308033333],[28.621333333,44.306973333],[28.619528333,44.300328333],[28.619418333,44.292261667],[28.618638333,44.29005],[28.616285,44.287328333],[28.618111667,44.284205],[28.618415,44.283056667],[28.617268333,44.278608333],[28.617695,44.27525],[28.617495,44.269565],[28.618108333,44.266306667],[28.618343333,44.258533333],[28.618905,44.252855],[28.619935,44.245048333],[28.622108333,44.237418333],[28.62412,44.234441667],[28.625615,44.231313333],[28.626746667,44.22806],[28.62834,44.224821667],[28.629065,44.221485],[28.630025,44.219271667],[28.62939,44.218263333],[28.625253333,44.21486],[28.615166667,44.207875],[28.60677,44.199775],[28.60521,44.197868333],[28.60095,44.18952],[28.595051667,44.176593333],[28.594381667,44.172216667],[28.593736667,44.169996667],[28.592238333,44.169715],[28.557263333,44.167423333],[28.534041667,44.165993333],[28.525625,44.165693333],[28.519065,44.16565],[28.508008333,44.16534],[28.497931667,44.165165],[28.505545,44.165181667],[28.515521667,44.165483333],[28.534466667,44.165921667],[28.542403333,44.16642],[28.547156667,44.166488333],[28.549246667,44.164798333],[28.550306667,44.158945],[28.552056667,44.154618333],[28.554181667,44.151561667],[28.557536667,44.1477],[28.558088333,44.14555],[28.557836667,44.143026667],[28.558381667,44.140871667],[28.560131667,44.138888333],[28.56288,44.137525],[28.56757,44.13626],[28.569936667,44.134661667],[28.572685,44.131855],[28.587355,44.116278333],[28.591755,44.11276],[28.595815,44.11052],[28.5987,44.109326667],[28.603186667,44.107981667],[28.606551667,44.107616667],[28.611486667,44.107781667],[28.614141667,44.108948333],[28.620866667,44.109803333],[28.616388333,44.109498333],[28.610196667,44.108595],[28.608645,44.108555],[28.608245,44.105183333],[28.607916667,44.099508333],[28.608105,44.098391667],[28.610211667,44.095271667],[28.611476667,44.090806667],[28.612136667,44.087548333],[28.62538,44.075768333],[28.627106667,44.073876667],[28.627733333,44.069248333],[28.631646667,44.059393333],[28.632255,44.05841],[28.635251667,44.0584],[28.638108333,44.05749],[28.641448333,44.053801667],[28.644648333,44.043895],[28.645685,44.036908333],[28.64644,44.033516667],[28.647618333,44.030128333],[28.645045,44.023491667],[28.641443333,44.013441667],[28.640255,44.011358333],[28.639156667,44.005826667],[28.638546667,44.004828333],[28.628598333,43.992916667],[28.62449,43.98776],[28.617886667,43.977066667],[28.615326667,43.972535],[28.611423333,43.966265],[28.601395,43.949626667],[28.599996667,43.94761],[28.59063,43.932045],[28.588181667,43.9278],[28.584905,43.922611667],[28.580491667,43.915128333],[28.576725,43.910241667],[28.5722,43.906896667],[28.571353333,43.905913333],[28.570868333,43.89902],[28.573073333,43.887383333],[28.573125,43.883843333],[28.574993333,43.866631667],[28.576083333,43.855203333],[28.575445,43.846933333],[28.576033333,43.838771667],[28.576276667,43.837618333],[28.581676667,43.825531667],[28.582433333,43.823375],[28.583096667,43.81784],[28.582025,43.817046667],[28.575305,43.814278333],[28.572991667,43.812888333],[28.571775,43.810858333],[28.571921667,43.808711667],[28.57122,43.807771667],[28.563383333,43.808143333],[28.561851667,43.807886667],[28.561093333,43.806841667],[28.55921,43.800076667],[28.559391667,43.797593333],[28.560603333,43.794156667],[28.561365,43.793218333],[28.562858333,43.793015],[28.57038,43.794573333],[28.571933333,43.79471],[28.574835,43.793901667],[28.576755,43.792078333],[28.577185,43.790971667],[28.578076667,43.784355],[28.578158333,43.778705],[28.577878333,43.776496667],[28.574295,43.766496667],[28.57122,43.752158333],[28.570828333,43.748815],[28.569498333,43.746786667],[28.561338333,43.739868333],[28.560183333,43.739176667],[28.553705,43.73013],[28.55159,43.726878333],[28.543366667,43.71297],[28.53483,43.698303333],[28.533855,43.69617],[28.527926667,43.675783333],[28.526996667,43.673563333],[28.521005,43.665395],[28.519195,43.663578333],[28.503321667,43.649065],[28.503425,43.646923333],[28.50711,43.641775],[28.510098333,43.636436667],[28.51627,43.623838333],[28.529156667,43.598243333],[28.529925,43.595943333],[28.53099,43.58652],[28.533165,43.568476667],[28.533296667,43.566171667],[28.531925,43.557303333],[28.531658333,43.552543333],[28.529758333,43.550813333],[28.526646667,43.549948333],[28.524956667,43.547916667],[28.523921667,43.540001667],[28.522933333,43.537738333],[28.52102,43.535948333],[28.52029,43.533875],[28.521811667,43.529263333],[28.521258333,43.52703],[28.503466667,43.51256],[28.495541667,43.50594],[28.482451667,43.492775],[28.477143333,43.490551667],[28.47482,43.489006667],[28.471271667,43.485405],[28.459731667,43.478975],[28.446771667,43.473966667],[28.443753333,43.473153333],[28.431968333,43.470395],[28.429143333,43.469428333],[28.388218333,43.448581667],[28.38553,43.447388333],[28.375715,43.443678333],[28.37271,43.442981667],[28.370321667,43.441573333],[28.366238333,43.440045],[28.354071667,43.436995],[28.354861667,43.435971667],[28.374813333,43.424816667],[28.396426667,43.412811667],[28.404876667,43.407228333],[28.407456667,43.4059],[28.410568333,43.403398333],[28.414076667,43.401468333],[28.416143333,43.399796667],[28.442573333,43.387281667],[28.440398333,43.3884],[28.416198333,43.39977],[28.41205,43.40282],[28.410673333,43.403296667],[28.40756,43.405805],[28.405085,43.407151667],[28.396946667,43.412578333],[28.363738333,43.431053333],[28.353803333,43.436543333],[28.352268333,43.436515],[28.34805,43.43524],[28.3479,43.435535],[28.343423333,43.435146667],[28.338765,43.435643333],[28.335658333,43.430785],[28.337481667,43.430606667],[28.339901667,43.431846667],[28.343165,43.43198],[28.344476667,43.431231667],[28.345625,43.428875],[28.347333333,43.42699],[28.348723333,43.423701667],[28.351496667,43.420841667],[28.351028333,43.418693333],[28.352323333,43.41675],[28.352485,43.418915],[28.353801667,43.418395],[28.356496667,43.415786667],[28.359808333,43.413546667],[28.36035,43.414558333],[28.357603333,43.419886667],[28.355858333,43.421715],[28.352856667,43.428121667],[28.35207,43.43256],[28.350696667,43.43572],[28.353501667,43.436533333],[28.361015,43.432675],[28.367218333,43.429081667],[28.391005,43.415883333],[28.390463333,43.414853333],[28.391953333,43.415293333],[28.382666667,43.4207],[28.367826667,43.428781667],[28.35927,43.433588333],[28.35445,43.436445],[28.355305,43.437365],[28.365478333,43.439776667],[28.370991667,43.441843333],[28.371871667,43.442723333],[28.362743333,43.444623333],[28.352176667,43.446573333],[28.349141667,43.446913333],[28.344313333,43.446498333],[28.326098333,43.44237],[28.3113,43.43838],[28.308588333,43.437196667],[28.304348333,43.433696667],[28.30181,43.432265],[28.287608333,43.427165],[28.284658333,43.426466667],[28.275536667,43.424795],[28.251081667,43.420613333],[28.236765,43.420816667],[28.212965,43.421346667],[28.208523333,43.422301667],[28.206285,43.424075],[28.191193333,43.440418333],[28.189138333,43.442161667],[28.186403333,43.44354],[28.181898333,43.444471667],[28.178758333,43.444395],[28.167981667,43.442586667],[28.16519,43.441825],[28.157151667,43.43863],[28.151571667,43.436248333],[28.148796667,43.435448333],[28.147601667,43.434661667],[28.14211,43.432336667],[28.13784,43.430881667],[28.130343333,43.428878333],[28.110115,43.422658333],[28.107423333,43.421466667],[28.089613333,43.41144],[28.08183,43.407633333],[28.074128333,43.404085],[28.07055,43.401875],[28.069518333,43.399711667],[28.07113,43.384488333],[28.07151,43.379953333],[28.070308333,43.377961667],[28.067166667,43.377735],[28.06366,43.381873333],[28.062375,43.385245],[28.061943333,43.388681667],[28.059176667,43.395613333],[28.056343333,43.398296667],[28.055061667,43.398873333],[28.053693333,43.398486667],[28.053536667,43.396293333],[28.052815,43.39403],[28.052245,43.384825],[28.052656667,43.382511667],[28.05439,43.380516667],[28.057121667,43.376371667],[28.061048333,43.372845],[28.062803333,43.37088],[28.065021667,43.366805],[28.06745,43.368086667],[28.0644,43.367443333],[28.066838333,43.366508333],[28.06622,43.365461667],[28.064941667,43.365988333],[28.06668,43.367756667],[28.065191667,43.368028333],[28.063915,43.366075],[28.05017,43.351058333],[28.050351667,43.346448333],[28.051651667,43.34309],[28.053875,43.341638333],[28.058051667,43.340351667],[28.060516667,43.33896],[28.059001667,43.338895],[28.061726667,43.336226667],[28.06188,43.333935],[28.063136667,43.33194],[28.06383,43.328428333],[28.0608,43.32208],[28.055743333,43.316403333],[28.053455,43.313305],[28.052015,43.30891],[28.050755,43.306838333],[28.050063333,43.30459],[28.046213333,43.299568333],[28.044866667,43.299035],[28.042728333,43.296973333],[28.042796667,43.293485],[28.041185,43.291626667],[28.038738333,43.290536667],[28.03768,43.288243333],[28.036408333,43.287548333],[28.033833333,43.284715],[28.03253,43.281501667],[28.029993333,43.27856],[28.03081,43.276448333],[28.029308333,43.274615],[28.0264,43.27496],[28.021433333,43.270276667],[28.019701667,43.267093333],[28.014801667,43.252486667],[28.014748333,43.251283333],[28.016028333,43.245695],[28.015468333,43.242296667],[28.01307,43.238131667],[28.011583333,43.236053333],[28.005368333,43.232618333],[28.002198333,43.22988],[28.000811667,43.227813333],[28.00028,43.2257],[27.997771667,43.224366667],[27.989885,43.223458333],[27.985345,43.223326667],[27.977623333,43.22232],[27.975415,43.220826667],[27.969631667,43.219008333],[27.961923333,43.21796],[27.953538333,43.215341667],[27.940966667,43.214058333],[27.936906667,43.212651667],[27.931646667,43.209878333],[27.923008333,43.208116667],[27.921756667,43.20624],[27.923243333,43.20626],[27.924225,43.207071667],[27.923671667,43.208065],[27.921473333,43.209493333],[27.919983333,43.209458333],[27.916811667,43.207046667],[27.911456667,43.204985],[27.90682,43.20464],[27.899456667,43.203455],[27.896811667,43.202365],[27.896058333,43.201368333],[27.896073333,43.198003333],[27.894875,43.19599],[27.893801667,43.1952],[27.88853,43.192575],[27.882761667,43.188816667],[27.879313333,43.18677],[27.875115,43.185325],[27.872063333,43.18467],[27.865733333,43.184483333],[27.862315,43.184125],[27.856228333,43.183953333],[27.84981,43.182605],[27.84673,43.180275],[27.845338333,43.175913333],[27.847251667,43.171506667],[27.847235,43.169276667],[27.846521667,43.167133333],[27.844391667,43.165301667],[27.842126667,43.1639],[27.83363,43.160605],[27.82892,43.157341667],[27.82671,43.15436],[27.820848333,43.143696667],[27.818546667,43.138025],[27.814171667,43.131023333],[27.811655,43.128201667],[27.809061667,43.126875],[27.808245,43.125873333],[27.80855,43.124806667],[27.815261667,43.119693333],[27.821898333,43.116693333],[27.824366667,43.115251667],[27.827466667,43.112833333],[27.829001667,43.109598333],[27.83287,43.105661667],[27.840296667,43.099365],[27.845486667,43.093383333],[27.848481667,43.090178333],[27.853905,43.083645],[27.855713333,43.07758],[27.85672,43.066178333],[27.858048333,43.062943333],[27.86119,43.056286667],[27.8629,43.055756667],[27.864378333,43.052151667],[27.864395,43.048801667],[27.864828333,43.047781667],[27.866398333,43.047835],[27.869295,43.046975],[27.87394,43.046795],[27.877171667,43.044458333],[27.883366667,43.040736667],[27.884436667,43.038598333],[27.888365,43.039326667],[27.88745,43.038475],[27.883845,43.04017],[27.878238333,43.043771667],[27.87692,43.044238333],[27.87395,43.046825],[27.871035,43.046801667],[27.865288333,43.047718333],[27.864573333,43.048685],[27.864608333,43.052005],[27.864185,43.053663333],[27.862665,43.055995],[27.860113333,43.057366667],[27.859528333,43.05964],[27.854111667,43.083121667],[27.844243333,43.094475],[27.838445,43.100988333],[27.832153333,43.105976667],[27.828073333,43.110416667],[27.826315,43.113493333],[27.821948333,43.116666667],[27.816223333,43.119166667],[27.808603333,43.124705],[27.807806667,43.126786667],[27.810345,43.128118333],[27.813631667,43.131038333],[27.814626667,43.133171667],[27.818928333,43.140156667],[27.821068333,43.144653333],[27.826615,43.153338333],[27.828761667,43.156333333],[27.830596667,43.158165],[27.83405,43.16046],[27.83691,43.161815],[27.842778333,43.163741667],[27.846626667,43.166138333],[27.847843333,43.168048333],[27.84784,43.171575],[27.846491667,43.174896667],[27.845976667,43.17722],[27.8464,43.179455],[27.847848333,43.18152],[27.850478333,43.183013333],[27.853598333,43.18391],[27.855328333,43.184041667],[27.870538333,43.184506667],[27.873621667,43.184983333],[27.87913,43.186955],[27.894048333,43.19532],[27.896336667,43.19818],[27.896655,43.200448333],[27.898001667,43.202428333],[27.899333333,43.202988333],[27.900563333,43.202385],[27.899133333,43.202075],[27.896356667,43.203015],[27.890351667,43.206588333],[27.88603,43.209873333],[27.881703333,43.211208333],[27.880765,43.21204],[27.876458333,43.218111667],[27.874428333,43.219765],[27.8744,43.2219],[27.87143,43.222438333],[27.868613333,43.223381667],[27.862606667,43.226973333],[27.858706667,43.22892],[27.841373333,43.236718333],[27.838751667,43.238096667],[27.837388333,43.240118333],[27.833781667,43.242046667],[27.83281,43.238731667],[27.831508333,43.238196667],[27.828565,43.238326667],[27.829405,43.237436667],[27.8309,43.237291667],[27.831928333,43.238051667],[27.82731,43.238375],[27.828335,43.237541667],[27.831323333,43.237348333],[27.833263333,43.238983333],[27.83623,43.23875],[27.841888333,43.236381667],[27.859236667,43.228436667],[27.864456667,43.225708333],[27.86812,43.223481667],[27.870745,43.222475],[27.873651667,43.22194],[27.874655,43.22116],[27.87432,43.220061667],[27.876226667,43.218338333],[27.881061667,43.211331667],[27.886631667,43.209388333],[27.890738333,43.20613],[27.895496667,43.20338],[27.896936667,43.203186667],[27.895978333,43.20108],[27.896081667,43.19879],[27.89534,43.196626667],[27.8933,43.19497],[27.879865,43.187578333],[27.875828333,43.185803333],[27.872966667,43.185071667],[27.86977,43.184673333],[27.85546,43.184191667],[27.852436667,43.183818333],[27.84843,43.181981667],[27.846593333,43.180003333],[27.845701667,43.17776],[27.845841667,43.175613333],[27.847321667,43.172305],[27.847463333,43.168858333],[27.846451667,43.166773333],[27.84448,43.164988333],[27.841873333,43.163761667],[27.836145,43.161681667],[27.83371,43.160461667],[27.829476667,43.157201667],[27.827085,43.154261667],[27.820995,43.143633333],[27.817906667,43.136693333],[27.815178333,43.132666667],[27.812116667,43.128663333],[27.808473333,43.1267],[27.80815,43.125543333],[27.808863333,43.124528333],[27.815496667,43.1195],[27.822271667,43.116698333],[27.827561667,43.112786667],[27.829,43.109681667],[27.832486667,43.105843333],[27.839063333,43.100728333],[27.84778,43.090923333],[27.853791667,43.083903333],[27.85435,43.082836667],[27.855685,43.078156667],[27.856455,43.067303333],[27.858145,43.06272],[27.861125,43.05645],[27.863451667,43.05505],[27.864581667,43.05277],[27.864483333,43.048236667],[27.868613333,43.046898333],[27.873075,43.047151667],[27.879826667,43.042705],[27.883378333,43.040688333],[27.88458,43.038725],[27.885815,43.0381],[27.888001667,43.03935],[27.888226667,43.03782],[27.886171667,43.036335],[27.888246667,43.03957],[27.888331667,43.040283333],[27.883781667,43.040356667],[27.888173333,43.039991667],[27.887003333,43.038018333],[27.884173333,43.038693333],[27.883178333,43.040715],[27.872895,43.047115],[27.871403333,43.046885],[27.865571667,43.047761667],[27.864595,43.048625],[27.86475,43.051973333],[27.863456667,43.055221667],[27.861108333,43.056573333],[27.859923333,43.053171667],[27.859138333,43.049845],[27.857546667,43.047885],[27.853621667,43.046123333],[27.851593333,43.04437],[27.849516667,43.039695],[27.848583333,43.038673333],[27.843306667,43.035613333],[27.841708333,43.033638333],[27.838035,43.026188333],[27.835455,43.024928333],[27.830915,43.024466667],[27.824303333,43.021291667],[27.818013333,43.017821667],[27.815616667,43.016151667],[27.797576667,42.998935],[27.795991667,42.996825],[27.79495,42.991016667],[27.793968333,42.988811667],[27.792525,42.988343333],[27.789558333,42.98832],[27.788223333,42.987786667],[27.788105,42.986636667],[27.789838333,42.984818333],[27.789333333,42.981413333],[27.787995,42.97699],[27.783585,42.976038333],[27.782891667,42.974966667],[27.783176667,42.971666667],[27.781426667,42.968535],[27.780711667,42.966416667],[27.77896,42.96449],[27.777593333,42.964091667],[27.771395,42.96397],[27.768895,42.962616667],[27.768183333,42.960508333],[27.768963333,42.958398333],[27.774718333,42.952825],[27.778758333,42.945393333],[27.779588333,42.944496667],[27.785415,42.940545],[27.786026667,42.939505],[27.786203333,42.933556667],[27.785748333,42.930051667],[27.788731667,42.925983333],[27.793066667,42.922841667],[27.794303333,42.922253333],[27.801831667,42.920581667],[27.805093333,42.92078],[27.806688333,42.920503333],[27.809203333,42.91928],[27.817006667,42.918473333],[27.818411667,42.918093333],[27.823535,42.915661667],[27.82803,42.914781667],[27.833773333,42.912803333],[27.83658,42.911523333],[27.839428333,42.9107],[27.84056,42.909895],[27.841465,42.907788333],[27.843413333,42.904515],[27.845151667,42.902375],[27.851876667,42.898516667],[27.854973333,42.898031667],[27.856256667,42.897453333],[27.858061667,42.895443333],[27.86151,42.893295],[27.864335,42.892311667],[27.868281667,42.890403333],[27.874091667,42.888285],[27.881901667,42.884721667],[27.882051667,42.883628333],[27.880606667,42.87809],[27.880853333,42.874661667],[27.886845,42.864006667],[27.886846667,42.861626667],[27.8831,42.84967],[27.881786667,42.847721667],[27.876995,42.843225],[27.876135,42.841036667],[27.876846667,42.825673333],[27.87905,42.82161],[27.879868333,42.820701667],[27.87959,42.817436667],[27.878251667,42.815436667],[27.878535,42.814378333],[27.876085,42.810295],[27.875131667,42.807073333],[27.875618333,42.806005],[27.881446667,42.802228333],[27.881515,42.801113333],[27.877535,42.797743333],[27.875235,42.793373333],[27.877146667,42.791511667],[27.879498333,42.789995],[27.881353333,42.78816],[27.880756667,42.787145],[27.878006667,42.786071667],[27.871758333,42.786051667],[27.871865,42.784933333],[27.875753333,42.781563333],[27.876468333,42.780593333],[27.87549,42.779793333],[27.871043333,42.778813333],[27.870226667,42.777818333],[27.872918333,42.774935],[27.8799,42.76977],[27.880781667,42.768828333],[27.880443333,42.767715],[27.876905,42.76546],[27.873896667,42.764925],[27.868263333,42.763046667],[27.868253333,42.761971667],[27.87037,42.760441667],[27.875061667,42.75774],[27.883495,42.755338333],[27.882578333,42.754391667],[27.883728333,42.751218333],[27.882681667,42.748008333],[27.884063333,42.748478333],[27.883208333,42.749478333],[27.883755,42.751591667],[27.882643333,42.754811667],[27.883483333,42.755301667],[27.875195,42.757731667],[27.869316667,42.761146667],[27.867376667,42.762776667],[27.8644,42.762613333],[27.857815,42.765405],[27.856373333,42.765648333],[27.853551667,42.764833333],[27.852121667,42.765221667],[27.848595,42.767395],[27.845686667,42.767986667],[27.839651667,42.767695],[27.836996667,42.76875],[27.830981667,42.77226],[27.824716667,42.775291667],[27.82175,42.775633333],[27.818788333,42.775565],[27.81628,42.774513333],[27.815916667,42.772286667],[27.816798333,42.771311667],[27.815313333,42.771481667],[27.797111667,42.777945],[27.794011667,42.777796667],[27.7917,42.77622],[27.791403333,42.772991667],[27.794173333,42.77238],[27.792333333,42.77068],[27.79241,42.768558333],[27.788645,42.766846667],[27.78782,42.765935],[27.786351667,42.766033333],[27.783198333,42.769786667],[27.774346667,42.774381667],[27.77175,42.77546],[27.77029,42.775581667],[27.767761667,42.774375],[27.767875,42.77222],[27.766668333,42.77149],[27.763676667,42.772045],[27.760761667,42.76949],[27.760301667,42.768398333],[27.76138,42.766353333],[27.758523333,42.766125],[27.756731667,42.764436667],[27.753871667,42.764946667],[27.752725,42.764208333],[27.752863333,42.761978333],[27.752205,42.759781667],[27.752573333,42.758671667],[27.754261667,42.75674],[27.755273333,42.753393333],[27.753801667,42.75341],[27.752721667,42.752638333],[27.753381667,42.7493],[27.753198333,42.747081667],[27.749161667,42.74834],[27.747611667,42.748156667],[27.743775,42.746206667],[27.73978,42.744513333],[27.738715,42.741076667],[27.738555,42.737813333],[27.738975,42.735555],[27.738401667,42.7333],[27.739658333,42.729965],[27.738988333,42.724918333],[27.734333333,42.724611667],[27.729828333,42.723883333],[27.726523333,42.719896667],[27.723591667,42.717266667],[27.722278333,42.716638333],[27.722143333,42.714465],[27.723828333,42.7126],[27.723041667,42.710518333],[27.717261667,42.70919],[27.710616667,42.706155],[27.706981667,42.703836667],[27.705163333,42.701888333],[27.700441667,42.692165],[27.699778333,42.68759],[27.699776667,42.681915],[27.698506667,42.677498333],[27.694411667,42.667681667],[27.692816667,42.663241667],[27.695843333,42.663271667],[27.707666667,42.66545],[27.712286667,42.665013333],[27.713621667,42.664558333],[27.715095,42.662698333],[27.715841667,42.660525],[27.720216667,42.660251667],[27.721443333,42.659653333],[27.724398333,42.659376667],[27.727373333,42.659518333],[27.730335,42.659145],[27.733288333,42.659441667],[27.736425,42.661143333],[27.732943333,42.584581667],[27.733826667,42.572616667],[27.735965,42.66114],[27.734956667,42.660375],[27.732083333,42.659326667],[27.729791667,42.659025],[27.726063333,42.659466667],[27.717615,42.663373333],[27.715351667,42.66512],[27.710721667,42.665255],[27.706708333,42.665675],[27.700533333,42.663898333],[27.694811667,42.662963333],[27.693066667,42.663171667],[27.691676667,42.660806667],[27.689118333,42.659298333],[27.678528333,42.656163333],[27.67042,42.652715],[27.664476667,42.650438333],[27.662628333,42.649461667],[27.645976667,42.645158333],[27.643343333,42.644315],[27.642253333,42.643251667],[27.636876667,42.635691667],[27.636743333,42.635063333],[27.630266667,42.624666667],[27.625045,42.61723],[27.623675,42.613966667],[27.62177,42.608396667],[27.615248333,42.595648333],[27.608141667,42.583635],[27.605628333,42.579953333],[27.604628333,42.579853333],[27.603525,42.581245],[27.600693333,42.586185],[27.598731667,42.588218333],[27.596591667,42.592651667],[27.592875,42.600891667],[27.585826667,42.608035],[27.584081667,42.61018],[27.582505,42.61279],[27.580055,42.615988333],[27.579238333,42.619948333],[27.577928333,42.623571667],[27.576033333,42.624833333],[27.572926667,42.62522],[27.569936667,42.627898333],[27.567461667,42.628961667],[27.563066667,42.630273333],[27.561476667,42.631356667],[27.55626,42.636533333],[27.550571667,42.630241667],[27.546206667,42.625751667],[27.544223333,42.62315],[27.540446667,42.620625],[27.538625,42.61682],[27.53768,42.613975],[27.533611667,42.60562],[27.531478333,42.603286667],[27.528178333,42.600523333],[27.525278333,42.596945],[27.519905,42.59265],[27.516658333,42.591225],[27.509716667,42.584686667],[27.509673333,42.584116667],[27.506931667,42.580373333],[27.503436667,42.576636667],[27.499525,42.570545],[27.494431667,42.56313],[27.490823333,42.557455],[27.490473333,42.556043333],[27.491173333,42.553146667],[27.490695,42.552515],[27.478096667,42.551608333],[27.47622,42.550935],[27.474746667,42.549281667],[27.473646667,42.544783333],[27.472555,42.54179],[27.471085,42.535861667],[27.468876667,42.531686667],[27.467651667,42.53137],[27.463313333,42.531343333],[27.458413333,42.529648333],[27.457521667,42.528813333],[27.455025,42.52789],[27.452193333,42.527553333],[27.441775,42.539381667],[27.42533,42.558613333],[27.422863333,42.561058333],[27.41773,42.567541667],[27.417146667,42.569031667],[27.414153333,42.572446667],[27.410331667,42.57628],[27.409005,42.5773],[27.401573333,42.584858333],[27.395938333,42.591173333],[27.39408,42.592383333],[27.390223333,42.5935],[27.37892,42.593678333],[27.374375,42.594261667],[27.363918333,42.596356667],[27.348476667,42.600981667],[27.34477,42.601903333],[27.337098333,42.603323333],[27.333231667,42.603841667],[27.327533333,42.604013333],[27.314785,42.604195],[27.293803333,42.604583333],[27.288391667,42.604513333],[27.282353333,42.60417],[27.277261667,42.603661667],[27.270095,42.6025],[27.26601,42.601648333],[27.257311667,42.599288333],[27.247966667,42.596371667],[27.23452,42.5919],[27.226705,42.589386667],[27.221518333,42.587968333],[27.217285,42.5872],[27.209156667,42.586493333],[27.194941667,42.586631667],[27.187786667,42.587625],[27.183856667,42.588606667],[27.17978,42.59038],[27.17088,42.594806667],[27.167556667,42.5959],[27.163101667,42.596261667],[27.157446667,42.5956],[27.153726667,42.594525],[27.149295,42.592326667],[27.146458333,42.59043],[27.142581667,42.588253333],[27.137423333,42.58621],[27.133655,42.585701667],[27.126228333,42.586038333],[27.123371667,42.586498333],[27.121148333,42.587373333],[27.100111667,42.586751667],[27.095468333,42.586855],[27.091166667,42.587213333],[27.088016667,42.587825],[27.082238333,42.58851],[27.078201667,42.589298333],[27.075223333,42.58932],[27.066976667,42.590355],[27.05885,42.590733333],[27.050651667,42.590595],[27.04068,42.58987],[27.028778333,42.589448333],[27.020468333,42.589023333],[27.013873333,42.58926],[27.007338333,42.589856667],[26.99586,42.590616667],[26.989868333,42.590806667],[26.981568333,42.590628333],[26.97139,42.589926667],[26.95649,42.588598333],[26.947678333,42.587483333],[26.938691667,42.585931667],[26.9209,42.58114],[26.914658333,42.57909],[26.907958333,42.577105],[26.903725,42.576401667],[26.897136667,42.575843333],[26.893365,42.575151667],[26.886656667,42.574371667],[26.882901667,42.573516667],[26.876205,42.570958333],[26.869311667,42.56721],[26.863485,42.564716667],[26.859605,42.56356],[26.856156667,42.562838333],[26.849526667,42.562085],[26.846868333,42.562143333],[26.842475,42.561475],[26.83478,42.561718333],[26.832368333,42.56161],[26.826968333,42.56082],[26.82168,42.559743333],[26.817078333,42.558448333],[26.811051667,42.556416667],[26.790581667,42.549111667],[26.783415,42.547],[26.777473333,42.545741667],[26.770241667,42.544906667],[26.765345,42.544763333],[26.758508333,42.545213333],[26.754421667,42.54575],[26.750015,42.545941667],[26.746758333,42.546726667],[26.743601667,42.548296667],[26.73905,42.549635],[26.729586667,42.552126667],[26.723125,42.553101667],[26.714695,42.555116667],[26.712116667,42.555328333],[26.705171667,42.556466667],[26.69749,42.557116667],[26.689396667,42.55748],[26.688623333,42.55774],[26.679776667,42.55722],[26.677055,42.556838333],[26.670496667,42.556363333],[26.657218333,42.556231667],[26.647288333,42.557386667],[26.643253333,42.558128333],[26.633433333,42.559491667],[26.626521667,42.559886667],[26.616728333,42.55982],[26.611315,42.559161667],[26.603198333,42.558878333],[26.597005,42.558261667],[26.593851667,42.557621667],[26.58916,42.557163333],[26.582356667,42.55688],[26.572635,42.555965],[26.55921,42.55543],[26.537678333,42.555993333],[26.533591667,42.55602],[26.523006667,42.556381667],[26.517175,42.556096667],[26.513278333,42.555495],[26.50806,42.554115],[26.502198333,42.551858333],[26.497596667,42.549393333],[26.489146667,42.543261667],[26.485196667,42.541046667],[26.48293,42.540236667],[26.475443333,42.539103333],[26.467716667,42.540335],[26.460083333,42.543348333],[26.457041667,42.544276667],[26.452358333,42.544985],[26.446531667,42.544978333],[26.442436667,42.544301667],[26.439571667,42.543398333],[26.431511667,42.541341667],[26.40951,42.535133333],[26.400988333,42.53241],[26.395171667,42.52976],[26.391543333,42.527846667],[26.387426667,42.525231667],[26.381283333,42.520858333],[26.374168333,42.516471667],[26.366688333,42.513215],[26.359783333,42.511036667],[26.353641667,42.50971],[26.343091667,42.508241667],[26.326328333,42.506891667],[26.309565,42.504378333],[26.302061667,42.502843333],[26.298061667,42.501566667],[26.288133333,42.498791667],[26.277841667,42.495668333],[26.269218333,42.4934],[26.259151667,42.491098333],[26.257448333,42.490531667],[26.250833333,42.489265],[26.242031667,42.488105],[26.223293333,42.487756667],[26.20221,42.487616667],[26.193913333,42.487391667],[26.188516667,42.48678],[26.177815,42.484836667],[26.170436667,42.483011667],[26.158561667,42.479386667],[26.15131,42.477665],[26.145776667,42.47664],[26.135996667,42.475261667],[26.128461667,42.474905],[26.115586667,42.474091667],[26.113515,42.473825],[26.105436667,42.473391667],[26.099688333,42.472603333],[26.093765,42.471425],[26.078716667,42.467598333],[26.072831667,42.465816667],[26.066718333,42.46317],[26.062678333,42.460888333],[26.049141667,42.451963333],[26.043635,42.448726667],[26.04022,42.447158333],[26.034495,42.44506],[26.030106667,42.443958333],[26.023498333,42.442886667],[26.007958333,42.441201667],[26.000258333,42.44026],[25.995236667,42.439336667],[25.98692,42.43731],[25.983571667,42.436168333],[25.974858333,42.432498333],[25.965948333,42.427943333],[25.961565,42.425938333],[25.95516,42.423328333],[25.933591667,42.415303333],[25.926473333,42.412358333],[25.921428333,42.409995],[25.914881667,42.406546667],[25.902625,42.399141667],[25.897651667,42.396433333],[25.89276,42.394055],[25.886123333,42.39139],[25.88136,42.389723333],[25.876233333,42.388181667],[25.866255,42.385956667],[25.845123333,42.382305],[25.83935,42.381153333],[25.82828,42.378285],[25.809848333,42.372546667],[25.803468333,42.37065],[25.794768333,42.368525],[25.76631,42.363041667],[25.763033333,42.362278333],[25.755211667,42.360008333],[25.750048333,42.358146667],[25.735631667,42.351815],[25.727065,42.348951667],[25.721775,42.347601667],[25.715168333,42.3463],[25.707886667,42.34538],[25.683455,42.343281667],[25.675803333,42.342276667],[25.665256667,42.340456667],[25.663256667,42.340916667],[25.66132,42.342493333],[25.659333333,42.347343333],[25.657208333,42.356513333],[25.652925,42.371141667],[25.652728333,42.372548333],[25.650831667,42.37852],[25.649611667,42.383211667],[25.646646667,42.392246667],[25.647353333,42.393496667],[25.64904,42.394178333],[25.654788333,42.394833333],[25.656673333,42.395303333],[25.659186667,42.396951667],[25.672545,42.40918],[25.674368333,42.411915],[25.674738333,42.413483333],[25.675036667,42.427323333],[25.674516667,42.429953333],[25.672378333,42.43179],[25.666213333,42.434688333],[25.657903333,42.438793333],[25.655595,42.44047],[25.650206667,42.445706667],[25.648751667,42.44668],[25.637855,42.451236667],[25.63724,42.451228333],[25.6321,42.453823333],[25.63106,42.455168333],[25.63009,42.462215],[25.62904,42.465303333],[25.624981667,42.472763333],[25.62499,42.474241667],[25.623878333,42.47553],[25.622038333,42.476225],[25.616796667,42.477348333],[25.61662,42.478403333],[25.612778333,42.482475],[25.609545,42.483895],[25.605803333,42.484086667],[25.60373,42.485626667],[25.603616667,42.489831667],[25.601333333,42.494295],[25.59793,42.498945],[25.595626667,42.503601667],[25.59311,42.50599],[25.592111667,42.507728333],[25.592051667,42.510633333],[25.590535,42.514925],[25.588973333,42.518236667],[25.585383333,42.521113333],[25.58275,42.524775],[25.58127,42.52532],[25.577676667,42.525858333],[25.57641,42.526513333],[25.573538333,42.530991667],[25.566538333,42.53698],[25.563448333,42.540013333],[25.562505,42.544646667],[25.56071,42.546721667],[25.550451667,42.55409],[25.548241667,42.557135],[25.548013333,42.559466667],[25.546471667,42.564128333],[25.544901667,42.56698],[25.542636667,42.569405],[25.538126667,42.572715],[25.526256667,42.579865],[25.519368333,42.584243333],[25.51576,42.586168333],[25.510398333,42.589628333],[25.50713,42.592068333],[25.501208333,42.597148333],[25.497193333,42.59949],[25.488653333,42.602381667],[25.480101667,42.603758333],[25.474018333,42.604923333],[25.455185,42.608246667],[25.44804,42.61095],[25.444898333,42.611718333],[25.439565,42.612485],[25.434621667,42.614141667],[25.431908333,42.614485],[25.427035,42.615533333],[25.423138333,42.614875],[25.415938333,42.6145],[25.412893333,42.612748333],[25.409731667,42.610406667],[25.405626667,42.608731667],[25.402195,42.60841],[25.39102,42.608593333],[25.387073333,42.60959],[25.384981667,42.609813333],[25.373841667,42.609913333],[25.37238,42.610115],[25.367771667,42.61303],[25.36579,42.615786667],[25.36421,42.617185],[25.346481667,42.630425],[25.33979,42.63509],[25.335236667,42.637176667],[25.327626667,42.640195],[25.321913333,42.642753333],[25.306086667,42.649283333],[25.304501667,42.649756667],[25.295285,42.650476667],[25.293483333,42.65092],[25.293715,42.653461667],[25.294976667,42.655593333],[25.29504,42.657856667],[25.296743333,42.660895],[25.300308333,42.663153333],[25.30427,42.670428333],[25.310556667,42.681195],[25.312575,42.683616667],[25.31526,42.685745],[25.320216667,42.691865],[25.322141667,42.69303],[25.323818333,42.69769],[25.325775,42.701425],[25.328156667,42.707115],[25.327406667,42.708496667],[25.328248333,42.70964],[25.327535,42.71045],[25.325123333,42.714923333],[25.32334,42.715835],[25.31809,42.716945],[25.31655,42.718433333],[25.31393,42.717933333],[25.31219,42.719436667],[25.310703333,42.723556667],[25.310608333,42.725526667],[25.309063333,42.733208333],[25.310745,42.729735],[25.312716667,42.729828333],[25.311378333,42.727873333],[25.312265,42.725538333],[25.3143,42.72389],[25.316785,42.72419],[25.319228333,42.72764],[25.32099,42.72568],[25.32207,42.722781667],[25.323268333,42.721978333],[25.32545,42.724405],[25.32337,42.726246667],[25.321766667,42.728698333],[25.32176,42.730065],[25.319553333,42.730865],[25.317421667,42.730605],[25.316851667,42.732026667],[25.317345,42.733836667],[25.318013333,42.732628333],[25.321693333,42.731106667],[25.323805,42.732225],[25.324763333,42.73418],[25.324535,42.735748333],[25.323385,42.737341667],[25.322021667,42.736866667],[25.322266667,42.73467],[25.320555,42.733765],[25.31882,42.73559],[25.318121667,42.737555],[25.319881667,42.741128333],[25.31915,42.742665],[25.320775,42.74469],[25.319428333,42.746768333],[25.318761667,42.74686],[25.316993333,42.749676667],[25.319515,42.753765],[25.321828333,42.751246667],[25.325701667,42.752023333],[25.327036667,42.751255],[25.326693333,42.750145],[25.329063333,42.749265],[25.329733333,42.748473333],[25.33229,42.748923333],[25.334983333,42.748408333],[25.34044,42.745063333],[25.342365,42.741403333],[25.341718333,42.741296667],[25.34139,42.738935],[25.3419,42.737263333],[25.345333333,42.733605],[25.346843333,42.735493333],[25.347066667,42.737141667],[25.34881,42.740656667],[25.349538333,42.740565],[25.353565,42.742051667],[25.354966667,42.74119],[25.357618333,42.740413333],[25.359906667,42.738535],[25.362271667,42.735586667],[25.365015,42.737461667],[25.387378333,42.735943333],[25.388238333,42.73389],[25.386958333,42.732053333],[25.38844,42.731836667],[25.39218,42.732096667],[25.39483,42.731605],[25.396388333,42.731921667],[25.397505,42.730956667],[25.400706667,42.732363333],[25.40325,42.732568333],[25.403381667,42.731048333],[25.400546667,42.731865],[25.402476667,42.729875],[25.400856667,42.729603333],[25.39716,42.730061667],[25.396473333,42.731615],[25.391965,42.732306667],[25.387225,42.731695],[25.388128333,42.732605],[25.381318333,42.738835],[25.379571667,42.739278333],[25.378136667,42.741388333],[25.375416667,42.74113],[25.374828333,42.740596667],[25.30777,42.68338],[25.304376667,42.678328333],[25.297566667,42.666728333],[25.296903333,42.665768333],[25.29487,42.664645],[25.291323333,42.66141],[25.288,42.65938],[25.289078333,42.657686667],[25.288808333,42.656538333],[25.287503333,42.655426667],[24.74884,42.160626667],[24.748253333,42.152915],[24.749228333,42.153791667],[24.758985,42.157491667],[24.762865,42.158488333],[24.748338333,42.153278333],[24.748038333,42.15396],[24.7485,42.148256667],[24.748301667,42.153416667],[24.74759,42.15366],[24.750673333,42.15441],[24.747716667,42.153281667],[24.749001667,42.152905],[24.748948333,42.15154],[24.74819,42.1536],[23.351485,42.663233333],[23.353675,42.664543333],[23.354398333,42.663403333],[23.350543333,42.661835],[23.350445,42.660681667],[23.345616667,42.659033333],[23.336383333,42.657155],[23.335571667,42.649498333],[23.33509,42.646981667],[23.333763333,42.645356667],[23.334611667,42.64156],[23.33372,42.633316667],[23.334721667,42.632385],[23.350648333,42.626051667],[23.353668333,42.625011667],[23.360123333,42.623945],[23.376818333,42.623233333],[23.382825,42.623058333],[23.381705,42.621403333],[23.380091667,42.62063],[23.380503333,42.617465],[23.378828333,42.616755],[23.377098333,42.617335],[23.378823333,42.617495],[23.377573333,42.618406667],[23.378338333,42.623055],[23.376603333,42.623478333],[23.369836667,42.623901667],[23.360803333,42.624083333],[23.354888333,42.624841667],[23.349695,42.626385],[23.336363333,42.632141667],[23.334408333,42.632755],[23.3343,42.63404],[23.33302,42.633955],[23.329076667,42.635078333],[23.318235,42.639308333],[23.303653333,42.645775],[23.297771667,42.647611667],[23.291938333,42.65026],[23.281613333,42.654378333],[23.282896667,42.654438333],[23.281561667,42.653383333],[23.272495,42.656798333],[23.275191667,42.656316667],[23.281578333,42.653926667],[23.28196,42.653093333],[23.276623333,42.649576667],[23.274141667,42.649015],[23.268188333,42.648863333],[23.26576,42.649565],[23.260711667,42.649985],[23.258975,42.651503333],[23.257745,42.651791667],[23.254771667,42.65348],[23.253511667,42.6533],[23.249435,42.655476667],[23.247556667,42.656761667],[23.2449,42.657448333],[23.242571667,42.657608333],[23.236701667,42.657208333],[23.228833333,42.654526667],[23.225523333,42.653866667],[23.223688333,42.652466667],[23.211675,42.648868333],[23.208693333,42.647598333],[23.205548333,42.645133333],[23.2036,42.642336667],[23.2004,42.639535],[23.19691,42.638095],[23.195846667,42.63569],[23.191276667,42.63388],[23.18927,42.631768333],[23.189258333,42.6303],[23.190905,42.626325],[23.189206667,42.624146667],[23.185663333,42.622838333],[23.182931667,42.622685],[23.18037,42.621485],[23.17745,42.618046667],[23.174373333,42.615316667],[23.173631667,42.61395],[23.173418333,42.611608333],[23.171105,42.60968],[23.165341667,42.607623333],[23.15971,42.603468333],[23.15626,42.602316667],[23.151943333,42.60249],[23.14814,42.602378333],[23.128706667,42.601176667],[23.125651667,42.600315],[23.123541667,42.600778333],[23.122303333,42.599778333],[23.121476667,42.596951667],[23.119783333,42.592781667],[23.11949,42.590365],[23.120748333,42.584261667],[23.120978333,42.581093333],[23.12061,42.580041667],[23.116891667,42.572898333],[23.115526667,42.568155],[23.115045,42.565526667],[23.11546,42.562025],[23.118906667,42.556241667],[23.120241667,42.554693333],[23.123603333,42.551993333],[23.125136667,42.549838333],[23.133741667,42.531843333],[23.134136667,42.530198333],[23.134361667,42.522216667],[23.135376667,42.520706667],[23.138648333,42.517955],[23.14079,42.51438],[23.141158333,42.511766667],[23.14093,42.50668],[23.13953,42.501075],[23.138368333,42.498593333],[23.13554,42.495913333],[23.133135,42.492436667],[23.13201,42.491298333],[23.121716667,42.4842],[23.119176667,42.482793333],[23.115498333,42.482708333],[23.112455,42.481263333],[23.109723333,42.47904],[23.108823333,42.476913333],[23.111053333,42.47122],[23.110893333,42.46762],[23.111483333,42.46496],[23.112615,42.462501667],[23.112981667,42.459928333],[23.11162,42.452768333],[23.111825,42.444168333],[23.112465,42.437855],[23.113456667,42.433873333],[23.118401667,42.420856667],[23.119341667,42.418066667],[23.120171667,42.412835],[23.120595,42.399053333],[23.119631667,42.394093333],[23.118526667,42.391343333],[23.113416667,42.382543333],[23.112583333,42.37997],[23.112703333,42.375775],[23.110718333,42.372045],[23.106318333,42.367243333],[23.104566667,42.364355],[23.103646667,42.361201667],[23.100933333,42.355865],[23.099441667,42.353723333],[23.096318333,42.350275],[23.095335,42.347688333],[23.095208333,42.344041667],[23.0956,42.34176],[23.097085,42.338993333],[23.096013333,42.336145],[23.097676667,42.334171667],[23.098675,42.33199],[23.10067,42.3289],[23.100933333,42.324411667],[23.098386667,42.320883333],[23.09765,42.31891],[23.099783333,42.314786667],[23.102886667,42.311661667],[23.115928333,42.294841667],[23.122488333,42.286073333],[23.1233,42.283696667],[23.126098333,42.282495],[23.126935,42.281706667],[23.128771667,42.277835],[23.130506667,42.276566667],[23.13444,42.279235],[23.147066667,42.282978333],[23.151506667,42.28452],[23.161471667,42.287395],[23.177161667,42.291451667],[23.186888333,42.293495],[23.189776667,42.293785],[23.196573333,42.295691667],[23.208886667,42.300086667],[23.216556667,42.302088333],[23.228818333,42.306278333],[23.240136667,42.30876],[23.24871,42.310811667],[23.27204,42.316595],[23.278988333,42.310748333],[23.287815,42.303833333],[23.28752,42.3025],[23.286146667,42.301383333],[23.276026667,42.297358333],[23.274141667,42.294835],[23.273656667,42.29281],[23.27218,42.29106],[23.266518333,42.289155],[23.26312,42.289026667],[23.25939,42.287671667],[23.254141667,42.28783],[23.257081667,42.286405],[23.262686667,42.286301667],[23.266546667,42.28748],[23.277083333,42.285243333],[23.274535,42.284513333],[23.271806667,42.284333333],[23.270501667,42.281308333],[23.26979,42.280761667],[23.271466667,42.279295],[23.269533333,42.279748333],[23.268628333,42.279166667],[23.272198333,42.277711667],[23.27395,42.275523333],[23.272665,42.27551],[23.274696667,42.271875],[23.276053333,42.271663333],[23.275831667,42.270438333],[23.277588333,42.271501667],[23.277976667,42.273056667],[23.276151667,42.276483333],[23.276498333,42.27753],[23.279351667,42.277965],[23.28109,42.277425],[23.278146667,42.276058333],[23.279405,42.274948333],[23.280558333,42.272616667],[23.280633333,42.270113333],[23.286793333,42.267326667],[23.288308333,42.266018333],[23.288895,42.263956667],[23.291761667,42.262651667],[23.294963333,42.260561667],[23.294746667,42.258383333],[23.293978333,42.256931667],[23.292515,42.25647],[23.294825,42.25566],[23.297543333,42.255408333],[23.299116667,42.254643333],[23.301481667,42.255515],[23.302835,42.255366667],[23.30361,42.256735],[23.304823333,42.256331667],[23.30506,42.254361667],[23.304281667,42.25355],[23.303796667,42.251535],[23.304843333,42.250678333],[23.307178333,42.250173333],[23.308778333,42.250958333],[23.31085,42.250666667],[23.313116667,42.247445],[23.312811667,42.24655],[23.315321667,42.244201667],[23.317246667,42.244725],[23.319776667,42.24316],[23.322445,42.243158333],[23.325006667,42.24152],[23.325046667,42.242475],[23.419408333,42.265966667],[23.450411667,42.281565],[23.453086667,42.28255],[23.540848333,42.333251667],[23.542808333,42.335288333],[23.324785,42.242666667],[23.32353,42.240933333],[23.322406667,42.237858333],[23.324251667,42.24138],[23.328581667,42.243065],[23.324415,42.241933333],[23.308183333,42.231346667],[23.27999,42.213291667],[23.32415,42.241788333],[23.321788333,42.24352],[23.31843,42.244045],[23.317301667,42.244621667],[23.315461667,42.244198333],[23.312383333,42.246245],[23.311285,42.248976667],[23.30986,42.250865],[23.307468333,42.25047],[23.304111667,42.251475],[23.305281667,42.255361667],[23.304833333,42.256381667],[23.302965,42.256591667],[23.302375,42.255775],[23.299085,42.254801667],[23.296541667,42.255638333],[23.29196,42.256131667],[23.294006667,42.257451667],[23.29504,42.260925],[23.292616667,42.261713333],[23.29181,42.262566667],[23.28948,42.262933333],[23.287755,42.266921667],[23.287008333,42.267696667],[23.280481667,42.270463333],[23.280585,42.272555],[23.279355,42.274915],[23.27833,42.275553333],[23.278796667,42.277038333],[23.281623333,42.27698],[23.282996667,42.277406667],[23.278358333,42.278225],[23.276538333,42.277616667],[23.27591,42.276185],[23.27749,42.27292],[23.277131667,42.271381667],[23.275676667,42.271798333],[23.273348333,42.273643333],[23.271088333,42.275975],[23.273635,42.275298333],[23.272073333,42.277048333],[23.27214,42.278096667],[23.270518333,42.279721667],[23.269651667,42.281295],[23.270798333,42.281806667],[23.270775,42.283446667],[23.271741667,42.284255],[23.27691,42.285333333],[23.27512,42.285438333],[23.268421667,42.28687],[23.26863,42.289803333],[23.265826667,42.291903333],[23.263816667,42.292131667],[23.265568333,42.294891667],[23.267035,42.295921667],[23.265816667,42.297838333],[23.255443333,42.31222],[23.254735,42.312295],[23.243046667,42.309468333],[23.22973,42.30653],[23.216766667,42.302221667],[23.21102,42.300865],[23.196113333,42.29565],[23.19099,42.29405],[23.182261667,42.292661667],[23.175885,42.291255],[23.16132,42.287421667],[23.150993333,42.28438],[23.147225,42.283081667],[23.133708333,42.279048333],[23.130998333,42.277236667],[23.130321667,42.276348333],[23.130796667,42.274421667],[23.130505,42.27181],[23.129836667,42.269805],[23.127996667,42.26718],[23.126621667,42.266175],[23.123205,42.26621],[23.12119,42.267631667],[23.1187,42.266891667],[23.11633,42.267811667],[23.113686667,42.267785],[23.112255,42.266966667],[23.110843333,42.268038333],[23.105193333,42.26587],[23.102595,42.262755],[23.101076667,42.261426667],[23.097683333,42.259655],[23.095945,42.257568333],[23.092585,42.245988333],[23.092323333,42.242948333],[23.091151667,42.240723333],[23.085555,42.235785],[23.084793333,42.23477],[23.083118333,42.230296667],[23.075048333,42.216128333],[23.071816667,42.2102],[23.06344,42.198666667],[23.055073333,42.183675],[23.051591667,42.177748333],[23.04133,42.159723333],[23.04086,42.153531667],[23.039883333,42.153885],[23.042966667,42.15499],[23.043093333,42.155918333],[23.04505,42.156113333],[23.046116667,42.15559],[23.047401667,42.153796667],[23.051511667,42.15042],[23.052106667,42.149538333],[23.053226667,42.14567],[23.055678333,42.14483],[23.057076667,42.14367],[23.057278333,42.141798333],[23.058376667,42.140218333],[23.060773333,42.139153333],[23.065603333,42.139578333],[23.068871667,42.140288333],[23.070738333,42.141828333],[23.07215,42.142025],[23.07257,42.143515],[23.074345,42.144376667],[23.07925,42.145123333],[23.083975,42.146288333],[23.08894,42.146426667],[23.092438333,42.144651667],[23.090153333,42.140926667],[23.09132,42.140853333],[23.093195,42.141746667],[23.093566667,42.139223333],[23.095265,42.139966667],[23.095533333,42.138476667],[23.09748,42.138025],[23.101028333,42.134571667],[23.10116,42.131425],[23.102345,42.131988333],[23.102788333,42.130621667],[23.104648333,42.131065],[23.105531667,42.12967],[23.109395,42.127486667],[23.112605,42.122665],[23.1126,42.12112],[23.111655,42.120476667],[23.111865,42.117963333],[23.11315,42.117991667],[23.115885,42.115198333],[23.12206,42.1182],[23.128581667,42.12258],[23.137653333,42.130916667],[23.140306667,42.131373333],[23.141818333,42.132428333],[23.143338333,42.131656667],[23.148186667,42.131371667],[23.150006667,42.132168333],[23.152023333,42.131783333],[23.154596667,42.132483333],[23.157773333,42.132071667],[23.159993333,42.130863333],[23.16194,42.130401667],[23.16991,42.127133333],[23.170828333,42.126328333],[23.179843333,42.124531667],[23.18188,42.124631667],[23.183646667,42.123756667],[23.185845,42.123496667],[23.188228333,42.122436667],[23.19059,42.123628333],[23.194088333,42.123498333],[23.195991667,42.123073333],[23.20008,42.122986667],[23.204,42.123681667],[23.205306667,42.123436667],[23.20807,42.123851667],[23.21223,42.123536667],[23.214615,42.122728333],[23.217785,42.126126667],[23.219371667,42.127026667],[23.222018333,42.12729],[23.223755,42.127975],[23.229123333,42.12799],[23.231071667,42.127481667],[23.235298333,42.127183333],[23.236441667,42.125985],[23.237126667,42.12401],[23.239196667,42.122593333],[23.243626667,42.123906667],[23.246303333,42.12429],[23.250501667,42.124003333],[23.25214,42.124935],[23.256116667,42.125865],[23.259626667,42.125136667],[23.263316667,42.12493],[23.268013333,42.12334],[23.271621667,42.121841667],[23.272795,42.119893333],[23.27679,42.120533333],[23.279641667,42.122845],[23.282425,42.123028333],[23.28444,42.123601667],[23.285776667,42.123256667],[23.292818333,42.11884],[23.295581667,42.118056667],[23.298535,42.11568],[23.30136,42.115255],[23.30273,42.113561667],[23.308626667,42.113675],[23.310878333,42.11485],[23.313628333,42.114328333],[23.317871667,42.114118333],[23.319978333,42.114588333],[23.322318333,42.116571667],[23.327035,42.12175],[23.329913333,42.1258],[23.333323333,42.129075],[23.334471667,42.130948333],[23.336411667,42.132405],[23.33896,42.132733333],[23.339973333,42.134121667],[23.341291667,42.134143333],[23.346851667,42.139365],[23.343906667,42.136956667],[23.343105,42.135295],[23.341491667,42.134063333],[23.339843333,42.133998333],[23.339146667,42.132596667],[23.336625,42.131883333],[23.33198,42.127403333],[23.329721667,42.125481667],[23.3265,42.120911667],[23.322608333,42.11741],[23.318678333,42.115463333],[23.316688333,42.116425],[23.314013333,42.115373333],[23.309116667,42.114566667],[23.307915,42.11359],[23.300921667,42.11414],[23.299905,42.115258333],[23.294778333,42.118838333],[23.291948333,42.119413333],[23.289271667,42.120671667],[23.286121667,42.12272],[23.283795,42.123275],[23.279875,42.122596667],[23.277546667,42.121385],[23.27652,42.120336667],[23.272646667,42.119841667],[23.271258333,42.121888333],[23.263648333,42.124843333],[23.259693333,42.125163333],[23.256386667,42.12582],[23.25275,42.125188333],[23.250243333,42.124035],[23.245593333,42.124475],[23.23905,42.122608333],[23.23719,42.123561667],[23.235508333,42.12706],[23.231293333,42.127436667],[23.228791667,42.128008333],[23.223965,42.127961667],[23.21934,42.126953333],[23.2174,42.12571],[23.214693333,42.122748333],[23.208488333,42.123868333],[23.203873333,42.123633333],[23.201093333,42.122998333],[23.19558,42.123031667],[23.190936667,42.12346],[23.188323333,42.12258],[23.187025,42.122626667],[23.185785,42.123561667],[23.183008333,42.124075],[23.182243333,42.124845],[23.177056667,42.125218333],[23.175598333,42.125883333],[23.170333333,42.126518333],[23.168925,42.127581667],[23.165518333,42.128776667],[23.161891667,42.130405],[23.16034,42.130735],[23.15785,42.132118333],[23.154901667,42.132481667],[23.151596667,42.13193],[23.150038333,42.132078333],[23.14771,42.1314],[23.143496667,42.131668333],[23.142283333,42.132375],[23.137586667,42.130825],[23.133431667,42.126795],[23.128583333,42.122555],[23.122811667,42.11865],[23.083691667,42.098921667],[23.074788333,42.094548333],[23.064516667,42.089815],[23.0621,42.087793333],[23.059071667,42.086446667],[23.057388333,42.086088333],[23.053293333,42.084155],[23.051071667,42.082506667],[23.044258333,42.07635],[23.043145,42.074736667],[23.041685,42.073846667],[23.038408333,42.073205],[23.038973333,42.071315],[23.038793333,42.069781667],[23.037218333,42.067936667],[23.039006667,42.062496667],[23.039828333,42.061096667],[23.041871667,42.059383333],[23.044091667,42.05837],[23.047488333,42.055496667],[23.049456667,42.055718333],[23.050328333,42.0532],[23.04985,42.05201],[23.050098333,42.043765],[23.051505,42.03549],[23.052595,42.033488333],[23.06169,42.025335],[23.064695,42.023276667],[23.068681667,42.019516667],[23.071715,42.017208333],[23.072406667,42.01588],[23.074316667,42.009701667],[23.075993333,42.007493333],[23.087031667,42.000645],[23.09093,41.998788333],[23.091903333,41.997518333],[23.091935,41.994928333],[23.088578333,41.988238333],[23.087376667,41.984798333],[23.087445,41.982425],[23.088776667,41.979035],[23.090131667,41.977135],[23.098363333,41.966463333],[23.099131667,41.964856667],[23.100836667,41.963271667],[23.103518333,41.960016667],[23.104043333,41.958526667],[23.104381667,41.955331667],[23.10422,41.953478333],[23.103238333,41.952111667],[23.098295,41.949355],[23.096765,41.947291667],[23.097563333,41.944618333],[23.100311667,41.9422],[23.102071667,41.939448333],[23.10346,41.93179],[23.104871667,41.929946667],[23.10707,41.928653333],[23.10812,41.927516667],[23.109105,41.924913333],[23.11029,41.92341],[23.115951667,41.918996667],[23.117196667,41.91617],[23.11707,41.914426667],[23.116115,41.911173333],[23.11701,41.90804],[23.119665,41.904376667],[23.120346667,41.902311667],[23.12005,41.89966],[23.116605,41.889268333],[23.118055,41.8892],[23.119635,41.884971667],[23.122531667,41.881596667],[23.127336667,41.879423333],[23.134946667,41.879196667],[23.136995,41.87943],[23.14483,41.881425],[23.149223333,41.883466667],[23.152823333,41.886081667],[23.154645,41.887771667],[23.159981667,41.890236667],[23.161498333,41.891653333],[23.161873333,41.893475],[23.162801667,41.89472],[23.162696667,41.89692],[23.163395,41.897951667],[23.166458333,41.89802],[23.167693333,41.898575],[23.168466667,41.900703333],[23.172196667,41.904805],[23.173843333,41.907263333],[23.176253333,41.907588333],[23.179125,41.908565],[23.181606667,41.908611667],[23.183455,41.909165],[23.185945,41.911516667],[23.189576667,41.912701667],[23.194045,41.915895],[23.196585,41.920871667],[23.198428333,41.922656667],[23.199658333,41.924985],[23.202285,41.926663333],[23.20796,41.927556667],[23.210858333,41.928316667],[23.214108333,41.930108333],[23.218063333,41.929268333],[23.219588333,41.929286667],[23.225173333,41.927391667],[23.227745,41.926731667],[23.230088333,41.926573333],[23.233201667,41.925673333],[23.2384,41.925145],[23.240776667,41.924463333],[23.246393333,41.923621667],[23.251938333,41.920991667],[23.256876667,41.921325],[23.261503333,41.919471667],[23.26575,41.9194],[23.271158333,41.917905],[23.272825,41.917145],[23.276371667,41.91643],[23.282133333,41.916186667],[23.283273333,41.915801667],[23.289676667,41.91224],[23.29459,41.91235],[23.29634,41.911631667],[23.298156667,41.911681667],[23.30241,41.909036667],[23.302315,41.907401667],[23.30319,41.906501667],[23.30794,41.904988333],[23.310416667,41.903435],[23.314418333,41.901758333],[23.316616667,41.90035],[23.31959,41.899981667],[23.322091667,41.897618333],[23.326295,41.896448333],[23.330683333,41.891535],[23.33756,41.88667],[23.34108,41.884573333],[23.34839,41.881356667],[23.354533333,41.881093333],[23.358708333,41.882425],[23.36568,41.883968333],[23.371726667,41.88428],[23.37552,41.884221667],[23.379601667,41.883266667],[23.382931667,41.883373333],[23.387175,41.882093333],[23.389716667,41.880876667],[23.3946,41.879156667],[23.400436667,41.877966667],[23.40299,41.87831],[23.405305,41.878068333],[23.418216667,41.873521667],[23.43077,41.873728333],[23.433925,41.872685],[23.436108333,41.870668333],[23.43856,41.869295],[23.441086667,41.868978333],[23.446798333,41.86913],[23.451806667,41.869711667],[23.462701667,41.871238333],[23.4664,41.871396667],[23.471505,41.871091667],[23.474678333,41.870243333],[23.476758333,41.868416667],[23.47879,41.86281],[23.481411667,41.851993333],[23.482546667,41.846733333],[23.484343333,41.839496667],[23.482496667,41.835008333],[23.480336667,41.832088333],[23.480945,41.830258333],[23.479611667,41.828383333],[23.477255,41.82411],[23.474035,41.820336667],[23.471551667,41.814743333],[23.471125,41.811996667],[23.474011667,41.808275],[23.472796667,41.806345],[23.47125,41.805886667],[23.471608333,41.804315],[23.469385,41.803843333],[23.468875,41.803175],[23.470476667,41.801241667],[23.46942,41.800468333],[23.46959,41.7991],[23.468578333,41.799578333],[23.46934,41.797231667],[23.467131667,41.795098333],[23.465323333,41.794276667],[23.463041667,41.79107],[23.462516667,41.789096667],[23.461156667,41.788276667],[23.460196667,41.790885],[23.459595,41.791055],[23.458663333,41.78695],[23.455646667,41.785895],[23.453366667,41.783576667],[23.452731667,41.785761667],[23.447801667,41.78183],[23.445835,41.783298333],[23.44469,41.783206667],[23.443258333,41.780556667],[23.443031667,41.779301667],[23.440785,41.777033333],[23.437313333,41.775596667],[23.435266667,41.77309],[23.43447,41.773221667],[23.431318333,41.772041667],[23.429296667,41.770195],[23.42849,41.768356667],[23.426501667,41.766558333],[23.424963333,41.766376667],[23.424213333,41.767273333],[23.425925,41.768303333],[23.42595,41.767081667],[23.424795,41.766315],[23.432441667,41.767051667],[23.42426,41.766416667],[23.424453333,41.766091667],[23.429103333,41.727928333],[23.426551667,41.74714],[23.426276667,41.748255],[23.424306667,41.766071667],[23.42764,41.767676667],[23.430453333,41.771226667],[23.483086667,41.836631667],[23.484256667,41.839751667],[23.47892,41.862466667],[23.476903333,41.868233333],[23.474296667,41.870458333],[23.47165,41.871116667],[23.466363333,41.871425],[23.462228333,41.871215],[23.447595,41.869251667],[23.441178333,41.869011667],[23.437553333,41.869758333],[23.433525,41.872971667],[23.430133333,41.87377],[23.41981,41.873295],[23.417268333,41.873746667],[23.40526,41.878108333],[23.402848333,41.878343333],[23.40047,41.878023333],[23.393921667,41.879288333],[23.389351667,41.880936667],[23.387148333,41.882005],[23.381565,41.883471667],[23.378675,41.883393333],[23.375735,41.88418],[23.372763333,41.884365],[23.365591667,41.883981667],[23.359691667,41.882765],[23.356055,41.881431667],[23.353503333,41.88111],[23.348888333,41.8812],[23.342345,41.883855],[23.340256667,41.884956667],[23.331091667,41.891316667],[23.325873333,41.896656667],[23.321965,41.897726667],[23.319463333,41.900125],[23.316741667,41.900323333],[23.314736667,41.901678333],[23.310628333,41.903248333],[23.307565,41.905273333],[23.303693333,41.90618],[23.302353333,41.907256667],[23.301763333,41.909566667],[23.29802,41.911678333],[23.296036667,41.911608333],[23.294401667,41.912338333],[23.290521667,41.912033333],[23.28919,41.91232],[23.287186667,41.913838333],[23.283283333,41.915895],[23.28197,41.91622],[23.276461667,41.916443333],[23.272793333,41.917093333],[23.271123333,41.917893333],[23.265361667,41.919423333],[23.260751667,41.919593333],[23.257328333,41.921175],[23.252065,41.920975],[23.246275,41.923751667],[23.240718333,41.924473333],[23.236276667,41.9254],[23.232593333,41.92571],[23.230013333,41.926495],[23.227968333,41.926626667],[23.221276667,41.928536667],[23.215125,41.929948333],[23.2132,41.929813333],[23.210785,41.928326667],[23.207786667,41.927503333],[23.202475,41.926753333],[23.19894,41.924188333],[23.198251667,41.922346667],[23.196678333,41.921083333],[23.193608333,41.91544],[23.19178,41.91456],[23.188551667,41.912141667],[23.185491667,41.911353333],[23.184253333,41.90969],[23.182095,41.90867],[23.178736667,41.908546667],[23.17644,41.907646667],[23.173456667,41.907171667],[23.17188,41.904646667],[23.168563333,41.900981667],[23.167868333,41.89896],[23.166336667,41.897996667],[23.164298333,41.898246667],[23.162883333,41.897838333],[23.162551667,41.895071667],[23.161653333,41.893663333],[23.161518333,41.892056667],[23.160315,41.890265],[23.154188333,41.887596667],[23.149495,41.883685],[23.1454,41.881848333],[23.1424,41.880843333],[23.136698333,41.879443333],[23.133833333,41.87921],[23.131146667,41.87945],[23.128276667,41.87917],[23.12523,41.880273333],[23.122463333,41.88169],[23.119876667,41.884765],[23.117948333,41.889696667],[23.116331667,41.891131667],[23.116296667,41.887001667],[23.11695,41.885121667],[23.119348333,41.882271667],[23.120548333,41.879901667],[23.120686667,41.876683333],[23.12161,41.874793333],[23.127228333,41.86679],[23.13928,41.849896667],[23.141976667,41.847485],[23.14683,41.844701667],[23.150296667,41.840976667],[23.149903333,41.838165],[23.150535,41.83716],[23.15373,41.836223333],[23.1547,41.83482],[23.153858333,41.831038333],[23.151713333,41.826688333],[23.152213333,41.825275],[23.153323333,41.824553333],[23.157341667,41.823766667],[23.158726667,41.82236],[23.157003333,41.816543333],[23.156983333,41.815421667],[23.158181667,41.814211667],[23.16094,41.812388333],[23.162916667,41.809853333],[23.163168333,41.808878333],[23.16237,41.806608333],[23.162878333,41.805263333],[23.161848333,41.802458333],[23.159881667,41.801161667],[23.157976667,41.797368333],[23.157878333,41.79582],[23.15968,41.793288333],[23.155535,41.789485],[23.152678333,41.78764],[23.1528,41.785315],[23.155505,41.782681667],[23.155765,41.78169],[23.15432,41.779055],[23.154023333,41.77613],[23.154971667,41.771371667],[23.154755,41.77033],[23.152925,41.768461667],[23.153331667,41.766058333],[23.152185,41.759961667],[23.152488333,41.756528333],[23.152365,41.752713333],[23.154091667,41.749343333],[23.155691667,41.748668333],[23.160425,41.748441667],[23.163113333,41.747091667],[23.163515,41.745],[23.159648333,41.741226667],[23.159013333,41.74027],[23.158596667,41.736185],[23.159211667,41.732133333],[23.158453333,41.730793333],[23.156935,41.729828333],[23.152026667,41.728783333],[23.150546667,41.726611667],[23.152848333,41.723961667],[23.155246667,41.722833333],[23.168683333,41.717211667],[23.170756667,41.714978333],[23.174073333,41.706821667],[23.17705,41.698626667],[23.184765,41.680011667],[23.186333333,41.673993333],[23.186241667,41.673056667],[23.183976667,41.669511667],[23.183595,41.668351667],[23.180896667,41.656073333],[23.18154,41.653991667],[23.183206667,41.653005],[23.18669,41.652128333],[23.189215,41.650983333],[23.195141667,41.647138333],[23.196205,41.645881667],[23.2015,41.635408333],[23.205753333,41.633011667],[23.211651667,41.629238333],[23.213828333,41.626498333],[23.21482,41.624096667],[23.219473333,41.61664],[23.225076667,41.606438333],[23.2255,41.605083333],[23.225333333,41.601245],[23.225773333,41.598866667],[23.227275,41.59726],[23.231173333,41.594578333],[23.234098333,41.591738333],[23.237115,41.586455],[23.237851667,41.584623333],[23.239288333,41.579438333],[23.239418333,41.577145],[23.240421667,41.57171],[23.24169,41.567665],[23.241723333,41.565511667],[23.24279,41.564068333],[23.255786667,41.558496667],[23.259416667,41.557253333],[23.263528333,41.555411667],[23.268636667,41.551458333],[23.26923,41.549293333],[23.270451667,41.547346667],[23.271226667,41.544883333],[23.271566667,41.539721667],[23.273658333,41.527613333],[23.273855,41.524385],[23.27311,41.518643333],[23.273171667,41.512881667],[23.274415,41.50839],[23.27673,41.503738333],[23.280111667,41.499343333],[23.280301667,41.498406667],[23.283201667,41.497425],[23.286901667,41.498776667],[23.288993333,41.498475],[23.29611,41.501436667],[23.298203333,41.501721667],[23.304886667,41.504313333],[23.310643333,41.503691667],[23.31293,41.504546667],[23.317516667,41.505065],[23.32173,41.507871667],[23.324826667,41.508185],[23.328315,41.506775],[23.329986667,41.504563333],[23.332918333,41.50306],[23.332763333,41.501621667],[23.333436667,41.500165],[23.336491667,41.499098333],[23.341231667,41.499381667],[23.343271667,41.497631667],[23.347233333,41.498276667],[23.35096,41.497355],[23.352581667,41.49649],[23.356976667,41.495745],[23.35924,41.494921667],[23.362485,41.494776667],[23.363053333,41.495995],[23.36197,41.497861667],[23.36317,41.500168333],[23.365,41.500756667],[23.364805,41.50207],[23.366425,41.50289],[23.366403333,41.504435],[23.369235,41.50646],[23.372063333,41.504573333],[23.373695,41.505198333],[23.374853333,41.50774],[23.378525,41.510385],[23.379213333,41.511725],[23.383711667,41.513083333],[23.384093333,41.515333333],[23.386506667,41.518776667],[23.39002,41.521733333],[23.39112,41.523118333],[23.431368333,41.53171],[23.433861667,41.53365],[23.432731667,41.534961667],[23.43246,41.53874],[23.430878333,41.539198333],[23.427373333,41.538725],[23.426281667,41.539136667],[23.425736667,41.541168333],[23.42208,41.543076667],[23.419681667,41.543015],[23.41866,41.543665],[23.41562,41.543948333],[23.410431667,41.540926667],[23.410155,41.540041667],[23.408255,41.539355],[23.40437,41.536018333],[23.356543333,41.495978333],[23.352785,41.496398333],[23.350593333,41.497433333],[23.34772,41.498225],[23.343058333,41.497628333],[23.341611667,41.499196667],[23.335051667,41.499328333],[23.333166667,41.500371667],[23.332928333,41.502995],[23.329605,41.504883333],[23.328301667,41.506825],[23.324456667,41.50827],[23.321995,41.507883333],[23.317803333,41.505288333],[23.314795,41.504558333],[23.312886667,41.504598333],[23.310701667,41.503778333],[23.305046667,41.504381667],[23.303831667,41.50424],[23.300876667,41.502668333],[23.297891667,41.501666667],[23.295761667,41.501371667],[23.2921,41.4998],[23.29042,41.49876],[23.286063333,41.498608333],[23.283366667,41.497376667],[23.278708333,41.498591667],[23.274413333,41.497626667],[23.26946,41.494296667],[23.267275,41.490981667],[23.266155,41.49002],[23.260515,41.487991667],[23.259621667,41.48732],[23.257208333,41.482921667],[23.254605,41.472365],[23.24329,41.463211667],[23.23754,41.458808333],[23.219231667,41.447706667],[23.217941667,41.446086667],[23.215795,41.440481667],[23.215871667,41.439081667],[23.218155,41.434561667],[23.218338333,41.431968333],[23.21587,41.429425],[23.212588333,41.41815],[23.206985,41.39826],[23.214285,41.397173333],[23.22199,41.398763333],[23.232415,41.403546667],[23.239133333,41.405293333],[23.242346667,41.407055],[23.258843333,41.412625],[23.265585,41.41459],[23.266963333,41.414641667],[23.26947,41.413766667],[23.275448333,41.41454],[23.278913333,41.415521667],[23.282615,41.417143333],[23.285213333,41.417356667],[23.287603333,41.416358333],[23.302396667,41.415316667],[23.30439,41.414603333],[23.306938333,41.414725],[23.309541667,41.415743333],[23.31333,41.41623],[23.3159,41.416151667],[23.320461667,41.417156667],[23.326966667,41.421063333],[23.329368333,41.421531667],[23.333483333,41.419708333],[23.337808333,41.416335],[23.342681667,41.415108333],[23.347478333,41.41358],[23.35498,41.410605],[23.358533333,41.407938333],[23.359915,41.40643],[23.360508333,41.40092],[23.362381667,41.397931667],[23.363546667,41.392398333],[23.363153333,41.385151667],[23.361985,41.384425],[23.362831667,41.380536667],[23.362828333,41.37779],[23.361545,41.375345],[23.358615,41.367261667],[23.353306667,41.358736667],[23.353136667,41.355141667],[23.352393333,41.353573333],[23.349601667,41.350033333],[23.348558333,41.347756667],[23.34943,41.342516667],[23.349241667,41.340713333],[23.345135,41.335206667],[23.344555,41.33353],[23.345105,41.331438333],[23.34913,41.326408333],[23.350153333,41.32351],[23.349831667,41.321731667],[23.347695,41.318596667],[23.346248333,41.317255],[23.342771667,41.314885],[23.341573333,41.313245],[23.340553333,41.308095],[23.338813333,41.305645],[23.3341,41.302191667],[23.332845,41.300701667],[23.332498333,41.299383333],[23.333101667,41.295738333],[23.33297,41.292935],[23.333878333,41.28789],[23.33372,41.28248],[23.33527,41.276948333],[23.336288333,41.274795],[23.337881667,41.273073333],[23.340243333,41.271378333],[23.342876667,41.26857],[23.345445,41.264993333],[23.347973333,41.26296],[23.34943,41.262256667],[23.359555,41.258411667],[23.364778333,41.254213333],[23.372315,41.25255],[23.373795,41.251808333],[23.378545,41.247021667],[23.379276667,41.245605],[23.37928,41.233553333],[23.37944,41.232411667],[23.381978333,41.227368333],[23.387963333,41.221223333],[23.38943,41.21878],[23.389768333,41.213778333],[23.389033333,41.205933333],[23.388261667,41.204193333],[23.385221667,41.199903333],[23.384753333,41.197525],[23.385061667,41.19518],[23.385873333,41.193041667],[23.389773333,41.188285],[23.390703333,41.185931667],[23.390098333,41.183331667],[23.388658333,41.180595],[23.388081667,41.178231667],[23.388881667,41.17587],[23.390635,41.174283333],[23.39824,41.16944],[23.40084,41.166381667],[23.40345,41.159118333],[23.405668333,41.15539],[23.406971667,41.153846667],[23.410851667,41.151776667],[23.413803333,41.151336667],[23.418365,41.151198333],[23.420526667,41.150678333],[23.42235,41.149668333],[23.425373333,41.146803333],[23.426603333,41.146051667],[23.434266667,41.142478333],[23.436781667,41.1405],[23.444556667,41.129326667],[23.446806667,41.126668333],[23.461253333,41.115233333],[23.466375,41.112591667],[23.468873333,41.110878333],[23.473015,41.107108333],[23.475646667,41.105203333],[23.481723333,41.101515],[23.48325,41.099601667],[23.482968333,41.09917],[23.474903333,41.09636],[23.459398333,41.091245],[23.453603333,41.089233333],[23.44332,41.085995],[23.430998333,41.081866667],[23.40788,41.074325],[23.402426667,41.073995],[23.3862,41.074026667],[23.379831667,41.073888333],[23.377093333,41.073391667],[23.356303333,41.066756667],[23.354335,41.065858333],[23.349663333,41.062763333],[23.346986667,41.060711667],[23.339743333,41.053535],[23.337168333,41.05176],[23.334271667,41.050515],[23.331523333,41.050146667],[23.319261667,41.049243333],[23.308611667,41.048205],[23.304893333,41.047226667],[23.298415,41.044326667],[23.293753333,41.043645],[23.291231667,41.04278],[23.287883333,41.039395],[23.285068333,41.037891667],[23.280236667,41.03851],[23.278961667,41.038288333],[23.277096667,41.036883333],[23.276596667,41.033563333],[23.275033333,41.032906667],[23.271985,41.032763333],[23.267711667,41.031135],[23.262665,41.02994],[23.25972,41.030605],[23.257623333,41.029475],[23.256476667,41.026303333],[23.252895,41.021758333],[23.250985,41.018065],[23.248976667,41.015553333],[23.249243333,41.013038333],[23.247431667,41.011455],[23.243811667,41.010081667],[23.24055,41.009478333],[23.239035,41.007491667],[23.237213333,41.006341667],[23.236395,41.005026667],[23.236555,41.003056667],[23.235168333,41.001638333],[23.231578333,41.001308333],[23.229965,41.000443333],[23.225805,41.00008],[23.224291667,40.999225],[23.223215,40.996365],[23.22244,40.995478333],[23.219798333,40.994088333],[23.217241667,40.993758333],[23.215446667,40.992978333],[23.211128333,40.992618333],[23.208275,40.991753333],[23.20264,40.98919],[23.197571667,40.988168333],[23.193088333,40.986518333],[23.19067,40.98514],[23.184143333,40.979526667],[23.180635,40.975946667],[23.178045,40.971085],[23.173406667,40.965203333],[23.171403333,40.963541667],[23.169318333,40.962381667],[23.16607,40.961273333],[23.1607,40.960323333],[23.156808333,40.959066667],[23.14859,40.955291667],[23.14643,40.953555],[23.143503333,40.949315],[23.139193333,40.945875],[23.137046667,40.943808333],[23.135988333,40.942241667],[23.133978333,40.937626667],[23.132818333,40.93563],[23.127283333,40.928643333],[23.122858333,40.924533333],[23.11574,40.919193333],[23.114238333,40.91737],[23.113086667,40.914806667],[23.111763333,40.913296667],[23.109746667,40.91231],[23.105445,40.910845],[23.096186667,40.904335],[23.093635,40.901758333],[23.090685,40.89496],[23.087538333,40.891515],[23.084473333,40.889271667],[23.076821667,40.885321667],[23.070325,40.8814],[23.062653333,40.87942],[23.059628333,40.87723],[23.058368333,40.875191667],[23.058015,40.873386667],[23.058041667,40.870116667],[23.057528333,40.867863333],[23.053996667,40.862038333],[23.053805,40.858835],[23.055118333,40.85336],[23.054891667,40.851075],[23.053605,40.848075],[23.043551667,40.831468333],[23.041216667,40.826066667],[23.040505,40.82197],[23.04029,40.817361667],[23.039078333,40.811911667],[23.037611667,40.808945],[23.036246667,40.806966667],[23.031378333,40.800856667],[23.029665,40.79842],[23.027245,40.793823333],[23.025498333,40.788186667],[23.024301667,40.778645],[23.023695,40.775013333],[23.022178333,40.770286667],[23.009368333,40.740658333],[23.007201667,40.738385],[23.001041667,40.73542],[22.993035,40.730436667],[22.98807,40.728355],[22.98281,40.726835],[22.978161667,40.723781667],[22.975361667,40.722496667],[22.971993333,40.720408333],[22.964155,40.716515],[22.960158333,40.713885],[22.952695,40.705968333],[22.947326667,40.695195],[22.946695,40.695648333],[22.951476667,40.69488],[22.956381667,40.695013333],[22.961903333,40.694355],[22.964366667,40.693053333],[22.96478,40.692101667],[22.96421,40.690388333],[22.96086,40.68859],[22.958795,40.686886667],[22.957343333,40.683918333],[22.957223333,40.68178],[22.959953333,40.675431667],[22.962195,40.668276667],[22.963383333,40.666095],[22.967176667,40.662988333],[22.968126667,40.660936667],[22.968013333,40.65965],[22.966531667,40.655548333],[22.966156667,40.65298],[22.966581667,40.650313333],[22.96872,40.645158333],[22.96855,40.64475],[22.963405,40.64355],[22.96287,40.64274],[22.95952,40.641618333],[22.958618333,40.642148333],[22.952856667,40.643695],[22.951401667,40.642753333],[22.952866667,40.642176667],[22.951998333,40.641553333],[22.999873333,40.61109],[22.9999,40.609761667],[22.998391667,40.602833333],[22.996945,40.59903],[22.994058333,40.594303333],[22.991645,40.592138333],[22.980346667,40.584171667],[22.97609,40.581456667],[22.976538333,40.58001],[22.979505,40.578606667],[22.98341,40.573626667],[22.986123333,40.569151667],[22.9902,40.563281667],[22.99912,40.55303],[23.001798333,40.549568333],[23.008441667,40.53983],[23.009665,40.537748333],[23.009166667,40.53574],[23.008138333,40.534993333],[23.006016667,40.534583333],[22.99558,40.533506667],[22.993988333,40.533058333],[22.990065,40.530391667],[22.97809,40.52527],[22.976335,40.524853333],[22.977485,40.52391],[22.97838,40.525151667],[22.989083333,40.529761667],[22.994906667,40.53333],[22.996158333,40.53359],[23.006495,40.534603333],[23.010521667,40.534881667],[23.011481667,40.534506667],[23.012401667,40.532548333],[23.012908333,40.527931667],[23.01259,40.525703333],[23.006316667,40.50554],[23.004751667,40.501035],[22.999555,40.492588333],[22.997793333,40.488281667],[22.997011667,40.487045],[22.993195,40.483498333],[22.992268333,40.48139],[22.992666667,40.480146667],[22.9927,40.473426667],[22.993746667,40.471036667],[22.99706,40.46667],[22.998466667,40.460936667],[23.000095,40.458985],[23.003423333,40.456518333],[23.007283333,40.45323],[23.009861667,40.450068333],[23.010378333,40.448661667],[23.011586667,40.442783333],[23.01233,40.441035],[23.017408333,40.43236],[23.018865,40.429421667],[23.020095,40.425823333],[23.022776667,40.420988333],[23.023146667,40.418995],[23.022878333,40.415],[23.023281667,40.412721667],[23.02406,40.41144],[23.028095,40.40752],[23.03,40.404465],[23.031483333,40.399206667],[23.036561667,40.388096667],[23.039741667,40.381958333],[23.040583333,40.379756667],[23.045076667,40.370208333],[23.048075,40.365046667],[23.053365,40.358335],[23.072423333,40.335461667],[23.077085,40.329508333],[23.081393333,40.325716667],[23.090983333,40.31682],[23.09438,40.314463333],[23.098043333,40.313185],[23.109711667,40.312305],[23.112035,40.311843333],[23.124965,40.307811667],[23.12777,40.30665],[23.130213333,40.305183333],[23.132631667,40.303095],[23.141693333,40.293633333],[23.147995,40.287238333],[23.151616667,40.28511],[23.15626,40.284166667],[23.166196667,40.284346667],[23.173685,40.284645],[23.18147,40.28451],[23.184916667,40.2841],[23.190181667,40.282606667],[23.198576667,40.279165],[23.208933333,40.275206667],[23.220175,40.271035],[23.233491667,40.265913333],[23.236288333,40.265053333],[23.239831667,40.264495],[23.251545,40.263233333],[23.278551667,40.26013],[23.283081667,40.258968333],[23.285503333,40.257453333],[23.299796667,40.241806667],[23.299455,40.240905],[23.298431667,40.241973333],[23.302975,40.244355],[23.309143333,40.247885],[23.323241667,40.255326667],[23.327023333,40.257953333],[23.335046667,40.265073333],[23.347111667,40.275608333],[23.350031667,40.277376667],[23.360648333,40.282603333],[23.363718333,40.283731667],[23.367468333,40.28392],[23.390985,40.282985],[23.416045,40.28227],[23.420146667,40.281763333],[23.444206667,40.276361667],[23.44646,40.275055],[23.449243333,40.271421667],[23.450605,40.270566667],[23.453551667,40.270286667],[23.455668333,40.268616667],[23.458705,40.2676],[23.460745,40.265395],[23.461895,40.26533],[23.464056667,40.266221667],[23.465158333,40.26592],[23.467113333,40.264101667],[23.471263333,40.26405],[23.473266667,40.26156],[23.475503333,40.260493333],[23.478248333,40.260378333],[23.489496667,40.261088333],[23.499901667,40.260291667],[23.506398333,40.25939],[23.508455,40.259653333],[23.512861667,40.26175],[23.515501667,40.26259],[23.517651667,40.262536667],[23.520405,40.261905],[23.528646667,40.259131667],[23.544346667,40.254235],[23.551173333,40.252461667],[23.554258333,40.252566667],[23.561,40.25367],[23.562875,40.253581667],[23.566466667,40.251628333],[23.574385,40.250391667],[23.577618333,40.24916],[23.581588333,40.246146667],[23.582888333,40.245483333],[23.584703333,40.243681667],[23.586215,40.241293333],[23.587593333,40.239943333],[23.590228333,40.238971667],[23.596726667,40.238991667],[23.598306667,40.238511667],[23.599815,40.237161667],[23.601116667,40.233956667],[23.602351667,40.232631667],[23.60514,40.232235],[23.60672,40.231593333],[23.607741667,40.230281667],[23.609911667,40.229355],[23.612936667,40.231828333],[23.614541667,40.231398333],[23.61706,40.231475],[23.62036,40.230998333],[23.624041667,40.231578333],[23.625621667,40.229875],[23.62709,40.229125],[23.629326667,40.229926667],[23.632563333,40.229631667],[23.636013333,40.22789],[23.638911667,40.228076667],[23.643606667,40.226996667],[23.646938333,40.227981667],[23.651358333,40.226728333],[23.654548333,40.227848333],[23.656648333,40.227836667],[23.663443333,40.226225],[23.664553333,40.225756667],[23.670101667,40.222216667],[23.676158333,40.21802],[23.681158333,40.214756667],[23.683065,40.21441],[23.685913333,40.215191667],[23.688366667,40.215088333],[23.68983,40.213573333],[23.692035,40.213108333],[23.69495,40.214343333],[23.696741667,40.215731667],[23.697518333,40.218393333],[23.698391667,40.219543333],[23.700696667,40.220656667],[23.701878333,40.22234],[23.700316667,40.226098333],[23.700173333,40.227866667],[23.70202,40.228915],[23.7071,40.229166667],[23.709808333,40.22988],[23.713861667,40.23246],[23.716705,40.232851667],[23.725955,40.232941667],[23.732605,40.23285],[23.73437,40.23228],[23.737643333,40.228831667],[23.741001667,40.227305],[23.743878333,40.225278333],[23.753276667,40.21576],[23.75542,40.213416667],[23.756928333,40.21022],[23.75992,40.207546667],[23.762861667,40.20228],[23.76578,40.19857],[23.767578333,40.197046667],[23.771376667,40.189281667],[23.773091667,40.187975],[23.77997,40.184908333],[23.78386,40.184061667],[23.798386667,40.182253333],[23.805938333,40.181525],[23.810775,40.180778333],[23.814798333,40.18043],[23.818243333,40.179105],[23.820088333,40.179048333],[23.825,40.179728333],[23.82801,40.179011667],[23.829766667,40.177415],[23.83407,40.176798333],[23.836648333,40.174101667],[23.837925,40.175951667],[23.839366667,40.176405],[23.841413333,40.174221667],[23.843956667,40.174063333],[23.845178333,40.172031667],[23.847856667,40.174276667],[23.84942,40.174905],[23.850353333,40.174348333],[23.850255,40.171286667],[23.850925,40.170043333],[23.853033333,40.169271667],[23.855655,40.169933333],[23.856368333,40.170666667],[23.855466667,40.17233],[23.855881667,40.17286],[23.857996667,40.172736667],[23.859906667,40.170811667],[23.860228333,40.169003333],[23.86247,40.167216667],[23.864651667,40.16627],[23.866335,40.163403333],[23.8711,40.161613333],[23.872628333,40.160653333],[23.876673333,40.159701667],[23.878903333,40.161293333],[23.884433333,40.160828333],[23.884701667,40.161781667],[23.887831667,40.161678333],[23.889333333,40.159468333],[23.892506667,40.158413333],[23.894753333,40.155366667],[23.895465,40.157033333],[23.898138333,40.159046667],[23.900946667,40.158171667],[23.901498333,40.156881667],[23.904708333,40.157841667],[23.908433333,40.156211667],[23.911305,40.156175],[23.911936667,40.154515],[23.9102,40.153711667],[23.912598333,40.151453333],[23.913036667,40.150036667],[23.915383333,40.149321667],[23.916696667,40.149436667],[23.918476667,40.150551667],[23.919595,40.149641667],[23.918918333,40.146998333],[23.919261667,40.14617],[23.922413333,40.142256667],[23.922163333,40.140963333],[23.923388333,40.13846],[23.923101667,40.136528333],[23.923715,40.135228333],[23.92725,40.131713333],[23.92971,40.130506667],[23.941916667,40.128171667],[23.946965,40.126051667],[23.953286667,40.12448],[23.95608,40.124633333],[23.959953333,40.126231667],[23.9629,40.126253333],[23.966876667,40.123875],[23.969736667,40.121585],[23.97073,40.119553333],[23.971318333,40.116958333],[23.972915,40.116213333],[23.975305,40.116545],[23.977496667,40.115881667],[23.978238333,40.115115],[23.978313333,40.113458333],[23.983123333,40.114098333],[23.98639,40.11332],[23.984565,40.10944],[23.986303333,40.10825],[23.987595,40.105573333],[23.985788333,40.105113333],[23.980866667,40.105231667],[23.978828333,40.103895],[23.980831667,40.101468333],[23.98001,40.100696667],[23.976993333,40.10109],[23.97579,40.100153333],[23.976251667,40.08854],[23.97691,40.082373333],[23.979143333,40.083006667],[23.978275,40.085941667],[23.977991667,40.088385],[23.978836667,40.094065],[23.978665,40.096518333],[23.976138333,40.097378333],[23.975835,40.099936667],[23.977101667,40.10107],[23.980063333,40.100678333],[23.981033333,40.101153333],[23.978938333,40.104028333],[23.980483333,40.105165],[23.986236667,40.10506],[23.987331667,40.1059],[23.985946667,40.107385],[23.98598,40.108416667],[23.984173333,40.109826667],[23.984985,40.111565],[23.987653333,40.111913333],[23.987436667,40.112613333],[23.983925,40.113233333],[23.982281667,40.113928333],[23.97986,40.114181667],[23.97729,40.113925],[23.977923333,40.115858333],[23.974486667,40.116936667],[23.971675,40.116481667],[23.970928333,40.116816667],[23.969981667,40.121011667],[23.968018333,40.123243333],[23.963643333,40.12579],[23.961056667,40.126488333],[23.956596667,40.124885],[23.95426,40.124516667],[23.952365,40.12472],[23.946151667,40.12635],[23.94202,40.128258333],[23.929506667,40.13064],[23.927636667,40.131423333],[23.923731667,40.135153333],[23.923055,40.13642],[23.923113333,40.13904],[23.922035,40.140856667],[23.922138333,40.142776667],[23.919371667,40.14604],[23.91878,40.147285],[23.919188333,40.149743333],[23.917708333,40.150536667],[23.916443333,40.149541667],[23.913333333,40.149913333],[23.912256667,40.151903333],[23.909936667,40.153608333],[23.909965,40.154221667],[23.911901667,40.154943333],[23.910576667,40.156201667],[23.908273333,40.156308333],[23.904496667,40.15771],[23.90257,40.15698],[23.898295,40.158961667],[23.895615,40.157496667],[23.895348333,40.156411667],[23.893603333,40.156225],[23.892575,40.15827],[23.891605,40.158941667],[23.889011667,40.159418333],[23.888423333,40.161193333],[23.88446,40.161865],[23.884403333,40.160905],[23.88029,40.161385],[23.878231667,40.161311667],[23.875398333,40.16025],[23.87293,40.16074],[23.871341667,40.16165],[23.866331667,40.163505],[23.865415,40.166043333],[23.860173333,40.169088333],[23.860045,40.170756667],[23.85886,40.172176667],[23.857078333,40.172941667],[23.855218333,40.172535],[23.855821667,40.170331667],[23.8515,40.170085],[23.85,40.170876667],[23.849341667,40.174436667],[23.846328333,40.173218333],[23.84618,40.17227],[23.844835,40.172078333],[23.84409,40.174018333],[23.841125,40.174321667],[23.838551667,40.176081667],[23.837608333,40.176016667],[23.835826667,40.174266667],[23.834821667,40.176795],[23.833021667,40.17731],[23.829803333,40.177431667],[23.826461667,40.179476667],[23.824896667,40.179746667],[23.819063333,40.178998333],[23.817148333,40.179081667],[23.812835,40.180496667],[23.806503333,40.181263333],[23.795306667,40.182828333],[23.783,40.184371667],[23.777923333,40.185848333],[23.77314,40.187866667],[23.771001667,40.18992],[23.767706667,40.196938333],[23.762785,40.202796667],[23.760045,40.207898333],[23.7571,40.210013333],[23.75626,40.212233333],[23.754996667,40.214048333],[23.743568333,40.225606667],[23.741878333,40.226945],[23.73699,40.22943],[23.73413,40.232346667],[23.73271,40.233026667],[23.730306667,40.233096667],[23.715996667,40.232936667],[23.713011667,40.232191667],[23.710938333,40.230531667],[23.708203333,40.229356667],[23.701543333,40.228741667],[23.700051667,40.227686667],[23.7,40.226383333],[23.701651667,40.222623333],[23.701085,40.220756667],[23.698541667,40.219521667],[23.697348333,40.218211667],[23.696616667,40.215743333],[23.695745,40.214763333],[23.691658333,40.21311],[23.68978,40.213486667],[23.687555,40.215098333],[23.685726667,40.2152],[23.683306667,40.214591667],[23.681141667,40.21475],[23.677503333,40.216983333],[23.66858,40.222963333],[23.664428333,40.225613333],[23.662983333,40.226191667],[23.656085,40.227791667],[23.654213333,40.227818333],[23.650648333,40.226785],[23.646986667,40.227948333],[23.643875,40.227168333],[23.641716667,40.22706],[23.6398,40.227975],[23.635856667,40.227686667],[23.630403333,40.229866667],[23.629536667,40.229968333],[23.626411667,40.229001667],[23.623693333,40.231235],[23.622756667,40.231486667],[23.619858333,40.230886667],[23.616825,40.231483333],[23.614613333,40.231215],[23.611253333,40.231496667],[23.610021667,40.230146667],[23.608581667,40.229861667],[23.60691,40.231648333],[23.605503333,40.232461667],[23.602633333,40.23285],[23.600975,40.23426],[23.599946667,40.236895],[23.597671667,40.238586667],[23.590386667,40.239141667],[23.587713333,40.23998],[23.586316667,40.24112],[23.583696667,40.244568333],[23.578426667,40.248463333],[23.57637,40.249633333],[23.572573333,40.250783333],[23.56771,40.251355],[23.56566,40.251895],[23.56253,40.253605],[23.560598333,40.253708333],[23.554421667,40.25268],[23.54975,40.25281],[23.547341667,40.25341],[23.532148333,40.258055],[23.51868,40.262396667],[23.515715,40.262691667],[23.514016667,40.262326667],[23.508568333,40.26002],[23.505541667,40.259678333],[23.497408333,40.261096667],[23.494038333,40.261365],[23.478156667,40.260258333],[23.476195,40.260288333],[23.473211667,40.261628333],[23.470745,40.264375],[23.467298333,40.264143333],[23.464555,40.266193333],[23.461933333,40.265523333],[23.460251667,40.265641667],[23.458566667,40.26769],[23.454593333,40.269168333],[23.453003333,40.270506667],[23.449545,40.271168333],[23.44655,40.274691667],[23.444995,40.275913333],[23.441885,40.276915],[23.420306667,40.281798333],[23.415463333,40.282345],[23.396723333,40.282936667],[23.386808333,40.283341667],[23.367575,40.283898333],[23.364803333,40.283816667],[23.361483333,40.28297],[23.349376667,40.277041667],[23.344886667,40.274088333],[23.339093333,40.268788333],[23.327341667,40.258301667],[23.323031667,40.25514],[23.315588333,40.251233333],[23.307981667,40.247011667],[23.30139,40.24358],[23.300331667,40.243488333],[23.297323333,40.244555],[23.286345,40.256588333],[23.284325,40.258301667],[23.280731667,40.259861667],[23.277738333,40.26039],[23.258893333,40.262573333],[23.239491667,40.264665],[23.232988333,40.266148333],[23.225553333,40.268935],[23.21501,40.273198333],[23.212791667,40.273961667],[23.190066667,40.282663333],[23.184823333,40.284213333],[23.181741667,40.284635],[23.174318333,40.284796667],[23.159591667,40.28446],[23.15663,40.284285],[23.153721667,40.284543333],[23.151423333,40.285245],[23.147771667,40.287548333],[23.13268,40.303123333],[23.129825,40.30566],[23.125593333,40.307736667],[23.11199,40.311941667],[23.108861667,40.312468333],[23.100221667,40.313043333],[23.095168333,40.314276667],[23.091851667,40.316245],[23.085746667,40.32175],[23.07947,40.327661667],[23.077815,40.329668333],[23.076488333,40.332393333],[23.074681667,40.334436667],[23.071611667,40.336741667],[23.05821,40.352768333],[23.05003,40.362775],[23.046926667,40.367318333],[23.045196667,40.370668333],[23.033891667,40.394396667],[23.0314,40.399916667],[23.030076667,40.404518333],[23.028745,40.407193333],[23.025041667,40.410801667],[23.023665,40.412518333],[23.023001667,40.415616667],[23.023241667,40.418593333],[23.023016667,40.420716667],[23.020446667,40.425736667],[23.018386667,40.430895],[23.012776667,40.440716667],[23.011401667,40.444363333],[23.01049,40.44886],[23.007945,40.452878333],[23.003786667,40.456581667],[23.000121667,40.459338333],[22.998866667,40.460895],[22.997615,40.465808333],[22.996378333,40.46836],[22.993666667,40.471951667],[22.993038333,40.473763333],[22.992846667,40.482576667],[22.99389,40.484248333],[22.997296667,40.486965],[22.997868333,40.487795],[22.9996,40.492451667],[23.004238333,40.499708333],[23.00561,40.502748333],[23.007886667,40.510536667],[23.009563333,40.515476667],[23.012515,40.524971667],[23.012983333,40.52751],[23.012768333,40.531288333],[23.011803333,40.535238333],[23.007121667,40.534686667],[22.995748333,40.533621667],[22.99445,40.533296667],[22.992095,40.531663333],[22.987578333,40.529273333],[22.977785,40.525116667],[22.979146667,40.525523333],[22.989321667,40.529933333],[22.994206667,40.532946667],[22.995896667,40.533495],[23.012296667,40.535173333],[23.012511667,40.536258333],[23.010451667,40.537108333],[23.001731667,40.55015],[22.998908333,40.553543333],[22.991028333,40.562586667],[22.988325,40.566228333],[22.98221,40.5755],[22.97905,40.57961],[22.976931667,40.581958333],[22.973043333,40.585543333],[22.967771667,40.58985],[22.965855,40.592275],[22.964805,40.595723333],[22.964375,40.60208],[22.962665,40.618876667],[22.962926667,40.619098333],[22.961991667,40.623701667],[22.959755,40.626511667],[22.956755,40.629275],[22.95352,40.631251667],[22.95605,40.634181667],[22.955675,40.634878333],[22.957345,40.636663333],[22.95692,40.636903333],[22.958998333,40.639183333],[22.955956667,40.634863333],[22.95473,40.63633],[22.952556667,40.637455],[22.948625,40.63872],[22.945781667,40.64157],[22.941838333,40.640403333],[22.935978333,40.640408333],[22.932008333,40.642418333],[22.928733333,40.643756667],[22.925388333,40.645593333],[22.921415,40.64816],[22.921048333,40.64884],[22.916031667,40.650958333],[22.915463333,40.650188333],[22.91683,40.649071667],[22.915086667,40.647181667],[22.906061667,40.650511667],[22.902868333,40.652205],[22.898505,40.653985],[22.891213333,40.655698333],[22.882413333,40.655696667],[22.879448333,40.65545],[22.87827,40.65468],[22.878803333,40.653998333],[22.876461667,40.653101667],[22.873485,40.653523333],[22.870055,40.655053333],[22.865193333,40.655035],[22.842656667,40.653441667],[22.82632,40.652126667],[22.820336667,40.65172],[22.816141667,40.651005],[22.812686667,40.64995],[22.808635,40.647985],[22.779143333,40.632913333],[22.7689,40.627611667],[22.75386,40.619983333],[22.739578333,40.612551667],[22.735988333,40.610795],[22.727181667,40.607356667],[22.723883333,40.606571667],[22.714413333,40.605115],[22.697101667,40.602723333],[22.684638333,40.600518333],[22.676728333,40.599318333],[22.672426667,40.598143333],[22.66952,40.596893333],[22.664668333,40.59434],[22.636628333,40.580088333],[22.623256667,40.573095],[22.612313333,40.566973333],[22.605806667,40.562601667],[22.600846667,40.558278333],[22.595013333,40.551803333],[22.581273333,40.536905],[22.577678333,40.531935],[22.575376667,40.527806667],[22.573138333,40.521976667],[22.57128,40.516266667],[22.569871667,40.51264],[22.564453333,40.49709],[22.56406,40.493335],[22.564498333,40.490305],[22.565123333,40.488581667],[22.570836667,40.474951667],[22.572606667,40.471545],[22.575055,40.468401667],[22.577276667,40.46446],[22.579895,40.45214],[22.581483333,40.447298333],[22.586473333,40.434718333],[22.587938333,40.430788333],[22.588823333,40.427595],[22.590795,40.417748333],[22.592041667,40.41312],[22.593715,40.409118333],[22.595625,40.405618333],[22.60107,40.397843333],[22.604358333,40.391613333],[22.605536667,40.387353333],[22.606401667,40.38241],[22.606566667,40.378853333],[22.605935,40.371398333],[22.604133333,40.36569],[22.603051667,40.36312],[22.601151667,40.359686667],[22.598886667,40.356311667],[22.593263333,40.347088333],[22.590868333,40.343656667],[22.583146667,40.333286667],[22.582303333,40.332631667],[22.580513333,40.329168333],[22.57798,40.325786667],[22.573663333,40.320953333],[22.569201667,40.316631667],[22.563866667,40.312071667],[22.55972,40.308806667],[22.545123333,40.297973333],[22.529441667,40.285863333],[22.523925,40.281945],[22.522325,40.280116667],[22.521573333,40.278488333],[22.521093333,40.275763333],[22.52628,40.26531],[22.527356667,40.264358333],[22.530798333,40.258118333],[22.533596667,40.249165],[22.539175,40.228693333],[22.544551667,40.20989],[22.545626667,40.20672],[22.546028333,40.204155],[22.547506667,40.198685],[22.548483333,40.196453333],[22.551205,40.185105],[22.55128,40.182631667],[22.550376667,40.178161667],[22.549265,40.175363333],[22.541521667,40.151826667],[22.539011667,40.151403333],[22.53808,40.150766667],[22.534421667,40.150241667],[22.530161667,40.148006667],[22.526333333,40.144933333],[22.524848333,40.144278333],[22.520225,40.14322],[22.520961667,40.137183333],[22.521688333,40.135333333],[22.521651667,40.133116667],[22.522498333,40.128348333],[22.522478333,40.124565],[22.518621667,40.118698333],[22.515866667,40.117205],[22.508171667,40.112488333],[22.506505,40.110498333],[22.503556667,40.108023333],[22.501828333,40.108431667],[22.499853333,40.107821667],[22.497806667,40.109858333],[22.496566667,40.11026],[22.494233333,40.110091667],[22.492113333,40.112985],[22.491316667,40.112953333],[22.488675,40.11573],[22.488386667,40.117206667],[22.486586667,40.118535],[22.48711,40.117353333],[22.486003333,40.115481667],[22.485886667,40.112616667],[22.482116667,40.11609],[22.48059,40.115745],[22.480578333,40.11703],[22.479273333,40.118233333],[22.478806667,40.117511667],[22.478846667,40.114621667],[22.479771667,40.114135],[22.480301667,40.112561667],[22.479121667,40.111963333],[22.477258333,40.11256],[22.479478333,40.11078],[22.479861667,40.108898333],[22.476891667,40.107653333],[22.48002,40.10677],[22.479558333,40.105438333],[22.477025,40.106325],[22.473015,40.1083],[22.475216667,40.109261667],[22.472743333,40.109383333],[22.470536667,40.110161667],[22.46843,40.110116667],[22.470341667,40.110996667],[22.471595,40.112333333],[22.468806667,40.112991667],[22.46939,40.1119],[22.466276667,40.111665],[22.463898333,40.110955],[22.462018333,40.109253333],[22.409205,40.084926667],[22.407243333,40.08462],[22.43477,40.07572],[22.407193333,40.08445],[22.406998333,40.08615],[22.40949,40.088223333],[22.411261667,40.088175],[22.417298333,40.091981667],[22.418505,40.091648333],[22.419905,40.092898333],[22.420753333,40.09635],[22.42244,40.096313333],[22.424971667,40.098313333],[22.429533333,40.098501667],[22.434848333,40.10022],[22.437115,40.100676667],[22.441446667,40.102985],[22.44361,40.102823333],[22.452235,40.103938333],[22.453413333,40.103205],[22.454968333,40.10362],[22.457278333,40.103415],[22.457098333,40.104328333],[22.458325,40.105896667],[22.461178333,40.105876667],[22.462496667,40.106663333],[22.465348333,40.107138333],[22.464605,40.10772],[22.46136,40.107175],[22.462171667,40.108905],[22.465818333,40.1111],[22.469865,40.111893333],[22.46917,40.112973333],[22.471443333,40.112195],[22.471291667,40.111683333],[22.467926667,40.109626667],[22.469206667,40.109308333],[22.470835,40.109996667],[22.47467,40.109348333],[22.473768333,40.108246667],[22.475898333,40.106208333],[22.477213333,40.106523333],[22.476536667,40.107585],[22.480001667,40.109113333],[22.479185,40.110946667],[22.47698,40.11157],[22.480023333,40.112485],[22.479116667,40.115518333],[22.47881,40.11784],[22.48054,40.117173333],[22.480373333,40.116006667],[22.482605,40.116033333],[22.483253333,40.114761667],[22.485678333,40.11253],[22.486063333,40.115016667],[22.487101667,40.116715],[22.487123333,40.11822],[22.49129,40.112898333],[22.492281667,40.112973333],[22.493623333,40.110601667],[22.497888333,40.110191667],[22.499918333,40.108881667],[22.50397,40.108408333],[22.506908333,40.110853333],[22.508438333,40.112713333],[22.513338333,40.115456667],[22.51544,40.116981667],[22.51809,40.118211667],[22.522523333,40.124328333],[22.52246,40.128148333],[22.52093,40.136723333],[22.520756667,40.143576667],[22.525073333,40.144283333],[22.527115,40.145238333],[22.52887,40.146801667],[22.533941667,40.14993],[22.538158333,40.150793333],[22.539005,40.151428333],[22.541288333,40.151015],[22.541061667,40.147376667],[22.544571667,40.136471667],[22.546325,40.131713333],[22.54505,40.131273333],[22.544996667,40.132428333],[22.549925,40.133471667],[22.552366667,40.124486667],[22.552796667,40.120536667],[22.553303333,40.119118333],[22.555873333,40.11435],[22.556435,40.1112],[22.559503333,40.10628],[22.561696667,40.10169],[22.559935,40.100216667],[22.554025,40.099003333],[22.555071667,40.098041667],[22.555133333,40.095041667],[22.55483,40.076273333],[22.554743333,40.066676667],[22.55491,40.065371667],[22.557016667,40.056911667],[22.558111667,40.054883333],[22.567803333,40.040828333],[22.56906,40.038371667],[22.569473333,40.03555],[22.57073,40.031208333],[22.576453333,40.021443333],[22.577585,40.019866667],[22.581991667,40.012553333],[22.584118333,40.011286667],[22.588036667,40.010566667],[22.590265,40.009656667],[22.59031,40.006938333],[22.592198333,40.005963333],[22.593333333,40.004055],[22.596345,40.00396],[22.59833,40.00292],[22.597891667,40.001418333],[22.598608333,40.00116],[22.600673333,40.002235],[22.602446667,40.002068333],[22.602138333,39.998451667],[22.605658333,39.994956667],[22.606703333,39.990483333],[22.610473333,39.986601667],[22.62538,39.980116667],[22.63426,39.976771667],[22.63737,39.974786667],[22.638498333,39.973521667],[22.639523333,39.97117],[22.64148,39.968458333],[22.644965,39.96637],[22.645453333,39.965466667],[22.645273333,39.961833333],[22.64642,39.958643333],[22.64566,39.95587],[22.645563333,39.95398],[22.646183333,39.952036667],[22.650138333,39.946696667],[22.650668333,39.944226667],[22.650238333,39.942191667],[22.649353333,39.940663333],[22.643211667,39.93275],[22.634668333,39.92193],[22.625893333,39.910486667],[22.618511667,39.903811667],[22.616076667,39.900841667],[22.6068,39.894046667],[22.606623333,39.890348333],[22.601985,39.886583333],[22.598783333,39.885643333],[22.596711667,39.883348333],[22.587735,39.880223333],[22.586553333,39.878593333],[22.583578333,39.876933333],[22.581733333,39.876415],[22.57415,39.875503333],[22.5702,39.875543333],[22.566906667,39.876145],[22.564235,39.876156667],[22.559171667,39.874755],[22.55699,39.87342],[22.55335,39.873041667],[22.549445,39.872048333],[22.547115,39.869326667],[22.5407,39.86375],[22.538008333,39.862361667],[22.534536667,39.86163],[22.53122,39.858528333],[22.528716667,39.857798333],[22.524265,39.85557],[22.521068333,39.853043333],[22.5175,39.848535],[22.516605,39.846723333],[22.515286667,39.841298333],[22.515251667,39.838583333],[22.513926667,39.836178333],[22.512178333,39.830008333],[22.508765,39.816948333],[22.507926667,39.814855],[22.501561667,39.80288],[22.477043333,39.757525],[22.475613333,39.754543333],[22.4749,39.75149],[22.474935,39.749503333],[22.47574,39.741766667],[22.476141667,39.739626667],[22.48478,39.707443333],[22.487356667,39.698875],[22.489801667,39.693066667],[22.496713333,39.678203333],[22.49897,39.673165],[22.505083333,39.660148333],[22.506953333,39.654743333],[22.508601667,39.647475],[22.509068333,39.641575],[22.508951667,39.636893333],[22.50798,39.629531667],[22.50619,39.623716667],[22.503783333,39.617733333],[22.500163333,39.60998],[22.494846667,39.600141667],[22.491636667,39.594851667],[22.488458333,39.590001667],[22.48377,39.583296667],[22.482448333,39.579696667],[22.482935,39.576353333],[22.49042,39.558328333],[22.492213333,39.554206667],[22.493451667,39.552131667],[22.495386667,39.550338333],[22.499268333,39.548398333],[22.543181667,39.531081667],[22.547388333,39.52921],[22.5495,39.527931667],[22.581015,39.506118333],[22.594251667,39.496913333],[22.598323333,39.495255],[22.600715,39.494986667],[22.625495,39.493565],[22.627721667,39.493365],[22.63081,39.492563333],[22.634341667,39.49052],[22.66305,39.469145],[22.666525,39.46604],[22.678858333,39.45189],[22.681356667,39.449128333],[22.692376667,39.436443333],[22.694995,39.433561667],[22.710516667,39.41591],[22.713423333,39.413501667],[22.715225,39.412651667],[22.73259,39.407096667],[22.740423333,39.404476667],[22.758463333,39.398848333],[22.761881667,39.396993333],[22.763568333,39.394881667],[22.76378,39.393698333],[22.762653333,39.391576667],[22.762825,39.390311667],[22.76477,39.389201667],[22.779801667,39.387066667],[22.783026667,39.386888333],[22.794565,39.385463333],[22.801233333,39.384808333],[22.81931,39.383826667],[22.821055,39.383358333],[22.827853333,39.380873333],[22.830306667,39.381106667],[22.83275,39.382725],[22.835826667,39.383645],[22.841061667,39.383853333],[22.845145,39.38456],[22.849055,39.384218333],[22.854246667,39.38173],[22.855953333,39.38132],[22.859456667,39.382276667],[22.861731667,39.382118333],[22.86504,39.380521667],[22.869296667,39.379708333],[22.873526667,39.379751667],[22.877911667,39.378411667],[22.882613333,39.377568333],[22.89749,39.375161667],[22.903803333,39.373851667],[22.908576667,39.378266667],[22.912078333,39.383253333],[22.915531667,39.386326667],[22.921865,39.389781667],[22.925473333,39.390345],[22.928585,39.389836667],[22.934031667,39.387965],[22.939428333,39.38664],[22.945605,39.384755],[22.947541667,39.383616667],[22.951273333,39.379518333],[22.955355,39.375595],[22.960096667,39.372973333],[22.961235,39.371671667],[22.967005,39.368986667],[22.965198333,39.367135],[22.964725,39.364078333],[22.96278,39.362481667],[22.962491667,39.360316667],[22.963163333,39.360045],[22.966393333,39.356643333],[22.966156667,39.35415],[22.965296667,39.353095],[22.965485,39.351241667],[22.967531667,39.349411667],[22.97032,39.348196667],[22.972576667,39.347895],[22.97634,39.348146667],[22.980308333,39.350401667],[22.987033333,39.351675],[22.992753333,39.351321667],[22.996903333,39.348586667],[22.998968333,39.346405],[22.999293333,39.34367],[23.000083333,39.342431667],[23.001576667,39.342126667],[23.003413333,39.34038],[23.004625,39.34006],[23.010815,39.339873333],[23.017333333,39.33672],[23.019278333,39.335135],[23.024168333,39.33283],[23.029151667,39.332031667],[23.030641667,39.332591667],[23.033046667,39.332725],[23.035391667,39.331266667],[23.039728333,39.330281667],[23.041868333,39.330445],[23.045031667,39.329001667],[23.048301667,39.328],[23.05148,39.327383333],[23.053823333,39.324451667],[23.05544,39.321875],[23.057116667,39.320613333],[23.063268333,39.318638333],[23.064718333,39.31655],[23.066013333,39.315658333],[23.068891667,39.315286667],[23.073188333,39.315461667],[23.080873333,39.314413333],[23.082375,39.312773333],[23.083976667,39.312041667],[23.085416667,39.3132],[23.090428333,39.31248],[23.09112,39.31128],[23.094326667,39.312366667],[23.097063333,39.310406667],[23.098556667,39.310443333],[23.103153333,39.31271],[23.10567,39.312573333],[23.107915,39.31097],[23.11053,39.310103333],[23.113975,39.310473333],[23.117758333,39.308366667],[23.123605,39.307628333],[23.131525,39.304358333],[23.135016667,39.303228333],[23.138321667,39.300636667],[23.138926667,39.299778333],[23.138776667,39.296918333],[23.139125,39.295938333],[23.141785,39.293758333],[23.14579,39.292781667],[23.149386667,39.291391667],[23.15412,39.288443333],[23.15455,39.287895],[23.153485,39.28574],[23.154001667,39.28339],[23.155001667,39.283056667],[23.156378333,39.281036667],[23.157838333,39.28165],[23.160633333,39.283611667],[23.162321667,39.283936667],[23.162838333,39.285431667],[23.165211667,39.285778333],[23.16693,39.283666667],[23.167576667,39.28212],[23.1697,39.282353333],[23.171543333,39.283611667],[23.172278333,39.285388333],[23.173171667,39.284753333],[23.175375,39.284765],[23.175131667,39.283913333],[23.177165,39.282946667],[23.17832,39.28183],[23.1794,39.28291],[23.179396667,39.284886667],[23.180706667,39.285331667],[23.18118,39.287456667],[23.181998333,39.288535],[23.184156667,39.289281667],[23.185385,39.290695],[23.186295,39.290033333],[23.18663,39.288421667],[23.185875,39.286105],[23.186878333,39.284368333],[23.189685,39.283938333],[23.194226667,39.28703],[23.196613333,39.286623333],[23.198773333,39.284351667],[23.201848333,39.283098333],[23.205608333,39.283201667],[23.204625,39.281276667],[23.207336667,39.280923333],[23.20808,39.27792],[23.207326667,39.276065],[23.204786667,39.274643333],[23.203148333,39.27318],[23.203236667,39.272158333],[23.202298333,39.26757],[23.204678333,39.26435],[23.20693,39.26428],[23.206056667,39.260591667],[23.207208333,39.260303333],[23.207748333,39.257386667],[23.208873333,39.257426667],[23.210048333,39.254605],[23.211875,39.254326667],[23.211896667,39.253326667],[23.21364,39.251908333],[23.214783333,39.250321667],[23.216255,39.249998333],[23.216283333,39.247753333],[23.218071667,39.247778333],[23.217981667,39.244255],[23.218916667,39.241081667],[23.221326667,39.24007],[23.222576667,39.240756667],[23.22464,39.23988],[23.22382,39.236735],[23.219758333,39.2287],[23.219753333,39.225791667],[23.21834,39.223791667],[23.217788333,39.22032],[23.218205,39.215065],[23.217001667,39.212288333],[23.215715,39.210836667],[23.215975,39.208575],[23.2169,39.207486667],[23.21385,39.205981667],[23.214438333,39.204398333],[23.213686667,39.202468333],[23.2156,39.202908333],[23.212661667,39.200186667],[23.210883333,39.202121667],[23.211115,39.200861667],[23.209765,39.198925],[23.21056,39.198138333],[23.212496667,39.197778333],[23.21309,39.196351667],[23.215161667,39.194981667],[23.212925,39.194486667],[23.211631667,39.195053333],[23.211663333,39.193706667],[23.212801667,39.193511667],[23.213356667,39.19173],[23.21437,39.191256667],[23.216238333,39.191583333],[23.219285,39.190151667],[23.218615,39.188925],[23.21947,39.18792],[23.21955,39.18532],[23.220636667,39.18303],[23.22231,39.182225],[23.223673333,39.180346667],[23.221105,39.179563333],[23.221041667,39.177611667],[23.222133333,39.177273333],[23.222145,39.175445],[23.219525,39.169458333],[23.218815,39.16632],[23.21611,39.164351667],[23.213523333,39.161408333],[23.21301,39.158926667],[23.211625,39.157798333],[23.21156,39.155555],[23.21617,39.152895],[23.216421667,39.150588333],[23.214475,39.148543333],[23.212925,39.146091667],[23.211383333,39.145598333],[23.207231667,39.14539],[23.206593333,39.14486],[23.207325,39.142411667],[23.204163333,39.141585],[23.20265,39.14395],[23.199986667,39.14241],[23.199503333,39.143675],[23.199895,39.145348333],[23.198671667,39.145771667],[23.196531667,39.145085],[23.195875,39.146331667],[23.197773333,39.14487],[23.199968333,39.145666667],[23.199938333,39.142648333],[23.201253333,39.142371667],[23.202283333,39.14397],[23.204048333,39.141583333],[23.207483333,39.142376667],[23.206968333,39.145],[23.208873333,39.145685],[23.211013333,39.14568],[23.213371667,39.14633],[23.215011667,39.149011667],[23.216401667,39.150393333],[23.21648,39.152795],[23.21148,39.155721667],[23.21156,39.158018333],[23.213046667,39.159448333],[23.213853333,39.161475],[23.216313333,39.164428333],[23.218696667,39.166033333],[23.21948,39.167143333],[23.219628333,39.169011667],[23.222708333,39.17633],[23.22103,39.177661667],[23.22076,39.179738333],[23.22363,39.180408333],[23.223795,39.181021667],[23.220835,39.182976667],[23.219528333,39.18496],[23.220066667,39.185978333],[23.219296667,39.188078333],[23.218555,39.188618333],[23.219646667,39.189983333],[23.216178333,39.191548333],[23.213276667,39.191668333],[23.21232,39.193936667],[23.211115,39.195228333],[23.212513333,39.194801667],[23.214776667,39.195055],[23.21301,39.19622],[23.212545,39.197741667],[23.210751667,39.19811],[23.209798333,39.199193333],[23.210945,39.200365],[23.210803333,39.202081667],[23.21263,39.200223333],[23.215318333,39.20281],[23.213385,39.202576667],[23.214371667,39.204486667],[23.213893333,39.20628],[23.216888333,39.207355],[23.215888333,39.208676667],[23.215758333,39.210998333],[23.217395,39.212888333],[23.218165,39.214791667],[23.217845,39.218701667],[23.21815,39.223278333],[23.21937,39.225305],[23.219473333,39.227878333],[23.220141667,39.229693333],[23.22276,39.234361667],[23.224351667,39.238045],[23.224785,39.239848333],[23.22332,39.240793333],[23.22133,39.240248333],[23.218696667,39.241005],[23.217978333,39.244908333],[23.218148333,39.248168333],[23.216528333,39.248981667],[23.216173333,39.250413333],[23.214436667,39.251018333],[23.211845,39.253275],[23.211628333,39.254763333],[23.210176667,39.255075],[23.20906,39.25739],[23.207381667,39.257761667],[23.207846667,39.259111667],[23.205883333,39.261146667],[23.206868333,39.26442],[23.204235,39.264681667],[23.202198333,39.268001667],[23.20307,39.270858333],[23.203321667,39.273426667],[23.207226667,39.27606],[23.208158333,39.277891667],[23.207436667,39.280923333],[23.20625,39.281751667],[23.204675,39.281125],[23.205105,39.28354],[23.201805,39.283138333],[23.198096667,39.284731667],[23.196426667,39.286635],[23.19445,39.287086667],[23.19152,39.285741667],[23.189338333,39.283956667],[23.186685,39.28442],[23.18589,39.2856],[23.186286667,39.290105],[23.185071667,39.290785],[23.184093333,39.289363333],[23.181473333,39.287548333],[23.1804,39.284986667],[23.17944,39.284986667],[23.178196667,39.282111667],[23.176798333,39.283205],[23.175071667,39.28372],[23.175516667,39.284718333],[23.172981667,39.284775],[23.172418333,39.28541],[23.171531667,39.283813333],[23.169843333,39.282445],[23.167585,39.282138333],[23.166441667,39.282938333],[23.166943333,39.283981667],[23.164601667,39.286006667],[23.162365,39.28529],[23.16194,39.283801667],[23.160001667,39.283465],[23.159406667,39.282775],[23.15623,39.281158333],[23.154753333,39.283095],[23.153338333,39.284043333],[23.153356667,39.28613],[23.154515,39.288123333],[23.148225,39.291995],[23.145868333,39.292851667],[23.142503333,39.293513333],[23.13882,39.296518333],[23.13892,39.299753333],[23.138505,39.30044],[23.135125,39.303228333],[23.131411667,39.304451667],[23.123931667,39.307501667],[23.117735,39.30843],[23.114638333,39.31043],[23.110548333,39.310221667],[23.108976667,39.311093333],[23.107535,39.311111667],[23.105961667,39.312518333],[23.103061667,39.312686667],[23.09772,39.310128333],[23.094888333,39.312125],[23.093601667,39.312361667],[23.091493333,39.311151667],[23.089948333,39.312463333],[23.085268333,39.313225],[23.083968333,39.312053333],[23.082196667,39.31287],[23.080353333,39.314626667],[23.07252,39.315483333],[23.069103333,39.315328333],[23.066336667,39.315736667],[23.064756667,39.316453333],[23.063521667,39.318421667],[23.057111667,39.320485],[23.05559,39.321633333],[23.052823333,39.325721667],[23.051461667,39.327316667],[23.04845,39.327935],[23.044873333,39.329063333],[23.041566667,39.330743333],[23.035435,39.331255],[23.032728333,39.332791667],[23.029246667,39.332098333],[23.025465,39.332595],[23.02355,39.333153333],[23.019175,39.335113333],[23.015535,39.337638333],[23.01258,39.341758333],[23.003546667,39.341838333],[23.00177,39.343055],[23.00169,39.344201667],[22.999446667,39.344028333],[22.998818333,39.346565],[22.996335,39.348966667],[22.992863333,39.3513],[22.99133,39.351618333],[22.987115,39.351688333],[22.984041667,39.351323333],[22.980081667,39.350386667],[22.976161667,39.348201667],[22.972221667,39.347863333],[22.97042,39.348151667],[22.967428333,39.349575],[22.966138333,39.350715],[22.964366667,39.351126667],[22.961213333,39.353968333],[22.951916667,39.358495],[22.95125,39.35818],[22.944928333,39.361511667],[22.942716667,39.36233],[22.93641,39.362568333],[22.933576667,39.361991667],[22.925153333,39.365761667],[22.918163333,39.369473333],[22.90946,39.37293],[22.90781,39.373416667],[22.896658333,39.375511667],[22.878735,39.378431667],[22.873248333,39.379998333],[22.87009,39.379826667],[22.864885,39.380733333],[22.860915,39.382578333],[22.859018333,39.38242],[22.85627,39.381471667],[22.854496667,39.381735],[22.849416667,39.384225],[22.847675,39.384705],[22.84384,39.384521667],[22.840378333,39.38392],[22.835716667,39.383841667],[22.833775,39.383471667],[22.830303333,39.381356667],[22.827288333,39.381231667],[22.820678333,39.38367],[22.818105,39.384153333],[22.803693333,39.384781667],[22.797778333,39.385318333],[22.785603333,39.386838333],[22.780018333,39.387235],[22.77315,39.388278333],[22.7655,39.389103333],[22.763526667,39.389726667],[22.762825,39.390785],[22.764355,39.391448333],[22.765018333,39.390838333],[22.766308333,39.387006667],[22.770031667,39.374395],[22.770308333,39.371973333],[22.769548333,39.367781667],[22.770196667,39.36526],[22.772675,39.362806667],[22.773683333,39.359856667],[22.772315,39.355551667],[22.772456667,39.35074],[22.77339,39.349225],[22.77506,39.348026667],[22.77894,39.346675],[22.781,39.345661667],[22.782111667,39.344473333],[22.783198333,39.34169],[22.783286667,39.337933333],[22.782028333,39.335475],[22.780583333,39.333991667],[22.766211667,39.321971667],[22.763553333,39.320458333],[22.756695,39.319085],[22.755,39.318316667],[22.752705,39.316325],[22.750755,39.313915],[22.749368333,39.31075],[22.749108333,39.305225],[22.748145,39.30282],[22.745288333,39.298353333],[22.744266667,39.29557],[22.74389,39.29093],[22.744045,39.28878],[22.745318333,39.283186667],[22.745356667,39.280641667],[22.743818333,39.277761667],[22.73892,39.2721],[22.737646667,39.268875],[22.736825,39.261086667],[22.735686667,39.255526667],[22.733693333,39.241131667],[22.733631667,39.238781667],[22.734565,39.236116667],[22.736805,39.231915],[22.738403333,39.229655],[22.742401667,39.226021667],[22.747121667,39.222031667],[22.74983,39.219113333],[22.756338333,39.207485],[22.758636667,39.204403333],[22.774296667,39.186986667],[22.781845,39.178701667],[22.783393333,39.177291667],[22.811855,39.155111667],[22.814781667,39.152745],[22.837458333,39.135065],[22.840166667,39.132631667],[22.868806667,39.09683],[22.870155,39.094858333],[22.88557,39.071023333],[22.886648333,39.068913333],[22.888023333,39.06322],[22.889786667,39.058006667],[22.893575,39.044848333],[22.895998333,39.04123],[22.909488333,39.029745],[22.911388333,39.027441667],[22.91528,39.019991667],[22.91574,39.017891667],[22.91516,39.015438333],[22.91373,39.012626667],[22.91293,39.008883333],[22.911773333,39.006723333],[22.911765,39.003105],[22.911296667,39.001313333],[22.909928333,38.999973333],[22.904448333,38.996896667],[22.901105,38.995665],[22.895661667,38.994663333],[22.894113333,38.993815],[22.89317,38.992465],[22.892808333,38.989653333],[22.892235,38.988503333],[22.89003,38.986738333],[22.889065,38.985003333],[22.889781667,38.981375],[22.889208333,38.97825],[22.890068333,38.975908333],[22.888871667,38.97316],[22.888488333,38.971118333],[22.889256667,38.968238333],[22.889198333,38.965845],[22.887533333,38.964055],[22.883681667,38.962331667],[22.882185,38.96111],[22.880875,38.959011667],[22.871415,38.940095],[22.87044,38.938581667],[22.86797,38.936325],[22.838543333,38.914651667],[22.83629,38.912118333],[22.834163333,38.908266667],[22.83374,38.906166667],[22.834176667,38.904911667],[22.835973333,38.90279],[22.836681667,38.901258333],[22.836405,38.895903333],[22.83511,38.893383333],[22.831803333,38.891405],[22.829885,38.891008333],[22.827306667,38.891383333],[22.825096667,38.892658333],[22.822465,38.893296667],[22.820813333,38.893076667],[22.809335,38.89082],[22.803791667,38.889253333],[22.801258333,38.888876667],[22.79499,38.889416667],[22.790658333,38.888628333],[22.787338333,38.887098333],[22.78366,38.886268333],[22.776408333,38.885083333],[22.773326667,38.88475],[22.768943333,38.884671667],[22.766611667,38.885256667],[22.758115,38.888998333],[22.75441,38.889906667],[22.717708333,38.888736667],[22.710801667,38.887805],[22.705905,38.887666667],[22.702183333,38.886526667],[22.688981667,38.883298333],[22.68447,38.882828333],[22.68194,38.882991667],[22.67663,38.88432],[22.664391667,38.889596667],[22.661458333,38.891413333],[22.65969,38.89301],[22.65261,38.901171667],[22.650193333,38.903415],[22.645928333,38.90599],[22.641396667,38.907643333],[22.626523333,38.911035],[22.619505,38.911956667],[22.6082,38.91137],[22.603758333,38.9106],[22.589373333,38.905725],[22.585826667,38.904865],[22.581436667,38.904233333],[22.575501667,38.903663333],[22.569631667,38.90342],[22.566566667,38.903085],[22.562041667,38.903083333],[22.54128,38.903781667],[22.523385,38.904313333],[22.519698333,38.904116667],[22.516091667,38.903421667],[22.498248333,38.898376667],[22.489171667,38.896043333],[22.483535,38.894118333],[22.478263333,38.891326667],[22.473205,38.887368333],[22.462126667,38.875966667],[22.460188333,38.873028333],[22.459225,38.869818333],[22.459775,38.866283333],[22.463035,38.85987],[22.467731667,38.852955],[22.469283333,38.850361667],[22.482443333,38.831046667],[22.499543333,38.806095],[22.502016667,38.80332],[22.506498333,38.800428333],[22.510241667,38.799158333],[22.521613333,38.797246667],[22.525838333,38.797073333],[22.528548333,38.797391667],[22.531695,38.798246667],[22.54005,38.801456667],[22.545318333,38.802715],[22.548023333,38.80291],[22.55708,38.802385],[22.561751667,38.802935],[22.567878333,38.804285],[22.571246667,38.804338333],[22.578446667,38.803653333],[22.583325,38.804055],[22.603585,38.808523333],[22.61605,38.81313],[22.619571667,38.814048333],[22.622246667,38.814295],[22.627116667,38.81381],[22.631435,38.812196667],[22.63346,38.810878333],[22.638948333,38.805051667],[22.643426667,38.802371667],[22.64798,38.80112],[22.651253333,38.800823333],[22.655556667,38.800861667],[22.65819,38.800615],[22.662401667,38.799671667],[22.665388333,38.798583333],[22.676878333,38.793568333],[22.685208333,38.790185],[22.687443333,38.789456667],[22.697331667,38.78677],[22.700421667,38.785701667],[22.708213333,38.781486667],[22.712036667,38.780228333],[22.719443333,38.779295],[22.724308333,38.779165],[22.756635,38.779585],[22.75966,38.77934],[22.761066667,38.778755],[22.762513333,38.779738333],[22.767685,38.779703333],[22.77085,38.777963333],[22.773005,38.777146667],[22.778343333,38.776635],[22.784525,38.778051667],[22.788985,38.780058333],[22.795395,38.78168],[22.798243333,38.782578333],[22.801008333,38.782778333],[22.80404,38.781123333],[22.806745,38.780145],[22.810013333,38.780933333],[22.815788333,38.783683333],[22.821195,38.78593],[22.825665,38.785543333],[22.827311667,38.78464],[22.829508333,38.781326667],[22.833618333,38.776795],[22.8391,38.771735],[22.842538333,38.769346667],[22.850141667,38.765966667],[22.854065,38.762965],[22.858076667,38.761268333],[22.859398333,38.75917],[22.859535,38.756983333],[22.861643333,38.755071667],[22.865445,38.753218333],[22.867725,38.753415],[22.875595,38.756205],[22.880085,38.75762],[22.8867,38.759031667],[22.889628333,38.75922],[22.892688333,38.758345],[22.896941667,38.755091667],[22.897525,38.753073333],[22.90045,38.75347],[22.907173333,38.751583333],[22.911753333,38.750643333],[22.923585,38.749696667],[22.927056667,38.749803333],[22.932808333,38.750805],[22.93983,38.751273333],[22.943268333,38.751098333],[22.947716667,38.749955],[22.95439,38.748533333],[22.96037,38.746155],[22.966216667,38.74478],[22.969865,38.744423333],[22.983878333,38.743745],[22.987841667,38.742795],[22.993506667,38.739566667],[22.996035,38.738831667],[23.007133333,38.737515],[23.010113333,38.737545],[23.023035,38.739113333],[23.03362,38.739118333],[23.036838333,38.738453333],[23.039891667,38.736528333],[23.047266667,38.729225],[23.050341667,38.72505],[23.055653333,38.714681667],[23.056113333,38.712088333],[23.055751667,38.707191667],[23.055956667,38.705043333],[23.058898333,38.694201667],[23.0651,38.672476667],[23.067746667,38.66713],[23.07192,38.659995],[23.07877,38.647698333],[23.085036667,38.636841667],[23.087546667,38.634483333],[23.10343,38.625755],[23.10702,38.624456667],[23.124158333,38.622078333],[23.139845,38.61845],[23.143075,38.61738],[23.147025,38.616741667],[23.164776667,38.612421667],[23.168306667,38.612386667],[23.171731667,38.613956667],[23.174893333,38.616536667],[23.177446667,38.617486667],[23.179203333,38.617598333],[23.181341667,38.61706],[23.183481667,38.615168333],[23.183726667,38.612118333],[23.178861667,38.60408],[23.17877,38.602606667],[23.179576667,38.600873333],[23.182483333,38.598515],[23.18497,38.597661667],[23.194936667,38.594835],[23.197525,38.593175],[23.1985,38.592063333],[23.204545,38.583153333],[23.205511667,38.580585],[23.204753333,38.577403333],[23.202045,38.57504],[23.195416667,38.571883333],[23.193843333,38.570923333],[23.192075,38.56899],[23.191316667,38.567446667],[23.189521667,38.561895],[23.18747,38.55935],[23.185153333,38.558053333],[23.174311667,38.554003333],[23.171406667,38.552603333],[23.168525,38.549896667],[23.167293333,38.547301667],[23.167425,38.543793333],[23.169926667,38.539406667],[23.170298333,38.537701667],[23.171006667,38.529828333],[23.170693333,38.527205],[23.16791,38.519041667],[23.1643,38.507983333],[23.163881667,38.505385],[23.163875,38.489433333],[23.163993333,38.476696667],[23.163806667,38.460775],[23.164718333,38.457891667],[23.166348333,38.456105],[23.168136667,38.45503],[23.171815,38.454013333],[23.18199,38.451908333],[23.203006667,38.450608333],[23.20715,38.44985],[23.210518333,38.448513333],[23.218061667,38.444746667],[23.22863,38.43918],[23.230041667,38.43784],[23.231148333,38.435461667],[23.230968333,38.433066667],[23.229108333,38.430258333],[23.225205,38.427476667],[23.223828333,38.426198333],[23.221261667,38.421938333],[23.21963,38.420726667],[23.215371667,38.418626667],[23.213775,38.416941667],[23.212926667,38.413823333],[23.213473333,38.411816667],[23.214821667,38.409946667],[23.217516667,38.407648333],[23.221023333,38.403225],[23.222768333,38.402091667],[23.226628333,38.400261667],[23.230798333,38.396736667],[23.23338,38.39508],[23.23725,38.393296667],[23.24499,38.387756667],[23.246585,38.385953333],[23.247201667,38.384268333],[23.247095,38.381235],[23.24745,38.379535],[23.249048333,38.377855],[23.2504,38.377265],[23.252928333,38.377021667],[23.258771667,38.377356667],[23.260913333,38.37694],[23.280145,38.372468333],[23.287158333,38.370633333],[23.293065,38.36937],[23.312828333,38.364691667],[23.317268333,38.364515],[23.32796,38.365508333],[23.408713333,38.372746667],[23.43178,38.374751667],[23.487818333,38.379763333],[23.493566667,38.380306667],[23.497208333,38.380393333],[23.500495,38.379511667],[23.505863333,38.376163333],[23.510293333,38.374495],[23.521605,38.37257],[23.523233333,38.372161667],[23.582811667,38.35067],[23.585815,38.349436667],[23.587806667,38.347841667],[23.597638333,38.33677],[23.60033,38.3345],[23.601636667,38.332326667],[23.604488333,38.329721667],[23.611775,38.32572],[23.649508333,38.305311667],[23.653631667,38.303008333],[23.671596667,38.293368333],[23.673916667,38.291486667],[23.694028333,38.272336667],[23.695546667,38.271131667],[23.698938333,38.269751667],[23.738566667,38.259161667],[23.759038333,38.253608333],[23.762453333,38.251691667],[23.77301,38.241151667],[23.774301667,38.240113333],[23.77698,38.238868333],[23.789161667,38.23483],[23.793861667,38.233075],[23.802428333,38.230195],[23.806001667,38.229186667],[23.808646667,38.229035],[23.81273,38.22961],[23.815741667,38.229351667],[23.820128333,38.228556667],[23.826108333,38.228881667],[23.831201667,38.230083333],[23.835436667,38.230263333],[23.844633333,38.228506667],[23.846866667,38.227755],[23.849248333,38.226163333],[23.851035,38.223366667],[23.854425,38.213011667],[23.855035,38.209975],[23.854955,38.205703333],[23.854408333,38.203233333],[23.851285,38.194486667],[23.850863333,38.191931667],[23.851085,38.189773333],[23.853205,38.179886667],[23.853873333,38.17577],[23.8557,38.169603333],[23.856175,38.165831667],[23.855478333,38.159753333],[23.855355,38.155341667],[23.85392,38.15187],[23.84595,38.143313333],[23.842835,38.138956667],[23.8364,38.125828333],[23.834103333,38.122515],[23.82507,38.113425],[23.816868333,38.105561667],[23.81403,38.103848333],[23.796716667,38.097118333],[23.793568333,38.094935],[23.781881667,38.079741667],[23.778083333,38.076355],[23.775368333,38.074976667],[23.760616667,38.069108333],[23.75335,38.066123333],[23.750553333,38.063825],[23.746198333,38.05681],[23.744796667,38.052821667],[23.743706667,38.05105],[23.734583333,38.042531667],[23.73323,38.037413333],[23.728378333,38.030315],[23.725771667,38.024778333],[23.724528333,38.02112],[23.722953333,38.019093333],[23.71971,38.016431667],[23.718655,38.0148],[23.717811667,38.010878333],[23.716871667,38.00967],[23.71444,38.008151667],[23.71155,38.005615],[23.7087,38.004355],[23.704298333,38.001308333],[23.696845,37.998153333],[23.6947,37.996008333],[23.701136667,37.991615],[23.711545,37.984891667],[23.715276667,37.984111667],[23.721863333,37.985265],[23.72326,37.982391667],[23.725973333,37.983023333],[23.727446667,37.983851667],[23.72969,37.982505],[23.73251,37.978403333],[23.733911667,37.977645],[23.736543333,37.978781667],[23.737566667,37.977188333],[23.737688333,37.975833333],[23.74311,37.975326667],[23.748103333,37.976525],[23.749953333,37.975223333],[23.75264,37.975831667],[23.758475,37.979365],[23.761105,37.978125],[23.76127,37.977101667],[23.759325,37.97793],[23.761531667,37.97902],[23.76398,37.979678333],[23.764898333,37.981325],[23.770951667,37.980668333],[23.769245,37.983228333],[23.766105,37.986448333],[23.767876667,37.988441667],[23.771671667,37.991175],[23.775685,37.99294],[23.782421667,37.997431667],[23.78495,37.999486667],[23.787691667,38.001106667],[23.792576667,38.00286],[23.794173333,38.001451667],[23.794888333,38.002215],[23.79331,38.00371],[23.795103333,38.00499],[23.796575,38.004251667],[23.795088333,38.002753333],[23.793438333,38.003745],[23.795778333,38.005028333],[23.797095,38.00435],[23.794866667,38.002693333],[23.793458333,38.00396],[23.795903333,38.005613333],[23.801476667,38.007298333],[23.804871667,38.008536667],[23.809036667,38.010551667],[23.82026,38.013451667],[23.827551667,38.013826667],[23.830651667,38.013816667],[23.836196667,38.012533333],[23.840066667,38.010835],[23.843783333,38.01073],[23.843428333,38.014063333],[23.837091667,38.020625],[23.836715,38.021618333],[23.83802,38.023336667],[23.83815,38.024711667],[23.835178333,38.024646667],[23.83126,38.026423333],[23.828605,38.027985],[23.818606667,38.036638333],[23.815358333,38.038575],[23.80623,38.04148],[23.796535,38.04433],[23.792461667,38.04537],[23.789623333,38.046478333],[23.786915,38.048116667],[23.77833,38.053756667],[23.773413333,38.056485],[23.769435,38.058203333],[23.765276667,38.059656667],[23.763141667,38.060005],[23.757958333,38.060211667],[23.7546,38.06059],[23.739036667,38.065573333],[23.727345,38.068273333],[23.718848333,38.069911667],[23.693088333,38.073313333],[23.689283333,38.07422],[23.684881667,38.075635],[23.677715,38.078835],[23.672698333,38.081541667],[23.659915,38.085831667],[23.65404,38.086601667],[23.642423333,38.086818333],[23.63526,38.087225],[23.628425,38.088376667],[23.610443333,38.092111667],[23.602473333,38.093478333],[23.594383333,38.09432],[23.589453333,38.094563333],[23.572856667,38.094788333],[23.565566667,38.094298333],[23.559073333,38.093011667],[23.55512,38.091855],[23.550501667,38.090051667],[23.545505,38.087426667],[23.541616667,38.084833333],[23.533441667,38.07879],[23.53085,38.076171667],[23.528445,38.072703333],[23.523356667,38.06677],[23.520716667,38.062698333],[23.519103333,38.061156667],[23.513071667,38.057788333],[23.508563333,38.053566667],[23.500033333,38.04706],[23.495758333,38.04312],[23.49474,38.041865],[23.48943,38.032438333],[23.487961667,38.030741667],[23.485961667,38.029526667],[23.484115,38.028983333],[23.480423333,38.028976667],[23.475211667,38.030575],[23.471875,38.030485],[23.458858333,38.028593333],[23.441861667,38.025515],[23.437775,38.02439],[23.434876667,38.023183333],[23.408321667,38.011135],[23.40536,38.009963333],[23.379205,38.002716667],[23.374233333,38.000635],[23.344648333,37.982733333],[23.341763333,37.981853333],[23.335826667,37.982041667],[23.329903333,37.983341667],[23.32474,37.983451667],[23.320401667,37.982208333],[23.317953333,37.980775],[23.310403333,37.97506],[23.306953333,37.973675],[23.30224,37.973088333],[23.2917,37.975216667],[23.284423333,37.977578333],[23.264035,37.978855],[23.260391667,37.978138333],[23.253965,37.977715],[23.248688333,37.978316667],[23.235723333,37.97696],[23.233466667,37.97649],[23.22928,37.974945],[23.226896667,37.974518333],[23.218445,37.974243333],[23.21612,37.97397],[23.213206667,37.972868333],[23.177893333,37.953695],[23.174176667,37.952303333],[23.16467,37.950075],[23.161738333,37.948765],[23.140753333,37.936073333],[23.132956667,37.931595],[23.119321667,37.922961667],[23.111836667,37.91854],[23.108046667,37.917348333],[23.10646,37.917341667],[23.101038333,37.918376667],[23.097516667,37.919831667],[23.090195,37.924668333],[23.085051667,37.926788333],[23.08063,37.927646667],[23.076376667,37.927715],[23.07033,37.926643333],[23.062851667,37.924106667],[23.058931667,37.92351],[23.053195,37.923598333],[23.047531667,37.924373333],[23.038168333,37.924988333],[23.03252,37.925665],[23.029296667,37.92557],[23.017896667,37.926073333],[23.015443333,37.925506667],[23.009826667,37.923158333],[23.006896667,37.92256],[23.003635,37.923216667],[22.999915,37.925196667],[22.996948333,37.927545],[22.995115,37.927626667],[22.992761667,37.926053333],[22.989165,37.925403333],[22.989048333,37.923875],[22.990391667,37.922223333],[22.987591667,37.920796667],[22.982665,37.919366667],[22.977711667,37.918968333],[22.972588333,37.919568333],[22.966115,37.921505],[22.961445,37.92249],[22.954066667,37.92307],[22.949831667,37.923038333],[22.943886667,37.922391667],[22.936746667,37.920756667],[22.931196667,37.919956667],[22.920198333,37.91963],[22.91217,37.91927],[22.903946667,37.918621667],[22.883755,37.91437],[22.875091667,37.911733333],[22.868156667,37.910195],[22.862665,37.909286667],[22.857728333,37.908973333],[22.846176667,37.909266667],[22.843246667,37.90961],[22.834526667,37.912156667],[22.831993333,37.913308333],[22.828875,37.915788333],[22.826566667,37.917156667],[22.819838333,37.9201],[22.817206667,37.920948333],[22.807651667,37.922881667],[22.796401667,37.926146667],[22.794335,37.926928333],[22.77716,37.934588333],[22.767271667,37.939905],[22.762853333,37.943016667],[22.757083333,37.948441667],[22.749943333,37.958136667],[22.748983333,37.959811667],[22.748405,37.962205],[22.748485,37.965146667],[22.748018333,37.966885],[22.744886667,37.969498333],[22.736025,37.981993333],[22.735188333,37.983606667],[22.735861667,37.989523333],[22.73551,37.997671667],[22.736145,38.005476667],[22.73406,38.009993333],[22.727943333,38.02166],[22.726503333,38.023661667],[22.72069,38.02998],[22.7186,38.031716667],[22.711676667,38.036428333],[22.7083,38.039663333],[22.705946667,38.041098333],[22.6991,38.044048333],[22.695091667,38.045058333],[22.683343333,38.050186667],[22.680293333,38.052021667],[22.670393333,38.056406667],[22.667455,38.057081667],[22.663318333,38.057246667],[22.660973333,38.05795],[22.657138333,38.060586667],[22.655121667,38.063891667],[22.65384,38.064611667],[22.649676667,38.064895],[22.647286667,38.06554],[22.637713333,38.070156667],[22.629651667,38.073181667],[22.628276667,38.07348],[22.62423,38.072745],[22.621671667,38.072595],[22.615403333,38.072938333],[22.612985,38.073545],[22.60567,38.077598333],[22.604356667,38.078101667],[22.59987,38.07883],[22.597696667,38.079566667],[22.587581667,38.08468],[22.585085,38.085353333],[22.581926667,38.085565],[22.580218333,38.086206667],[22.569586667,38.093685],[22.56833,38.094191667],[22.564331667,38.094818333],[22.559766667,38.097548333],[22.557723333,38.098438333],[22.55367,38.099176667],[22.535565,38.103816667],[22.534176667,38.104408333],[22.518543333,38.114635],[22.50169,38.127403333],[22.495721667,38.130203333],[22.493135,38.13057],[22.486638333,38.130191667],[22.48218,38.130566667],[22.476305,38.129701667],[22.468175,38.126923333],[22.460725,38.12536],[22.45886,38.125205],[22.452731667,38.126641667],[22.448891667,38.128378333],[22.444221667,38.131],[22.432801667,38.133881667],[22.431295,38.134125],[22.42663,38.133236667],[22.421355,38.130761667],[22.415838333,38.129466667],[22.41249,38.129411667],[22.403105,38.131381667],[22.4013,38.131975],[22.391326667,38.134263333],[22.390135,38.134805],[22.387341667,38.137175],[22.384705,38.13835],[22.380243333,38.14108],[22.378673333,38.14138],[22.375665,38.141073333],[22.373631667,38.141245],[22.369296667,38.142685],[22.364671667,38.144643333],[22.35512,38.147023333],[22.348595,38.150523333],[22.343713333,38.154388333],[22.340821667,38.157133333],[22.335571667,38.163031667],[22.333176667,38.164941667],[22.32542,38.169015],[22.321888333,38.170508333],[22.315296667,38.17022],[22.30799,38.170241667],[22.292048333,38.171638333],[22.289126667,38.171388333],[22.28419,38.169968333],[22.280505,38.16813],[22.277725,38.167616667],[22.266156667,38.16814],[22.263405,38.168921667],[22.2617,38.169915],[22.258065,38.173301667],[22.255511667,38.174328333],[22.250778333,38.174848333],[22.247281667,38.174291667],[22.245163333,38.174385],[22.237515,38.176596667],[22.22952,38.17751],[22.223556667,38.177453333],[22.21771,38.178528333],[22.212513333,38.18046],[22.203616667,38.182481667],[22.199005,38.182901667],[22.19451,38.184378333],[22.189621667,38.18471],[22.185056667,38.186073333],[22.179535,38.186163333],[22.17753,38.186588333],[22.174835,38.188406667],[22.170661667,38.189926667],[22.159408333,38.190735],[22.157065,38.191691667],[22.151558333,38.196845],[22.14922,38.199605],[22.147101667,38.201443333],[22.143871667,38.20363],[22.138285,38.20608],[22.136663333,38.207661667],[22.13441,38.20865],[22.129051667,38.209998333],[22.12257,38.213215],[22.117783333,38.21402],[22.109605,38.217335],[22.10289,38.221285],[22.097213333,38.224233333],[22.090378333,38.227381667],[22.085055,38.230426667],[22.081695,38.232945],[22.07701,38.237805],[22.075138333,38.240458333],[22.073626667,38.243275],[22.070343333,38.25085],[22.06806,38.25413],[22.065546667,38.25598],[22.062728333,38.257586667],[22.059211667,38.262556667],[22.058385,38.263333333],[22.050755,38.268391667],[22.044256667,38.270701667],[22.037406667,38.276468333],[22.035775,38.277456667],[22.027418333,38.279421667],[22.025126667,38.280481667],[22.024951667,38.282018333],[22.0235,38.28441],[22.023551667,38.285353333],[22.020933333,38.286378333],[22.018341667,38.287876667],[22.016478333,38.289515],[22.00709,38.294968333],[22.005033333,38.295403333],[22.002096667,38.297265],[22.002883333,38.297928333],[22.000345,38.299276667],[21.997526667,38.301551667],[21.995363333,38.305871667],[21.992595,38.309466667],[21.989428333,38.311338333],[21.986141667,38.31167],[21.983846667,38.312678333],[21.982593333,38.31459],[21.978475,38.317581667],[21.974628333,38.31905],[21.971718333,38.321038333],[21.969638333,38.321361667],[21.965103333,38.323551667],[21.96149,38.32503],[21.957485,38.325993333],[21.95392,38.326296667],[21.950405,38.327326667],[21.943765,38.32774],[21.940941667,38.327353333],[21.937608333,38.326371667],[21.933738333,38.32632],[21.92989,38.32685],[21.927865,38.326521667],[21.923218333,38.324123333],[21.919968333,38.32359],[21.915445,38.32394],[21.912393333,38.32462],[21.910885,38.324576667],[21.906313333,38.32337],[21.904371667,38.323331667],[21.898163333,38.324858333],[21.893501667,38.324946667],[21.887218333,38.32337],[21.877853333,38.323958333],[21.872908333,38.325156667],[21.866898333,38.325838333],[21.86417,38.324656667],[21.860945,38.323913333],[21.855913333,38.32501],[21.854071667,38.32477],[21.849155,38.325693333],[21.841271667,38.325185],[21.838213333,38.324043333],[21.833331667,38.321265],[21.83016,38.319968333],[21.827993333,38.317128333],[21.826983333,38.314213333],[21.821753333,38.312821667],[21.81717,38.312075],[21.812186667,38.309586667],[21.807775,38.307058333],[21.803151667,38.305403333],[21.800946667,38.304295],[21.799496667,38.302608333],[21.796716667,38.301296667],[21.797601667,38.29987],[21.796298333,38.298166667],[21.792993333,38.29633],[21.789536667,38.29483],[21.786933333,38.294543333],[21.779225,38.290361667],[21.776161667,38.288428333],[21.77413,38.286396667],[21.771518333,38.282878333],[21.769846667,38.283371667],[21.767096667,38.280553333],[21.758388333,38.272596667],[21.7541,38.267041667],[21.748501667,38.259503333],[21.747538333,38.256595],[21.74642,38.255991667],[21.744445,38.256268333],[21.739803333,38.257536667],[21.739311667,38.257223333],[21.738071667,38.253751667],[21.737061667,38.253533333],[21.735828333,38.250095],[21.731825,38.246941667],[21.727596667,38.244531667],[21.726781667,38.243696667],[21.725881667,38.238688333],[21.724216667,38.230798333],[21.722435,38.226093333],[21.721135,38.224198333],[21.719793333,38.219338333],[21.720688333,38.22417],[21.722366667,38.22683],[21.723346667,38.230473333],[21.7223,38.230828333],[21.720903333,38.228741667],[21.720008333,38.230305],[21.720545,38.231676667],[21.719945,38.2324],[21.720001,38.234894],[21.718889,38.236298],[21.716215,38.238003],[21.70698,38.239372],[21.705118,38.239334],[21.699396,38.240025],[21.69381,38.239895],[21.685932,38.240555],[21.682926,38.240517],[21.675381,38.240963],[21.669579,38.241138],[21.658915,38.24184],[21.65225,38.242031],[21.646576,38.242546],[21.640726,38.242599],[21.631926,38.243202],[21.627674,38.243313],[21.619116,38.243946],[21.61685,38.244278],[21.611557,38.244278],[21.606821,38.244553],[21.600431,38.244648],[21.581221,38.245964],[21.579863,38.245659],[21.574961,38.246258],[21.5644,38.246677],[21.561035,38.246937],[21.558144,38.247986],[21.556423,38.248089],[21.554384,38.247349],[21.552269,38.247746],[21.543316,38.247864],[21.542709,38.247631],[21.535112,38.248322],[21.532122,38.248058],[21.515099,38.248264],[21.506081,38.248638],[21.503878,38.248581],[21.490332,38.249008],[21.484419,38.249332],[21.480886,38.249298],[21.469694,38.249714],[21.459158,38.249813],[21.453327,38.250084],[21.44125,38.250408],[21.439865,38.25032],[21.43297,38.250713],[21.42856,38.250648],[21.417984,38.251122],[21.404184,38.251419],[21.397642,38.251709],[21.38451,38.251896],[21.379696,38.25219],[21.365009,38.25246],[21.348186,38.25317],[21.336588,38.253319],[21.319981,38.254543],[21.314753,38.254696],[21.305855,38.255444],[21.298786,38.255402],[21.28598,38.256302],[21.283007,38.256317],[21.276894,38.256893],[21.262667,38.257572],[21.260454,38.257584],[21.255224,38.258156],[21.248434,38.258476],[21.243908,38.259045],[21.219992,38.261559],[21.212555,38.262054],[21.201904,38.262199],[21.193552,38.262924],[21.182009,38.263371],[21.178679,38.263382],[21.167048,38.263992],[21.142416,38.264877],[21.136742,38.265175],[21.134171,38.265572],[21.124174,38.266651],[21.113989,38.267574],[21.109055,38.268341],[21.104193,38.269688],[21.100052,38.271744],[21.090673,38.277386],[21.08259,38.282509],[21.076727,38.28558],[21.069542,38.28986],[21.059626,38.295944],[21.052225,38.300274],[21.04504,38.304749],[21.034466,38.310799],[21.02433,38.317066],[21.022293,38.31802],[21.018713,38.320431],[21.010979,38.324814],[21.002989,38.329727],[20.991983,38.336315],[20.989725,38.337837],[20.985346,38.340019],[20.976812,38.345249],[20.975149,38.346474],[20.96792,38.350353],[20.964401,38.352695],[20.96254,38.353519],[20.957468,38.356899],[20.952438,38.359566],[20.93885,38.367878],[20.935246,38.369793],[20.920357,38.378506],[20.914896,38.381886],[20.907639,38.385933],[20.903624,38.388596],[20.893963,38.394371],[20.892275,38.395634],[20.886168,38.399529],[20.881708,38.401989],[20.879442,38.403572],[20.872765,38.407513],[20.864532,38.413078],[20.848345,38.423195],[20.845488,38.425251],[20.839327,38.429115],[20.831779,38.434364],[20.822542,38.440483],[20.819721,38.442039],[20.815758,38.444721],[20.80714,38.4501],[20.798635,38.455841],[20.797647,38.456299],[20.790266,38.461433],[20.784472,38.465649],[20.779976,38.46841],[20.771755,38.474075],[20.765261,38.478012],[20.760309,38.48156],[20.758629,38.482437],[20.751251,38.487419],[20.74136,38.493938],[20.73674,38.496769],[20.734768,38.498264],[20.728203,38.502312],[20.72596,38.503948],[20.72208,38.506123],[20.71574,38.510029],[20.705673,38.515755],[20.700069,38.518574],[20.690083,38.522732],[20.688572,38.523663],[20.680773,38.526882],[20.675966,38.529175],[20.656807,38.535889],[20.652006,38.536282],[20.618,38.539639],[20.616276,38.539463],[20.605646,38.539917],[20.604382,38.54063],[20.601339,38.540585],[20.594004,38.541306],[20.586843,38.542191],[20.578642,38.543781],[20.574129,38.544308],[20.565578,38.546402],[20.561239,38.546871],[20.553492,38.548405],[20.543566,38.549725],[20.540733,38.550587],[20.534758,38.552887],[20.533672,38.55368],[20.528412,38.556137],[20.526026,38.558056],[20.519775,38.569649],[20.519485,38.572899],[20.51803,38.574303],[20.510414,38.594719],[20.509972,38.596588],[20.507544,38.602711],[20.505095,38.610096],[20.504133,38.612179],[20.503639,38.614876],[20.501303,38.620289],[20.50075,38.623001],[20.498657,38.627762],[20.49766,38.631493],[20.496265,38.634281],[20.495567,38.6376],[20.492748,38.644661],[20.491838,38.648609],[20.489998,38.652447],[20.488047,38.658264],[20.485044,38.665531],[20.482271,38.671242],[20.481482,38.674618],[20.479475,38.679764],[20.478451,38.681477],[20.476681,38.686493],[20.473705,38.692917],[20.473032,38.695072],[20.469921,38.701538],[20.468729,38.705399],[20.46608,38.711258],[20.460571,38.724598],[20.456709,38.735058],[20.455275,38.737446],[20.453735,38.742252],[20.452929,38.743237],[20.4517,38.746895],[20.431763,38.796249],[20.431696,38.798058],[20.430485,38.800499],[20.429747,38.803181],[20.427208,38.809704],[20.425943,38.81234],[20.424917,38.815643],[20.423653,38.818066],[20.421986,38.823933],[20.419168,38.831142],[20.417379,38.836666],[20.417189,38.837902],[20.414455,38.845127],[20.411896,38.849998],[20.411093,38.853962],[20.408342,38.859295],[20.408508,38.860149],[20.40691,38.864006],[20.405539,38.869049],[20.404022,38.873474],[20.403471,38.873978],[20.3906,38.913757],[20.390251,38.914272],[20.388355,38.921669],[20.38619,38.928257],[20.3853,38.92955],[20.384552,38.932796],[20.382799,38.937664],[20.382227,38.940689],[20.380037,38.949287],[20.377506,38.957134],[20.372797,38.970604],[20.372957,38.972355],[20.372404,38.975849],[20.373438,38.975052],[20.361088,39.010864],[20.355457,39.031071],[20.353806,39.038799],[20.333792,39.103577],[20.333572,39.105843],[20.327957,39.121044],[20.32781,39.123047],[20.324015,39.131161],[20.316198,39.154251],[20.316648,39.15641],[20.312822,39.166618],[20.303371,39.194836],[20.298567,39.196083],[20.255234,39.489784],[20.253889,39.489418],[20.242964,39.494503],[20.239264,39.493305],[20.237671,39.491501],[20.180843,39.503902],[20.161062,39.503418],[20.157806,39.504993],[20.127466,39.508087],[20.124256,39.510384],[20.121881,39.509766],[20.060591,39.573475],[20.061113,39.575077],[20.018677,39.62051],[20.0172,39.623165],[20.00626,39.635662],[20.003916,39.635338],[19.957762,39.694477],[19.971012,39.767048],[19.962475,39.769077],[19.976969,39.783352],[19.975073,39.782864],[19.958775,39.799213],[19.954834,39.804001],[19.942127,39.816593],[19.94042,39.817165],[19.919931,39.829285],[19.916634,39.829262],[19.715414,39.941917],[19.714121,39.942341],[19.711775,39.941242],[19.694439,39.95385],[19.688744,39.95686],[19.684267,39.959705],[19.681105,39.960739],[19.673027,39.96463],[19.657505,39.973511],[19.652702,39.975651],[19.647461,39.977684],[19.615656,39.995155],[19.615644,39.995659],[19.542564,40.03318],[19.539932,40.034016],[19.538334,40.035587],[19.529936,40.039127],[19.524916,40.041916],[19.523626,40.042046],[19.451658,40.078323],[19.437111,40.076412],[18.646301,40.487419],[18.644476,40.487179],[18.642836,40.486328],[18.642933,40.488396],[18.641954,40.488655],[18.641697,40.492378],[18.640676,40.493343],[16.862166667,41.128053333],[16.862038333,41.12851],[16.865588333,41.129498333],[16.868386667,41.132918333],[16.867318333,41.132268333],[16.865361667,41.129618333],[16.861406667,41.12867],[16.85545,41.128471667],[16.852086667,41.12936],[16.851376667,41.130241667],[16.84595,41.133398333],[16.844395,41.134086667],[16.845413333,41.13281],[16.851908333,41.128998333],[16.853668333,41.128188333],[16.860113333,41.12802],[16.862838333,41.128565],[16.865178333,41.128438333],[16.867198333,41.125956667],[16.871578333,41.126256667],[16.880723333,41.121498333],[16.88715,41.120151667],[16.889525,41.11918],[16.88863,41.116828333],[16.887418333,41.115115],[16.892301667,41.113123333],[16.893578333,41.114488333],[16.89478,41.114363333],[16.901123333,41.112055],[16.910301667,41.108523333],[16.923251667,41.103338333],[16.92725,41.100515],[16.93142,41.099958333],[16.938963333,41.097291667],[16.947818333,41.093785],[16.951175,41.092945],[16.964678333,41.091868333],[16.987015,41.08725],[16.988956667,41.08662],[16.993801667,41.084276667],[16.996675,41.08367],[17.004583333,41.082468333],[17.009686667,41.082813333],[17.013688333,41.08273],[17.024801667,41.081121667],[17.04709,41.077716667],[17.049228333,41.077213333],[17.061725,41.072191667],[17.064065,41.070748333],[17.06613,41.068393333],[17.066813333,41.066818333],[17.069296667,41.055628333],[17.070736667,41.053076667],[17.074608333,41.050203333],[17.078576667,41.048421667],[17.081018333,41.048096667],[17.083396667,41.048285],[17.090811667,41.049863333],[17.093666667,41.049931667],[17.097536667,41.049288333],[17.100853333,41.047958333],[17.104003333,41.046328333],[17.111703333,41.042848333],[17.115448333,41.040998333],[17.121276667,41.038638333],[17.123751667,41.037358333],[17.127083333,41.036116667],[17.130836667,41.03434],[17.133486667,41.033478333],[17.136351667,41.033071667],[17.143598333,41.032511667],[17.151658333,41.030393333],[17.15612,41.029045],[17.165788333,41.026486667],[17.168023333,41.02557],[17.17748,41.020616667],[17.180561667,41.018293333],[17.190006667,41.008745],[17.191871667,41.00735],[17.195545,41.005543333],[17.197756667,41.003496667],[17.201198333,40.998778333],[17.207455,40.990986667],[17.209606667,40.988991667],[17.213183333,40.987565],[17.215543333,40.98728],[17.230746667,40.987925],[17.233736667,40.987286667],[17.240003333,40.984175],[17.252495,40.977208333],[17.25818,40.974275],[17.260895,40.971841667],[17.26175,40.970021667],[17.261963333,40.967536667],[17.259955,40.958191667],[17.260426667,40.954376667],[17.262,40.952106667],[17.263705,40.950693333],[17.2664,40.949185],[17.277515,40.943433333],[17.295846667,40.93373],[17.310243333,40.926231667],[17.312771667,40.924606667],[17.316395,40.921221667],[17.317916667,40.91899],[17.328748333,40.898538333],[17.329955,40.896088333],[17.329488333,40.89476],[17.330108333,40.89328],[17.329651667,40.892341667],[17.322946667,40.888571667],[17.319238333,40.88608],[17.316361667,40.885813333],[17.314583333,40.885036667],[17.310948333,40.882398333],[17.306701667,40.87977],[17.30167,40.877775],[17.300361667,40.877913333],[17.298191667,40.880241667],[17.29633,40.880826667],[17.292568333,40.881021667],[17.288246667,40.880076667],[17.283398333,40.880596667],[17.283208333,40.88011],[17.286191667,40.878703333],[17.28953,40.876358333],[17.291576667,40.875738333],[17.293108333,40.874671667],[17.292946667,40.873643333],[17.291098333,40.872288333],[17.292565,40.868083333],[17.291675,40.864355],[17.288105,40.86326],[17.286195,40.864701667],[17.282285,40.866326667],[17.280276667,40.867551667],[17.278583333,40.870338333],[17.278106667,40.872256667],[17.276771667,40.874006667],[17.274978333,40.875453333],[17.273178333,40.875798333],[17.271113333,40.876946667],[17.26678,40.873746667],[17.263816667,40.870691667],[17.261646667,40.86961],[17.260518333,40.868198333],[17.260543333,40.864686667],[17.258525,40.861508333],[17.257185,40.860103333],[17.257291667,40.85859],[17.255955,40.85729],[17.253453333,40.852341667],[17.25303,40.849198333],[17.253313333,40.847143333],[17.254618333,40.844883333],[17.254056667,40.842828333],[17.253015,40.842118333],[17.251573333,40.839876667],[17.249206667,40.837938333],[17.247765,40.833418333],[17.248006667,40.831528333],[17.249085,40.830115],[17.24954,40.82727],[17.248615,40.82306],[17.248368333,40.819745],[17.24773,40.817401667],[17.249676667,40.80861],[17.251066667,40.805731667],[17.2495,40.801441667],[17.248095,40.800208333],[17.245488333,40.795985],[17.24587,40.792876667],[17.2426,40.791333333],[17.24293,40.790975],[17.24588,40.792856667],[17.245538333,40.795878333],[17.248155,40.800338333],[17.24959,40.80153],[17.25111,40.806255],[17.24979,40.808488333],[17.247733333,40.817513333],[17.248411667,40.820088333],[17.248621667,40.823241667],[17.249491667,40.825083333],[17.252181667,40.824883333],[17.264876667,40.823326667],[17.268836667,40.823111667],[17.276465,40.82116],[17.274345,40.816285],[17.274093333,40.814005],[17.273386667,40.813218333],[17.267798333,40.810515],[17.270895,40.811741667],[17.273703333,40.81331],[17.274363333,40.814176667],[17.274516667,40.816373333],[17.276318333,40.820651667],[17.277391667,40.821371667],[17.284281667,40.821721667],[17.291561667,40.82177],[17.307468333,40.817448333],[17.31397,40.816893333],[17.319443333,40.815876667],[17.32237,40.814698333],[17.326715,40.813885],[17.333193333,40.813545],[17.336431667,40.81286],[17.340041667,40.811548333],[17.343141667,40.810768333],[17.34425,40.808438333],[17.346968333,40.806973333],[17.34524,40.808833333],[17.344903333,40.81052],[17.346538333,40.812813333],[17.346233333,40.814265],[17.344788333,40.816116667],[17.345571667,40.817765],[17.345291667,40.820448333],[17.347531667,40.821763333],[17.349595,40.825805],[17.350738333,40.827238333],[17.350071667,40.833941667],[17.350731667,40.837335],[17.356838333,40.849293333],[17.358788333,40.849518333],[17.365275,40.84349],[17.368868333,40.841495],[17.390405,40.834748333],[17.396348333,40.833973333],[17.423208333,40.833405],[17.450411667,40.832875],[17.455903333,40.832276667],[17.464133333,40.8302],[17.471283333,40.826691667],[17.479961667,40.824086667],[17.487908333,40.822385],[17.489825,40.821796667],[17.52097,40.809471667],[17.527745,40.80675],[17.538488333,40.800928333],[17.540568333,40.799568333],[17.539693333,40.799045],[17.541993333,40.797018333],[17.543393333,40.794168333],[17.545326667,40.792896667],[17.546406667,40.788775],[17.547968333,40.787178333],[17.5479,40.785595],[17.545976667,40.781695],[17.543953333,40.779105],[17.550288333,40.775315],[17.553085,40.771665],[17.55639,40.768686667],[17.557315,40.765511667],[17.558068333,40.76476],[17.562835,40.761925],[17.563891667,40.761025],[17.564808333,40.758223333],[17.563431667,40.753063333],[17.563555,40.751541667],[17.56526,40.748158333],[17.571246667,40.74337],[17.572286667,40.741475],[17.578848333,40.739038333],[17.577548333,40.739875],[17.579383333,40.743691667],[17.581428333,40.744965],[17.58216,40.746303333],[17.581805,40.74888],[17.5827,40.751973333],[17.583426667,40.75634],[17.584338333,40.757628333],[17.583878333,40.761256667],[17.584981667,40.764925],[17.583401667,40.769413333],[17.582301667,40.77411],[17.582513333,40.778448333],[17.58344,40.78168],[17.584938333,40.785131667],[17.585206667,40.78772],[17.58451,40.786503333],[17.58194,40.787058333],[17.580768333,40.788371667],[17.582531667,40.790373333],[17.578001667,40.79045],[17.577863333,40.79284],[17.578461667,40.792971667],[17.578318333,40.790491667],[17.582381667,40.79018],[17.580625,40.78818],[17.581835,40.787033333],[17.58417,40.78616],[17.585105,40.787058333],[17.584165,40.783598333],[17.583256667,40.783623333],[17.583903333,40.785583333],[17.583293333,40.786218333],[17.625735,40.768493333],[17.627943333,40.767761667],[17.67518,40.756261667],[17.69906,40.750938333],[17.70154,40.75012],[17.707585,40.746611667],[17.74423,40.724498333],[17.750565,40.720741667],[17.753075,40.719913333],[17.769045,40.716806667],[17.773988333,40.715766667],[17.782318333,40.714536667],[17.785728333,40.712843333],[17.791141667,40.708648333],[17.807353333,40.699306667],[17.827063333,40.687828333],[17.835431667,40.683085],[17.839358333,40.680693333],[17.855776667,40.671196667],[17.857615,40.670365],[17.863801667,40.668738333],[17.87125,40.66706],[17.882965,40.662435],[17.887675,40.661463333],[17.89139,40.660098333],[17.89628,40.656568333],[17.908085,40.651435],[17.911741667,40.648711667],[17.913656667,40.645391667],[17.914518333,40.641756667],[17.918731667,40.628131667],[17.920661667,40.625178333],[17.92258,40.623583333],[17.925798333,40.621691667],[17.928818333,40.620731667],[17.953831667,40.617328333],[17.956218333,40.616585],[17.957893333,40.615091667],[17.963165,40.607438333],[17.964371667,40.605146667],[17.965731667,40.601536667],[17.967406667,40.598515],[17.971193333,40.593486667],[17.972095,40.591986667],[17.974748333,40.585838333],[17.976171667,40.583163333],[17.979785,40.577673333],[17.990116667,40.559883333],[17.991568333,40.557601667],[17.997088333,40.550083333],[18.001125,40.542896667],[18.00266,40.540535],[18.008615,40.533558333],[18.009955,40.531625],[18.014171667,40.524448333],[18.022285,40.513888333],[18.023628333,40.511055],[18.024251667,40.506845],[18.025338333,40.504541667],[18.026348333,40.503573333],[18.030215,40.501275],[18.0328,40.499046667],[18.035786667,40.494945],[18.039121667,40.48891],[18.051423333,40.46982],[18.053523333,40.467161667],[18.058365,40.462125],[18.064173333,40.454468333],[18.065693333,40.452723333],[18.073663333,40.445196667],[18.080275,40.436906667],[18.090631667,40.425255],[18.092631667,40.423186667],[18.09937,40.416863333],[18.10651,40.40885],[18.112341667,40.40018],[18.113805,40.398388333],[18.118396667,40.393771667],[18.122118333,40.388348333],[18.124378333,40.386595],[18.129181667,40.384015],[18.13245,40.38184],[18.138003333,40.377326667],[18.142698333,40.374136667],[18.1448,40.373056667],[18.149335,40.371281667],[18.149055,40.370598333],[18.147401667,40.371085],[18.15103,40.375605],[18.152106667,40.37992],[18.153548333,40.38145],[18.158978333,40.385053333],[18.164076667,40.387248333],[18.16509,40.38684],[18.1658,40.38451],[18.168626667,40.384676667],[18.168676667,40.386845],[18.16997,40.389423333],[18.169763333,40.391361667],[18.167695,40.391548333],[18.165666667,40.38897],[18.164431667,40.389545],[18.163633333,40.391288333],[18.162583333,40.390973333],[18.163985,40.389678333],[18.164208333,40.387571667],[18.159825,40.385645],[18.153256667,40.38143],[18.151446667,40.37867],[18.151186667,40.376523333],[18.150386667,40.374823333],[18.145688333,40.369333333],[18.144665,40.36772],[18.141583333,40.361106667],[18.14015,40.359165],[18.13636,40.356918333],[18.134603333,40.356903333],[18.132458333,40.356235],[18.139331667,40.355116667],[18.14795,40.353883333],[18.150723333,40.35206],[18.150548333,40.353603333],[18.156206667,40.359406667],[18.159408333,40.364945],[18.160838333,40.365688333],[18.163725,40.364381667],[18.165036667,40.364478333],[18.169675,40.360985],[18.163325,40.350871667],[18.160148333,40.347786667],[18.16056,40.34694],[18.157896667,40.34398],[18.167685,40.338105],[18.167935,40.33764],[18.164956667,40.327355],[18.162553333,40.31653],[18.162803333,40.316593333],[18.165535,40.328808333],[18.168058333,40.337648333],[18.16789,40.338118333],[18.161876667,40.341531667],[18.158933333,40.34345],[18.159438333,40.343726667],[18.161303333,40.347065],[18.160773333,40.347901667],[18.162443333,40.349076667],[18.16424,40.351923333],[18.164533333,40.353516667],[18.167323333,40.353946667],[18.172525,40.355331667],[18.171268333,40.355263333],[18.164995,40.353148333],[18.166988333,40.352871667],[18.165036667,40.351895],[18.1642,40.349365],[18.172341667,40.369753333],[18.170371667,40.364601667],[18.165578333,40.3558],[18.164828333,40.351783333],[18.166943333,40.350731667],[18.171323333,40.347501667],[17.579861667,40.549493333],[17.578993333,40.549525],[17.57734,40.548011667],[17.571948333,40.546898333],[17.559691667,40.546875],[17.549636667,40.54704],[17.546588333,40.546658333],[17.51951,40.533495],[17.492395,40.534133333],[17.478295,40.53426],[17.453015,40.531573333],[17.439465,40.524796667],[17.429833333,40.522963333],[17.425025,40.5247],[17.40447,40.530625],[17.402185,40.530768333],[17.395626667,40.529281667],[17.378708333,40.526526667],[17.366696667,40.52429],[17.358893333,40.522136667],[17.352526667,40.520613333],[17.346696667,40.5197],[17.34328,40.519401667],[17.334043333,40.518198333],[17.328915,40.517336667],[17.323368333,40.516741667],[17.312386667,40.515046667],[17.30088,40.513645],[17.286856667,40.511226667],[17.24799,40.501128333],[17.243858333,40.500538333],[17.240556667,40.500418333],[17.232068333,40.499616667],[17.230371667,40.499311667],[17.22551,40.497465],[17.218273333,40.494085],[17.210241667,40.489533333],[17.208546667,40.48827],[17.206065,40.485483333],[17.205353333,40.4854],[17.201288333,40.486725],[17.188516667,40.4927],[17.172996667,40.500956667],[17.16763,40.50673],[17.165753333,40.508043333],[17.163125,40.50913],[17.159316667,40.510128333],[17.155801667,40.512423333],[17.15215,40.514158333],[17.142218333,40.518463333],[17.134836667,40.522621667],[17.132491667,40.52457],[17.121986667,40.528505],[17.117196667,40.529605],[17.112053333,40.531095],[17.10913,40.531278333],[17.08854,40.531048333],[17.080428333,40.530693333],[17.06059,40.529496667],[17.047135,40.527135],[17.043703333,40.526213333],[17.025476667,40.522076667],[17.006543333,40.516213333],[16.999591667,40.51465],[16.99325,40.511776667],[16.965943333,40.50309],[16.96388,40.50205],[16.941396667,40.497563333],[16.92051,40.487998333],[16.9076,40.480396667],[16.904245,40.478198333],[16.884866667,40.465118333],[16.785321667,40.371926667],[16.782353333,40.367763333],[16.780736667,40.36621],[16.778586667,40.361235],[16.767188333,40.347748333],[16.751006667,40.329903333],[16.71651,40.28126],[16.712313333,40.274005],[16.70734,40.265113333],[16.70055,40.253895],[16.693721667,40.239513333],[16.691106667,40.23525],[16.688998333,40.229485],[16.686423333,40.225523333],[16.683728333,40.2209],[16.681533333,40.213175],[16.680053333,40.208856667],[16.678923333,40.206543333],[16.665285,40.184623333],[16.664305,40.18334],[16.657663333,40.1763],[16.650896667,40.170413333],[16.649655,40.168711667],[16.648036667,40.169116667],[16.642101667,40.174551667],[16.639961667,40.175751667],[16.632355,40.179091667],[16.622773333,40.185666667],[16.613303333,40.190138333],[16.610983333,40.19174],[16.605053333,40.197623333],[16.602781667,40.199303333],[16.59469,40.203743333],[16.589333333,40.207483333],[16.582668333,40.21142],[16.577666667,40.215076667],[16.574833333,40.216786667],[16.566693333,40.220468333],[16.55905,40.22428],[16.556171667,40.225253333],[16.552045,40.226091667],[16.549545,40.226271667],[16.546225,40.225921667],[16.539388333,40.22391],[16.53125,40.222346667],[16.519325,40.218218333],[16.511465,40.216188333],[16.49732,40.210013333],[16.489536667,40.208405],[16.487331667,40.207571667],[16.471528333,40.198625],[16.468731667,40.19609],[16.464905,40.190355],[16.450365,40.183343333],[16.449753333,40.182935],[16.443403333,40.175008333],[16.437963333,40.17062],[16.437255,40.170303333],[16.430748333,40.169195],[16.427318333,40.166718333],[16.420845,40.162768333],[16.400678333,40.165881667],[16.390491667,40.171253333],[16.387465,40.173945],[16.379393333,40.17881],[16.37551,40.180601667],[16.34073,40.186198333],[16.337056667,40.183826667],[16.335243333,40.18143],[16.334565,40.178853333],[16.333486667,40.177026667],[16.331495,40.17513],[16.326206667,40.170898333],[16.322211667,40.166135],[16.321068333,40.164058333],[16.318626667,40.156975],[16.316891667,40.150331667],[16.315005,40.146985],[16.31147,40.141728333],[16.308225,40.135936667],[16.302461667,40.13069],[16.300428333,40.125848333],[16.300693333,40.12243],[16.299721667,40.12074],[16.297465,40.119123333],[16.293156667,40.116888333],[16.29065,40.11455],[16.288076667,40.113483333],[16.281073333,40.111226667],[16.263516667,40.10333],[16.256605,40.100938333],[16.245438333,40.097848333],[16.240496667,40.09603],[16.237348333,40.094605],[16.232843333,40.092935],[16.22695,40.091506667],[16.219365,40.090553333],[16.21074,40.090111667],[16.205985,40.089033333],[16.199386667,40.086233333],[16.188288333,40.081843333],[16.18467,40.080693333],[16.18299,40.080675],[16.17995,40.081695],[16.170405,40.08684],[16.167075,40.08774],[16.163101667,40.08671],[16.160635,40.085213333],[16.155841667,40.083908333],[16.152651667,40.084068333],[16.146091667,40.08554],[16.141781667,40.086306667],[16.139355,40.086253333],[16.133315,40.084996667],[16.13105,40.084323333],[16.129045,40.082711667],[16.127811667,40.080558333],[16.12259,40.075296667],[16.118483333,40.073498333],[16.114936667,40.073073333],[16.110763333,40.071638333],[16.106073333,40.06962],[16.101495,40.069445],[16.09696,40.06973],[16.092018333,40.072905],[16.088783333,40.073691667],[16.083238333,40.074498333],[16.076886667,40.073601667],[16.074825,40.072701667],[16.072448333,40.071061667],[16.069521667,40.069883333],[16.065741667,40.069438333],[16.062241667,40.069793333],[16.057365,40.071328333],[16.05357,40.071615],[16.05046,40.071061667],[16.043466667,40.069105],[16.039471667,40.068771667],[16.035673333,40.06935],[16.031286667,40.070913333],[16.024698333,40.0744],[16.020175,40.075605],[16.017946667,40.077713333],[16.01682,40.078231667],[16.008856667,40.07858],[16.005861667,40.07783],[16.002825,40.077968333],[15.998425,40.079568333],[15.995276667,40.082568333],[15.993156667,40.082598333],[15.984145,40.084003333],[15.979735,40.083461667],[15.973985,40.081065],[15.96882,40.081181667],[15.965771667,40.08088],[15.956586667,40.076786667],[15.95247,40.075473333],[15.947016667,40.07453],[15.941195,40.074316667],[15.93729,40.074585],[15.914961667,40.07809],[15.892515,40.074365],[15.886638333,40.070708333],[15.865561667,40.073746667],[15.863748333,40.073033333],[15.866421667,40.070615],[15.863515,40.070886667],[15.853581667,40.070505],[15.858228333,40.069338333],[15.857403333,40.067581667],[15.850416667,40.06013],[15.850545,40.058666667],[15.85216,40.05748],[15.85168,40.055913333],[15.850173333,40.054678333],[15.846228333,40.054198333],[15.842163333,40.051438333],[15.839661667,40.05547],[15.837336667,40.056858333],[15.834716667,40.053658333],[15.833345,40.04945],[15.832548333,40.048256667],[15.829665,40.047791667],[15.826521667,40.044815],[15.82225,40.044861667],[15.82143,40.043413333],[15.818995,40.041608333],[15.819976667,40.039628333],[15.81762,40.036568333],[15.816175,40.035605],[15.8148,40.037476667],[15.811301667,40.03902],[15.810305,40.03853],[15.811946667,40.036933333],[15.812256667,40.035301667],[15.811075,40.033478333],[15.81193,40.030843333],[15.808795,40.031555],[15.806896667,40.032895],[15.805921667,40.032503333],[15.805616667,40.030025],[15.806585,40.028588333],[15.809061667,40.027568333],[15.807963333,40.024493333],[15.806651667,40.022601667],[15.801148333,40.021331667],[15.799508333,40.020308333],[15.796423333,40.016456667],[15.796396667,40.014746667],[15.798108333,40.01196],[15.798625,40.008493333],[15.798188333,40.00422],[15.797098333,40.002406667],[15.797468333,40.000478333],[15.80016,39.997613333],[15.799296667,39.993173333],[15.800471667,39.99117],[15.804468333,39.988796667],[15.804875,39.985751667],[15.804386667,39.984858333],[15.80181,39.984293333],[15.799111667,39.981865],[15.796706667,39.978026667],[15.796548333,39.975593333],[15.795598333,39.973505],[15.793568333,39.971236667],[15.790746667,39.970548333],[15.787381667,39.969261667],[15.785063333,39.969251667],[15.782858333,39.967858333],[15.778683333,39.966703333],[15.776386667,39.964463333],[15.772266667,39.96115],[15.76945,39.9574],[15.769511667,39.95571],[15.770543333,39.954021667],[15.771021667,39.951853333],[15.769803333,39.947851667],[15.769991667,39.945705],[15.768451667,39.943481667],[15.76612,39.939185],[15.766466667,39.937681667],[15.765578333,39.936383333],[15.764291667,39.936463333],[15.763341667,39.938171667],[15.761215,39.939225],[15.756563333,39.938926667],[15.753895,39.936661667],[15.749781667,39.93514],[15.747125,39.935905],[15.747398333,39.937445],[15.746565,39.93886],[15.743653333,39.940151667],[15.742441667,39.941298333],[15.739836667,39.947428333],[15.738093333,39.94993],[15.73945,39.951761667],[15.739576667,39.95415],[15.739005,39.957696667],[15.737556667,39.961388333],[15.737753333,39.959371667],[15.736785,39.958888333],[15.736066667,39.959941667],[15.739428333,39.957201667],[15.736266667,39.960145],[15.734175,39.959225],[15.736246667,39.959323333],[15.737106667,39.96345],[15.72425,39.987903333],[15.724116667,39.987243333],[15.726113333,39.986333333],[15.728433333,39.986923333],[15.730991667,39.986928333],[15.729948333,39.985676667],[15.72462,39.984535],[15.723613333,39.98513],[15.71918,39.986125],[15.718078333,39.987283333],[15.717288333,39.991061667],[15.716748333,39.992],[15.719493333,39.993445],[15.71813,39.993386667],[15.720135,39.99524],[15.71948,39.996593333],[15.719671667,39.998528333],[15.71833,39.998693333],[15.716983333,39.99983],[15.716466667,39.998868333],[15.716726667,39.995375],[15.715988333,39.994023333],[15.714088333,39.994038333],[15.71326,39.997263333],[15.712296667,39.997951667],[15.709968333,39.997125],[15.708008333,39.99451],[15.706363333,39.993231667],[15.706083333,39.996296667],[15.705596667,39.993358333],[15.703826667,39.9938],[15.702106667,39.995821667],[15.701145,39.998221667],[15.699935,39.996018333],[15.741108333,40.125815],[15.700166667,39.99702],[15.701541667,39.99777],[15.706015,39.99663],[15.706596667,39.995793333],[15.706568333,39.993176667],[15.707871667,39.994306667],[15.710086667,39.997271667],[15.711711667,39.998051667],[15.712838333,39.99731],[15.714181667,39.994296667],[15.714828333,39.994211667],[15.713598333,39.989206667],[15.714068333,39.988778333],[15.71367,39.985918333],[15.714905,39.983051667],[15.72107,39.978665],[15.723753333,39.975656667],[15.723931667,39.973511667],[15.725665,39.971203333],[15.727591667,39.970646667],[15.72988,39.968983333],[15.731075,39.968663333],[15.734405,39.966675],[15.736233333,39.964528333],[15.736475,39.962828333],[15.738538333,39.959801667],[15.738986667,39.95614],[15.739745,39.954418333],[15.738555,39.951041667],[15.74032,39.9464],[15.741098333,39.942916667],[15.743535,39.940006667],[15.744801667,39.939618333],[15.747008333,39.937893333],[15.747401667,39.93554],[15.750013333,39.935351667],[15.7544,39.937148333],[15.756155,39.938838333],[15.75973,39.938873333],[15.762726667,39.939345],[15.76606,39.93874],[15.767055,39.940015],[15.767478333,39.942483333],[15.770205,39.946006667],[15.770091667,39.948098333],[15.770653333,39.949803333],[15.772318333,39.951823333],[15.770418333,39.958636667],[15.772485,39.961353333],[15.77901,39.966751667],[15.782625,39.967656667],[15.785305,39.969243333],[15.787876667,39.969348333],[15.789633333,39.970248333],[15.793338333,39.971355],[15.798133333,39.980565],[15.804363333,39.988876667],[15.802058333,39.990345],[15.799286667,39.993026667],[15.79985,39.99861],[15.797765,40.003891667],[15.799378333,40.006986667],[15.796496667,40.016008333],[15.798241667,40.01871],[15.803075,40.02202],[15.808531667,40.026313333],[15.805496667,40.029466667],[15.804535,40.031856667],[15.805088333,40.034075],[15.80414,40.035415],[15.802156667,40.035988333],[15.799251667,40.03861],[15.795796667,40.038691667],[15.79275,40.03945],[15.789881667,40.03949],[15.784798333,40.042488333],[15.782046667,40.0453],[15.776423333,40.04885],[15.77335,40.051628333],[15.770985,40.05492],[15.770758333,40.056726667],[15.768061667,40.058468333],[15.766253333,40.060828333],[15.762573333,40.062335],[15.759341667,40.06274],[15.756123333,40.065206667],[15.752635,40.066806667],[15.751993333,40.068083333],[15.751795,40.070683333],[15.750021667,40.073311667],[15.74681,40.075961667],[15.740103333,40.081105],[15.739055,40.08231],[15.737735,40.08604],[15.736675,40.086943333],[15.732281667,40.088448333],[15.7306,40.089976667],[15.731756667,40.0923],[15.734755,40.093891667],[15.739611667,40.095275],[15.74043,40.09672],[15.740045,40.099196667],[15.740731667,40.099985],[15.74353,40.101525],[15.744705,40.103371667],[15.745681667,40.107031667],[15.74657,40.1085],[15.749756667,40.111131667],[15.751756667,40.11359],[15.751046667,40.117678333],[15.751083333,40.120481667],[15.742821667,40.127215],[15.737863333,40.132176667],[15.736195,40.145291667],[15.738103333,40.147583333],[15.739898333,40.15095],[15.740928333,40.155453333],[15.743825,40.154733333],[15.752228333,40.150633333],[15.749386667,40.151631667],[15.749836667,40.15298],[15.74073,40.156973333],[15.722366667,40.171826667],[15.715973333,40.177491667],[15.708221667,40.18675],[15.703973333,40.191308333],[15.702975,40.193106667],[15.685666667,40.201666667],[15.67196,40.216806667],[15.671438333,40.220116667],[15.671996667,40.221783333],[15.66948,40.228421667],[15.66413,40.233993333],[15.659188333,40.26222],[15.657971667,40.267001667],[15.64686,40.300428333],[15.64128,40.314348333],[15.639008333,40.319603333],[15.637661667,40.323273333],[15.581235,40.398558333],[15.560706667,40.416601667],[15.55836,40.43068],[15.555796667,40.436],[15.55094,40.441886667],[15.549625,40.444278333],[15.515446667,40.51139],[15.510531667,40.515813333],[15.475266667,40.532611667],[15.471498333,40.533255],[15.465275,40.533553333],[15.459348333,40.533396667],[15.452756667,40.531401667],[15.449496667,40.53123],[15.443161667,40.53154],[15.43928,40.531166667],[15.434095,40.530076667],[15.431975,40.530046667],[15.42873,40.530706667],[15.424286667,40.533261667],[15.419545,40.538246667],[15.41386,40.546258333],[15.408735,40.549813333],[15.40539,40.551346667],[15.399021667,40.553643333],[15.396371667,40.554886667],[15.392186667,40.558131667],[15.383646667,40.561291667],[15.380545,40.564065],[15.377973333,40.565385],[15.374836667,40.56596],[15.351023333,40.570788333],[15.347935,40.573401667],[15.34636,40.575166667],[15.3453,40.5774],[15.341516667,40.583728333],[15.339886667,40.585098333],[15.33201,40.590098333],[15.325825,40.592466667],[15.320555,40.596296667],[15.31714,40.597955],[15.30983,40.600578333],[15.298681667,40.607123333],[15.296438333,40.608846667],[15.292738333,40.610091667],[15.289213333,40.610253333],[15.28514,40.611056667],[15.279063333,40.613683333],[15.275028333,40.614538333],[15.271825,40.61469],[15.268173333,40.614358333],[15.258048333,40.612873333],[15.253368333,40.612856667],[15.250358333,40.613578333],[15.244781667,40.618321667],[15.24361,40.619848333],[15.236571667,40.627233333],[15.232286667,40.62858],[15.228325,40.628835],[15.22153,40.628943333],[15.192471667,40.627061667],[15.187878333,40.627238333],[15.185776667,40.627003333],[15.180803333,40.625265],[15.169788333,40.619263333],[15.166235,40.617858333],[15.15131,40.61389],[15.149738333,40.613616667],[15.143943333,40.613618333],[15.139293333,40.612705],[15.1299,40.608713333],[15.124638333,40.607563333],[15.116888333,40.606863333],[15.104716667,40.606161667],[15.099091667,40.60663],[15.094613333,40.607796667],[15.091538333,40.608968333],[15.088071667,40.609598333],[15.083898333,40.609845],[15.079008333,40.609576667],[15.072256667,40.608415],[15.067171667,40.607903333],[15.051351667,40.60805],[15.047343333,40.607786667],[15.042088333,40.606983333],[15.039921667,40.606395],[15.034081667,40.604205],[15.031036667,40.603463333],[15.02624,40.603175],[15.015263333,40.601338333],[15.009001667,40.600898333],[15.005868333,40.601445],[15.00385,40.60245],[14.998403333,40.607271667],[14.995726667,40.610971667],[14.993211667,40.613346667],[14.99085,40.615086667],[14.988173333,40.616473333],[14.985206667,40.617401667],[14.98217,40.617778333],[14.977295,40.619638333],[14.974296667,40.620481667],[14.967873333,40.620731667],[14.964653333,40.62112],[14.957723333,40.622926667],[14.952468333,40.624728333],[14.945965,40.627283333],[14.942085,40.628265],[14.934948333,40.628721667],[14.932655,40.629155],[14.92821,40.63052],[14.920743333,40.633086667],[14.909581667,40.636703333],[14.906681667,40.637828333],[14.892798333,40.6442],[14.872986667,40.652976667],[14.866021667,40.655878333],[14.862478333,40.658196667],[14.860386667,40.660591667],[14.859108333,40.662935],[14.840235,40.689238333],[14.836918333,40.691075],[14.831045,40.69538],[14.82763,40.697295],[14.822288333,40.698543333],[14.819068333,40.698875],[14.809705,40.6994],[14.806535,40.699063333],[14.797961667,40.697128333],[14.788758333,40.69746],[14.783081667,40.69647],[14.77938,40.694431667],[14.775675,40.693155],[14.77347,40.69149],[14.773035,40.689565],[14.771968333,40.687591667],[14.770055,40.68665],[14.763153333,40.686366667],[14.760803333,40.685023333],[14.750513333,40.68253],[14.74653,40.680596667],[14.740736667,40.678718333],[14.738463333,40.67732],[14.735393333,40.675946667],[14.734566667,40.673901667],[14.732991667,40.672808333],[14.730886667,40.672916667],[14.729005,40.674725],[14.725638333,40.676418333],[14.724093333,40.678313333],[14.723545,40.679735],[14.725131667,40.683348333],[14.725111667,40.684651667],[14.72358,40.68631],[14.722873333,40.689238333],[14.721751667,40.690803333],[14.71557,40.69356],[14.714691667,40.694373333],[14.714568333,40.696568333],[14.712683333,40.69998],[14.710888333,40.702283333],[14.70906,40.705421667],[14.70736,40.709725],[14.70551,40.713048333],[14.703396667,40.714726667],[14.698876667,40.716843333],[14.692583333,40.722645],[14.691005,40.726336667],[14.686746667,40.729751667],[14.683588333,40.731696667],[14.67822,40.733548333],[14.669581667,40.735991667],[14.667156667,40.736345],[14.659758333,40.736305],[14.646375,40.735733333],[14.642973333,40.736151667],[14.633725,40.740285],[14.629,40.740648333],[14.622533333,40.73961],[14.61709,40.737808333],[14.611163333,40.737555],[14.604581667,40.737525],[14.586046667,40.737036667],[14.583861667,40.73638],[14.577228333,40.732943333],[14.575003333,40.732158333],[14.571713333,40.731715],[14.569291667,40.731823333],[14.566211667,40.732553333],[14.56187,40.734091667],[14.554738333,40.735016667],[14.54919,40.736226667],[14.5448,40.737518333],[14.526746667,40.741696667],[14.525363333,40.742146667],[14.518275,40.74532],[14.516208333,40.745855],[14.512418333,40.745233333],[14.50941,40.744113333],[14.505568333,40.743231667],[14.503101667,40.743053333],[14.486628333,40.742643333],[14.483541667,40.743073333],[14.481803333,40.74429],[14.479461667,40.748406667],[14.478446667,40.749116667],[14.46377,40.755935],[14.460536667,40.75769],[14.452043333,40.761543333],[14.450151667,40.761908333],[14.444401667,40.762105],[14.441318333,40.762796667],[14.420728333,40.76969],[14.408693333,40.774166667],[14.397331667,40.778078333],[14.391643333,40.780586667],[14.388378333,40.784151667],[14.386071667,40.785945],[14.379505,40.789805],[14.377795,40.791158333],[14.365698333,40.80618],[14.361911667,40.81025],[14.358133333,40.81347],[14.354433333,40.817448333],[14.348443333,40.825595],[14.344508333,40.83122],[14.34182,40.834001667],[14.337991667,40.83674],[14.31681,40.847916667],[14.316315,40.850046667],[14.31858,40.854501667],[14.318511667,40.857285],[14.321355,40.868],[14.321441667,40.870296667],[14.319318333,40.879596667],[14.318491667,40.883768333],[14.31855,40.8869],[14.316283333,40.888178333],[14.31186,40.886478333],[14.308501667,40.88591],[14.305058333,40.8862],[14.302621667,40.886946667],[14.300345,40.885575],[14.297516667,40.884391667],[14.296145,40.882675],[14.293271667,40.88081],[14.291395,40.879058333],[14.287765,40.874323333],[14.284386667,40.872245],[14.28296,40.871843333],[14.277988333,40.872171667],[14.27412,40.87032],[14.270956667,40.869398333],[14.264346667,40.868855],[14.259836667,40.869546667],[14.256158333,40.869228333],[14.243783333,40.866533333],[14.241326667,40.86503],[14.23439,40.862413333],[14.233681667,40.8594],[14.232491667,40.857558333],[14.233648333,40.855931667],[14.235678333,40.854523333],[14.236245,40.852705],[14.242343333,40.851536667],[14.245126667,40.85266],[14.245901667,40.8517],[14.250083333,40.850593333],[14.251575,40.851581667],[14.251766667,40.853031667],[14.24995,40.852995],[14.247188333,40.854111667],[14.245236667,40.85308],[14.243716667,40.853911667],[14.240828333,40.854721667],[14.237106667,40.855123333],[14.235685,40.853633333],[14.236246667,40.852656667],[14.238241667,40.852485],[14.238766667,40.851775],[14.242641667,40.851626667],[14.245421667,40.852855],[14.244685,40.853688333],[14.241913333,40.854138333],[14.241518333,40.854835],[14.237406667,40.855236667],[14.091588333,41.280623333],[14.091246667,41.295756667],[14.091003333,41.301341667],[14.090635,41.303321667],[14.087673333,41.311656667],[14.084915,41.318611667],[14.083901667,41.320385],[14.08181,41.322736667],[14.074588333,41.328291667],[14.064535,41.335855],[14.036326667,41.356821667],[14.021528333,41.367898333],[14.009425,41.376828333],[13.986573333,41.393928333],[13.976426667,41.401453333],[13.973248333,41.403345],[13.960736667,41.408388333],[13.935113333,41.418253333],[13.91844,41.424968333],[13.909161667,41.428471667],[13.906726667,41.429565],[13.897888333,41.433051667],[13.889198333,41.436145],[13.882078333,41.439213333],[13.873448333,41.441906667],[13.851515,41.446683333],[13.82806,41.45194],[13.818818333,41.45392],[13.793241667,41.459596667],[13.776951667,41.463293333],[13.760766667,41.466733333],[13.748571667,41.469511667],[13.744816667,41.470878333],[13.738986667,41.473471667],[13.725378333,41.479251667],[13.717573333,41.482681667],[13.6972,41.491403333],[13.688041667,41.49505],[13.675038333,41.500836667],[13.6675,41.504006667],[13.659583333,41.507546667],[13.649531667,41.511695],[13.64076,41.515446667],[13.624548333,41.52262],[13.622481667,41.52333],[13.586378333,41.538676667],[13.583311667,41.539873333],[13.576983333,41.541805],[13.567418333,41.543675],[13.561075,41.544215],[13.55814,41.544266667],[13.545121667,41.543953333],[13.529311667,41.543405],[13.52344,41.543321667],[13.504828333,41.542668333],[13.501398333,41.542753333],[13.496356667,41.543283333],[13.483955,41.545601667],[13.467713333,41.548491667],[13.443705,41.552645],[13.441421667,41.552945],[13.427765,41.555323333],[13.414238333,41.557873333],[13.41041,41.559068333],[13.394571667,41.565563333],[13.373481667,41.574546667],[13.363306667,41.578623333],[13.356855,41.581851667],[13.345516667,41.5888],[13.339503333,41.59263],[13.337168333,41.594918333],[13.335956667,41.597],[13.330481667,41.61007],[13.328846667,41.61263],[13.327468333,41.61384],[13.323861667,41.61566],[13.304453333,41.622515],[13.300415,41.624001667],[13.275563333,41.632673333],[13.270755,41.635248333],[13.263703333,41.640825],[13.259465,41.643096667],[13.243813333,41.649518333],[13.23873,41.652521667],[13.225528333,41.661351667],[13.223813333,41.662353333],[13.213838333,41.669116667],[13.211576667,41.670865],[13.198613333,41.679578333],[13.196036667,41.680996667],[13.186745,41.687403333],[13.18367,41.689053333],[13.15709,41.701926667],[13.143546667,41.708621667],[13.126103333,41.717115],[13.111346667,41.724233333],[13.099046667,41.730275],[13.075346667,41.741796667],[13.069601667,41.744483333],[13.063436667,41.747566667],[13.058541667,41.748666667],[13.031101667,41.748823333],[12.99506,41.749203333],[12.989891667,41.750061667],[12.965738333,41.75703],[12.960698333,41.758336667],[12.937465,41.763433333],[12.930073333,41.765133333],[12.88582,41.774843333],[12.866848333,41.77895],[12.860803333,41.780996667],[12.858468333,41.782161667],[12.839038333,41.793221667],[12.833371667,41.7963],[12.820943333,41.802756667],[12.811373333,41.808378333],[12.805418333,41.810816667],[12.793663333,41.816738333],[12.790303333,41.817806667],[12.786125,41.818126667],[12.773375,41.818333333],[12.769363333,41.818896667],[12.74897,41.823966667],[12.737771667,41.82683],[12.733925,41.827025],[12.726131667,41.826161667],[12.719216667,41.826243333],[12.69768,41.829085],[12.69211,41.829081667],[12.688745,41.828523333],[12.676138333,41.825971667],[12.671605,41.826376667],[12.661778333,41.830008333],[12.635411667,41.839513333],[12.610961667,41.84848],[12.59981,41.852411667],[12.596343333,41.853863333],[12.597343333,41.854093333],[12.595141667,41.846828333],[12.59085,41.83881],[12.58862,41.835418333],[12.58381,41.831505],[12.581603333,41.827836667],[12.580195,41.82258],[12.57537,41.81524],[12.572728333,41.812755],[12.552545,41.801928333],[12.548836667,41.800575],[12.538091667,41.798076667],[12.526375,41.795591667],[12.523106667,41.795171667],[12.51349,41.794361667],[12.509178333,41.794318333],[12.479918333,41.797698333],[12.466116667,41.799453333],[12.458816667,41.800268333],[12.442256667,41.802351667],[12.436485,41.802988333],[12.430988333,41.804231667],[12.422115,41.807206667],[12.420115,41.807673333],[12.409595,41.809133333],[12.404746667,41.810043333],[12.3995,41.811571667],[12.395063333,41.814015],[12.393291667,41.816263333],[12.394218333,41.818183333],[12.39629,41.818766667],[12.412936667,41.820256667],[12.415831667,41.82103],[12.418241667,41.822598333],[12.419573333,41.824433333],[12.420053333,41.826475],[12.420003333,41.829146667],[12.420551667,41.83061],[12.423528333,41.833188333],[12.426846667,41.83402],[12.42935,41.83354],[12.434345,41.83158],[12.438605,41.831216667],[12.44101,41.831673333],[12.446358333,41.834133333],[12.448958333,41.835976667],[12.453098333,41.840378333],[12.455683333,41.840333333],[12.460143333,41.838426667],[12.462156667,41.839516667],[12.436353333,41.819723333],[12.430398333,41.815408333],[12.421713333,41.809941667],[12.419791667,41.808015],[12.413633333,41.808798333],[12.409963333,41.809063333],[12.404236667,41.810105],[12.401118333,41.810966667],[12.396375,41.813168333],[12.394775,41.81425],[12.393198333,41.816086667],[12.394228333,41.818293333],[12.396606667,41.818918333],[12.412831667,41.82024],[12.416198333,41.821185],[12.418938333,41.823316667],[12.419936667,41.82613],[12.419858333,41.82901],[12.420395,41.83044],[12.422611667,41.832536667],[12.425671667,41.83393],[12.429636667,41.833531667],[12.433598333,41.831818333],[12.437423333,41.831183333],[12.44034,41.831476667],[12.445455,41.832645],[12.448058333,41.834258333],[12.450781667,41.837608333],[12.452798333,41.838816667],[12.454428333,41.841238333],[12.454273333,41.842426667],[12.451461667,41.839103333],[12.450556667,41.838683333],[12.446291667,41.840115],[12.444841667,41.841705],[12.44381,41.845178333],[12.440313333,41.855193333],[12.440601667,41.857085],[12.442931667,41.859125],[12.443646667,41.862908333],[12.443843333,41.866165],[12.444275,41.86691],[12.442998333,41.871405],[12.443086667,41.87449],[12.444865,41.875775],[12.445873333,41.875011667],[12.444608333,41.872876667],[12.447966667,41.870353333],[12.445581667,41.872668333],[12.44307,41.873208333],[12.446195,41.873616667],[12.42895,41.873688333],[12.445485,41.873711667],[12.44126,41.872011667],[12.444626667,41.87273],[12.44493,41.873321667],[12.428006667,41.871625],[12.42207,41.87165],[12.426256667,41.872228333],[12.444813333,41.872671667],[12.441443333,41.871706667],[12.443678333,41.871221667],[12.444595,41.871641667],[12.443823333,41.873316667],[12.444916667,41.87265],[11.98704,41.990376667],[12.444763333,41.87283],[12.441238333,41.873655],[12.44328,41.869743333],[12.443348333,41.876003333],[12.442163333,41.877176667],[12.440211667,41.87759],[12.43224,41.87764],[12.430763333,41.87723],[12.42972,41.876138333],[12.428625,41.877066667],[12.424695,41.883346667],[12.421703333,41.886295],[12.421218333,41.888383333],[12.415321667,41.888675],[12.41047,41.8898],[12.385825,41.886421667],[12.384575,41.88557],[12.382931667,41.885488333],[12.381745,41.886425],[12.384296667,41.905481667],[12.385796667,41.912246667],[12.384401667,41.917638333],[12.383235,41.920526667],[12.534986667,42.063101667],[12.53535,42.067191667],[12.536618333,42.070458333],[12.538353333,42.073181667],[12.539626667,42.074183333],[12.544793333,42.077118333],[12.546468333,42.077631667],[12.557026667,42.082431667],[12.56031,42.084315],[12.572181667,42.093283333],[12.581295,42.100038333],[12.583478333,42.102615],[12.58747,42.109093333],[12.593061667,42.118881667],[12.594463333,42.120285],[12.597778333,42.126586667],[12.601793333,42.132898333],[12.60445,42.138406667],[12.606795,42.14079],[12.609046667,42.146563333],[12.611976667,42.152036667],[12.61686,42.160003333],[12.618221667,42.165428333],[12.61656,42.167718333],[12.612443333,42.169676667],[12.611258333,42.170608333],[12.604441667,42.177405],[12.6025,42.180586667],[12.602416667,42.182331667],[12.604216667,42.194016667],[12.60419,42.196451667],[12.602465,42.200991667],[12.602498333,42.203575],[12.603133333,42.20525],[12.603048333,42.207418333],[12.600995,42.21134],[12.600565,42.213523333],[12.598923333,42.215431667],[12.597981667,42.217276667],[12.59302,42.222816667],[12.591828333,42.224746667],[12.591923333,42.231133333],[12.57162,42.250615],[12.557916667,42.255088333],[12.556488333,42.255745],[12.555096667,42.257331667],[12.550426667,42.267921667],[12.547646667,42.270386667],[12.538138333,42.274545],[12.522041667,42.282345],[12.519165,42.28339],[12.504811667,42.287768333],[12.502711667,42.288638333],[12.499391667,42.291168333],[12.498658333,42.292383333],[12.493353333,42.304015],[12.49328,42.305931667],[12.494813333,42.309431667],[12.494953333,42.311755],[12.49316,42.315353333],[12.493795,42.316785],[12.49183,42.317831667],[12.490036667,42.320881667],[12.488685,42.322353333],[12.483623333,42.326093333],[12.480901667,42.327251667],[12.477286667,42.328275],[12.46994,42.33153],[12.467505,42.333435],[12.466691667,42.33665],[12.467216667,42.33849],[12.470431667,42.343353333],[12.471006667,42.346613333],[12.471501667,42.351738333],[12.470821667,42.366655],[12.471011667,42.373633333],[12.471938333,42.378706667],[12.470398333,42.38737],[12.469356667,42.388968333],[12.465451667,42.392973333],[12.460223333,42.398041667],[12.458925,42.399666667],[12.448648333,42.409185],[12.44659,42.410973333],[12.441741667,42.415811667],[12.438818333,42.4194],[12.432583333,42.427661667],[12.429336667,42.43049],[12.421571667,42.43539],[12.419901667,42.437543333],[12.418213333,42.44235],[12.41746,42.445413333],[12.41586,42.447481667],[12.413185,42.448855],[12.406798333,42.450673333],[12.402161667,42.452366667],[12.398665,42.455183333],[12.39743,42.456865],[12.39495,42.461911667],[12.392268333,42.464335],[12.388156667,42.465335],[12.382893333,42.46562],[12.364958333,42.467055],[12.357686667,42.467855],[12.350286667,42.471071667],[12.347763333,42.472728333],[12.341593333,42.478816667],[12.326248333,42.490416667],[12.317206667,42.49631],[12.314881667,42.498018333],[12.309076667,42.501701667],[12.303648333,42.504543333],[12.301886667,42.505736667],[12.293833333,42.509265],[12.290518333,42.511201667],[12.287455,42.513388333],[12.28363,42.51676],[12.280268333,42.518578333],[12.271511667,42.520818333],[12.268451667,42.52193],[12.26577,42.523548333],[12.262795,42.526676667],[12.261343333,42.530375],[12.259185,42.538975],[12.255825,42.551738333],[12.25352,42.557115],[12.250115,42.564233333],[12.24517,42.575603333],[12.238996667,42.588628333],[12.237088333,42.594368333],[12.235453333,42.602386667],[12.233651667,42.612525],[12.231303333,42.6243],[12.229555,42.631988333],[12.227101667,42.644651667],[12.22643,42.646363333],[12.223171667,42.65135],[12.222631667,42.653703333],[12.223926667,42.657798333],[12.22328,42.660243333],[12.220308333,42.662241667],[12.219061667,42.663696667],[12.217815,42.666561667],[12.21264,42.671776667],[12.210353333,42.675358333],[12.210176667,42.6772],[12.211353333,42.682168333],[12.211386667,42.684093333],[12.210636667,42.687958333],[12.209118333,42.69098],[12.20613,42.694216667],[12.203621667,42.696001667],[12.195083333,42.6993],[12.19259,42.699511667],[12.185975,42.69893],[12.183505,42.699063333],[12.178725,42.7003],[12.171575,42.702391667],[12.161236667,42.705626667],[12.159166667,42.706801667],[12.152981667,42.71203],[12.146558333,42.717801667],[12.141206667,42.720893333],[12.126493333,42.726798333],[12.118208333,42.729976667],[12.107648333,42.734175],[12.09198,42.74053],[12.087313333,42.743046667],[12.076243333,42.751556667],[12.051333333,42.770941667],[12.049581667,42.773166667],[12.049031667,42.77508],[12.047865,42.790705],[12.047341667,42.795736667],[12.0467,42.798238333],[12.04385,42.80292],[12.041413333,42.804695],[12.038528333,42.806063333],[12.036076667,42.807878333],[12.034875,42.809525],[12.032383333,42.815001667],[12.032361667,42.817495],[12.034276667,42.819591667],[12.03879,42.822468333],[12.040725,42.824436667],[12.042186667,42.827026667],[12.042545,42.828646667],[12.043121667,42.834598333],[12.042981667,42.836185],[12.037323333,42.85103],[12.037315,42.853743333],[12.038295,42.858255],[12.038221667,42.859546667],[12.036073333,42.862225],[12.020466667,42.872415],[12.018986667,42.874691667],[12.009898333,42.891771667],[12.008665,42.893258333],[11.995146667,42.903105],[11.990486667,42.906016667],[11.974873333,42.911308333],[11.970935,42.913615],[11.969988333,42.914618333],[11.957705,42.931855],[11.952671667,42.940666667],[11.944675,42.955065],[11.939291667,42.96641],[11.938128333,42.968131667],[11.922538333,42.986178333],[11.921228333,42.989101667],[11.919995,42.998363333],[11.91844,43.001815],[11.910991667,43.010251667],[11.910166667,43.012063333],[11.910665,43.01676],[11.911301667,43.017776667],[11.913483333,43.024006667],[11.913528333,43.027211667],[11.911988333,43.02949],[11.90708,43.034028333],[11.905633333,43.037008333],[11.905803333,43.038871667],[11.907368333,43.042786667],[11.907731667,43.044671667],[11.907135,43.047155],[11.905278333,43.051298333],[11.898573333,43.067588333],[11.894388333,43.077445],[11.888128333,43.092476667],[11.881996667,43.106993333],[11.879786667,43.10981],[11.871286667,43.11838],[11.870661667,43.12091],[11.87131,43.125556667],[11.87107,43.128035],[11.870473333,43.12923],[11.862481667,43.138656667],[11.85568,43.146961667],[11.851961667,43.151315],[11.837488333,43.168938333],[11.835365,43.171745],[11.831701667,43.177488333],[11.828326667,43.183285],[11.821793333,43.193791667],[11.814801667,43.203553333],[11.813333333,43.205825],[11.80651,43.215326667],[11.799321667,43.223406667],[11.792053333,43.231743333],[11.78828,43.235146667],[11.783255,43.23851],[11.773476667,43.247366667],[11.771315,43.250221667],[11.767131667,43.261325],[11.76719,43.26263],[11.769005,43.266345],[11.76935,43.269535],[11.766848333,43.278953333],[11.7659,43.283193333],[11.764388333,43.288381667],[11.76381,43.29161],[11.762826667,43.30037],[11.761348333,43.315745],[11.761346667,43.318293333],[11.764518333,43.35171],[11.764741667,43.355591667],[11.764028333,43.35873],[11.758215,43.369968333],[11.75703,43.37307],[11.756763333,43.375596667],[11.756578333,43.388078333],[11.756768333,43.392403333],[11.758143333,43.396698333],[11.765573333,43.410405],[11.767011667,43.412701667],[11.770493333,43.41709],[11.776661667,43.424411667],[11.778503333,43.428006667],[11.778133333,43.431678333],[11.774493333,43.440228333],[11.77228,43.442936667],[11.76862,43.44552],[11.765821667,43.447065],[11.763463333,43.447828333],[11.758755,43.448751667],[11.75611,43.449981667],[11.755101667,43.452045],[11.754231667,43.455336667],[11.752381667,43.4604],[11.750415,43.462826667],[11.742345,43.47046],[11.738066667,43.476021667],[11.735695,43.477905],[11.728478333,43.480816667],[11.724015,43.48231],[11.720865,43.48367],[11.718211667,43.484221667],[11.71281,43.48388],[11.708395,43.484181667],[11.697563333,43.48655],[11.683913333,43.48922],[11.67441,43.491208333],[11.67188,43.491865],[11.668376667,43.493595],[11.665856667,43.49628],[11.663208333,43.498071667],[11.65634,43.500855],[11.649875,43.504425],[11.6451,43.51116],[11.642403333,43.513205],[11.635468333,43.515006667],[11.631881667,43.515161667],[11.628586667,43.514398333],[11.61786,43.514833333],[11.612891667,43.5158],[11.60986,43.517051667],[11.60409,43.520566667],[11.591536667,43.527885],[11.580068333,43.534238333],[11.571061667,43.53948],[11.561416667,43.545905],[11.551971667,43.552418333],[11.545026667,43.55625],[11.543238333,43.557613333],[11.54217,43.559605],[11.542783333,43.566981667],[11.542231667,43.569845],[11.54142,43.571145],[11.538703333,43.573706667],[11.53213,43.578295],[11.528583333,43.580246667],[11.523793333,43.581703333],[11.521096667,43.583246667],[11.513295,43.590313333],[11.509876667,43.593743333],[11.50769,43.595505],[11.500443333,43.60242],[11.491503333,43.612313333],[11.485751667,43.619303333],[11.482765,43.622518333],[11.471226667,43.63274],[11.467185,43.635918333],[11.466181667,43.637598333],[11.465726667,43.640255],[11.465795,43.645583333],[11.465626667,43.6556],[11.465053333,43.657575],[11.461396667,43.661953333],[11.459676667,43.664328333],[11.45565,43.671466667],[11.453308333,43.67661],[11.450748333,43.680551667],[11.44334,43.688585],[11.441098333,43.690138333],[11.43661,43.691513333],[11.423853333,43.694295],[11.421345,43.694456667],[11.41595,43.693318333],[11.411791667,43.692948333],[11.40902,43.693855],[11.404495,43.698993333],[11.3932,43.708401667],[11.392651667,43.709511667],[11.392178333,43.713041667],[11.391411667,43.714768333],[11.389246667,43.716416667],[11.385571667,43.718366667],[11.374816667,43.725368333],[11.37335,43.72858],[11.371221667,43.72996],[11.368798333,43.73022],[11.364228333,43.730005],[11.35405,43.72926],[11.346305,43.727735],[11.342831667,43.727996667],[11.335498333,43.729518333],[11.324761667,43.729568333],[11.320381667,43.73013],[11.311536667,43.732355],[11.307086667,43.733223333],[11.301206667,43.733571667],[11.296526667,43.736253333],[11.290601667,43.73796],[11.285435,43.740556667],[11.282628333,43.740833333],[11.274433333,43.740243333],[11.271936667,43.739466667],[11.266705,43.736501667],[11.259286667,43.731758333],[11.252695,43.727986667],[11.241815,43.721511667],[11.238371667,43.721046667],[11.233916667,43.72156],[11.2233,43.723493333],[11.220883333,43.724266667],[11.217373333,43.72618],[11.214565,43.72687],[11.206443333,43.727425],[11.203756667,43.728248333],[11.199346667,43.729021667],[11.19098,43.731376667],[11.188256667,43.733241667],[11.186038333,43.737021667],[11.180565,43.742981667],[11.178558333,43.744186667],[11.174581667,43.745673333],[11.172433333,43.747656667],[11.170075,43.760425],[11.16931,43.762898333],[11.164148333,43.77032],[11.162343333,43.7746],[11.157768333,43.791411667],[11.15533,43.799781667],[11.151915,43.812043333],[11.15163,43.813973333],[11.151756667,43.824498333],[11.152208333,43.826433333],[11.153235,43.828238333],[11.156003333,43.83179],[11.164145,43.840941667],[11.168296667,43.84647],[11.176448333,43.855013333],[11.177686667,43.857446667],[11.177543333,43.861681667],[11.173425,43.871808333],[11.174003333,43.874438333],[11.178125,43.878503333],[11.182195,43.880355],[11.184806667,43.882858333],[11.185058333,43.884205],[11.184366667,43.888048333],[11.18445,43.889563333],[11.185753333,43.892085],[11.18976,43.895425],[11.19297,43.89866],[11.194543333,43.903685],[11.194941667,43.906865],[11.194846667,43.909506667],[11.195778333,43.911586667],[11.199191667,43.915001667],[11.199901667,43.9166],[11.201406667,43.917951667],[11.204276667,43.919043333],[11.209296667,43.919975],[11.212151667,43.921236667],[11.214456667,43.92342],[11.217205,43.92658],[11.218338333,43.928546667],[11.219531667,43.932978333],[11.2216,43.935585],[11.221871667,43.939228333],[11.221213333,43.940998333],[11.213831667,43.949325],[11.21362,43.951021667],[11.212533333,43.952713333],[11.210273333,43.954926667],[11.209208333,43.956566667],[11.208973333,43.95903],[11.211033333,43.963541667],[11.21171,43.966691667],[11.211376667,43.98038],[11.211455,43.986163333],[11.213351667,43.989311667],[11.220046667,43.992756667],[11.221116667,43.994133333],[11.221038333,43.995261667],[11.21869,44.000518333],[11.21853,44.001723333],[11.219506667,44.004598333],[11.218625,44.008503333],[11.219406667,44.010176667],[11.224395,44.017446667],[11.22446,44.019126667],[11.222165,44.023795],[11.222588333,44.026495],[11.22575,44.030255],[11.225665,44.031836667],[11.224628333,44.033765],[11.223851667,44.036788333],[11.222751667,44.0385],[11.223391667,44.04086],[11.22627,44.041896667],[11.228713333,44.041933333],[11.23144,44.044748333],[11.230471667,44.048415],[11.229178333,44.050531667],[11.226348333,44.052071667],[11.22201,44.052728333],[11.220341667,44.053413333],[11.21301,44.05466],[11.211486667,44.055205],[11.209748333,44.056715],[11.209086667,44.060765],[11.209073333,44.064666667],[11.208616667,44.070865],[11.20916,44.07241],[11.210986667,44.073486667],[11.218296667,44.073771667],[11.228695,44.077578333],[11.230203333,44.079048333],[11.230278333,44.081343333],[11.228845,44.091956667],[11.229151667,44.09608],[11.227518333,44.098138333],[11.225478333,44.099226667],[11.22188,44.100438333],[11.220306667,44.102355],[11.220325,44.105073333],[11.223633333,44.106341667],[11.225645,44.107758333],[11.230105,44.112653333],[11.231361667,44.115051667],[11.231258333,44.118553333],[11.22975,44.120986667],[11.226835,44.124363333],[11.221811667,44.132078333],[11.220666667,44.133196667],[11.217798333,44.134968333],[11.208113333,44.139391667],[11.209215,44.147131667],[11.210298333,44.150383333],[11.21016,44.151721667],[11.209021667,44.153233333],[11.206,44.155388333],[11.20527,44.156426667],[11.205278333,44.158066667],[11.207645,44.160236667],[11.20856,44.162045],[11.208621667,44.164058333],[11.20958,44.168043333],[11.210295,44.169288333],[11.213655,44.172368333],[11.21412,44.174315],[11.213598333,44.176245],[11.209361667,44.184463333],[11.210295,44.18775],[11.210013333,44.189033333],[11.208488333,44.190713333],[11.202238333,44.206685],[11.201568333,44.209106667],[11.20157,44.212515],[11.201056667,44.213738333],[11.198695,44.21703],[11.198131667,44.220115],[11.19633,44.22214],[11.193371667,44.223768333],[11.192328333,44.2261],[11.194073333,44.231918333],[11.195666667,44.234301667],[11.195545,44.235518333],[11.19428,44.237201667],[11.193306667,44.239456667],[11.194023333,44.241948333],[11.196051667,44.244111667],[11.195396667,44.250205],[11.195426667,44.25413],[11.194548333,44.256713333],[11.194826667,44.258695],[11.196441667,44.262526667],[11.199105,44.26617],[11.19957,44.267423333],[11.199528333,44.270536667],[11.201106667,44.273786667],[11.201901667,44.277043333],[11.203116667,44.27883],[11.206073333,44.281288333],[11.207005,44.283063333],[11.207068333,44.287173333],[11.208458333,44.290215],[11.210215,44.291718333],[11.212488333,44.292821667],[11.218655,44.294483333],[11.230915,44.297295],[11.23464,44.297901667],[11.244851667,44.304156667],[11.248893333,44.307728333],[11.250621667,44.31028],[11.250965,44.312693333],[11.255196667,44.323416667],[11.267815,44.339935],[11.268518333,44.341913333],[11.268455,44.343935],[11.267785,44.345841667],[11.262185,44.357916667],[11.258305,44.367028333],[11.257756667,44.369945],[11.259368333,44.39243],[11.259235,44.394966667],[11.26055,44.398881667],[11.263516667,44.402785],[11.2644,44.40461],[11.268783333,44.417141667],[11.275405,44.428518333],[11.276733333,44.432521667],[11.28128,44.453188333],[11.281065,44.45526],[11.280311667,44.456525],[11.275698333,44.460375],[11.274896667,44.462155],[11.274568333,44.46754],[11.274266667,44.468838333],[11.272978333,44.47056],[11.269621667,44.473655],[11.266023333,44.477458333],[11.262883333,44.480311667],[11.258371667,44.48495],[11.255405,44.487141667],[11.250696667,44.489535],[11.235628333,44.494988333],[11.228145,44.497595],[11.220791667,44.500311667],[11.208755,44.50458],[11.202933333,44.50678],[11.189806667,44.511463333],[11.165143333,44.520433333],[11.157693333,44.52309],[11.153556667,44.524325],[11.1389,44.52938],[11.125555,44.53363],[11.120843333,44.535528333],[11.112801667,44.538495],[11.0876,44.548225],[11.078031667,44.551795],[11.065556667,44.556631667],[11.060303333,44.558386667],[11.051803333,44.561756667],[11.044288333,44.56457],[11.040073333,44.565731667],[11.027021667,44.568503333],[11.024361667,44.568936667],[11.013058333,44.571403333],[10.9978,44.574851667],[10.987628333,44.577381667],[10.973366667,44.58116],[10.970063333,44.582246667],[10.96455,44.584705],[10.948081667,44.591531667],[10.942741667,44.594191667],[10.93522,44.59716],[10.928888333,44.599856667],[10.92655,44.60108],[10.918731667,44.604541667],[10.914046667,44.606098333],[10.901786667,44.61146],[10.89407,44.614585],[10.888441667,44.616648333],[10.884888333,44.61925],[10.8829,44.621573333],[10.877168333,44.63123],[10.871495,44.640558333],[10.867876667,44.646198333],[10.864811667,44.651476667],[10.859978333,44.658833333],[10.85687,44.662105],[10.854461667,44.663783333],[10.85109,44.665448333],[10.846435,44.667126667],[10.844458333,44.66852],[10.844361667,44.669671667],[10.845485,44.672241667],[10.848023333,44.676998333],[10.849033333,44.680233333],[10.85081,44.69037],[10.850756667,44.694978333],[10.849148333,44.701216667],[10.849056667,44.703948333],[10.848228333,44.705831667],[10.846895,44.716305],[10.846011667,44.720773333],[10.844183333,44.728441667],[10.84414,44.730783333],[10.844726667,44.738586667],[10.844903333,44.749198333],[10.844066667,44.75875],[10.844071667,44.76175],[10.844576667,44.766415],[10.845818333,44.773556667],[10.84665,44.776028333],[10.85147,44.788053333],[10.852698333,44.793096667],[10.852845,44.796251667],[10.850771667,44.812133333],[10.851088333,44.816883333],[10.85273,44.826906667],[10.852918333,44.83317],[10.852125,44.846415],[10.852013333,44.852778333],[10.851638333,44.861303333],[10.850018333,44.874133333],[10.85025,44.883378333],[10.850711667,44.890196667],[10.850456667,44.89426],[10.848575,44.903863333],[10.848428333,44.907478333],[10.849246667,44.911603333],[10.853803333,44.92183],[10.855348333,44.924878333],[10.863736667,44.937231667],[10.864815,44.939725],[10.865151667,44.942258333],[10.86434,44.950685],[10.863093333,44.955866667],[10.8586,44.96585],[10.85807,44.967745],[10.856088333,44.978001667],[10.855441667,44.98053],[10.851565,44.990883333],[10.850698333,44.994543333],[10.849518333,45.003756667],[10.850143333,45.007991667],[10.853653333,45.01908],[10.85397,45.021543333],[10.853943333,45.031265],[10.853703333,45.039786667],[10.85325,45.042933333],[10.852233333,45.045323333],[10.848755,45.049785],[10.843133333,45.05527],[10.841688333,45.058518333],[10.841533333,45.060711667],[10.84223,45.06376],[10.84614,45.072168333],[10.855003333,45.089263333],[10.860426667,45.104496667],[10.870088333,45.125896667],[10.870808333,45.12809],[10.871421667,45.13196],[10.87118,45.136466667],[10.870273333,45.139825],[10.865483333,45.151045],[10.861808333,45.160236667],[10.85763,45.16866],[10.85351,45.17617],[10.850348333,45.18251],[10.849375,45.185563333],[10.84669,45.200748333],[10.847183333,45.204986667],[10.847906667,45.206793333],[10.859481667,45.229525],[10.862046667,45.234355],[10.863118333,45.23683],[10.864608333,45.241803333],[10.872801667,45.267571667],[10.874113333,45.27055],[10.877745,45.27552],[10.88649,45.28667],[10.888348333,45.288793333],[10.89915,45.298873333],[10.902243333,45.30189],[10.904783333,45.305316667],[10.911163333,45.317336667],[10.916288333,45.325685],[10.917335,45.328805],[10.918881667,45.34713],[10.920661667,45.359491667],[10.920241667,45.363723333],[10.918278333,45.36856],[10.909765,45.38478],[10.908811667,45.38703],[10.908381667,45.389408333],[10.908723333,45.39297],[10.909845,45.39617],[10.91442,45.41296],[10.914601667,45.415918333],[10.913756667,45.418853333],[10.908,45.430468333],[10.905501667,45.43413],[10.902391667,45.436923333],[10.887573333,45.447051667],[10.885443333,45.44829],[10.882138333,45.449503333],[10.875418333,45.45101],[10.867751667,45.452913333],[10.845738333,45.457125],[10.83928,45.459051667],[10.822781667,45.466268333],[10.818141667,45.468401667],[10.815268333,45.47012],[10.813515,45.471818333],[10.809515,45.476461667],[10.806873333,45.478971667],[10.80426,45.480841667],[10.797738333,45.484408333],[10.795083333,45.486073333],[10.794045,45.487153333],[10.786838333,45.497113333],[10.785336667,45.499523333],[10.784408333,45.501946667],[10.784175,45.503843333],[10.784773333,45.512871667],[10.78152,45.526736667],[10.780003333,45.537543333],[10.779963333,45.539773333],[10.780933333,45.542426667],[10.782108333,45.54389],[10.784733333,45.545823333],[10.796041667,45.551888333],[10.798093333,45.553585],[10.79995,45.556766667],[10.802006667,45.564333333],[10.803336667,45.57075],[10.804245,45.573095],[10.807138333,45.576886667],[10.811631667,45.579898333],[10.814595,45.581191667],[10.819383333,45.582325],[10.82657,45.583433333],[10.831583333,45.585466667],[10.833348333,45.586731667],[10.835136667,45.588676667],[10.837891667,45.593553333],[10.839751667,45.596025],[10.847508333,45.604453333],[10.85005,45.607835],[10.851688333,45.610775],[10.853823333,45.613585],[10.862171667,45.621975],[10.86609,45.626681667],[10.873245,45.634965],[10.878131667,45.639738333],[10.883403333,45.645598333],[10.891383333,45.65642],[10.892856667,45.658818333],[10.894236667,45.662561667],[10.895836667,45.665603333],[10.902513333,45.67536],[10.904563333,45.678965],[10.905691667,45.68209],[10.906475,45.685786667],[10.908235,45.689348333],[10.91222,45.692531667],[10.916355,45.694963333],[10.921103333,45.699246667],[10.9221,45.700826667],[10.926586667,45.70922],[10.92796,45.711065],[10.932191667,45.715648333],[10.940363333,45.727268333],[10.944163333,45.730911667],[10.947035,45.732731667],[10.953246667,45.735933333],[10.956456667,45.737276667],[10.962928333,45.738555],[10.966363333,45.73967],[10.971876667,45.742421667],[10.984148333,45.747696667],[10.986511667,45.748893333],[10.988853333,45.75095],[10.997763333,45.762668333],[10.99955,45.764221667],[11.00781,45.768745],[11.010273333,45.77067],[11.011551667,45.772436667],[11.016,45.782666667],[11.019655,45.787951667],[11.02081,45.79251],[11.021216667,45.795205],[11.020943333,45.797191667],[11.018921667,45.801008333],[11.015363333,45.806758333],[11.011716667,45.810531667],[11.008955,45.814995],[11.006226667,45.818053333],[11.004376667,45.821456667],[11.004043333,45.825621667],[11.003063333,45.830488333],[11.002783333,45.838396667],[11.002141667,45.840718333],[11.00012,45.844705],[10.999786667,45.846935],[11.000186667,45.849413333],[11.001443333,45.853008333],[11.00141,45.854831667],[11.000505,45.859076667],[11.00145,45.862101667],[11.00689,45.870136667],[11.007615,45.872423333],[11.009325,45.879943333],[11.010498333,45.882923333],[11.013888333,45.889333333],[11.015603333,45.892148333],[11.017021667,45.893741667],[11.022011667,45.897391667],[11.02555,45.900301667],[11.026931667,45.901956667],[11.03491,45.912573333],[11.037533333,45.915131667],[11.040015,45.916991667],[11.056351667,45.92623],[11.059508333,45.927591667],[11.062196667,45.928123333],[11.065036667,45.92808],[11.072201667,45.9267],[11.074045,45.926658333],[11.077653333,45.927225],[11.080076667,45.92821],[11.08208,45.929548333],[11.090381667,45.937661667],[11.09771,45.943931667],[11.099731667,45.945913333],[11.101556667,45.948641667],[11.105241667,45.956723333],[11.105976667,45.959211667],[11.106815,45.965575],[11.107961667,45.97176],[11.1087,45.979346667],[11.109506667,45.982393333],[11.110693333,45.984048333],[11.116576667,45.990113333],[11.118271667,45.992331667],[11.119778333,45.995261667],[11.120796667,45.998311667],[11.121088333,46.0014],[11.121328333,46.01032],[11.122086667,46.022613333],[11.122003333,46.034891667],[11.126528333,46.034513333],[11.124838333,46.036958333],[11.122065,46.039976667],[11.113745,46.047501667],[11.11271,46.049038333],[11.112928333,46.051781667],[11.110231667,46.053925],[11.109335,46.05614],[11.111406667,46.063763333],[11.113943333,46.069506667],[11.113551667,46.070843333],[11.11053,46.070873333],[11.109181667,46.0713],[11.107413333,46.072936667],[11.107375,46.074638333],[11.113458333,46.075243333],[11.114686667,46.073331667],[11.114913333,46.07171],[11.115586667,46.074331667],[11.114688333,46.076991667],[11.109621667,46.07742],[11.10203,46.090136667],[11.095336667,46.097166667],[11.091435,46.101441667],[11.085676667,46.139123333],[11.08757,46.14304],[11.091961667,46.154136667],[11.23524,46.280121667],[11.236263333,46.284815],[11.237683333,46.288706667],[11.239148333,46.291221667],[11.242206667,46.295153333],[11.247115,46.300963333],[11.255375,46.310978333],[11.259785,46.31539],[11.266401667,46.320233333],[11.270441667,46.324286667],[11.274835,46.330188333],[11.275966667,46.331986667],[11.278775,46.339956667],[11.281271667,46.34634],[11.286378333,46.353708333],[11.287588333,46.356366667],[11.289848333,46.362465],[11.290613333,46.367601667],[11.290576667,46.374271667],[11.290866667,46.376226667],[11.293568333,46.386291667],[11.295366667,46.393435],[11.300523333,46.40223],[11.304898333,46.408818333],[11.312161667,46.420066667],[11.314155,46.422843333],[11.315213333,46.424958333],[11.315938333,46.428375],[11.317001667,46.436223333],[11.31697,46.438595],[11.31631,46.44095],[11.314323333,46.444008333],[11.309618333,46.44904],[11.307071667,46.452326667],[11.304201667,46.457246667],[11.304093333,46.460788333],[11.305068333,46.46333],[11.306561667,46.465235],[11.311365,46.469056667],[11.314961667,46.472625],[11.318888333,46.477735],[11.320423333,46.479256667],[11.3236,46.481146667],[11.327246667,46.483915],[11.330318333,46.48539],[11.334566667,46.486546667],[11.339896667,46.487581667],[11.344373333,46.488173333],[11.348455,46.489528333],[11.360885,46.49019],[11.362868333,46.49086],[11.366608333,46.491153333],[11.374886667,46.492876667],[11.37822,46.493378333],[11.386336667,46.492988333],[11.390763333,46.493113333],[11.393431667,46.49292],[11.397336667,46.49316],[11.406378333,46.494601667],[11.40909,46.494713333],[11.41336,46.493625],[11.42112,46.489763333],[11.423646667,46.489276667],[11.427003333,46.489838333],[11.430501667,46.491861667],[11.438185,46.493095],[11.439678333,46.493811667],[11.442196667,46.495821667],[11.44948,46.498606667],[11.45214,46.499906667],[11.456193333,46.502931667],[11.459435,46.504726667],[11.46084,46.505983333],[11.466053333,46.50846],[11.468135,46.510713333],[11.471161667,46.512495],[11.475556667,46.513553333],[11.477203333,46.514791667],[11.478486667,46.51686],[11.482598333,46.521103333],[11.484863333,46.52281],[11.488225,46.526905],[11.489515,46.527716667],[11.491791667,46.53133],[11.495181667,46.534496667],[11.500001667,46.537035],[11.505566667,46.542641667],[11.509143333,46.545398333],[11.513168333,46.54954],[11.51469,46.552883333],[11.513095,46.556728333],[11.513443333,46.559265],[11.515196667,46.562455],[11.51683,46.564016667],[11.521291667,46.567298333],[11.52253,46.569038333],[11.52373,46.572375],[11.523586667,46.57753],[11.524411667,46.58173],[11.524641667,46.585175],[11.530136667,46.593093333],[11.53186,46.594888333],[11.534536667,46.602095],[11.535516667,46.606815],[11.537488333,46.611613333],[11.540091667,46.614328333],[11.541441667,46.617693333],[11.542775,46.619278333],[11.547071667,46.623285],[11.54992,46.625438333],[11.551411667,46.628233333],[11.552996667,46.629813333],[11.558083333,46.63247],[11.561908333,46.635305],[11.570013333,46.638286667],[11.572296667,46.639493333],[11.575716667,46.641895],[11.57891,46.643326667],[11.58267,46.64385],[11.585063333,46.644826667],[11.586213333,46.645786667],[11.589371667,46.649661667],[11.592958333,46.652706667],[11.599493333,46.655193333],[11.602116667,46.656888333],[11.606818333,46.65905],[11.61149,46.66336],[11.614358333,46.666966667],[11.618445,46.672666667],[11.621781667,46.678046667],[11.623411667,46.681931667],[11.625638333,46.684183333],[11.638411667,46.690055],[11.640203333,46.691548333],[11.646326667,46.70037],[11.647951667,46.703111667],[11.64875,46.706371667],[11.647881667,46.710463333],[11.647746667,46.713688333],[11.646365,46.719576667],[11.646453333,46.723085],[11.644665,46.727026667],[11.641221667,46.732266667],[11.639483333,46.736346667],[11.639441667,46.741771667],[11.638446667,46.74494],[11.63497,46.749621667],[11.634101667,46.75129],[11.633625,46.753643333],[11.634086667,46.755938333],[11.637706667,46.76214],[11.638606667,46.764483333],[11.638193333,46.769245],[11.637043333,46.77169],[11.634866667,46.773045],[11.629986667,46.774513333],[11.627016667,46.777081667],[11.62282,46.778995],[11.617903333,46.78198],[11.616906667,46.783193333],[11.615956667,46.785841667],[11.607436667,46.795008333],[11.603716667,46.797821667],[11.599538333,46.798885],[11.594676667,46.801595],[11.588553333,46.803873333],[11.58545,46.804668333],[11.575606667,46.805601667],[11.573033333,46.806266667],[11.563195,46.809921667],[11.558831667,46.812278333],[11.557058333,46.812851667],[11.55233,46.813318333],[11.542281667,46.814936667],[11.539235,46.816261667],[11.537895,46.81786],[11.537456667,46.819868333],[11.536813333,46.826768333],[11.535265,46.829833333],[11.527741667,46.838855],[11.523743333,46.84403],[11.521456667,46.84568],[11.516553333,46.847253333],[11.514803333,46.849118333],[11.511216667,46.854378333],[11.507348333,46.859515],[11.504841667,46.861245],[11.498368333,46.862966667],[11.491093333,46.866436667],[11.486296667,46.867881667],[11.484433333,46.868755],[11.480688333,46.869446667],[11.477605,46.870375],[11.445255,46.881765],[11.441871667,46.882721667],[11.437403333,46.884378333],[11.43553,46.885395],[11.43095,46.886151667],[11.42778,46.887385],[11.425686667,46.888975],[11.424065,46.892411667],[11.423798333,46.898555],[11.424081667,46.900083333],[11.426975,46.903683333],[11.427651667,46.905138333],[11.428248333,46.908248333],[11.42996,46.911058333],[11.435368333,46.915061667],[11.440571667,46.917723333],[11.442348333,46.919336667],[11.443301667,46.921288333],[11.443878333,46.92437],[11.446418333,46.927458333],[11.447225,46.928975],[11.44946,46.938343333],[11.44961,46.941426667],[11.452456667,46.947258333],[11.454991667,46.951141667],[11.457121667,46.952958333],[11.459311667,46.955811667],[11.463646667,46.962815],[11.471133333,46.969185],[11.476873333,46.97369],[11.48339,46.97702],[11.491843333,46.98186],[11.493975,46.983498333],[11.495731667,46.985751667],[11.498276667,46.990193333],[11.500086667,46.993926667],[11.501876667,46.996518333],[11.503288333,46.997755],[11.508513333,47.005071667],[11.509021667,47.007281667],[11.50812,47.010721667],[11.50633,47.013453333],[11.50684,47.015928333],[11.50619,47.018326667],[11.503161667,47.020603333],[11.501058333,47.023851667],[11.49922,47.025056667],[11.494735,47.026096667],[11.491756667,47.027211667],[11.483555,47.032898333],[11.481493333,47.033663333],[11.475968333,47.034801667],[11.473996667,47.037208333],[11.47417,47.038346667],[11.476583333,47.041501667],[11.48022,47.045163333],[11.481536667,47.04737],[11.482026667,47.049228333],[11.481838333,47.052011667],[11.479998333,47.058401667],[11.479888333,47.06254],[11.481018333,47.068035],[11.480953333,47.070531667],[11.479801667,47.073003333],[11.478281667,47.07467],[11.472285,47.077941667],[11.468955,47.08107],[11.465976667,47.082726667],[11.461031667,47.084653333],[11.459046667,47.086688333],[11.458685,47.089265],[11.459601667,47.09114],[11.4614,47.0934],[11.462566667,47.095786667],[11.462458333,47.097681667],[11.461106667,47.099971667],[11.456213333,47.105063333],[11.452526667,47.110141667],[11.45134,47.112598333],[11.450666667,47.1169],[11.448886667,47.119768333],[11.449113333,47.122275],[11.450261667,47.125146667],[11.450421667,47.126936667],[11.449993333,47.129955],[11.44997,47.135255],[11.448736667,47.138156667],[11.446033333,47.142001667],[11.445355,47.143745],[11.444686667,47.147988333],[11.44352,47.152143333],[11.441735,47.155146667],[11.439371667,47.157721667],[11.435786667,47.160873333],[11.432966667,47.164996667],[11.428858333,47.169433333],[11.426676667,47.171326667],[11.423213333,47.17333],[11.418613333,47.175058333],[11.416533333,47.17627],[11.414573333,47.178403333],[11.411165,47.181151667],[11.409345,47.183023333],[11.407513333,47.184026667],[11.404428333,47.184288333],[11.398481667,47.181976667],[11.397346667,47.182598333],[11.397725,47.18364],[11.400208333,47.18517],[11.397911667,47.193705],[11.397818333,47.195133333],[11.399248333,47.198861667],[11.40327,47.203633333],[11.404131667,47.205356667],[11.40324,47.20824],[11.400993333,47.211578333],[11.393983333,47.219173333],[11.3923,47.222348333],[11.392123333,47.224971667],[11.393358333,47.227455],[11.393688333,47.229908333],[11.390561667,47.239285],[11.390876667,47.242246667],[11.392538333,47.244451667],[11.39506,47.246056667],[11.396673333,47.246605],[11.4031,47.24954],[11.404723333,47.251521667],[11.407343333,47.252811667],[11.417426667,47.254285],[11.424778333,47.255615],[11.437915,47.260891667],[11.439846667,47.261406667],[11.450326667,47.262038333],[11.454513333,47.26296],[11.457595,47.2647],[11.460246667,47.26665],[11.464858333,47.268796667],[11.466575,47.269271667],[11.48167,47.271883333],[11.487466667,47.27221],[11.49388,47.271695],[11.497645,47.271921667],[11.500271667,47.272681667],[11.505526667,47.274856667],[11.508178333,47.275603333],[11.511086667,47.275803333],[11.516998333,47.27568],[11.523895,47.276376667],[11.535845,47.278553333],[11.546033333,47.280641667],[11.55135,47.282186667],[11.55531,47.284183333],[11.557286667,47.2856],[11.559955,47.288391667],[11.56389,47.292956667],[11.567335,47.296083333],[11.569526667,47.29737],[11.573865,47.298895],[11.576768333,47.29932],[11.585406667,47.300036667],[11.591163333,47.299963333],[11.59862,47.299106667],[11.601493333,47.299388333],[11.605086667,47.300311667],[11.608198333,47.301935],[11.61457,47.306225],[11.617983333,47.307491667],[11.628821667,47.308996667],[11.633881667,47.310883333],[11.639511667,47.314363333],[11.64456,47.31625],[11.65195,47.317448333],[11.65971,47.319881667],[11.668643333,47.323621667],[11.675416667,47.327383333],[11.680223333,47.33137],[11.683773333,47.33523],[11.685195,47.337651667],[11.687585,47.344008333],[11.688743333,47.345786667],[11.691948333,47.34892],[11.696938333,47.35285],[11.700206667,47.356873333],[11.702515,47.358933333],[11.707155,47.361215],[11.716276667,47.363256667],[11.72101,47.364026667],[11.727536667,47.365378333],[11.733315,47.367855],[11.743023333,47.373506667],[11.751886667,47.379608333],[11.755743333,47.382415],[11.758978333,47.383936667],[11.764361667,47.385631667],[11.769263333,47.386076667],[11.776291667,47.38574],[11.779173333,47.386103333],[11.781828333,47.386946667],[11.792243333,47.391311667],[11.795145,47.393101667],[11.797266667,47.395303333],[11.800493333,47.400721667],[11.804503333,47.403531667],[11.808888333,47.404733333],[11.811781667,47.405233333],[11.817723333,47.405366667],[11.82384,47.405276667],[11.828273333,47.40604],[11.834528333,47.408],[11.845541667,47.413003333],[11.848651667,47.414936667],[11.851138333,47.417171667],[11.855306667,47.421911667],[11.857826667,47.424261667],[11.861323333,47.426476667],[11.865821667,47.42898],[11.87,47.43171],[11.876256667,47.43675],[11.87965,47.439111667],[11.883633333,47.440953333],[11.896135,47.44443],[11.900296667,47.446006667],[11.905686667,47.448665],[11.9077,47.449896667],[11.916428333,47.456428333],[11.919431667,47.457865],[11.922993333,47.458731667],[11.933221667,47.46016],[11.938681667,47.461683333],[11.94697,47.46529],[11.960665,47.469776667],[11.97115,47.473526667],[11.976061667,47.475663333],[11.980833333,47.477993333],[11.986075,47.479498333],[11.998165,47.480258333],[12.005581667,47.481446667],[12.010866667,47.482688333],[12.01455,47.483331667],[12.018876667,47.48364],[12.024486667,47.483505],[12.027075,47.482523333],[12.0292,47.48022],[12.032156667,47.478456667],[12.041221667,47.478421667],[12.044888333,47.477728333],[12.049488333,47.479838333],[12.053908333,47.481],[12.049511667,47.480115],[12.045531667,47.47805],[12.043885,47.477945],[12.040065,47.478535],[12.03191,47.478601667],[12.02855,47.480868333],[12.027048333,47.482708333],[12.027635,47.483661667],[12.037486667,47.485208333],[12.042053333,47.486293333],[12.047533333,47.488036667],[12.053441667,47.490578333],[12.057535,47.493436667],[12.058875,47.495966667],[12.058906667,47.498006667],[12.058266667,47.500673333],[12.058361667,47.503318333],[12.059753333,47.505791667],[12.063431667,47.510465],[12.065336667,47.51509],[12.067488333,47.519088333],[12.070406667,47.522493333],[12.079428333,47.529383333],[12.08175,47.530736667],[12.086936667,47.532386667],[12.095956667,47.533308333],[12.101835,47.534746667],[12.10819,47.537416667],[12.111811667,47.539621667],[12.114848333,47.542173333],[12.118398333,47.546506667],[12.120585,47.5499],[12.122598333,47.552015],[12.127661667,47.555695],[12.134293333,47.559661667],[12.137003333,47.562098333],[12.140785,47.567053333],[12.14604,47.574683333],[12.150761667,47.58118],[12.154806667,47.584993333],[12.15801,47.587055],[12.16227,47.589211667],[12.169638333,47.592555],[12.172486667,47.594005],[12.179745,47.599176667],[12.184846667,47.601596667],[12.19025,47.603481667],[12.193893333,47.605133333],[12.197638333,47.607478333],[12.200021667,47.609703333],[12.201601667,47.612138333],[12.202678333,47.615951667],[12.20224,47.622506667],[12.200751667,47.627785],[12.1993,47.630753333],[12.196405,47.635406667],[12.192933333,47.64058],[12.190483333,47.645181667],[12.188191667,47.650171667],[12.18507,47.655456667],[12.183515,47.660138333],[12.182228333,47.665333333],[12.180728333,47.668306667],[12.179211667,47.669808333],[12.172596667,47.6745],[12.169001667,47.677921667],[12.166278333,47.68188],[12.164803333,47.68509],[12.16281,47.693808333],[12.160911667,47.699865],[12.159083333,47.70284],[12.150341667,47.7118],[12.14787,47.714663333],[12.139816667,47.722761667],[12.137513333,47.725395],[12.132716667,47.731541667],[12.128165,47.73807],[12.124166667,47.743151667],[12.119835,47.747971667],[12.115183333,47.752778333],[12.107808333,47.759885],[12.104043333,47.763856667],[12.098998333,47.769678333],[12.095708333,47.774525],[12.093563333,47.778871667],[12.091298333,47.785833333],[12.090638333,47.78943],[12.09,47.79785],[12.090918333,47.801748333],[12.091911667,47.803368333],[12.094701667,47.806636667],[12.096355,47.807841667],[12.099178333,47.808833333],[12.104133333,47.80894],[12.12057,47.807416667],[12.108705,47.80865],[12.10111,47.809335],[12.096466667,47.809935],[12.075283333,47.813206667],[12.063668333,47.814885],[12.057613333,47.815515],[12.04775,47.816741667],[12.042816667,47.817216667],[12.028538333,47.818238333],[12.019306667,47.819991667],[12.015476667,47.820475],[12.001743333,47.82137],[11.989081667,47.822078333],[11.973371667,47.821795],[11.96785,47.822485],[11.965236667,47.823318333],[11.96064,47.825405],[11.958496667,47.826046667],[11.949391667,47.827235],[11.946028333,47.827306667],[11.943586667,47.826931667],[11.940831667,47.825883333],[11.936316667,47.823181667],[11.932583333,47.822275],[11.92992,47.82214],[11.92492,47.823295],[11.914033333,47.82912],[11.910326667,47.83044],[11.907548333,47.830715],[11.903606667,47.830266667],[11.89825,47.828506667],[11.894548333,47.82808],[11.890771667,47.828915],[11.874238333,47.837868333],[11.871526667,47.839945],[11.86889,47.842851667],[11.867611667,47.844896667],[11.86657,47.847668333],[11.864391667,47.850943333],[11.859125,47.85568],[11.856023333,47.857433333],[11.846936667,47.861228333],[11.842703333,47.862096667],[11.83834,47.86253],[11.831245,47.864151667],[11.822263333,47.865645],[11.817708333,47.865878333],[11.804266667,47.86471],[11.799588333,47.865023333],[11.795995,47.865643333],[11.79153,47.866893333],[11.779033333,47.872023333],[11.769723333,47.875721667],[11.74809,47.884476667],[11.736923333,47.889118333],[11.73284,47.890625],[11.729808333,47.892063333],[11.726391667,47.894211667],[11.724021667,47.896275],[11.72181,47.89906],[11.720558333,47.901426667],[11.717048333,47.910168333],[11.71492,47.915828333],[11.710238333,47.927261667],[11.708698333,47.930373333],[11.7035,47.93823],[11.701065,47.942328333],[11.695106667,47.95129],[11.69261,47.95525],[11.689828333,47.96055],[11.68628,47.971666667],[11.681991667,47.98733],[11.680178333,47.991813333],[11.67881,47.994316667],[11.670851667,48.005905],[11.665643333,48.013658333],[11.663895,48.016726667],[11.660726667,48.024946667],[11.661261667,48.027661667],[11.663086667,48.029293333],[11.672115,48.03374],[11.677833333,48.037645],[11.681485,48.040958333],[11.684866667,48.044913333],[11.688078333,48.049143333],[11.691773333,48.053235],[11.6958,48.056231667],[11.70036,48.058841667],[11.709983333,48.063141667],[11.719476667,48.068041667],[11.728731667,48.074163333],[11.733876667,48.078315],[11.739113333,48.08311],[11.746888333,48.092571667],[11.748581667,48.095015],[11.751933333,48.100823333],[11.755286667,48.108363333],[11.757873333,48.117041667],[11.758875,48.12225],[11.75933,48.126205],[11.759391667,48.133063333],[11.758606667,48.140296667],[11.758091667,48.142601667],[11.75665,48.146696667],[11.753618333,48.152206667],[11.750256667,48.156753333],[11.74576,48.162136667],[11.740911667,48.167326667],[11.736803333,48.171485],[11.730738333,48.177146667],[11.72552,48.181348333],[11.71998,48.184678333],[11.715351667,48.186943333],[11.70948,48.189268333],[11.700705,48.191718333],[11.687045,48.19452],[11.682183333,48.195656667],[11.67453,48.197753333],[11.668958333,48.19965],[11.660828333,48.202736667],[11.65512,48.205415],[11.649085,48.208856667],[11.639166667,48.215833333],[11.634628333,48.218891667],[11.632741667,48.221078333],[11.631831667,48.224885],[11.632298333,48.226775],[11.634635,48.231535],[11.643785,48.249638333],[11.6467,48.255836667],[11.647153333,48.257676667],[11.64735,48.261016667],[11.64685,48.26377],[11.645416667,48.267793333],[11.640746667,48.28188],[11.639298333,48.28494],[11.633326667,48.29603],[11.625713333,48.309021667],[11.622691667,48.313628333],[11.617256667,48.323023333],[11.613848333,48.329518333],[11.606093333,48.343073333],[11.596818333,48.358593333],[11.595901667,48.360515],[11.595248333,48.363153333],[11.59534,48.366571667],[11.596725,48.379018333],[11.597546667,48.385133333],[11.597111667,48.38973],[11.596235,48.392],[11.592766667,48.39691],[11.590581667,48.400911667],[11.58986,48.405245],[11.589853333,48.410915],[11.589438333,48.443625],[11.59107,48.455595],[11.591015,48.457435],[11.5903,48.460581667],[11.586741667,48.469536667],[11.585371667,48.4734],[11.58532,48.475548333],[11.58612,48.478638333],[11.587333333,48.48087],[11.592598333,48.48831],[11.594161667,48.491135],[11.594905,48.493735],[11.594586667,48.497851667],[11.593101667,48.500708333],[11.585783333,48.509066667],[11.583426667,48.51326],[11.582836667,48.518356667],[11.583123333,48.52031],[11.58487,48.524045],[11.586895,48.526235],[11.59198,48.530616667],[11.594081667,48.532798333],[11.595076667,48.534713333],[11.595348333,48.537388333],[11.59402,48.546046667],[11.593205,48.548606667],[11.589458333,48.554658333],[11.588681667,48.556456667],[11.588631667,48.559746667],[11.589936667,48.563045],[11.591908333,48.56689],[11.592588333,48.569525],[11.592846667,48.575858333],[11.591331667,48.578998333],[11.58883,48.581111667],[11.5848,48.582755],[11.576536667,48.585378333],[11.571463333,48.587886667],[11.565063333,48.593245],[11.558276667,48.599166667],[11.550893333,48.604305],[11.548316667,48.605923333],[11.544503333,48.609008333],[11.53961,48.61327],[11.537573333,48.614655],[11.529451667,48.619368333],[11.527095,48.621576667],[11.525326667,48.625345],[11.524065,48.632048333],[11.52091,48.638213333],[11.51559,48.647416667],[11.514738333,48.649375],[11.510948333,48.66366],[11.510228333,48.665646667],[11.507526667,48.671383333],[11.502028333,48.680301667],[11.498998333,48.684381667],[11.492683333,48.693268333],[11.490711667,48.696873333],[11.485033333,48.710975],[11.47952,48.72134],[11.474838333,48.727746667],[11.46474,48.740708333],[11.45904,48.748573333],[11.458108333,48.750436667],[11.45729,48.75371],[11.457688333,48.75704],[11.45875,48.760473333],[11.460493333,48.767878333],[11.461243333,48.772301667],[11.461023333,48.77716],[11.460128333,48.78435],[11.460181667,48.786863333],[11.463615,48.797383333],[11.46481,48.800685],[11.465881667,48.804613333],[11.466213333,48.811516667],[11.466465,48.813266667],[11.46776,48.816455],[11.47235,48.824686667],[11.473186667,48.827515],[11.472863333,48.831136667],[11.466221667,48.846313333],[11.465053333,48.850706667],[11.465076667,48.854956667],[11.468208333,48.872061667],[11.46835,48.874466667],[11.466728333,48.880278333],[11.466288333,48.882976667],[11.467261667,48.894206667],[11.468095,48.897301667],[11.470133333,48.902458333],[11.470525,48.905578333],[11.470495,48.911145],[11.470071667,48.915736667],[11.469485,48.918415],[11.467713333,48.923171667],[11.466496667,48.925586667],[11.462795,48.93003],[11.459736667,48.932798333],[11.456531667,48.935115],[11.450611667,48.940043333],[11.443488333,48.944591667],[11.435035,48.948783333],[11.431683333,48.951026667],[11.427985,48.954508333],[11.425083333,48.958463333],[11.421418333,48.961716667],[11.41556,48.967276667],[11.40849,48.972003333],[11.401843333,48.976131667],[11.397661667,48.978325],[11.39579,48.979643333],[11.392298333,48.983278333],[11.390318333,48.984598333],[11.385928333,48.988706667],[11.381793333,48.993161667],[11.379746667,48.994671667],[11.374166667,48.997346667],[11.360026667,49.001316667],[11.357743333,49.002628333],[11.356258333,49.004408333],[11.35447,49.00831],[11.354285,49.009643333],[11.3552,49.012313333],[11.357146667,49.014353333],[11.364818333,49.019103333],[11.366126667,49.020166667],[11.367586667,49.022633333],[11.367306667,49.02574],[11.366071667,49.027655],[11.361205,49.03276],[11.358528333,49.037676667],[11.35639,49.039803333],[11.35313,49.041505],[11.341455,49.044116667],[11.337906667,49.045756667],[11.331445,49.051058333],[11.329246667,49.05326],[11.325733333,49.05837],[11.323713333,49.060665],[11.320326667,49.062981667],[11.299165,49.073406667],[11.296181667,49.075055],[11.293121667,49.077516667],[11.290731667,49.0803],[11.288723333,49.08452],[11.28391,49.103416667],[11.283038333,49.105896667],[11.27949,49.111943333],[11.277475,49.119498333],[11.276343333,49.122591667],[11.271431667,49.13153],[11.270138333,49.13536],[11.265561667,49.154961667],[11.262345,49.169636667],[11.261395,49.17355],[11.26031,49.176183333],[11.258771667,49.17875],[11.25263,49.186095],[11.24324,49.197025],[11.227381667,49.216486667],[11.225335,49.22093],[11.221615,49.232346667],[11.21887,49.240275],[11.218013333,49.243501667],[11.216088333,49.25219],[11.214368333,49.258506667],[11.211698333,49.269846667],[11.211251667,49.273863333],[11.209331667,49.279881667],[11.20862,49.291645],[11.208055,49.303698333],[11.207861667,49.312711667],[11.206033333,49.327231667],[11.20466,49.335898333],[11.203861667,49.344148333],[11.203908333,49.351485],[11.20335,49.35524],[11.201903333,49.36761],[11.200453333,49.378341667],[11.200613333,49.380785],[11.201915,49.385856667],[11.202321667,49.38848],[11.201816667,49.392416667],[11.201321667,49.39366],[11.19671,49.402123333],[11.195595,49.40586],[11.196083333,49.410323333],[11.198268333,49.414191667],[11.199746667,49.415846667],[11.20763,49.423671667],[11.215411667,49.430593333],[11.226846667,49.441111667],[11.230325,49.444066667],[11.235113333,49.449055],[11.23914,49.452805],[11.242503333,49.457155],[11.252198333,49.467565],[11.25596,49.470713333],[11.262885,49.475905],[11.266375,49.478875],[11.270731667,49.48342],[11.283875,49.497965],[11.286651667,49.50063],[11.293043333,49.50533],[11.29547,49.507321667],[11.299968333,49.511495],[11.313213333,49.524261667],[11.315866667,49.528735],[11.323106667,49.55302],[11.325295,49.559366667],[11.326886667,49.562183333],[11.330226667,49.566113333],[11.338586667,49.573913333],[11.344828333,49.579351667],[11.348371667,49.581693333],[11.350483333,49.584548333],[11.353921667,49.587473333],[11.356158333,49.590263333],[11.360073333,49.592226667],[11.362033333,49.594555],[11.362303333,49.597281667],[11.362973333,49.599308333],[11.36694,49.605],[11.368771667,49.607326667],[11.371086667,49.6096],[11.374098333,49.611385],[11.377698333,49.612603333],[11.386498333,49.614171667],[11.392211667,49.615391667],[11.40642,49.620158333],[11.409865,49.621778333],[11.415873333,49.62686],[11.41997,49.630123333],[11.42302,49.632953333],[11.42721,49.637848333],[11.428468333,49.639025],[11.432718333,49.64206],[11.435461667,49.64646],[11.437145,49.648011667],[11.44032,49.649545],[11.444246667,49.650265],[11.4502,49.651038333],[11.454381667,49.653058333],[11.457821667,49.655675],[11.465063333,49.66164],[11.467236667,49.663915],[11.468385,49.665796667],[11.469093333,49.66823],[11.469051667,49.670598333],[11.465326667,49.696758333],[11.465515,49.701285],[11.467136667,49.705283333],[11.469896667,49.7086],[11.479508333,49.718488333],[11.481386667,49.719955],[11.486096667,49.721831667],[11.494525,49.723681667],[11.505558333,49.726343333],[11.50808,49.727353333],[11.510271667,49.728683333],[11.514181667,49.733471667],[11.515468333,49.736008333],[11.515448333,49.739198333],[11.509408333,49.75687],[11.508848333,49.761803333],[11.506196667,49.765565],[11.505853333,49.767438333],[11.507491667,49.773331667],[11.50828,49.774995],[11.51062,49.777226667],[11.512136667,49.779215],[11.512875,49.782045],[11.51187,49.78544],[11.509886667,49.787525],[11.507596667,49.788895],[11.504786667,49.789981667],[11.498155,49.791826667],[11.495818333,49.793051667],[11.493455,49.795791667],[11.49297,49.79766],[11.493283333,49.799486667],[11.494808333,49.801683333],[11.497645,49.803893333],[11.500026667,49.80655],[11.500736667,49.809638333],[11.499915,49.812006667],[11.497731667,49.815761667],[11.497186667,49.817955],[11.497445,49.820281667],[11.499218333,49.824175],[11.499648333,49.825816667],[11.499748333,49.829398333],[11.500231667,49.831185],[11.502298333,49.834866667],[11.504141667,49.840885],[11.506423333,49.84385],[11.50851,49.84572],[11.51241,49.848545],[11.51526,49.851008333],[11.517773333,49.854951667],[11.518261667,49.857565],[11.518591667,49.864856667],[11.519726667,49.868061667],[11.523188333,49.87104],[11.525933333,49.872215],[11.530051667,49.873158333],[11.539623333,49.87374],[11.544033333,49.875346667],[11.549183333,49.87915],[11.552496667,49.880578333],[11.555216667,49.88124],[11.559923333,49.881896667],[11.56404,49.882031667],[11.581696667,49.882048333],[11.587618333,49.882423333],[11.591463333,49.88347],[11.594741667,49.88512],[11.597168333,49.887245],[11.59876,49.88963],[11.600618333,49.893438333],[11.601053333,49.895893333],[11.6049,49.906338333],[11.605605,49.910298333],[11.605415,49.9143],[11.602911667,49.925428333],[11.60252,49.92875],[11.602736667,49.930788333],[11.607675,49.949483333],[11.607783333,49.953486667],[11.606568333,49.957981667],[11.605656667,49.962375],[11.605596667,49.967841667],[11.607721667,49.983058333],[11.607936667,49.9863],[11.607691667,49.990126667],[11.606815,49.998515],[11.607973333,50.001441667],[11.610343333,50.004616667],[11.610626667,50.005888333],[11.609748333,50.00809],[11.607615,50.010666667],[11.604828333,50.017278333],[11.604386667,50.021021667],[11.605,50.023686667],[11.607918333,50.03425],[11.609108333,50.036101667],[11.612791667,50.040163333],[11.61549,50.044355],[11.617476667,50.049773333],[11.618135,50.053005],[11.61807,50.059528333],[11.618555,50.062173333],[11.62074,50.065821667],[11.624488333,50.068546667],[11.630068333,50.07197],[11.63234,50.072765],[11.637788333,50.07391],[11.644361667,50.075593333],[11.653486667,50.076723333],[11.657016667,50.077805],[11.664525,50.08089],[11.671913333,50.084086667],[11.677618333,50.087061667],[11.681936667,50.088913333],[11.687353333,50.090938333],[11.691358333,50.093193333],[11.698211667,50.098256667],[11.70027,50.100445],[11.705025,50.106816667],[11.706761667,50.108625],[11.710918333,50.11168],[11.716933333,50.11433],[11.727806667,50.119896667],[11.735265,50.124035],[11.738915,50.126968333],[11.740578333,50.129286667],[11.742105,50.1332],[11.742451667,50.139158333],[11.742981667,50.141753333],[11.74383,50.143613333],[11.749088333,50.152323333],[11.749601667,50.153615],[11.749378333,50.156916667],[11.746251667,50.164503333],[11.745876667,50.167623333],[11.746203333,50.16949],[11.747705,50.172578333],[11.752733333,50.177573333],[11.756356667,50.180716667],[11.761191667,50.185556667],[11.767565,50.19302],[11.774595,50.20148],[11.776093333,50.203625],[11.781546667,50.2144],[11.78231,50.217068333],[11.782526667,50.219558333],[11.782196667,50.222296667],[11.780798333,50.225686667],[11.77801,50.230475],[11.77737,50.23297],[11.777496667,50.236046667],[11.778736667,50.238951667],[11.780583333,50.241146667],[11.783655,50.243771667],[11.789596667,50.248298333],[11.791893333,50.250481667],[11.794445,50.25404],[11.80083,50.264351667],[11.806285,50.272636667],[11.810766667,50.28001],[11.811731667,50.281868333],[11.812735,50.286335],[11.812413333,50.289586667],[11.810253333,50.294731667],[11.79916,50.315688333],[11.798043333,50.317435],[11.792841667,50.323001667],[11.791313333,50.325766667],[11.787115,50.338021667],[11.786876667,50.340281667],[11.787886667,50.344686667],[11.787986667,50.346636667],[11.787016667,50.349228333],[11.783333333,50.353188333],[11.781656667,50.3556],[11.78122,50.357543333],[11.78192,50.360863333],[11.78332,50.362615],[11.7894,50.367758333],[11.791806667,50.370543333],[11.792455,50.373755],[11.791948333,50.375715],[11.790808333,50.377546667],[11.787656667,50.38012],[11.781336667,50.383441667],[11.77949,50.384981667],[11.777088333,50.387783333],[11.77428,50.389743333],[11.767986667,50.39188],[11.76496,50.393881667],[11.764045,50.39567],[11.763428333,50.398935],[11.763715,50.400931667],[11.766135,50.403153333],[11.768005,50.40384],[11.771203333,50.404308333],[11.773873333,50.405373333],[11.774916667,50.40651],[11.775928333,50.409138333],[11.778568333,50.412055],[11.780203333,50.414556667],[11.781548333,50.415543333],[11.787716667,50.419046667],[11.790531667,50.421806667],[11.793225,50.42598],[11.798008333,50.43083],[11.802925,50.438168333],[11.803528333,50.439935],[11.803316667,50.443548333],[11.800078333,50.450876667],[11.799373333,50.453825],[11.799428333,50.455728333],[11.800148333,50.45823],[11.802633333,50.463835],[11.80385,50.467145],[11.804138333,50.47049],[11.803815,50.472475],[11.802136667,50.47682],[11.801911667,50.47867],[11.802645,50.481116667],[11.80543,50.486601667],[11.805956667,50.488981667],[11.804451667,50.492373333],[11.80223,50.494166667],[11.79782,50.49622],[11.795631667,50.497635],[11.793906667,50.49945],[11.792718333,50.502136667],[11.793105,50.505535],[11.794713333,50.508096667],[11.797646667,50.511833333],[11.798363333,50.514625],[11.798966667,50.52222],[11.800393333,50.525806667],[11.804185,50.530576667],[11.805088333,50.53281],[11.805418333,50.536701667],[11.804741667,50.539385],[11.80212,50.543408333],[11.799785,50.545458333],[11.79551,50.548238333],[11.793113333,50.550403333],[11.791838333,50.552923333],[11.79019,50.55793],[11.78935,50.559693333],[11.787241667,50.561758333],[11.778501667,50.567668333],[11.776703333,50.56917],[11.775168333,50.571386667],[11.77446,50.574421667],[11.775441667,50.577485],[11.789688333,50.603495],[11.79098,50.606291667],[11.792033333,50.61061],[11.793326667,50.622693333],[11.801063333,50.644038333],[11.80258,50.646895],[11.806013333,50.650573333],[11.812416667,50.655703333],[11.81467,50.657823333],[11.816378333,50.660093333],[11.822731667,50.671296667],[11.824278333,50.673615],[11.83055,50.68178],[11.83737,50.69142],[11.843381667,50.699741667],[11.849458333,50.705648333],[11.851535,50.708023333],[11.85311,50.711363333],[11.853413333,50.71342],[11.853121667,50.715976667],[11.85213,50.718316667],[11.848896667,50.72405],[11.847811667,50.727028333],[11.847731667,50.729545],[11.849011667,50.733191667],[11.851043333,50.735973333],[11.86022,50.74781],[11.862891667,50.750566667],[11.875768333,50.760606667],[11.877373333,50.762223333],[11.878756667,50.765303333],[11.880243333,50.773991667],[11.881206667,50.775776667],[11.884021667,50.778365],[11.891855,50.782925],[11.894783333,50.786153333],[11.895428333,50.788733333],[11.895591667,50.809326667],[11.895025,50.811211667],[11.892781667,50.814008333],[11.886461667,50.819065],[11.883495,50.822306667],[11.879978333,50.828756667],[11.877731667,50.83143],[11.866245,50.840901667],[11.863666667,50.843573333],[11.862471667,50.8453],[11.855418333,50.85645],[11.854603333,50.858003333],[11.851356667,50.866255],[11.850173333,50.869825],[11.850378333,50.870335],[11.848598333,50.873198333],[11.847428333,50.876791667],[11.844831667,50.892476667],[11.84397,50.896963333],[11.840163333,50.921933333],[11.839688333,50.923946667],[11.836186667,50.935733333],[11.834126667,50.944696667],[11.834068333,50.946648333],[11.83518,50.949236667],[11.838251667,50.953486667],[11.841315,50.956253333],[11.843768333,50.957468333],[11.854766667,50.961891667],[11.858975,50.964561667],[11.860626667,50.966973333],[11.863891667,50.973771667],[11.86568,50.97551],[11.868863333,50.977351667],[11.87464,50.979005],[11.890881667,50.983055],[11.901568333,50.985815],[11.904803333,50.986958333],[11.90888,50.988956667],[11.911921667,50.991028333],[11.915655,50.994998333],[11.927011667,51.013133333],[11.939328333,51.033475],[11.940713333,51.036541667],[11.941156667,51.039],[11.941901667,51.046478333],[11.94315,51.049483333],[11.94608,51.053951667],[11.94759,51.05666],[11.952188333,51.063915],[11.954028333,51.06803],[11.95527,51.073436667],[11.955426667,51.076391667],[11.95561,51.090081667],[11.955925,51.0965],[11.956161667,51.116283333],[11.957075,51.120693333],[11.959211667,51.125101667],[11.961446667,51.128088333],[11.998028333,51.169671667],[11.999918333,51.172015],[12.01694,51.196728333],[12.018815,51.199095],[12.022383333,51.202425],[12.035086667,51.21279],[12.037436667,51.214915],[12.043441667,51.220868333],[12.054121667,51.231886667],[12.070025,51.247875],[12.075156667,51.252055],[12.078111667,51.254003333],[12.101468333,51.267053333],[12.112258333,51.273245],[12.118581667,51.27827],[12.132578333,51.287295],[12.135328333,51.289391667],[12.149226667,51.300788333],[12.151028333,51.302425],[12.15909,51.311481667],[12.174018333,51.328008333],[12.17799,51.333461667],[12.185223333,51.34371],[12.186943333,51.347556667],[12.189426667,51.360461667],[12.189595,51.363996667],[12.188931667,51.366895],[12.184683333,51.379891667],[12.18093,51.392018333],[12.180805,51.395175],[12.181623333,51.398436667],[12.182605,51.400386667],[12.190243333,51.413451667],[12.204685,51.43851],[12.214238333,51.455253333],[12.216386667,51.460376667],[12.216901667,51.464306667],[12.21674,51.466965],[12.214926667,51.476036667],[12.213951667,51.479211667],[12.212671667,51.481818333],[12.211008333,51.484246667],[12.20479,51.492613333],[12.203355,51.495045],[12.202505,51.497511667],[12.200973333,51.503566667],[12.197776667,51.515361667],[12.197286667,51.519395],[12.197021667,51.529358333],[12.19599,51.534531667],[12.192081667,51.544961667],[12.187746667,51.556891667],[12.187351667,51.560786667],[12.187701667,51.562718333],[12.191143333,51.575011667],[12.191226667,51.57764],[12.190143333,51.581543333],[12.184511667,51.594281667],[12.18359,51.596843333],[12.183238333,51.60013],[12.183858333,51.603375],[12.190175,51.618861667],[12.193423333,51.626486667],[12.198138333,51.637996667],[12.199901667,51.643208333],[12.200901667,51.647088333],[12.202353333,51.654925],[12.20377,51.661531667],[12.205425,51.671221667],[12.207481667,51.682271667],[12.210241667,51.695891667],[12.213623333,51.714318333],[12.217266667,51.733406667],[12.21797,51.735983333],[12.21988,51.740456667],[12.222311667,51.744485],[12.224246667,51.74721],[12.235916667,51.762385],[12.23818,51.764675],[12.241728333,51.76717],[12.259298333,51.77659],[12.264858333,51.779713333],[12.267528333,51.781766667],[12.270078333,51.784608333],[12.274481667,51.791371667],[12.2848,51.803671667],[12.288595,51.806866667],[12.29995,51.813638333],[12.303623333,51.8166],[12.307271667,51.820443333],[12.318165,51.831213333],[12.32078,51.83457],[12.32677,51.844211667],[12.329181667,51.84745],[12.332866667,51.850508333],[12.337035,51.85306],[12.340981667,51.854925],[12.346025,51.856956667],[12.362546667,51.864255],[12.367065,51.866055],[12.378046667,51.869688333],[12.384388333,51.87266],[12.388068333,51.875153333],[12.390371667,51.877286667],[12.41131,51.901215],[12.4164,51.904865],[12.433766667,51.913446667],[12.438388333,51.91627],[12.440908333,51.918558333],[12.442576667,51.921223333],[12.447253333,51.93209],[12.448635,51.934826667],[12.450271667,51.938931667],[12.456358333,51.953323333],[12.457576667,51.955301667],[12.459816667,51.957766667],[12.463393333,51.960536667],[12.465901667,51.96194],[12.476936667,51.967083333],[12.482363333,51.969446667],[12.486216667,51.970708333],[12.503948333,51.975396667],[12.518101667,51.980088333],[12.521866667,51.981553333],[12.531616667,51.984978333],[12.535963333,51.986928333],[12.539725,51.98912],[12.550358333,51.99611],[12.556766667,52.000458333],[12.563343333,52.005983333],[12.569248333,52.01114],[12.573441667,52.013578333],[12.584826667,52.018043333],[12.595553333,52.022525],[12.598776667,52.024411667],[12.604446667,52.02948],[12.6079,52.031235],[12.615023333,52.032985],[12.619498333,52.03504],[12.621445,52.036643333],[12.624573333,52.040156667],[12.627515,52.042271667],[12.641066667,52.048135],[12.643468333,52.049555],[12.647788333,52.053496667],[12.653103333,52.06141],[12.657941667,52.069015],[12.661985,52.074305],[12.666021667,52.07846],[12.671773333,52.083381667],[12.684106667,52.09213],[12.686523333,52.093576667],[12.697328333,52.099166667],[12.708143333,52.106686667],[12.71307,52.110236667],[12.71775,52.112778333],[12.737811667,52.12128],[12.743208333,52.124633333],[12.750313333,52.130676667],[12.772948333,52.150523333],[12.784211667,52.160206667],[12.789508333,52.163716667],[12.795001667,52.165905],[12.8029,52.167923333],[12.815156667,52.170781667],[12.819856667,52.172145],[12.828241667,52.17396],[12.832046667,52.175195],[12.835566667,52.176818333],[12.838668333,52.17873],[12.849503333,52.18724],[12.85419,52.189973333],[12.860678333,52.192335],[12.870043333,52.194376667],[12.874973333,52.195808333],[12.87847,52.197255],[12.883445,52.200406667],[12.913725,52.22865],[12.914841667,52.229853333],[12.916683333,52.233075],[12.917396667,52.235698333],[12.917478333,52.239626667],[12.916475,52.242765],[12.914241667,52.247046667],[12.908695,52.256333333],[12.907886667,52.258291667],[12.907345,52.261518333],[12.907423333,52.263491667],[12.911878333,52.27642],[12.914873333,52.285378333],[12.91625,52.288536667],[12.917446667,52.28964],[12.919865,52.290801667],[12.944098333,52.296301667],[12.95214,52.298215],[12.959785,52.299781667],[12.975788333,52.303373333],[12.977905,52.303593333],[13.01164,52.303311667],[13.01667,52.30247],[13.0311,52.29841],[13.035651667,52.298218333],[13.039911667,52.299028333],[13.044933333,52.300676667],[13.049178333,52.301153333],[13.070973333,52.30038],[13.077001667,52.299578333],[13.08098,52.299738333],[13.08427,52.301186667],[13.085311667,52.302313333],[13.09227,52.31311],[13.0945,52.316365],[13.096945,52.318798333],[13.106208333,52.32746],[13.10835,52.328841667],[13.112203333,52.330295],[13.132048333,52.335971667],[13.136625,52.337995],[13.139295,52.34029],[13.140538333,52.342278333],[13.141106667,52.34438],[13.140753333,52.359798333],[13.1413,52.361838333],[13.14293,52.36376],[13.147075,52.366318333],[13.149568333,52.368713333],[13.150298333,52.371563333],[13.150136667,52.377845],[13.150548333,52.380641667],[13.15458,52.387088333],[13.156966667,52.389341667],[13.159755,52.390588333],[13.174285,52.394053333],[13.17919,52.395761667],[13.183125,52.398303333],[13.196178333,52.41005],[13.197436667,52.411886667],[13.197568333,52.414465],[13.195598333,52.42284],[13.194841667,52.423876667],[13.192296667,52.425725],[13.191038333,52.427218333],[13.191081667,52.428555],[13.192425,52.433538333],[13.193818333,52.435355],[13.205015,52.44404],[13.240683333,52.472171667],[13.252975,52.48294],[13.263075,52.49089],[13.265783333,52.492765],[13.269998333,52.496311667],[13.277115,52.501943333],[13.27897,52.502103333],[13.28128,52.498878333],[13.284123333,52.495875],[13.286943333,52.493991667],[13.290533333,52.493783333],[13.291865,52.493191667],[13.29746,52.489635],[13.304238333,52.484766667],[13.306111667,52.483243333],[13.309576667,52.481896667],[13.312541667,52.480105],[13.317178333,52.478373333],[13.321125,52.477855],[13.33123,52.477765],[13.337036667,52.478421667],[13.3414,52.4786],[13.345785,52.47742],[13.347996667,52.475738333],[13.35195,52.473868333],[13.355403333,52.47354],[13.35953,52.474083333],[13.362418333,52.473895],[13.365561667,52.472898333],[13.369436667,52.471023333],[13.375115,52.470096667],[13.38504,52.469701667],[13.389326667,52.469258333],[13.395256667,52.467035],[13.401253333,52.465045],[13.40514,52.462331667],[13.410965,52.461075],[13.4168,52.460573333],[13.442621667,52.462678333],[13.445125,52.462781667],[13.44281,52.465223333],[13.441948333,52.467706667],[13.441196667,52.472425],[13.43951,52.475886667],[13.43733,52.479273333],[13.435575,52.48089],[13.437308333,52.481318333],[13.437165,52.482533333],[13.439023333,52.482153333],[13.437088333,52.48317]]]}}"

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	var _elements = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuHeight = _elements.articles[0].fixed.getElementsByClassName('language-switch')[0].getBoundingClientRect().bottom;
	
	var menuShortened = false;
	
	init();
	_windowDimensions2.default.onResize(init);
	
	function init() {
	    var shouldShorten = menuHeight > _windowDimensions2.default.height;
	
	    if (shouldShorten === menuShortened) {
	        return;
	    }
	
	    (0, _lodash.forEach)(_elements.articles, function (article) {
	        article.fixed.classList.toggle('is-short-menu', shouldShorten);
	    });
	
	    menuShortened = shouldShorten;
	}

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	var leftButton = document.getElementsByClassName('mode-switch-bar-left')[0];
	var rightButton = document.getElementsByClassName('mode-switch-bar-right')[0];
	
	var nav = false;
	var map = false;
	
	window.addEventListener('hashchange', reset);
	
	rightButton.addEventListener('click', function () {
	    if (nav) {
	        return reset();
	    }
	
	    toggleMap(true);
	});
	
	leftButton.addEventListener('click', function () {
	    if (map) {
	        return reset();
	    }
	
	    toggleNav(true);
	});
	
	function reset() {
	    toggleMap(false);
	    toggleNav(false);
	}
	
	function toggleMap(toggle) {
	    map = toggle;
	    document.body.classList.toggle('is-showing-map', toggle);
	}
	
	function toggleNav(toggle) {
	    nav = toggle;
	    document.body.classList.toggle('is-showing-nav', toggle);
	}

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** app.js
 **/